// Auto-generated TypeScript enums from PHP enums

export type AgentName = 'build_data_model' | 'build_notifications' | 'build_pages' | 'build_workflows' | 'configure_workspace' | 'execute_approved_record_change' | 'find_records' | 'gather_web_data' | 'inspect_image' | 'lookup_workspace_data' | 'manage_brand_kit' | 'manage_skills' | 'manage_tests' | 'plan_project' | 'plan_record_change' | 'plan_roles' | 'plan_workflow' | 'read_record_data' | 'use_browser' | 'use_workspace_api';

export const AgentName = {
  BuildDataModel: 'build_data_model' as const,
  BuildNotifications: 'build_notifications' as const,
  BuildPages: 'build_pages' as const,
  BuildWorkflows: 'build_workflows' as const,
  ConfigureWorkspace: 'configure_workspace' as const,
  ExecuteApprovedRecordChange: 'execute_approved_record_change' as const,
  FindRecords: 'find_records' as const,
  GatherWebData: 'gather_web_data' as const,
  InspectImage: 'inspect_image' as const,
  LookupWorkspaceData: 'lookup_workspace_data' as const,
  ManageBrandKit: 'manage_brand_kit' as const,
  ManageSkills: 'manage_skills' as const,
  ManageTests: 'manage_tests' as const,
  PlanProject: 'plan_project' as const,
  PlanRecordChange: 'plan_record_change' as const,
  PlanRoles: 'plan_roles' as const,
  PlanWorkflow: 'plan_workflow' as const,
  ReadRecordData: 'read_record_data' as const,
  UseBrowser: 'use_browser' as const,
  UseWorkspaceApi: 'use_workspace_api' as const,
} as const;

export const AgentNameUtils = {
  values: Object.values(AgentName),
  keys: Object.keys(AgentName) as Array<keyof typeof AgentName>,
  entries: Object.entries(AgentName) as Array<[keyof typeof AgentName, AgentName]>,
  isValid: (value: any): value is AgentName => Object.values(AgentName).includes(value),
  fromKey: (key: keyof typeof AgentName): AgentName => AgentName[key],
};

export type AiAssistantMode = 'conversations' | 'personal-skills' | 'workspace-skills';

export const AiAssistantMode = {
  Conversations: 'conversations' as const,
  PersonalSkills: 'personal-skills' as const,
  WorkspaceSkills: 'workspace-skills' as const,
} as const;

export const AiAssistantModeUtils = {
  values: Object.values(AiAssistantMode),
  keys: Object.keys(AiAssistantMode) as Array<keyof typeof AiAssistantMode>,
  entries: Object.entries(AiAssistantMode) as Array<[keyof typeof AiAssistantMode, AiAssistantMode]>,
  isValid: (value: any): value is AiAssistantMode => Object.values(AiAssistantMode).includes(value),
  fromKey: (key: keyof typeof AiAssistantMode): AiAssistantMode => AiAssistantMode[key],
};

export type AiConversationSurface = 'admin' | 'control_panel' | 'customer' | 'workflow';

export const AiConversationSurface = {
  Admin: 'admin' as const,
  ControlPanel: 'control_panel' as const,
  Customer: 'customer' as const,
  Workflow: 'workflow' as const,
} as const;

export const AiConversationSurfaceUtils = {
  values: Object.values(AiConversationSurface),
  keys: Object.keys(AiConversationSurface) as Array<keyof typeof AiConversationSurface>,
  entries: Object.entries(AiConversationSurface) as Array<[keyof typeof AiConversationSurface, AiConversationSurface]>,
  isValid: (value: any): value is AiConversationSurface => Object.values(AiConversationSurface).includes(value),
  fromKey: (key: keyof typeof AiConversationSurface): AiConversationSurface => AiConversationSurface[key],
};

export type AiEvalCaseSource = 'hand_written' | 'production_failure' | 'production_typical' | 'synthetic';

export const AiEvalCaseSource = {
  HandWritten: 'hand_written' as const,
  ProductionFailure: 'production_failure' as const,
  ProductionTypical: 'production_typical' as const,
  Synthetic: 'synthetic' as const,
} as const;

export const AiEvalCaseSourceUtils = {
  values: Object.values(AiEvalCaseSource),
  keys: Object.keys(AiEvalCaseSource) as Array<keyof typeof AiEvalCaseSource>,
  entries: Object.entries(AiEvalCaseSource) as Array<[keyof typeof AiEvalCaseSource, AiEvalCaseSource]>,
  isValid: (value: any): value is AiEvalCaseSource => Object.values(AiEvalCaseSource).includes(value),
  fromKey: (key: keyof typeof AiEvalCaseSource): AiEvalCaseSource => AiEvalCaseSource[key],
};

export type AiEvalSplit = 'test' | 'train';

export const AiEvalSplit = {
  Test: 'test' as const,
  Train: 'train' as const,
} as const;

export const AiEvalSplitUtils = {
  values: Object.values(AiEvalSplit),
  keys: Object.keys(AiEvalSplit) as Array<keyof typeof AiEvalSplit>,
  entries: Object.entries(AiEvalSplit) as Array<[keyof typeof AiEvalSplit, AiEvalSplit]>,
  isValid: (value: any): value is AiEvalSplit => Object.values(AiEvalSplit).includes(value),
  fromKey: (key: keyof typeof AiEvalSplit): AiEvalSplit => AiEvalSplit[key],
};

export type AiImageAspectRatio = '16:9' | '21:9' | '3:2' | '4:3' | '2:3' | '3:4' | '9:16' | '1:1';

export const AiImageAspectRatio = {
  Landscape16x9: '16:9' as const,
  Landscape21x9: '21:9' as const,
  Landscape3x2: '3:2' as const,
  Landscape4x3: '4:3' as const,
  Portrait2x3: '2:3' as const,
  Portrait3x4: '3:4' as const,
  Portrait9x16: '9:16' as const,
  Square: '1:1' as const,
} as const;

export const AiImageAspectRatioUtils = {
  values: Object.values(AiImageAspectRatio),
  keys: Object.keys(AiImageAspectRatio) as Array<keyof typeof AiImageAspectRatio>,
  entries: Object.entries(AiImageAspectRatio) as Array<[keyof typeof AiImageAspectRatio, AiImageAspectRatio]>,
  isValid: (value: any): value is AiImageAspectRatio => Object.values(AiImageAspectRatio).includes(value),
  fromKey: (key: keyof typeof AiImageAspectRatio): AiImageAspectRatio => AiImageAspectRatio[key],
};

export type AiImageBackground = 'opaque' | 'transparent';

export const AiImageBackground = {
  Opaque: 'opaque' as const,
  Transparent: 'transparent' as const,
} as const;

export const AiImageBackgroundUtils = {
  values: Object.values(AiImageBackground),
  keys: Object.keys(AiImageBackground) as Array<keyof typeof AiImageBackground>,
  entries: Object.entries(AiImageBackground) as Array<[keyof typeof AiImageBackground, AiImageBackground]>,
  isValid: (value: any): value is AiImageBackground => Object.values(AiImageBackground).includes(value),
  fromKey: (key: keyof typeof AiImageBackground): AiImageBackground => AiImageBackground[key],
};

export type AiImageModel = 'openai/gpt-image-2';

export const AiImageModel = {
  OpenAiGptImage2: 'openai/gpt-image-2' as const,
} as const;

export const AiImageModelUtils = {
  values: Object.values(AiImageModel),
  keys: Object.keys(AiImageModel) as Array<keyof typeof AiImageModel>,
  entries: Object.entries(AiImageModel) as Array<[keyof typeof AiImageModel, AiImageModel]>,
  isValid: (value: any): value is AiImageModel => Object.values(AiImageModel).includes(value),
  fromKey: (key: keyof typeof AiImageModel): AiImageModel => AiImageModel[key],
};

export type AiModel = 'claude-opus-5-5' | 'deepseek/deepseek-v4-flash' | 'gpt-5.4' | 'gpt-5.6-luna' | 'gpt-5.6-sol' | 'gpt-5.6-terra' | 'gpt-6.1-sol' | 'gpt-6-luna' | 'grok-4.6' | 'z-ai/glm-5.3-flash';

export const AiModel = {
  ClaudeOpus55: 'claude-opus-5-5' as const,
  DeepseekV4Flash: 'deepseek/deepseek-v4-flash' as const,
  Gpt54: 'gpt-5.4' as const,
  Gpt56Luna: 'gpt-5.6-luna' as const,
  Gpt56Sol: 'gpt-5.6-sol' as const,
  Gpt56Terra: 'gpt-5.6-terra' as const,
  Gpt61Sol: 'gpt-6.1-sol' as const,
  Gpt6Luna: 'gpt-6-luna' as const,
  Grok46: 'grok-4.6' as const,
  ZaiGlm53Flash: 'z-ai/glm-5.3-flash' as const,
} as const;

export const AiModelUtils = {
  values: Object.values(AiModel),
  keys: Object.keys(AiModel) as Array<keyof typeof AiModel>,
  entries: Object.entries(AiModel) as Array<[keyof typeof AiModel, AiModel]>,
  isValid: (value: any): value is AiModel => Object.values(AiModel).includes(value),
  fromKey: (key: keyof typeof AiModel): AiModel => AiModel[key],
};

export type AskUserStatus = 'answered' | 'pending' | 'superseded';

export const AskUserStatus = {
  Answered: 'answered' as const,
  Pending: 'pending' as const,
  Superseded: 'superseded' as const,
} as const;

export const AskUserStatusUtils = {
  values: Object.values(AskUserStatus),
  keys: Object.keys(AskUserStatus) as Array<keyof typeof AskUserStatus>,
  entries: Object.entries(AskUserStatus) as Array<[keyof typeof AskUserStatus, AskUserStatus]>,
  isValid: (value: any): value is AskUserStatus => Object.values(AskUserStatus).includes(value),
  fromKey: (key: keyof typeof AskUserStatus): AskUserStatus => AskUserStatus[key],
};

export type ChatMode = 'build' | 'plan';

export const ChatMode = {
  Build: 'build' as const,
  Plan: 'plan' as const,
} as const;

export const ChatModeUtils = {
  values: Object.values(ChatMode),
  keys: Object.keys(ChatMode) as Array<keyof typeof ChatMode>,
  entries: Object.entries(ChatMode) as Array<[keyof typeof ChatMode, ChatMode]>,
  isValid: (value: any): value is ChatMode => Object.values(ChatMode).includes(value),
  fromKey: (key: keyof typeof ChatMode): ChatMode => ChatMode[key],
};

export type ConversationContextHealthLevel = 'critical' | 'high' | 'ok';

export const ConversationContextHealthLevel = {
  Critical: 'critical' as const,
  High: 'high' as const,
  Ok: 'ok' as const,
} as const;

export const ConversationContextHealthLevelUtils = {
  values: Object.values(ConversationContextHealthLevel),
  keys: Object.keys(ConversationContextHealthLevel) as Array<keyof typeof ConversationContextHealthLevel>,
  entries: Object.entries(ConversationContextHealthLevel) as Array<[keyof typeof ConversationContextHealthLevel, ConversationContextHealthLevel]>,
  isValid: (value: any): value is ConversationContextHealthLevel => Object.values(ConversationContextHealthLevel).includes(value),
  fromKey: (key: keyof typeof ConversationContextHealthLevel): ConversationContextHealthLevel => ConversationContextHealthLevel[key],
};

export type ConversationHarnessKey = 'email_layout_editor' | 'project_build' | 'project_planner' | 'project_task_build' | 'task_scope' | 'workspace';

export const ConversationHarnessKey = {
  EmailLayoutEditor: 'email_layout_editor' as const,
  ProjectBuild: 'project_build' as const,
  ProjectPlanner: 'project_planner' as const,
  ProjectTaskBuild: 'project_task_build' as const,
  TaskScope: 'task_scope' as const,
  Workspace: 'workspace' as const,
} as const;

export const ConversationHarnessKeyUtils = {
  values: Object.values(ConversationHarnessKey),
  keys: Object.keys(ConversationHarnessKey) as Array<keyof typeof ConversationHarnessKey>,
  entries: Object.entries(ConversationHarnessKey) as Array<[keyof typeof ConversationHarnessKey, ConversationHarnessKey]>,
  isValid: (value: any): value is ConversationHarnessKey => Object.values(ConversationHarnessKey).includes(value),
  fromKey: (key: keyof typeof ConversationHarnessKey): ConversationHarnessKey => ConversationHarnessKey[key],
};

export type DecisionQuestionType = 'choice' | 'noul' | 'score';

export const DecisionQuestionType = {
  Choice: 'choice' as const,
  Noul: 'noul' as const,
  Score: 'score' as const,
} as const;

export const DecisionQuestionTypeUtils = {
  values: Object.values(DecisionQuestionType),
  keys: Object.keys(DecisionQuestionType) as Array<keyof typeof DecisionQuestionType>,
  entries: Object.entries(DecisionQuestionType) as Array<[keyof typeof DecisionQuestionType, DecisionQuestionType]>,
  isValid: (value: any): value is DecisionQuestionType => Object.values(DecisionQuestionType).includes(value),
  fromKey: (key: keyof typeof DecisionQuestionType): DecisionQuestionType => DecisionQuestionType[key],
};

export type DocumentationSection = 'overview' | 'permissions' | 'resources' | 'tiptap' | 'variables' | 'workflows' | 'workspace';

export const DocumentationSection = {
  Overview: 'overview' as const,
  Permissions: 'permissions' as const,
  Resources: 'resources' as const,
  TipTap: 'tiptap' as const,
  Variables: 'variables' as const,
  Workflows: 'workflows' as const,
  Workspace: 'workspace' as const,
} as const;

export const DocumentationSectionUtils = {
  values: Object.values(DocumentationSection),
  keys: Object.keys(DocumentationSection) as Array<keyof typeof DocumentationSection>,
  entries: Object.entries(DocumentationSection) as Array<[keyof typeof DocumentationSection, DocumentationSection]>,
  isValid: (value: any): value is DocumentationSection => Object.values(DocumentationSection).includes(value),
  fromKey: (key: keyof typeof DocumentationSection): DocumentationSection => DocumentationSection[key],
};

export type EvalClassifierGradeOutcome = 'fail' | 'pass' | 'uncertain';

export const EvalClassifierGradeOutcome = {
  Fail: 'fail' as const,
  Pass: 'pass' as const,
  Uncertain: 'uncertain' as const,
} as const;

export const EvalClassifierGradeOutcomeUtils = {
  values: Object.values(EvalClassifierGradeOutcome),
  keys: Object.keys(EvalClassifierGradeOutcome) as Array<keyof typeof EvalClassifierGradeOutcome>,
  entries: Object.entries(EvalClassifierGradeOutcome) as Array<[keyof typeof EvalClassifierGradeOutcome, EvalClassifierGradeOutcome]>,
  isValid: (value: any): value is EvalClassifierGradeOutcome => Object.values(EvalClassifierGradeOutcome).includes(value),
  fromKey: (key: keyof typeof EvalClassifierGradeOutcome): EvalClassifierGradeOutcome => EvalClassifierGradeOutcome[key],
};

export type FlaggedConversationIssueType = 'error' | 'negative_feedback' | 'slow' | 'tooling_gap';

export const FlaggedConversationIssueType = {
  Error: 'error' as const,
  NegativeFeedback: 'negative_feedback' as const,
  Slow: 'slow' as const,
  ToolingGap: 'tooling_gap' as const,
} as const;

export const FlaggedConversationIssueTypeUtils = {
  values: Object.values(FlaggedConversationIssueType),
  keys: Object.keys(FlaggedConversationIssueType) as Array<keyof typeof FlaggedConversationIssueType>,
  entries: Object.entries(FlaggedConversationIssueType) as Array<[keyof typeof FlaggedConversationIssueType, FlaggedConversationIssueType]>,
  isValid: (value: any): value is FlaggedConversationIssueType => Object.values(FlaggedConversationIssueType).includes(value),
  fromKey: (key: keyof typeof FlaggedConversationIssueType): FlaggedConversationIssueType => FlaggedConversationIssueType[key],
};

export type GenerationReconciliationStatus = 'failed' | 'pending' | 'success';

export const GenerationReconciliationStatus = {
  Failed: 'failed' as const,
  Pending: 'pending' as const,
  Success: 'success' as const,
} as const;

export const GenerationReconciliationStatusUtils = {
  values: Object.values(GenerationReconciliationStatus),
  keys: Object.keys(GenerationReconciliationStatus) as Array<keyof typeof GenerationReconciliationStatus>,
  entries: Object.entries(GenerationReconciliationStatus) as Array<[keyof typeof GenerationReconciliationStatus, GenerationReconciliationStatus]>,
  isValid: (value: any): value is GenerationReconciliationStatus => Object.values(GenerationReconciliationStatus).includes(value),
  fromKey: (key: keyof typeof GenerationReconciliationStatus): GenerationReconciliationStatus => GenerationReconciliationStatus[key],
};

export type GuidanceDocument = 'page-code-guide' | 'record-mutation-guide' | 'workflow-code-guide';

export const GuidanceDocument = {
  PageCodeGuide: 'page-code-guide' as const,
  RecordMutationGuide: 'record-mutation-guide' as const,
  WorkflowCodeGuide: 'workflow-code-guide' as const,
} as const;

export const GuidanceDocumentUtils = {
  values: Object.values(GuidanceDocument),
  keys: Object.keys(GuidanceDocument) as Array<keyof typeof GuidanceDocument>,
  entries: Object.entries(GuidanceDocument) as Array<[keyof typeof GuidanceDocument, GuidanceDocument]>,
  isValid: (value: any): value is GuidanceDocument => Object.values(GuidanceDocument).includes(value),
  fromKey: (key: keyof typeof GuidanceDocument): GuidanceDocument => GuidanceDocument[key],
};

export type LatencyIntervalCategory = 'model' | 'nested_tool' | 'sandbox' | 'subagent' | 'tool';

export const LatencyIntervalCategory = {
  Model: 'model' as const,
  NestedTool: 'nested_tool' as const,
  Sandbox: 'sandbox' as const,
  Subagent: 'subagent' as const,
  Tool: 'tool' as const,
} as const;

export const LatencyIntervalCategoryUtils = {
  values: Object.values(LatencyIntervalCategory),
  keys: Object.keys(LatencyIntervalCategory) as Array<keyof typeof LatencyIntervalCategory>,
  entries: Object.entries(LatencyIntervalCategory) as Array<[keyof typeof LatencyIntervalCategory, LatencyIntervalCategory]>,
  isValid: (value: any): value is LatencyIntervalCategory => Object.values(LatencyIntervalCategory).includes(value),
  fromKey: (key: keyof typeof LatencyIntervalCategory): LatencyIntervalCategory => LatencyIntervalCategory[key],
};

export type LongConversationHistoryProfile = 'compacted-page-focused' | 'fresh' | 'long-page-focused' | 'long-unrelated';

export const LongConversationHistoryProfile = {
  CompactedPageFocused: 'compacted-page-focused' as const,
  Fresh: 'fresh' as const,
  LongPageFocused: 'long-page-focused' as const,
  LongUnrelated: 'long-unrelated' as const,
} as const;

export const LongConversationHistoryProfileUtils = {
  values: Object.values(LongConversationHistoryProfile),
  keys: Object.keys(LongConversationHistoryProfile) as Array<keyof typeof LongConversationHistoryProfile>,
  entries: Object.entries(LongConversationHistoryProfile) as Array<[keyof typeof LongConversationHistoryProfile, LongConversationHistoryProfile]>,
  isValid: (value: any): value is LongConversationHistoryProfile => Object.values(LongConversationHistoryProfile).includes(value),
  fromKey: (key: keyof typeof LongConversationHistoryProfile): LongConversationHistoryProfile => LongConversationHistoryProfile[key],
};

export type McpCredentialType = 'api_key' | 'oauth';

export const McpCredentialType = {
  ApiKey: 'api_key' as const,
  OAuth: 'oauth' as const,
} as const;

export const McpCredentialTypeUtils = {
  values: Object.values(McpCredentialType),
  keys: Object.keys(McpCredentialType) as Array<keyof typeof McpCredentialType>,
  entries: Object.entries(McpCredentialType) as Array<[keyof typeof McpCredentialType, McpCredentialType]>,
  isValid: (value: any): value is McpCredentialType => Object.values(McpCredentialType).includes(value),
  fromKey: (key: keyof typeof McpCredentialType): McpCredentialType => McpCredentialType[key],
};

export type McpToolCallStatus = 'exception' | 'ok' | 'started' | 'tool_error';

export const McpToolCallStatus = {
  Exception: 'exception' as const,
  Ok: 'ok' as const,
  Started: 'started' as const,
  ToolError: 'tool_error' as const,
} as const;

export const McpToolCallStatusUtils = {
  values: Object.values(McpToolCallStatus),
  keys: Object.keys(McpToolCallStatus) as Array<keyof typeof McpToolCallStatus>,
  entries: Object.entries(McpToolCallStatus) as Array<[keyof typeof McpToolCallStatus, McpToolCallStatus]>,
  isValid: (value: any): value is McpToolCallStatus => Object.values(McpToolCallStatus).includes(value),
  fromKey: (key: keyof typeof McpToolCallStatus): McpToolCallStatus => McpToolCallStatus[key],
};

export type MessageErrorType = 'attachment_upload_failed' | 'broadcast_error' | 'generic_error' | 'invalid_audience' | 'provider_auth_error' | 'provider_overloaded' | 'provider_rate_limited' | 'provider_unavailable' | 'request_too_large' | 'tool_failed' | 'turn_attempts_exhausted' | 'worker_stopped';

export const MessageErrorType = {
  AttachmentUploadFailed: 'attachment_upload_failed' as const,
  BroadcastError: 'broadcast_error' as const,
  GenericError: 'generic_error' as const,
  InvalidAudience: 'invalid_audience' as const,
  ProviderAuthError: 'provider_auth_error' as const,
  ProviderOverloaded: 'provider_overloaded' as const,
  ProviderRateLimited: 'provider_rate_limited' as const,
  ProviderUnavailable: 'provider_unavailable' as const,
  RequestTooLarge: 'request_too_large' as const,
  ToolFailed: 'tool_failed' as const,
  TurnAttemptsExhausted: 'turn_attempts_exhausted' as const,
  WorkerStopped: 'worker_stopped' as const,
} as const;

export const MessageErrorTypeUtils = {
  values: Object.values(MessageErrorType),
  keys: Object.keys(MessageErrorType) as Array<keyof typeof MessageErrorType>,
  entries: Object.entries(MessageErrorType) as Array<[keyof typeof MessageErrorType, MessageErrorType]>,
  isValid: (value: any): value is MessageErrorType => Object.values(MessageErrorType).includes(value),
  fromKey: (key: keyof typeof MessageErrorType): MessageErrorType => MessageErrorType[key],
};

export type MessageFeedbackCategory = 'incorrect_or_incomplete' | 'not_what_i_asked_for' | 'other' | 'safety_or_legal_concern' | 'slow_or_buggy' | 'style_or_tone';

export const MessageFeedbackCategory = {
  IncorrectOrIncomplete: 'incorrect_or_incomplete' as const,
  NotWhatIAskedFor: 'not_what_i_asked_for' as const,
  Other: 'other' as const,
  SafetyOrLegalConcern: 'safety_or_legal_concern' as const,
  SlowOrBuggy: 'slow_or_buggy' as const,
  StyleOrTone: 'style_or_tone' as const,
} as const;

export const MessageFeedbackCategoryUtils = {
  values: Object.values(MessageFeedbackCategory),
  keys: Object.keys(MessageFeedbackCategory) as Array<keyof typeof MessageFeedbackCategory>,
  entries: Object.entries(MessageFeedbackCategory) as Array<[keyof typeof MessageFeedbackCategory, MessageFeedbackCategory]>,
  isValid: (value: any): value is MessageFeedbackCategory => Object.values(MessageFeedbackCategory).includes(value),
  fromKey: (key: keyof typeof MessageFeedbackCategory): MessageFeedbackCategory => MessageFeedbackCategory[key],
};

export type MessageFeedbackType = 'negative' | 'positive';

export const MessageFeedbackType = {
  Negative: 'negative' as const,
  Positive: 'positive' as const,
} as const;

export const MessageFeedbackTypeUtils = {
  values: Object.values(MessageFeedbackType),
  keys: Object.keys(MessageFeedbackType) as Array<keyof typeof MessageFeedbackType>,
  entries: Object.entries(MessageFeedbackType) as Array<[keyof typeof MessageFeedbackType, MessageFeedbackType]>,
  isValid: (value: any): value is MessageFeedbackType => Object.values(MessageFeedbackType).includes(value),
  fromKey: (key: keyof typeof MessageFeedbackType): MessageFeedbackType => MessageFeedbackType[key],
};

export type MessageRole = 'ask_user' | 'assistant' | 'compaction' | 'model_call' | 'record_mutation_plan' | 'subagent_finish' | 'subagent_start' | 'subagent_turn' | 'system' | 'thinking' | 'tool' | 'tool_call' | 'tool_result' | 'user';

export const MessageRole = {
  AskUser: 'ask_user' as const,
  Assistant: 'assistant' as const,
  Compaction: 'compaction' as const,
  ModelCall: 'model_call' as const,
  RecordMutationPlan: 'record_mutation_plan' as const,
  SubagentFinish: 'subagent_finish' as const,
  SubagentStart: 'subagent_start' as const,
  SubagentTurn: 'subagent_turn' as const,
  System: 'system' as const,
  Thinking: 'thinking' as const,
  Tool: 'tool' as const,
  ToolCall: 'tool_call' as const,
  ToolResult: 'tool_result' as const,
  User: 'user' as const,
} as const;

export const MessageRoleUtils = {
  values: Object.values(MessageRole),
  keys: Object.keys(MessageRole) as Array<keyof typeof MessageRole>,
  entries: Object.entries(MessageRole) as Array<[keyof typeof MessageRole, MessageRole]>,
  isValid: (value: any): value is MessageRole => Object.values(MessageRole).includes(value),
  fromKey: (key: keyof typeof MessageRole): MessageRole => MessageRole[key],
};

export type ModelPreset = 'auto' | 'balanced' | 'fast' | 'smart';

export const ModelPreset = {
  Auto: 'auto' as const,
  Balanced: 'balanced' as const,
  Fast: 'fast' as const,
  Smart: 'smart' as const,
} as const;

export const ModelPresetUtils = {
  values: Object.values(ModelPreset),
  keys: Object.keys(ModelPreset) as Array<keyof typeof ModelPreset>,
  entries: Object.entries(ModelPreset) as Array<[keyof typeof ModelPreset, ModelPreset]>,
  isValid: (value: any): value is ModelPreset => Object.values(ModelPreset).includes(value),
  fromKey: (key: keyof typeof ModelPreset): ModelPreset => ModelPreset[key],
};

export type NavigationPortal = 'dynamic' | 'system_admin';

export const NavigationPortal = {
  Dynamic: 'dynamic' as const,
  SystemAdmin: 'system_admin' as const,
} as const;

export const NavigationPortalUtils = {
  values: Object.values(NavigationPortal),
  keys: Object.keys(NavigationPortal) as Array<keyof typeof NavigationPortal>,
  entries: Object.entries(NavigationPortal) as Array<[keyof typeof NavigationPortal, NavigationPortal]>,
  isValid: (value: any): value is NavigationPortal => Object.values(NavigationPortal).includes(value),
  fromKey: (key: keyof typeof NavigationPortal): NavigationPortal => NavigationPortal[key],
};

export type OpenRouterReasoningEffort = 'high' | 'low' | 'medium' | 'minimal' | 'none' | 'xhigh';

export const OpenRouterReasoningEffort = {
  High: 'high' as const,
  Low: 'low' as const,
  Medium: 'medium' as const,
  Minimal: 'minimal' as const,
  None: 'none' as const,
  Xhigh: 'xhigh' as const,
} as const;

export const OpenRouterReasoningEffortUtils = {
  values: Object.values(OpenRouterReasoningEffort),
  keys: Object.keys(OpenRouterReasoningEffort) as Array<keyof typeof OpenRouterReasoningEffort>,
  entries: Object.entries(OpenRouterReasoningEffort) as Array<[keyof typeof OpenRouterReasoningEffort, OpenRouterReasoningEffort]>,
  isValid: (value: any): value is OpenRouterReasoningEffort => Object.values(OpenRouterReasoningEffort).includes(value),
  fromKey: (key: keyof typeof OpenRouterReasoningEffort): OpenRouterReasoningEffort => OpenRouterReasoningEffort[key],
};

export type PlatformOperatorCapability = 'describe_database_schema' | 'diff_workspace_page' | 'execute_page_change_set' | 'execute_workspace_code' | 'explain_query' | 'export_workspace' | 'filter_workspace_api_endpoints' | 'flag_conversations' | 'get_ai_spend' | 'get_conversation_latency_breakdown' | 'get_email_message' | 'get_platform_health' | 'get_platform_stats' | 'get_queue_stats' | 'get_workflow_execution' | 'get_workflow_execution_analytics' | 'get_workspace_workflow' | 'list_conversations' | 'list_email_messages' | 'list_sandbox_executions' | 'list_workflow_executions' | 'notify_slack' | 'preview_workspace_page' | 'publish_workspace_page' | 'query_database' | 'query_data_lake' | 'query_workspace_records' | 'rank_conversations' | 'rebuild_embeddings' | 'rebuild_sitemap' | 'recover_stuck_workflow_executions' | 'run_page_codemod' | 'search_workspace_api_endpoints' | 'search_workspace_workflows' | 'stage_page_change_set' | 'sync_default_system_fields' | 'validate_email_sending_domains';

export const PlatformOperatorCapability = {
  DescribeDatabaseSchema: 'describe_database_schema' as const,
  DiffWorkspacePage: 'diff_workspace_page' as const,
  ExecutePageChangeSet: 'execute_page_change_set' as const,
  ExecuteWorkspaceCode: 'execute_workspace_code' as const,
  ExplainQuery: 'explain_query' as const,
  ExportWorkspace: 'export_workspace' as const,
  FilterWorkspaceApiEndpoints: 'filter_workspace_api_endpoints' as const,
  FlagConversations: 'flag_conversations' as const,
  GetAiSpend: 'get_ai_spend' as const,
  GetConversationLatencyBreakdown: 'get_conversation_latency_breakdown' as const,
  GetEmailMessage: 'get_email_message' as const,
  GetPlatformHealth: 'get_platform_health' as const,
  GetPlatformStats: 'get_platform_stats' as const,
  GetQueueStats: 'get_queue_stats' as const,
  GetWorkflowExecution: 'get_workflow_execution' as const,
  GetWorkflowExecutionAnalytics: 'get_workflow_execution_analytics' as const,
  GetWorkspaceWorkflow: 'get_workspace_workflow' as const,
  ListConversations: 'list_conversations' as const,
  ListEmailMessages: 'list_email_messages' as const,
  ListSandboxExecutions: 'list_sandbox_executions' as const,
  ListWorkflowExecutions: 'list_workflow_executions' as const,
  NotifySlack: 'notify_slack' as const,
  PreviewWorkspacePage: 'preview_workspace_page' as const,
  PublishWorkspacePage: 'publish_workspace_page' as const,
  QueryDatabase: 'query_database' as const,
  QueryDataLake: 'query_data_lake' as const,
  QueryWorkspaceRecords: 'query_workspace_records' as const,
  RankConversations: 'rank_conversations' as const,
  RebuildEmbeddings: 'rebuild_embeddings' as const,
  RebuildSitemap: 'rebuild_sitemap' as const,
  RecoverStuckWorkflowExecutions: 'recover_stuck_workflow_executions' as const,
  RunPageCodemod: 'run_page_codemod' as const,
  SearchWorkspaceApiEndpoints: 'search_workspace_api_endpoints' as const,
  SearchWorkspaceWorkflows: 'search_workspace_workflows' as const,
  StagePageChangeSet: 'stage_page_change_set' as const,
  SyncDefaultSystemFields: 'sync_default_system_fields' as const,
  ValidateEmailSendingDomains: 'validate_email_sending_domains' as const,
} as const;

export const PlatformOperatorCapabilityUtils = {
  values: Object.values(PlatformOperatorCapability),
  keys: Object.keys(PlatformOperatorCapability) as Array<keyof typeof PlatformOperatorCapability>,
  entries: Object.entries(PlatformOperatorCapability) as Array<[keyof typeof PlatformOperatorCapability, PlatformOperatorCapability]>,
  isValid: (value: any): value is PlatformOperatorCapability => Object.values(PlatformOperatorCapability).includes(value),
  fromKey: (key: keyof typeof PlatformOperatorCapability): PlatformOperatorCapability => PlatformOperatorCapability[key],
};

export type RecordMutationPlanStatus = 'completed' | 'failed' | 'failed_retryable' | 'partially_applied' | 'pending' | 'superseded';

export const RecordMutationPlanStatus = {
  Completed: 'completed' as const,
  Failed: 'failed' as const,
  FailedRetryable: 'failed_retryable' as const,
  PartiallyApplied: 'partially_applied' as const,
  Pending: 'pending' as const,
  Superseded: 'superseded' as const,
} as const;

export const RecordMutationPlanStatusUtils = {
  values: Object.values(RecordMutationPlanStatus),
  keys: Object.keys(RecordMutationPlanStatus) as Array<keyof typeof RecordMutationPlanStatus>,
  entries: Object.entries(RecordMutationPlanStatus) as Array<[keyof typeof RecordMutationPlanStatus, RecordMutationPlanStatus]>,
  isValid: (value: any): value is RecordMutationPlanStatus => Object.values(RecordMutationPlanStatus).includes(value),
  fromKey: (key: keyof typeof RecordMutationPlanStatus): RecordMutationPlanStatus => RecordMutationPlanStatus[key],
};

export type SandboxExecutionEventType = 'execution_finished' | 'execution_started' | 'record_validated';

export const SandboxExecutionEventType = {
  ExecutionFinished: 'execution_finished' as const,
  ExecutionStarted: 'execution_started' as const,
  RecordValidated: 'record_validated' as const,
} as const;

export const SandboxExecutionEventTypeUtils = {
  values: Object.values(SandboxExecutionEventType),
  keys: Object.keys(SandboxExecutionEventType) as Array<keyof typeof SandboxExecutionEventType>,
  entries: Object.entries(SandboxExecutionEventType) as Array<[keyof typeof SandboxExecutionEventType, SandboxExecutionEventType]>,
  isValid: (value: any): value is SandboxExecutionEventType => Object.values(SandboxExecutionEventType).includes(value),
  fromKey: (key: keyof typeof SandboxExecutionEventType): SandboxExecutionEventType => SandboxExecutionEventType[key],
};

export type SandboxExecutionRequestStatus = 'completed' | 'failed' | 'queued' | 'running';

export const SandboxExecutionRequestStatus = {
  Completed: 'completed' as const,
  Failed: 'failed' as const,
  Queued: 'queued' as const,
  Running: 'running' as const,
} as const;

export const SandboxExecutionRequestStatusUtils = {
  values: Object.values(SandboxExecutionRequestStatus),
  keys: Object.keys(SandboxExecutionRequestStatus) as Array<keyof typeof SandboxExecutionRequestStatus>,
  entries: Object.entries(SandboxExecutionRequestStatus) as Array<[keyof typeof SandboxExecutionRequestStatus, SandboxExecutionRequestStatus]>,
  isValid: (value: any): value is SandboxExecutionRequestStatus => Object.values(SandboxExecutionRequestStatus).includes(value),
  fromKey: (key: keyof typeof SandboxExecutionRequestStatus): SandboxExecutionRequestStatus => SandboxExecutionRequestStatus[key],
};

export type SubagentStatus = 'answered' | 'completed' | 'failed' | 'interrupted' | 'needs_approval' | 'needs_clarification' | 'no_change_needed' | 'not_found' | 'partial' | 'planned' | 'platform_blocked';

export const SubagentStatus = {
  Answered: 'answered' as const,
  Completed: 'completed' as const,
  Failed: 'failed' as const,
  Interrupted: 'interrupted' as const,
  NeedsApproval: 'needs_approval' as const,
  NeedsClarification: 'needs_clarification' as const,
  NoChangeNeeded: 'no_change_needed' as const,
  NotFound: 'not_found' as const,
  Partial: 'partial' as const,
  Planned: 'planned' as const,
  PlatformBlocked: 'platform_blocked' as const,
} as const;

export const SubagentStatusUtils = {
  values: Object.values(SubagentStatus),
  keys: Object.keys(SubagentStatus) as Array<keyof typeof SubagentStatus>,
  entries: Object.entries(SubagentStatus) as Array<[keyof typeof SubagentStatus, SubagentStatus]>,
  isValid: (value: any): value is SubagentStatus => Object.values(SubagentStatus).includes(value),
  fromKey: (key: keyof typeof SubagentStatus): SubagentStatus => SubagentStatus[key],
};

export type ToolingGapDispatch = 'immediate' | 'queued';

export const ToolingGapDispatch = {
  Immediate: 'immediate' as const,
  Queued: 'queued' as const,
} as const;

export const ToolingGapDispatchUtils = {
  values: Object.values(ToolingGapDispatch),
  keys: Object.keys(ToolingGapDispatch) as Array<keyof typeof ToolingGapDispatch>,
  entries: Object.entries(ToolingGapDispatch) as Array<[keyof typeof ToolingGapDispatch, ToolingGapDispatch]>,
  isValid: (value: any): value is ToolingGapDispatch => Object.values(ToolingGapDispatch).includes(value),
  fromKey: (key: keyof typeof ToolingGapDispatch): ToolingGapDispatch => ToolingGapDispatch[key],
};

export type ToolingGapReportKind = 'capability_gap' | 'locked_template_change';

export const ToolingGapReportKind = {
  CapabilityGap: 'capability_gap' as const,
  LockedTemplateChange: 'locked_template_change' as const,
} as const;

export const ToolingGapReportKindUtils = {
  values: Object.values(ToolingGapReportKind),
  keys: Object.keys(ToolingGapReportKind) as Array<keyof typeof ToolingGapReportKind>,
  entries: Object.entries(ToolingGapReportKind) as Array<[keyof typeof ToolingGapReportKind, ToolingGapReportKind]>,
  isValid: (value: any): value is ToolingGapReportKind => Object.values(ToolingGapReportKind).includes(value),
  fromKey: (key: keyof typeof ToolingGapReportKind): ToolingGapReportKind => ToolingGapReportKind[key],
};

export type ToolingGapReportStatus = 'already_filed' | 'failed' | 'filed' | 'not_configured';

export const ToolingGapReportStatus = {
  AlreadyFiled: 'already_filed' as const,
  Failed: 'failed' as const,
  Filed: 'filed' as const,
  NotConfigured: 'not_configured' as const,
} as const;

export const ToolingGapReportStatusUtils = {
  values: Object.values(ToolingGapReportStatus),
  keys: Object.keys(ToolingGapReportStatus) as Array<keyof typeof ToolingGapReportStatus>,
  entries: Object.entries(ToolingGapReportStatus) as Array<[keyof typeof ToolingGapReportStatus, ToolingGapReportStatus]>,
  isValid: (value: any): value is ToolingGapReportStatus => Object.values(ToolingGapReportStatus).includes(value),
  fromKey: (key: keyof typeof ToolingGapReportStatus): ToolingGapReportStatus => ToolingGapReportStatus[key],
};

export type TurnStatus = 'completed' | 'failed' | 'pending';

export const TurnStatus = {
  Completed: 'completed' as const,
  Failed: 'failed' as const,
  Pending: 'pending' as const,
} as const;

export const TurnStatusUtils = {
  values: Object.values(TurnStatus),
  keys: Object.keys(TurnStatus) as Array<keyof typeof TurnStatus>,
  entries: Object.entries(TurnStatus) as Array<[keyof typeof TurnStatus, TurnStatus]>,
  isValid: (value: any): value is TurnStatus => Object.values(TurnStatus).includes(value),
  fromKey: (key: keyof typeof TurnStatus): TurnStatus => TurnStatus[key],
};

export type AuthenticationAuditActorType = 'staff_user' | 'workspace_user';

export const AuthenticationAuditActorType = {
  StaffUser: 'staff_user' as const,
  WorkspaceUser: 'workspace_user' as const,
} as const;

export const AuthenticationAuditActorTypeUtils = {
  values: Object.values(AuthenticationAuditActorType),
  keys: Object.keys(AuthenticationAuditActorType) as Array<keyof typeof AuthenticationAuditActorType>,
  entries: Object.entries(AuthenticationAuditActorType) as Array<[keyof typeof AuthenticationAuditActorType, AuthenticationAuditActorType]>,
  isValid: (value: any): value is AuthenticationAuditActorType => Object.values(AuthenticationAuditActorType).includes(value),
  fromKey: (key: keyof typeof AuthenticationAuditActorType): AuthenticationAuditActorType => AuthenticationAuditActorType[key],
};

export type AuthenticationAuditEventType = 'email_identification' | 'impersonation_ended' | 'impersonation_started' | 'magic_link_requested' | 'magic_link_verification' | 'password_changed' | 'password_reset' | 'password_reset_requested' | 'password_verification' | 'rate_limited' | 'session_revoked' | 'set_password_link_issued' | 'sign_in' | 'sign_out' | 'step_up_code_requested' | 'step_up_verification' | 'trusted_device_issued' | 'trusted_devices_revoked' | 'trusted_device_used' | 'two_factor_challenge' | 'two_factor_code_resent' | 'two_factor_verification';

export const AuthenticationAuditEventType = {
  EmailIdentification: 'email_identification' as const,
  ImpersonationEnded: 'impersonation_ended' as const,
  ImpersonationStarted: 'impersonation_started' as const,
  MagicLinkRequested: 'magic_link_requested' as const,
  MagicLinkVerification: 'magic_link_verification' as const,
  PasswordChanged: 'password_changed' as const,
  PasswordReset: 'password_reset' as const,
  PasswordResetRequested: 'password_reset_requested' as const,
  PasswordVerification: 'password_verification' as const,
  RateLimited: 'rate_limited' as const,
  SessionRevoked: 'session_revoked' as const,
  SetPasswordLinkIssued: 'set_password_link_issued' as const,
  SignIn: 'sign_in' as const,
  SignOut: 'sign_out' as const,
  StepUpCodeRequested: 'step_up_code_requested' as const,
  StepUpVerification: 'step_up_verification' as const,
  TrustedDeviceIssued: 'trusted_device_issued' as const,
  TrustedDevicesRevoked: 'trusted_devices_revoked' as const,
  TrustedDeviceUsed: 'trusted_device_used' as const,
  TwoFactorChallenge: 'two_factor_challenge' as const,
  TwoFactorCodeResent: 'two_factor_code_resent' as const,
  TwoFactorVerification: 'two_factor_verification' as const,
} as const;

export const AuthenticationAuditEventTypeUtils = {
  values: Object.values(AuthenticationAuditEventType),
  keys: Object.keys(AuthenticationAuditEventType) as Array<keyof typeof AuthenticationAuditEventType>,
  entries: Object.entries(AuthenticationAuditEventType) as Array<[keyof typeof AuthenticationAuditEventType, AuthenticationAuditEventType]>,
  isValid: (value: any): value is AuthenticationAuditEventType => Object.values(AuthenticationAuditEventType).includes(value),
  fromKey: (key: keyof typeof AuthenticationAuditEventType): AuthenticationAuditEventType => AuthenticationAuditEventType[key],
};

export type AuthenticationAuditOutcome = 'failure' | 'success';

export const AuthenticationAuditOutcome = {
  Failure: 'failure' as const,
  Success: 'success' as const,
} as const;

export const AuthenticationAuditOutcomeUtils = {
  values: Object.values(AuthenticationAuditOutcome),
  keys: Object.keys(AuthenticationAuditOutcome) as Array<keyof typeof AuthenticationAuditOutcome>,
  entries: Object.entries(AuthenticationAuditOutcome) as Array<[keyof typeof AuthenticationAuditOutcome, AuthenticationAuditOutcome]>,
  isValid: (value: any): value is AuthenticationAuditOutcome => Object.values(AuthenticationAuditOutcome).includes(value),
  fromKey: (key: keyof typeof AuthenticationAuditOutcome): AuthenticationAuditOutcome => AuthenticationAuditOutcome[key],
};

export type AuthenticationAuditReason = 'authentication_disabled' | 'challenge_expired' | 'credential_removed' | 'delivery_failed' | 'invalid_code' | 'invalid_credentials' | 'invalid_token' | 'missing_phone' | 'not_configured' | 'outbound_email_disabled' | 'password_changed' | 'rate_limited' | 'too_many_attempts' | 'unknown_account';

export const AuthenticationAuditReason = {
  AuthenticationDisabled: 'authentication_disabled' as const,
  ChallengeExpired: 'challenge_expired' as const,
  CredentialRemoved: 'credential_removed' as const,
  DeliveryFailed: 'delivery_failed' as const,
  InvalidCode: 'invalid_code' as const,
  InvalidCredentials: 'invalid_credentials' as const,
  InvalidToken: 'invalid_token' as const,
  MissingPhone: 'missing_phone' as const,
  NotConfigured: 'not_configured' as const,
  OutboundEmailDisabled: 'outbound_email_disabled' as const,
  PasswordChanged: 'password_changed' as const,
  RateLimited: 'rate_limited' as const,
  TooManyAttempts: 'too_many_attempts' as const,
  UnknownAccount: 'unknown_account' as const,
} as const;

export const AuthenticationAuditReasonUtils = {
  values: Object.values(AuthenticationAuditReason),
  keys: Object.keys(AuthenticationAuditReason) as Array<keyof typeof AuthenticationAuditReason>,
  entries: Object.entries(AuthenticationAuditReason) as Array<[keyof typeof AuthenticationAuditReason, AuthenticationAuditReason]>,
  isValid: (value: any): value is AuthenticationAuditReason => Object.values(AuthenticationAuditReason).includes(value),
  fromKey: (key: keyof typeof AuthenticationAuditReason): AuthenticationAuditReason => AuthenticationAuditReason[key],
};

export type AuthenticationMethod = 'magic_link' | 'password' | 'password_reset' | 'recovery_code' | 'sms' | 'workflow';

export const AuthenticationMethod = {
  MagicLink: 'magic_link' as const,
  Password: 'password' as const,
  PasswordReset: 'password_reset' as const,
  RecoveryCode: 'recovery_code' as const,
  Sms: 'sms' as const,
  Workflow: 'workflow' as const,
} as const;

export const AuthenticationMethodUtils = {
  values: Object.values(AuthenticationMethod),
  keys: Object.keys(AuthenticationMethod) as Array<keyof typeof AuthenticationMethod>,
  entries: Object.entries(AuthenticationMethod) as Array<[keyof typeof AuthenticationMethod, AuthenticationMethod]>,
  isValid: (value: any): value is AuthenticationMethod => Object.values(AuthenticationMethod).includes(value),
  fromKey: (key: keyof typeof AuthenticationMethod): AuthenticationMethod => AuthenticationMethod[key],
};

export type OAuthRedirectTargetKind = 'app' | 'device' | 'website';

export const OAuthRedirectTargetKind = {
  App: 'app' as const,
  Device: 'device' as const,
  Website: 'website' as const,
} as const;

export const OAuthRedirectTargetKindUtils = {
  values: Object.values(OAuthRedirectTargetKind),
  keys: Object.keys(OAuthRedirectTargetKind) as Array<keyof typeof OAuthRedirectTargetKind>,
  entries: Object.entries(OAuthRedirectTargetKind) as Array<[keyof typeof OAuthRedirectTargetKind, OAuthRedirectTargetKind]>,
  isValid: (value: any): value is OAuthRedirectTargetKind => Object.values(OAuthRedirectTargetKind).includes(value),
  fromKey: (key: keyof typeof OAuthRedirectTargetKind): OAuthRedirectTargetKind => OAuthRedirectTargetKind[key],
};

export type PlatformApiTokenScope = 'ai-debug:read';

export const PlatformApiTokenScope = {
  AiDebugRead: 'ai-debug:read' as const,
} as const;

export const PlatformApiTokenScopeUtils = {
  values: Object.values(PlatformApiTokenScope),
  keys: Object.keys(PlatformApiTokenScope) as Array<keyof typeof PlatformApiTokenScope>,
  entries: Object.entries(PlatformApiTokenScope) as Array<[keyof typeof PlatformApiTokenScope, PlatformApiTokenScope]>,
  isValid: (value: any): value is PlatformApiTokenScope => Object.values(PlatformApiTokenScope).includes(value),
  fromKey: (key: keyof typeof PlatformApiTokenScope): PlatformApiTokenScope => PlatformApiTokenScope[key],
};

export type AppOriginKind = 'ai_conversation' | 'api' | 'browser' | 'import' | 'mcp' | 'sandbox' | 'workflow';

export const AppOriginKind = {
  AiConversation: 'ai_conversation' as const,
  Api: 'api' as const,
  Browser: 'browser' as const,
  Import: 'import' as const,
  Mcp: 'mcp' as const,
  Sandbox: 'sandbox' as const,
  Workflow: 'workflow' as const,
} as const;

export const AppOriginKindUtils = {
  values: Object.values(AppOriginKind),
  keys: Object.keys(AppOriginKind) as Array<keyof typeof AppOriginKind>,
  entries: Object.entries(AppOriginKind) as Array<[keyof typeof AppOriginKind, AppOriginKind]>,
  isValid: (value: any): value is AppOriginKind => Object.values(AppOriginKind).includes(value),
  fromKey: (key: keyof typeof AppOriginKind): AppOriginKind => AppOriginKind[key],
};

export type AppSideEffect = 'lifecycle_workflows' | 'media_keywords' | 'outbound_emails' | 'outbound_sms' | 'record_event_workflows';

export const AppSideEffect = {
  LifecycleWorkflows: 'lifecycle_workflows' as const,
  MediaKeywords: 'media_keywords' as const,
  OutboundEmails: 'outbound_emails' as const,
  OutboundSms: 'outbound_sms' as const,
  RecordEventWorkflows: 'record_event_workflows' as const,
} as const;

export const AppSideEffectUtils = {
  values: Object.values(AppSideEffect),
  keys: Object.keys(AppSideEffect) as Array<keyof typeof AppSideEffect>,
  entries: Object.entries(AppSideEffect) as Array<[keyof typeof AppSideEffect, AppSideEffect]>,
  isValid: (value: any): value is AppSideEffect => Object.values(AppSideEffect).includes(value),
  fromKey: (key: keyof typeof AppSideEffect): AppSideEffect => AppSideEffect[key],
};

export type AuthenticatableField = 'authentication_enabled_field' | 'email_field' | 'password_field' | 'roles_field';

export const AuthenticatableField = {
  AuthenticationEnabled: 'authentication_enabled_field' as const,
  Email: 'email_field' as const,
  Password: 'password_field' as const,
  Roles: 'roles_field' as const,
} as const;

export const AuthenticatableFieldUtils = {
  values: Object.values(AuthenticatableField),
  keys: Object.keys(AuthenticatableField) as Array<keyof typeof AuthenticatableField>,
  entries: Object.entries(AuthenticatableField) as Array<[keyof typeof AuthenticatableField, AuthenticatableField]>,
  isValid: (value: any): value is AuthenticatableField => Object.values(AuthenticatableField).includes(value),
  fromKey: (key: keyof typeof AuthenticatableField): AuthenticatableField => AuthenticatableField[key],
};

export type AuthorizationStorageMode = 'legacy' | 'resource';

export const AuthorizationStorageMode = {
  Legacy: 'legacy' as const,
  Resource: 'resource' as const,
} as const;

export const AuthorizationStorageModeUtils = {
  values: Object.values(AuthorizationStorageMode),
  keys: Object.keys(AuthorizationStorageMode) as Array<keyof typeof AuthorizationStorageMode>,
  entries: Object.entries(AuthorizationStorageMode) as Array<[keyof typeof AuthorizationStorageMode, AuthorizationStorageMode]>,
  isValid: (value: any): value is AuthorizationStorageMode => Object.values(AuthorizationStorageMode).includes(value),
  fromKey: (key: keyof typeof AuthorizationStorageMode): AuthorizationStorageMode => AuthorizationStorageMode[key],
};

export type AvailabilityField = 'effect_field' | 'schedulable_relation';

export const AvailabilityField = {
  Effect: 'effect_field' as const,
  Schedulable: 'schedulable_relation' as const,
} as const;

export const AvailabilityFieldUtils = {
  values: Object.values(AvailabilityField),
  keys: Object.keys(AvailabilityField) as Array<keyof typeof AvailabilityField>,
  entries: Object.entries(AvailabilityField) as Array<[keyof typeof AvailabilityField, AvailabilityField]>,
  isValid: (value: any): value is AvailabilityField => Object.values(AvailabilityField).includes(value),
  fromKey: (key: keyof typeof AvailabilityField): AvailabilityField => AvailabilityField[key],
};

export type BookingField = 'end_field' | 'hold_expires_field' | 'idempotency_field' | 'quantity_field' | 'source_status_field' | 'start_field' | 'status_field' | 'status_source_relation' | 'time_source_relation';

export const BookingField = {
  End: 'end_field' as const,
  HoldExpires: 'hold_expires_field' as const,
  Idempotency: 'idempotency_field' as const,
  Quantity: 'quantity_field' as const,
  SourceStatus: 'source_status_field' as const,
  Start: 'start_field' as const,
  Status: 'status_field' as const,
  StatusSource: 'status_source_relation' as const,
  TimeSource: 'time_source_relation' as const,
} as const;

export const BookingFieldUtils = {
  values: Object.values(BookingField),
  keys: Object.keys(BookingField) as Array<keyof typeof BookingField>,
  entries: Object.entries(BookingField) as Array<[keyof typeof BookingField, BookingField]>,
  isValid: (value: any): value is BookingField => Object.values(BookingField).includes(value),
  fromKey: (key: keyof typeof BookingField): BookingField => BookingField[key],
};

export type CapabilityDefinitionType = 'resource';

export const CapabilityDefinitionType = {
  Resource: 'resource' as const,
} as const;

export const CapabilityDefinitionTypeUtils = {
  values: Object.values(CapabilityDefinitionType),
  keys: Object.keys(CapabilityDefinitionType) as Array<keyof typeof CapabilityDefinitionType>,
  entries: Object.entries(CapabilityDefinitionType) as Array<[keyof typeof CapabilityDefinitionType, CapabilityDefinitionType]>,
  isValid: (value: any): value is CapabilityDefinitionType => Object.values(CapabilityDefinitionType).includes(value),
  fromKey: (key: keyof typeof CapabilityDefinitionType): CapabilityDefinitionType => CapabilityDefinitionType[key],
};

export type CapabilityHookType = 'after_archive' | 'after_create' | 'after_restore' | 'after_save' | 'after_update' | 'before_archive' | 'before_create' | 'before_persist' | 'before_restore' | 'before_save' | 'before_update' | 'before_update_write' | 'before_validate';

export const CapabilityHookType = {
  AfterArchive: 'after_archive' as const,
  AfterCreate: 'after_create' as const,
  AfterRestore: 'after_restore' as const,
  AfterSave: 'after_save' as const,
  AfterUpdate: 'after_update' as const,
  BeforeArchive: 'before_archive' as const,
  BeforeCreate: 'before_create' as const,
  BeforePersist: 'before_persist' as const,
  BeforeRestore: 'before_restore' as const,
  BeforeSave: 'before_save' as const,
  BeforeUpdate: 'before_update' as const,
  BeforeUpdateWrite: 'before_update_write' as const,
  BeforeValidate: 'before_validate' as const,
} as const;

export const CapabilityHookTypeUtils = {
  values: Object.values(CapabilityHookType),
  keys: Object.keys(CapabilityHookType) as Array<keyof typeof CapabilityHookType>,
  entries: Object.entries(CapabilityHookType) as Array<[keyof typeof CapabilityHookType, CapabilityHookType]>,
  isValid: (value: any): value is CapabilityHookType => Object.values(CapabilityHookType).includes(value),
  fromKey: (key: keyof typeof CapabilityHookType): CapabilityHookType => CapabilityHookType[key],
};

export type CapabilityMaintenanceOperation = 'backfill-invoice-source-subscriptions' | 'recalculate-payables' | 'resolve-subscription-statuses';

export const CapabilityMaintenanceOperation = {
  BackfillInvoiceSourceSubscriptions: 'backfill-invoice-source-subscriptions' as const,
  RecalculatePayables: 'recalculate-payables' as const,
  ResolveSubscriptionStatuses: 'resolve-subscription-statuses' as const,
} as const;

export const CapabilityMaintenanceOperationUtils = {
  values: Object.values(CapabilityMaintenanceOperation),
  keys: Object.keys(CapabilityMaintenanceOperation) as Array<keyof typeof CapabilityMaintenanceOperation>,
  entries: Object.entries(CapabilityMaintenanceOperation) as Array<[keyof typeof CapabilityMaintenanceOperation, CapabilityMaintenanceOperation]>,
  isValid: (value: any): value is CapabilityMaintenanceOperation => Object.values(CapabilityMaintenanceOperation).includes(value),
  fromKey: (key: keyof typeof CapabilityMaintenanceOperation): CapabilityMaintenanceOperation => CapabilityMaintenanceOperation[key],
};

export type CapabilityType = 'authenticatable' | 'availability' | 'booking' | 'eventable' | 'itemizable' | 'lockable' | 'notifiable' | 'payable' | 'payable_adjustment' | 'payer' | 'payer_balance_entry' | 'payment' | 'payment_method' | 'permission' | 'price' | 'product' | 'refund' | 'revenue_accounting' | 'role' | 'schedulable' | 'subscription' | 'subscription_discount' | 'subscription_item' | 'subscription_period';

export const CapabilityType = {
  Authenticatable: 'authenticatable' as const,
  Availability: 'availability' as const,
  Booking: 'booking' as const,
  Eventable: 'eventable' as const,
  Itemizable: 'itemizable' as const,
  Lockable: 'lockable' as const,
  Notifiable: 'notifiable' as const,
  Payable: 'payable' as const,
  PayableAdjustment: 'payable_adjustment' as const,
  Payer: 'payer' as const,
  PayerBalanceEntry: 'payer_balance_entry' as const,
  Payment: 'payment' as const,
  PaymentMethod: 'payment_method' as const,
  Permission: 'permission' as const,
  Price: 'price' as const,
  Product: 'product' as const,
  Refund: 'refund' as const,
  RevenueAccounting: 'revenue_accounting' as const,
  Role: 'role' as const,
  Schedulable: 'schedulable' as const,
  Subscription: 'subscription' as const,
  SubscriptionDiscount: 'subscription_discount' as const,
  SubscriptionItem: 'subscription_item' as const,
  SubscriptionPeriod: 'subscription_period' as const,
} as const;

export const CapabilityTypeUtils = {
  values: Object.values(CapabilityType),
  keys: Object.keys(CapabilityType) as Array<keyof typeof CapabilityType>,
  entries: Object.entries(CapabilityType) as Array<[keyof typeof CapabilityType, CapabilityType]>,
  isValid: (value: any): value is CapabilityType => Object.values(CapabilityType).includes(value),
  fromKey: (key: keyof typeof CapabilityType): CapabilityType => CapabilityType[key],
};

export type ComponentType = 'code' | 'layout';

export const ComponentType = {
  Code: 'code' as const,
  Layout: 'layout' as const,
} as const;

export const ComponentTypeUtils = {
  values: Object.values(ComponentType),
  keys: Object.keys(ComponentType) as Array<keyof typeof ComponentType>,
  entries: Object.entries(ComponentType) as Array<[keyof typeof ComponentType, ComponentType]>,
  isValid: (value: any): value is ComponentType => Object.values(ComponentType).includes(value),
  fromKey: (key: keyof typeof ComponentType): ComponentType => ComponentType[key],
};

export type DynamicDisplayType = 'boolean' | 'color' | 'content' | 'date' | 'datetime' | 'dictionary' | 'email' | 'event_schedule' | 'file' | 'list' | 'location' | 'markdown' | 'money' | 'number' | 'password' | 'phone' | 'point' | 'recurrence' | 'regular_hours' | 'relation' | 'resource' | 'select' | 'text' | 'time' | 'timezone' | 'wallet_accounting_account' | 'wallet_accounting_entity';

export const DynamicDisplayType = {
  Boolean: 'boolean' as const,
  Color: 'color' as const,
  Content: 'content' as const,
  Date: 'date' as const,
  Datetime: 'datetime' as const,
  Dictionary: 'dictionary' as const,
  Email: 'email' as const,
  EventSchedule: 'event_schedule' as const,
  File: 'file' as const,
  List: 'list' as const,
  Location: 'location' as const,
  Markdown: 'markdown' as const,
  Money: 'money' as const,
  Number: 'number' as const,
  Password: 'password' as const,
  Phone: 'phone' as const,
  Point: 'point' as const,
  Recurrence: 'recurrence' as const,
  RegularHours: 'regular_hours' as const,
  Relation: 'relation' as const,
  Resource: 'resource' as const,
  Select: 'select' as const,
  Text: 'text' as const,
  Time: 'time' as const,
  Timezone: 'timezone' as const,
  WalletAccountingAccount: 'wallet_accounting_account' as const,
  WalletAccountingEntity: 'wallet_accounting_entity' as const,
} as const;

export const DynamicDisplayTypeUtils = {
  values: Object.values(DynamicDisplayType),
  keys: Object.keys(DynamicDisplayType) as Array<keyof typeof DynamicDisplayType>,
  entries: Object.entries(DynamicDisplayType) as Array<[keyof typeof DynamicDisplayType, DynamicDisplayType]>,
  isValid: (value: any): value is DynamicDisplayType => Object.values(DynamicDisplayType).includes(value),
  fromKey: (key: keyof typeof DynamicDisplayType): DynamicDisplayType => DynamicDisplayType[key],
};

export type DynamicFieldType = 'boolean' | 'boolean_filter' | 'checkbox_group' | 'code' | 'color' | 'combobox' | 'component' | 'content' | 'content_type_settings' | 'css_classes' | 'data_grid_column_definitions' | 'date' | 'datetime' | 'dictionary' | 'dynamic' | 'email_layout_fields_input' | 'email_layout_select' | 'event_handler' | 'event_schedule' | 'file' | 'filter' | 'font' | 'guard_rules' | 'icon' | 'inline_select' | 'interval' | 'json' | 'list' | 'location' | 'markdown' | 'money' | 'navigation_menu' | 'none' | 'number' | 'operation_options' | 'page' | 'password' | 'phone' | 'plain_text' | 'point' | 'rating' | 'record' | 'recurrence' | 'regular_hours' | 'relation' | 'resource' | 'resource_field' | 'resource_field_key' | 'resource_field_value' | 'resource_field_value_entries' | 'resource_field_value_mapper' | 'resource_relation' | 'rich_text' | 'role' | 'schema' | 'schema_key' | 'select' | 'select_options' | 'success_redirect' | 'task' | 'text' | 'textarea' | 'time' | 'timezone' | 'unknown' | 'url' | 'wallet_accounting_account' | 'wallet_accounting_entity' | 'workflow' | 'workflow_fields_input' | 'workflow_select' | 'workflow_variable';

export const DynamicFieldType = {
  Boolean: 'boolean' as const,
  BooleanFilter: 'boolean_filter' as const,
  CheckboxGroup: 'checkbox_group' as const,
  Code: 'code' as const,
  Color: 'color' as const,
  Combobox: 'combobox' as const,
  Component: 'component' as const,
  Content: 'content' as const,
  ContentTypeSettings: 'content_type_settings' as const,
  CssClasses: 'css_classes' as const,
  DataGridColumnDefinitions: 'data_grid_column_definitions' as const,
  Date: 'date' as const,
  Datetime: 'datetime' as const,
  Dictionary: 'dictionary' as const,
  Dynamic: 'dynamic' as const,
  EmailLayoutFieldsInput: 'email_layout_fields_input' as const,
  EmailLayoutSelect: 'email_layout_select' as const,
  EventHandler: 'event_handler' as const,
  EventSchedule: 'event_schedule' as const,
  File: 'file' as const,
  Filter: 'filter' as const,
  Font: 'font' as const,
  GuardRules: 'guard_rules' as const,
  Icon: 'icon' as const,
  InlineSelect: 'inline_select' as const,
  Interval: 'interval' as const,
  Json: 'json' as const,
  List: 'list' as const,
  Location: 'location' as const,
  Markdown: 'markdown' as const,
  Money: 'money' as const,
  NavigationMenu: 'navigation_menu' as const,
  None: 'none' as const,
  Number: 'number' as const,
  OperationOptions: 'operation_options' as const,
  Page: 'page' as const,
  Password: 'password' as const,
  Phone: 'phone' as const,
  PlainText: 'plain_text' as const,
  Point: 'point' as const,
  Rating: 'rating' as const,
  Record: 'record' as const,
  Recurrence: 'recurrence' as const,
  RegularHours: 'regular_hours' as const,
  Relation: 'relation' as const,
  Resource: 'resource' as const,
  ResourceField: 'resource_field' as const,
  ResourceFieldKey: 'resource_field_key' as const,
  ResourceFieldValue: 'resource_field_value' as const,
  ResourceFieldValueEntries: 'resource_field_value_entries' as const,
  ResourceFieldValueMapper: 'resource_field_value_mapper' as const,
  ResourceRelation: 'resource_relation' as const,
  RichText: 'rich_text' as const,
  Role: 'role' as const,
  Schema: 'schema' as const,
  SchemaKey: 'schema_key' as const,
  Select: 'select' as const,
  SelectOptions: 'select_options' as const,
  SuccessRedirect: 'success_redirect' as const,
  Task: 'task' as const,
  Text: 'text' as const,
  Textarea: 'textarea' as const,
  Time: 'time' as const,
  Timezone: 'timezone' as const,
  Unknown: 'unknown' as const,
  Url: 'url' as const,
  WalletAccountingAccount: 'wallet_accounting_account' as const,
  WalletAccountingEntity: 'wallet_accounting_entity' as const,
  Workflow: 'workflow' as const,
  WorkflowFieldsInput: 'workflow_fields_input' as const,
  WorkflowSelect: 'workflow_select' as const,
  WorkflowVariable: 'workflow_variable' as const,
} as const;

export const DynamicFieldTypeUtils = {
  values: Object.values(DynamicFieldType),
  keys: Object.keys(DynamicFieldType) as Array<keyof typeof DynamicFieldType>,
  entries: Object.entries(DynamicFieldType) as Array<[keyof typeof DynamicFieldType, DynamicFieldType]>,
  isValid: (value: any): value is DynamicFieldType => Object.values(DynamicFieldType).includes(value),
  fromKey: (key: keyof typeof DynamicFieldType): DynamicFieldType => DynamicFieldType[key],
};

export type EventableField = 'calendar_owner_relation' | 'calendar_status_field' | 'event_schedule_field' | 'label_field' | 'location_field' | 'location_select_field' | 'calendar_meeting_link_condition_field' | 'repeat_owner_relation' | 'timezone_field' | 'video_conference_link_field';

export const EventableField = {
  CalendarOwnerRelation: 'calendar_owner_relation' as const,
  CalendarStatus: 'calendar_status_field' as const,
  EventSchedule: 'event_schedule_field' as const,
  Label: 'label_field' as const,
  Location: 'location_field' as const,
  LocationSelect: 'location_select_field' as const,
  MeetingLinkCondition: 'calendar_meeting_link_condition_field' as const,
  RepeatOwnerRelation: 'repeat_owner_relation' as const,
  Timezone: 'timezone_field' as const,
  VideoConferenceLink: 'video_conference_link_field' as const,
} as const;

export const EventableFieldUtils = {
  values: Object.values(EventableField),
  keys: Object.keys(EventableField) as Array<keyof typeof EventableField>,
  entries: Object.entries(EventableField) as Array<[keyof typeof EventableField, EventableField]>,
  isValid: (value: any): value is EventableField => Object.values(EventableField).includes(value),
  fromKey: (key: keyof typeof EventableField): EventableField => EventableField[key],
};

export type ExportImportObject = 'capability_definitions' | 'components' | 'domains' | 'email_layouts' | 'email_sending_domains' | 'files' | 'folders' | 'media_library_items' | 'mongo_data' | 'navigation_menu_items' | 'navigation_menus' | 'notification_schedules' | 'notification_templates' | 'notification_types' | 'package_entity_resolutions' | 'package_installations' | 'pages' | 'page_versions' | 'permission_roles' | 'permissions' | 'record_roles' | 'roles' | 'test_suite_cases' | 'test_suites' | 'wallet_accounting_entities' | 'workflows' | 'workflow_scenarios' | 'workflow_steps' | 'workflow_transitions' | 'workflow_variables' | 'workflow_versions' | 'workspaces';

export const ExportImportObject = {
  CapabilityDefinitions: 'capability_definitions' as const,
  Components: 'components' as const,
  Domains: 'domains' as const,
  EmailLayouts: 'email_layouts' as const,
  EmailSendingDomains: 'email_sending_domains' as const,
  Files: 'files' as const,
  Folders: 'folders' as const,
  MediaLibraryItems: 'media_library_items' as const,
  MongoData: 'mongo_data' as const,
  NavigationMenuItems: 'navigation_menu_items' as const,
  NavigationMenus: 'navigation_menus' as const,
  NotificationSchedules: 'notification_schedules' as const,
  NotificationTemplates: 'notification_templates' as const,
  NotificationTypes: 'notification_types' as const,
  PackageEntityResolutions: 'package_entity_resolutions' as const,
  PackageInstallations: 'package_installations' as const,
  Pages: 'pages' as const,
  PageVersions: 'page_versions' as const,
  PermissionRoles: 'permission_roles' as const,
  Permissions: 'permissions' as const,
  RecordRoles: 'record_roles' as const,
  Roles: 'roles' as const,
  TestSuiteCases: 'test_suite_cases' as const,
  TestSuites: 'test_suites' as const,
  WalletAccountingEntities: 'wallet_accounting_entities' as const,
  Workflows: 'workflows' as const,
  WorkflowScenarios: 'workflow_scenarios' as const,
  WorkflowSteps: 'workflow_steps' as const,
  WorkflowTransitions: 'workflow_transitions' as const,
  WorkflowVariables: 'workflow_variables' as const,
  WorkflowVersions: 'workflow_versions' as const,
  Workspaces: 'workspaces' as const,
} as const;

export const ExportImportObjectUtils = {
  values: Object.values(ExportImportObject),
  keys: Object.keys(ExportImportObject) as Array<keyof typeof ExportImportObject>,
  entries: Object.entries(ExportImportObject) as Array<[keyof typeof ExportImportObject, ExportImportObject]>,
  isValid: (value: any): value is ExportImportObject => Object.values(ExportImportObject).includes(value),
  fromKey: (key: keyof typeof ExportImportObject): ExportImportObject => ExportImportObject[key],
};

export type FilterOperator = 'all' | 'between' | 'contains' | 'elem_match' | 'ends_with' | '=' | 'exists' | '>' | '>=' | 'has_value' | 'in' | 'is' | 'is_not' | 'is_not_null' | 'is_null' | '<' | '<=' | 'missing_value' | 'mod' | 'not' | '!=' | 'not_exists' | 'not_in' | 'regex' | 'search' | 'starts_with';

export const FilterOperator = {
  All: 'all' as const,
  Between: 'between' as const,
  Contains: 'contains' as const,
  ElemMatch: 'elem_match' as const,
  EndsWith: 'ends_with' as const,
  Equal: '=' as const,
  Exists: 'exists' as const,
  GreaterThan: '>' as const,
  GreaterThanOrEqual: '>=' as const,
  HasValue: 'has_value' as const,
  In: 'in' as const,
  Is: 'is' as const,
  IsNot: 'is_not' as const,
  IsNotNull: 'is_not_null' as const,
  IsNull: 'is_null' as const,
  LessThan: '<' as const,
  LessThanOrEqual: '<=' as const,
  MissingValue: 'missing_value' as const,
  Mod: 'mod' as const,
  Not: 'not' as const,
  NotEqual: '!=' as const,
  NotExists: 'not_exists' as const,
  NotIn: 'not_in' as const,
  Regex: 'regex' as const,
  Search: 'search' as const,
  StartsWith: 'starts_with' as const,
} as const;

export const FilterOperatorUtils = {
  values: Object.values(FilterOperator),
  keys: Object.keys(FilterOperator) as Array<keyof typeof FilterOperator>,
  entries: Object.entries(FilterOperator) as Array<[keyof typeof FilterOperator, FilterOperator]>,
  isValid: (value: any): value is FilterOperator => Object.values(FilterOperator).includes(value),
  fromKey: (key: keyof typeof FilterOperator): FilterOperator => FilterOperator[key],
};

export type FilterValueShape = 'array' | 'divisor_remainder' | 'nested' | 'none' | 'range' | 'regex' | 'single';

export const FilterValueShape = {
  Array: 'array' as const,
  DivisorRemainder: 'divisor_remainder' as const,
  Nested: 'nested' as const,
  None: 'none' as const,
  Range: 'range' as const,
  Regex: 'regex' as const,
  Single: 'single' as const,
} as const;

export const FilterValueShapeUtils = {
  values: Object.values(FilterValueShape),
  keys: Object.keys(FilterValueShape) as Array<keyof typeof FilterValueShape>,
  entries: Object.entries(FilterValueShape) as Array<[keyof typeof FilterValueShape, FilterValueShape]>,
  isValid: (value: any): value is FilterValueShape => Object.values(FilterValueShape).includes(value),
  fromKey: (key: keyof typeof FilterValueShape): FilterValueShape => FilterValueShape[key],
};

export type FolderType = 'component' | 'layout' | 'media_library' | 'page';

export const FolderType = {
  Component: 'component' as const,
  Layout: 'layout' as const,
  MediaLibrary: 'media_library' as const,
  Page: 'page' as const,
} as const;

export const FolderTypeUtils = {
  values: Object.values(FolderType),
  keys: Object.keys(FolderType) as Array<keyof typeof FolderType>,
  entries: Object.entries(FolderType) as Array<[keyof typeof FolderType, FolderType]>,
  isValid: (value: any): value is FolderType => Object.values(FolderType).includes(value),
  fromKey: (key: keyof typeof FolderType): FolderType => FolderType[key],
};

export type HttpMethod = 'DELETE' | 'GET' | 'PATCH' | 'POST' | 'PUT';

export const HttpMethod = {
  Delete: 'DELETE' as const,
  Get: 'GET' as const,
  Patch: 'PATCH' as const,
  Post: 'POST' as const,
  Put: 'PUT' as const,
} as const;

export const HttpMethodUtils = {
  values: Object.values(HttpMethod),
  keys: Object.keys(HttpMethod) as Array<keyof typeof HttpMethod>,
  entries: Object.entries(HttpMethod) as Array<[keyof typeof HttpMethod, HttpMethod]>,
  isValid: (value: any): value is HttpMethod => Object.values(HttpMethod).includes(value),
  fromKey: (key: keyof typeof HttpMethod): HttpMethod => HttpMethod[key],
};

export type HttpStatusCode = '202' | '208' | '502' | '400' | '409' | '100' | '201' | '103' | '417' | '424' | '403' | '302' | '504' | '410' | '505' | '418' | '226' | '507' | '500' | '411' | '423' | '508' | '405' | '421' | '301' | '300' | '207' | '511' | '204' | '203' | '406' | '510' | '404' | '501' | '304' | '200' | '206' | '402' | '308' | '412' | '428' | '102' | '407' | '416' | '413' | '431' | '408' | '414' | '205' | '303' | '503' | '101' | '307' | '425' | '429' | '401' | '451' | '422' | '415' | '426' | '305' | '506';

export const HttpStatusCode = {
  Accepted: '202' as const,
  AlreadyReported: '208' as const,
  BadGateway: '502' as const,
  BadRequest: '400' as const,
  Conflict: '409' as const,
  Continue: '100' as const,
  Created: '201' as const,
  EarlyHints: '103' as const,
  ExpectationFailed: '417' as const,
  FailedDependency: '424' as const,
  Forbidden: '403' as const,
  Found: '302' as const,
  GatewayTimeout: '504' as const,
  Gone: '410' as const,
  HttpVersionNotSupported: '505' as const,
  ImATeapot: '418' as const,
  ImUsed: '226' as const,
  InsufficientStorage: '507' as const,
  InternalServerError: '500' as const,
  LengthRequired: '411' as const,
  Locked: '423' as const,
  LoopDetected: '508' as const,
  MethodNotAllowed: '405' as const,
  MisdirectedRequest: '421' as const,
  MovedPermanently: '301' as const,
  MultipleChoices: '300' as const,
  MultiStatus: '207' as const,
  NetworkAuthenticationRequired: '511' as const,
  NoContent: '204' as const,
  NonAuthoritativeInformation: '203' as const,
  NotAcceptable: '406' as const,
  NotExtended: '510' as const,
  NotFound: '404' as const,
  NotImplemented: '501' as const,
  NotModified: '304' as const,
  Ok: '200' as const,
  PartialContent: '206' as const,
  PaymentRequired: '402' as const,
  PermanentRedirect: '308' as const,
  PreconditionFailed: '412' as const,
  PreconditionRequired: '428' as const,
  Processing: '102' as const,
  ProxyAuthenticationRequired: '407' as const,
  RequestedRangeNotSatisfiable: '416' as const,
  RequestEntityTooLarge: '413' as const,
  RequestHeaderFieldsTooLarge: '431' as const,
  RequestTimeout: '408' as const,
  RequestUriTooLong: '414' as const,
  ResetContent: '205' as const,
  SeeOther: '303' as const,
  ServiceUnavailable: '503' as const,
  SwitchingProtocols: '101' as const,
  TemporaryRedirect: '307' as const,
  TooEarly: '425' as const,
  TooManyRequests: '429' as const,
  Unauthorized: '401' as const,
  UnavailableForLegalReasons: '451' as const,
  UnprocessableEntity: '422' as const,
  UnsupportedMediaType: '415' as const,
  UpgradeRequired: '426' as const,
  UseProxy: '305' as const,
  VariantAlsoNegotiates: '506' as const,
} as const;

export const HttpStatusCodeUtils = {
  values: Object.values(HttpStatusCode),
  keys: Object.keys(HttpStatusCode) as Array<keyof typeof HttpStatusCode>,
  entries: Object.entries(HttpStatusCode) as Array<[keyof typeof HttpStatusCode, HttpStatusCode]>,
  isValid: (value: any): value is HttpStatusCode => Object.values(HttpStatusCode).includes(value),
  fromKey: (key: keyof typeof HttpStatusCode): HttpStatusCode => HttpStatusCode[key],
};

export type ItemizableField = 'accounting_source_field' | 'description_field' | 'parent_relation_field' | 'price_field' | 'quantity_field' | 'recognition_date_field' | 'revenue_account_field' | 'service_period_end_field' | 'service_period_start_field' | 'source_subscription_item_field' | 'total_field' | 'unit_price_field';

export const ItemizableField = {
  AccountingSource: 'accounting_source_field' as const,
  Description: 'description_field' as const,
  ParentRelation: 'parent_relation_field' as const,
  Price: 'price_field' as const,
  Quantity: 'quantity_field' as const,
  RecognitionDate: 'recognition_date_field' as const,
  RevenueAccount: 'revenue_account_field' as const,
  ServicePeriodEnd: 'service_period_end_field' as const,
  ServicePeriodStart: 'service_period_start_field' as const,
  SourceSubscriptionItem: 'source_subscription_item_field' as const,
  Total: 'total_field' as const,
  UnitPrice: 'unit_price_field' as const,
} as const;

export const ItemizableFieldUtils = {
  values: Object.values(ItemizableField),
  keys: Object.keys(ItemizableField) as Array<keyof typeof ItemizableField>,
  entries: Object.entries(ItemizableField) as Array<[keyof typeof ItemizableField, ItemizableField]>,
  isValid: (value: any): value is ItemizableField => Object.values(ItemizableField).includes(value),
  fromKey: (key: keyof typeof ItemizableField): ItemizableField => ItemizableField[key],
};

export type JobStatus = 'done' | 'failed' | 'running';

export const JobStatus = {
  Done: 'done' as const,
  Failed: 'failed' as const,
  Running: 'running' as const,
} as const;

export const JobStatusUtils = {
  values: Object.values(JobStatus),
  keys: Object.keys(JobStatus) as Array<keyof typeof JobStatus>,
  entries: Object.entries(JobStatus) as Array<[keyof typeof JobStatus, JobStatus]>,
  isValid: (value: any): value is JobStatus => Object.values(JobStatus).includes(value),
  fromKey: (key: keyof typeof JobStatus): JobStatus => JobStatus[key],
};

export type LocationDisplayVariant = 'formatted_address' | 'map';

export const LocationDisplayVariant = {
  FormattedAddress: 'formatted_address' as const,
  Map: 'map' as const,
} as const;

export const LocationDisplayVariantUtils = {
  values: Object.values(LocationDisplayVariant),
  keys: Object.keys(LocationDisplayVariant) as Array<keyof typeof LocationDisplayVariant>,
  entries: Object.entries(LocationDisplayVariant) as Array<[keyof typeof LocationDisplayVariant, LocationDisplayVariant]>,
  isValid: (value: any): value is LocationDisplayVariant => Object.values(LocationDisplayVariant).includes(value),
  fromKey: (key: keyof typeof LocationDisplayVariant): LocationDisplayVariant => LocationDisplayVariant[key],
};

export type LogicalOperator = 'and' | 'nor' | 'or';

export const LogicalOperator = {
  And: 'and' as const,
  Nor: 'nor' as const,
  Or: 'or' as const,
} as const;

export const LogicalOperatorUtils = {
  values: Object.values(LogicalOperator),
  keys: Object.keys(LogicalOperator) as Array<keyof typeof LogicalOperator>,
  entries: Object.entries(LogicalOperator) as Array<[keyof typeof LogicalOperator, LogicalOperator]>,
  isValid: (value: any): value is LogicalOperator => Object.values(LogicalOperator).includes(value),
  fromKey: (key: keyof typeof LogicalOperator): LogicalOperator => LogicalOperator[key],
};

export type NotifiableField = 'email_field' | 'phone_field';

export const NotifiableField = {
  Email: 'email_field' as const,
  Phone: 'phone_field' as const,
} as const;

export const NotifiableFieldUtils = {
  values: Object.values(NotifiableField),
  keys: Object.keys(NotifiableField) as Array<keyof typeof NotifiableField>,
  entries: Object.entries(NotifiableField) as Array<[keyof typeof NotifiableField, NotifiableField]>,
  isValid: (value: any): value is NotifiableField => Object.values(NotifiableField).includes(value),
  fromKey: (key: keyof typeof NotifiableField): NotifiableField => NotifiableField[key],
};

export type PackageWriteOperation = 'create' | 'delete' | 'update';

export const PackageWriteOperation = {
  Create: 'create' as const,
  Delete: 'delete' as const,
  Update: 'update' as const,
} as const;

export const PackageWriteOperationUtils = {
  values: Object.values(PackageWriteOperation),
  keys: Object.keys(PackageWriteOperation) as Array<keyof typeof PackageWriteOperation>,
  entries: Object.entries(PackageWriteOperation) as Array<[keyof typeof PackageWriteOperation, PackageWriteOperation]>,
  isValid: (value: any): value is PackageWriteOperation => Object.values(PackageWriteOperation).includes(value),
  fromKey: (key: keyof typeof PackageWriteOperation): PackageWriteOperation => PackageWriteOperation[key],
};

export type PayableAdjustmentCalculationType = 'fixed_amount' | 'percentage';

export const PayableAdjustmentCalculationType = {
  FixedAmount: 'fixed_amount' as const,
  Percentage: 'percentage' as const,
} as const;

export const PayableAdjustmentCalculationTypeUtils = {
  values: Object.values(PayableAdjustmentCalculationType),
  keys: Object.keys(PayableAdjustmentCalculationType) as Array<keyof typeof PayableAdjustmentCalculationType>,
  entries: Object.entries(PayableAdjustmentCalculationType) as Array<[keyof typeof PayableAdjustmentCalculationType, PayableAdjustmentCalculationType]>,
  isValid: (value: any): value is PayableAdjustmentCalculationType => Object.values(PayableAdjustmentCalculationType).includes(value),
  fromKey: (key: keyof typeof PayableAdjustmentCalculationType): PayableAdjustmentCalculationType => PayableAdjustmentCalculationType[key],
};

export type PayableAdjustmentField = 'accounting_account_field' | 'amount_field' | 'calculation_type_field' | 'corrects_operation_field' | 'covered_end_field' | 'covered_start_field' | 'description_field' | 'effective_at_field' | 'fixed_amount_field' | 'kind_field' | 'line_allocations_field' | 'payable_field' | 'payment_field' | 'percent_field' | 'source_line_field' | 'status_field';

export const PayableAdjustmentField = {
  AccountingAccount: 'accounting_account_field' as const,
  Amount: 'amount_field' as const,
  CalculationType: 'calculation_type_field' as const,
  CorrectsOperation: 'corrects_operation_field' as const,
  CoveredEnd: 'covered_end_field' as const,
  CoveredStart: 'covered_start_field' as const,
  Description: 'description_field' as const,
  EffectiveAt: 'effective_at_field' as const,
  FixedAmount: 'fixed_amount_field' as const,
  Kind: 'kind_field' as const,
  LineAllocations: 'line_allocations_field' as const,
  Payable: 'payable_field' as const,
  Payment: 'payment_field' as const,
  Percent: 'percent_field' as const,
  SourceLine: 'source_line_field' as const,
  Status: 'status_field' as const,
} as const;

export const PayableAdjustmentFieldUtils = {
  values: Object.values(PayableAdjustmentField),
  keys: Object.keys(PayableAdjustmentField) as Array<keyof typeof PayableAdjustmentField>,
  entries: Object.entries(PayableAdjustmentField) as Array<[keyof typeof PayableAdjustmentField, PayableAdjustmentField]>,
  isValid: (value: any): value is PayableAdjustmentField => Object.values(PayableAdjustmentField).includes(value),
  fromKey: (key: keyof typeof PayableAdjustmentField): PayableAdjustmentField => PayableAdjustmentField[key],
};

export type PayableAdjustmentKind = 'charge' | 'charge_credit' | 'credit' | 'write_off' | 'write_off_reversal';

export const PayableAdjustmentKind = {
  Charge: 'charge' as const,
  ChargeCredit: 'charge_credit' as const,
  Credit: 'credit' as const,
  WriteOff: 'write_off' as const,
  WriteOffReversal: 'write_off_reversal' as const,
} as const;

export const PayableAdjustmentKindUtils = {
  values: Object.values(PayableAdjustmentKind),
  keys: Object.keys(PayableAdjustmentKind) as Array<keyof typeof PayableAdjustmentKind>,
  entries: Object.entries(PayableAdjustmentKind) as Array<[keyof typeof PayableAdjustmentKind, PayableAdjustmentKind]>,
  isValid: (value: any): value is PayableAdjustmentKind => Object.values(PayableAdjustmentKind).includes(value),
  fromKey: (key: keyof typeof PayableAdjustmentKind): PayableAdjustmentKind => PayableAdjustmentKind[key],
};

export type PayableAdjustmentStatus = 'active' | 'void';

export const PayableAdjustmentStatus = {
  Active: 'active' as const,
  Void: 'void' as const,
} as const;

export const PayableAdjustmentStatusUtils = {
  values: Object.values(PayableAdjustmentStatus),
  keys: Object.keys(PayableAdjustmentStatus) as Array<keyof typeof PayableAdjustmentStatus>,
  entries: Object.entries(PayableAdjustmentStatus) as Array<[keyof typeof PayableAdjustmentStatus, PayableAdjustmentStatus]>,
  isValid: (value: any): value is PayableAdjustmentStatus => Object.values(PayableAdjustmentStatus).includes(value),
  fromKey: (key: keyof typeof PayableAdjustmentStatus): PayableAdjustmentStatus => PayableAdjustmentStatus[key],
};

export type PayableField = 'accounting_entity_field' | 'amount_adjustment_field' | 'amount_charge_adjustment_field' | 'amount_credit_adjustment_field' | 'amount_outstanding_field' | 'amount_overpaid_field' | 'amount_paid_field' | 'amount_subtotal_field' | 'amount_total_field' | 'amount_written_off_field' | 'currency_field' | 'due_at_field' | 'exclude_from_subscription_status_field' | 'paid_at_field' | 'payer_field' | 'period_end_field' | 'period_start_field' | 'source_subscription_field' | 'source_subscription_period_field' | 'status_field';

export const PayableField = {
  AccountingEntity: 'accounting_entity_field' as const,
  AmountAdjustment: 'amount_adjustment_field' as const,
  AmountChargeAdjustment: 'amount_charge_adjustment_field' as const,
  AmountCreditAdjustment: 'amount_credit_adjustment_field' as const,
  AmountOutstanding: 'amount_outstanding_field' as const,
  AmountOverpaid: 'amount_overpaid_field' as const,
  AmountPaid: 'amount_paid_field' as const,
  AmountSubtotal: 'amount_subtotal_field' as const,
  AmountTotal: 'amount_total_field' as const,
  AmountWrittenOff: 'amount_written_off_field' as const,
  Currency: 'currency_field' as const,
  DueAt: 'due_at_field' as const,
  ExcludeFromSubscriptionStatus: 'exclude_from_subscription_status_field' as const,
  PaidAt: 'paid_at_field' as const,
  Payer: 'payer_field' as const,
  PeriodEnd: 'period_end_field' as const,
  PeriodStart: 'period_start_field' as const,
  SourceSubscription: 'source_subscription_field' as const,
  SourceSubscriptionPeriod: 'source_subscription_period_field' as const,
  Status: 'status_field' as const,
} as const;

export const PayableFieldUtils = {
  values: Object.values(PayableField),
  keys: Object.keys(PayableField) as Array<keyof typeof PayableField>,
  entries: Object.entries(PayableField) as Array<[keyof typeof PayableField, PayableField]>,
  isValid: (value: any): value is PayableField => Object.values(PayableField).includes(value),
  fromKey: (key: keyof typeof PayableField): PayableField => PayableField[key],
};

export type PayableStatus = 'draft' | 'open' | 'overpaid' | 'paid' | 'partially_paid' | 'void' | 'written_off';

export const PayableStatus = {
  Draft: 'draft' as const,
  Open: 'open' as const,
  Overpaid: 'overpaid' as const,
  Paid: 'paid' as const,
  PartiallyPaid: 'partially_paid' as const,
  Void: 'void' as const,
  WrittenOff: 'written_off' as const,
} as const;

export const PayableStatusUtils = {
  values: Object.values(PayableStatus),
  keys: Object.keys(PayableStatus) as Array<keyof typeof PayableStatus>,
  entries: Object.entries(PayableStatus) as Array<[keyof typeof PayableStatus, PayableStatus]>,
  isValid: (value: any): value is PayableStatus => Object.values(PayableStatus).includes(value),
  fromKey: (key: keyof typeof PayableStatus): PayableStatus => PayableStatus[key],
};

export type PayerBalanceEntryDirection = 'credit' | 'debit';

export const PayerBalanceEntryDirection = {
  Credit: 'credit' as const,
  Debit: 'debit' as const,
} as const;

export const PayerBalanceEntryDirectionUtils = {
  values: Object.values(PayerBalanceEntryDirection),
  keys: Object.keys(PayerBalanceEntryDirection) as Array<keyof typeof PayerBalanceEntryDirection>,
  entries: Object.entries(PayerBalanceEntryDirection) as Array<[keyof typeof PayerBalanceEntryDirection, PayerBalanceEntryDirection]>,
  isValid: (value: any): value is PayerBalanceEntryDirection => Object.values(PayerBalanceEntryDirection).includes(value),
  fromKey: (key: keyof typeof PayerBalanceEntryDirection): PayerBalanceEntryDirection => PayerBalanceEntryDirection[key],
};

export type PayerBalanceEntryField = 'accounting_entity_field' | 'amount_field' | 'description_field' | 'direction_field' | 'effective_at_field' | 'payer_field' | 'payment_field' | 'source_payable_field';

export const PayerBalanceEntryField = {
  AccountingEntity: 'accounting_entity_field' as const,
  Amount: 'amount_field' as const,
  Description: 'description_field' as const,
  Direction: 'direction_field' as const,
  EffectiveAt: 'effective_at_field' as const,
  Payer: 'payer_field' as const,
  Payment: 'payment_field' as const,
  SourcePayable: 'source_payable_field' as const,
} as const;

export const PayerBalanceEntryFieldUtils = {
  values: Object.values(PayerBalanceEntryField),
  keys: Object.keys(PayerBalanceEntryField) as Array<keyof typeof PayerBalanceEntryField>,
  entries: Object.entries(PayerBalanceEntryField) as Array<[keyof typeof PayerBalanceEntryField, PayerBalanceEntryField]>,
  isValid: (value: any): value is PayerBalanceEntryField => Object.values(PayerBalanceEntryField).includes(value),
  fromKey: (key: keyof typeof PayerBalanceEntryField): PayerBalanceEntryField => PayerBalanceEntryField[key],
};

export type PayerField = 'balance_field' | 'default_payment_method_field' | 'email_field' | 'name_field';

export const PayerField = {
  Balance: 'balance_field' as const,
  DefaultPaymentMethod: 'default_payment_method_field' as const,
  Email: 'email_field' as const,
  Name: 'name_field' as const,
} as const;

export const PayerFieldUtils = {
  values: Object.values(PayerField),
  keys: Object.keys(PayerField) as Array<keyof typeof PayerField>,
  entries: Object.entries(PayerField) as Array<[keyof typeof PayerField, PayerField]>,
  isValid: (value: any): value is PayerField => Object.values(PayerField).includes(value),
  fromKey: (key: keyof typeof PayerField): PayerField => PayerField[key],
};

export type PaymentField = 'amount_field' | 'currency_field' | 'diagonal_fee_field' | 'diagonal_fee_net_field' | 'diagonal_fee_refunded_field' | 'failure_reason_field' | 'method_field' | 'notes_field' | 'paid_at_field' | 'payable_field' | 'payer_field' | 'refunded_amount_field' | 'status_field';

export const PaymentField = {
  Amount: 'amount_field' as const,
  Currency: 'currency_field' as const,
  DiagonalFee: 'diagonal_fee_field' as const,
  DiagonalFeeNet: 'diagonal_fee_net_field' as const,
  DiagonalFeeRefunded: 'diagonal_fee_refunded_field' as const,
  FailureReason: 'failure_reason_field' as const,
  Method: 'method_field' as const,
  Notes: 'notes_field' as const,
  PaidAt: 'paid_at_field' as const,
  Payable: 'payable_field' as const,
  Payer: 'payer_field' as const,
  RefundedAmount: 'refunded_amount_field' as const,
  Status: 'status_field' as const,
} as const;

export const PaymentFieldUtils = {
  values: Object.values(PaymentField),
  keys: Object.keys(PaymentField) as Array<keyof typeof PaymentField>,
  entries: Object.entries(PaymentField) as Array<[keyof typeof PaymentField, PaymentField]>,
  isValid: (value: any): value is PaymentField => Object.values(PaymentField).includes(value),
  fromKey: (key: keyof typeof PaymentField): PaymentField => PaymentField[key],
};

export type PaymentMethod = 'direct_charge' | 'manual' | 'payer_balance' | 'stripe_checkout';

export const PaymentMethod = {
  DirectCharge: 'direct_charge' as const,
  Manual: 'manual' as const,
  PayerBalance: 'payer_balance' as const,
  StripeCheckout: 'stripe_checkout' as const,
} as const;

export const PaymentMethodUtils = {
  values: Object.values(PaymentMethod),
  keys: Object.keys(PaymentMethod) as Array<keyof typeof PaymentMethod>,
  entries: Object.entries(PaymentMethod) as Array<[keyof typeof PaymentMethod, PaymentMethod]>,
  isValid: (value: any): value is PaymentMethod => Object.values(PaymentMethod).includes(value),
  fromKey: (key: keyof typeof PaymentMethod): PaymentMethod => PaymentMethod[key],
};

export type PaymentMethodField = 'bank_name_field' | 'brand_field' | 'display_name_field' | 'exp_month_field' | 'exp_year_field' | 'last4_field' | 'payer_field' | 'type_field';

export const PaymentMethodField = {
  BankName: 'bank_name_field' as const,
  Brand: 'brand_field' as const,
  DisplayName: 'display_name_field' as const,
  ExpMonth: 'exp_month_field' as const,
  ExpYear: 'exp_year_field' as const,
  Last4: 'last4_field' as const,
  Payer: 'payer_field' as const,
  Type: 'type_field' as const,
} as const;

export const PaymentMethodFieldUtils = {
  values: Object.values(PaymentMethodField),
  keys: Object.keys(PaymentMethodField) as Array<keyof typeof PaymentMethodField>,
  entries: Object.entries(PaymentMethodField) as Array<[keyof typeof PaymentMethodField, PaymentMethodField]>,
  isValid: (value: any): value is PaymentMethodField => Object.values(PaymentMethodField).includes(value),
  fromKey: (key: keyof typeof PaymentMethodField): PaymentMethodField => PaymentMethodField[key],
};

export type PaymentMethodType = 'card' | 'us_bank_account';

export const PaymentMethodType = {
  Card: 'card' as const,
  UsBankAccount: 'us_bank_account' as const,
} as const;

export const PaymentMethodTypeUtils = {
  values: Object.values(PaymentMethodType),
  keys: Object.keys(PaymentMethodType) as Array<keyof typeof PaymentMethodType>,
  entries: Object.entries(PaymentMethodType) as Array<[keyof typeof PaymentMethodType, PaymentMethodType]>,
  isValid: (value: any): value is PaymentMethodType => Object.values(PaymentMethodType).includes(value),
  fromKey: (key: keyof typeof PaymentMethodType): PaymentMethodType => PaymentMethodType[key],
};

export type PaymentStatus = 'failed' | 'partially_refunded' | 'pending' | 'processing' | 'refunded' | 'succeeded';

export const PaymentStatus = {
  Failed: 'failed' as const,
  PartiallyRefunded: 'partially_refunded' as const,
  Pending: 'pending' as const,
  Processing: 'processing' as const,
  Refunded: 'refunded' as const,
  Succeeded: 'succeeded' as const,
} as const;

export const PaymentStatusUtils = {
  values: Object.values(PaymentStatus),
  keys: Object.keys(PaymentStatus) as Array<keyof typeof PaymentStatus>,
  entries: Object.entries(PaymentStatus) as Array<[keyof typeof PaymentStatus, PaymentStatus]>,
  isValid: (value: any): value is PaymentStatus => Object.values(PaymentStatus).includes(value),
  fromKey: (key: keyof typeof PaymentStatus): PaymentStatus => PaymentStatus[key],
};

export type PermissionField = 'description_field' | 'name_field' | 'slug_field';

export const PermissionField = {
  Description: 'description_field' as const,
  Name: 'name_field' as const,
  Slug: 'slug_field' as const,
} as const;

export const PermissionFieldUtils = {
  values: Object.values(PermissionField),
  keys: Object.keys(PermissionField) as Array<keyof typeof PermissionField>,
  entries: Object.entries(PermissionField) as Array<[keyof typeof PermissionField, PermissionField]>,
  isValid: (value: any): value is PermissionField => Object.values(PermissionField).includes(value),
  fromKey: (key: keyof typeof PermissionField): PermissionField => PermissionField[key],
};

export type PriceField = 'amount_field' | 'product_field' | 'recurrence_field';

export const PriceField = {
  Amount: 'amount_field' as const,
  Product: 'product_field' as const,
  Recurrence: 'recurrence_field' as const,
} as const;

export const PriceFieldUtils = {
  values: Object.values(PriceField),
  keys: Object.keys(PriceField) as Array<keyof typeof PriceField>,
  entries: Object.entries(PriceField) as Array<[keyof typeof PriceField, PriceField]>,
  isValid: (value: any): value is PriceField => Object.values(PriceField).includes(value),
  fromKey: (key: keyof typeof PriceField): PriceField => PriceField[key],
};

export type PriceRecurrence = 'monthly' | 'one_time' | 'quarterly' | 'semi_annual' | 'yearly';

export const PriceRecurrence = {
  Monthly: 'monthly' as const,
  OneTime: 'one_time' as const,
  Quarterly: 'quarterly' as const,
  SemiAnnual: 'semi_annual' as const,
  Yearly: 'yearly' as const,
} as const;

export const PriceRecurrenceUtils = {
  values: Object.values(PriceRecurrence),
  keys: Object.keys(PriceRecurrence) as Array<keyof typeof PriceRecurrence>,
  entries: Object.entries(PriceRecurrence) as Array<[keyof typeof PriceRecurrence, PriceRecurrence]>,
  isValid: (value: any): value is PriceRecurrence => Object.values(PriceRecurrence).includes(value),
  fromKey: (key: keyof typeof PriceRecurrence): PriceRecurrence => PriceRecurrence[key],
};

export type ProductField = 'accounting_entity_field' | 'description_field' | 'name_field' | 'revenue_account_field';

export const ProductField = {
  AccountingEntity: 'accounting_entity_field' as const,
  Description: 'description_field' as const,
  Name: 'name_field' as const,
  RevenueAccount: 'revenue_account_field' as const,
} as const;

export const ProductFieldUtils = {
  values: Object.values(ProductField),
  keys: Object.keys(ProductField) as Array<keyof typeof ProductField>,
  entries: Object.entries(ProductField) as Array<[keyof typeof ProductField, ProductField]>,
  isValid: (value: any): value is ProductField => Object.values(ProductField).includes(value),
  fromKey: (key: keyof typeof ProductField): ProductField => ProductField[key],
};

export type Queue = 'ai-streaming' | 'data-processing' | 'default' | 'workflows';

export const Queue = {
  AiStreaming: 'ai-streaming' as const,
  DataProcessing: 'data-processing' as const,
  Default: 'default' as const,
  Workflows: 'workflows' as const,
} as const;

export const QueueUtils = {
  values: Object.values(Queue),
  keys: Object.keys(Queue) as Array<keyof typeof Queue>,
  entries: Object.entries(Queue) as Array<[keyof typeof Queue, Queue]>,
  isValid: (value: any): value is Queue => Object.values(Queue).includes(value),
  fromKey: (key: keyof typeof Queue): Queue => Queue[key],
};

export type RefundField = 'amount_field' | 'currency_field' | 'failure_reason_field' | 'payment_field' | 'reason_field' | 'refunded_at_field' | 'status_field';

export const RefundField = {
  Amount: 'amount_field' as const,
  Currency: 'currency_field' as const,
  FailureReason: 'failure_reason_field' as const,
  Payment: 'payment_field' as const,
  Reason: 'reason_field' as const,
  RefundedAt: 'refunded_at_field' as const,
  Status: 'status_field' as const,
} as const;

export const RefundFieldUtils = {
  values: Object.values(RefundField),
  keys: Object.keys(RefundField) as Array<keyof typeof RefundField>,
  entries: Object.entries(RefundField) as Array<[keyof typeof RefundField, RefundField]>,
  isValid: (value: any): value is RefundField => Object.values(RefundField).includes(value),
  fromKey: (key: keyof typeof RefundField): RefundField => RefundField[key],
};

export type RefundStatus = 'failed' | 'pending' | 'succeeded';

export const RefundStatus = {
  Failed: 'failed' as const,
  Pending: 'pending' as const,
  Succeeded: 'succeeded' as const,
} as const;

export const RefundStatusUtils = {
  values: Object.values(RefundStatus),
  keys: Object.keys(RefundStatus) as Array<keyof typeof RefundStatus>,
  entries: Object.entries(RefundStatus) as Array<[keyof typeof RefundStatus, RefundStatus]>,
  isValid: (value: any): value is RefundStatus => Object.values(RefundStatus).includes(value),
  fromKey: (key: keyof typeof RefundStatus): RefundStatus => RefundStatus[key],
};

export type RelationCardinality = 'many_to_many' | 'many_to_one' | 'one_to_many' | 'one_to_one';

export const RelationCardinality = {
  ManyToMany: 'many_to_many' as const,
  ManyToOne: 'many_to_one' as const,
  OneToMany: 'one_to_many' as const,
  OneToOne: 'one_to_one' as const,
} as const;

export const RelationCardinalityUtils = {
  values: Object.values(RelationCardinality),
  keys: Object.keys(RelationCardinality) as Array<keyof typeof RelationCardinality>,
  entries: Object.entries(RelationCardinality) as Array<[keyof typeof RelationCardinality, RelationCardinality]>,
  isValid: (value: any): value is RelationCardinality => Object.values(RelationCardinality).includes(value),
  fromKey: (key: keyof typeof RelationCardinality): RelationCardinality => RelationCardinality[key],
};

export type RevenueAccountingField = 'deferred_revenue_account_field' | 'recognition_method_field' | 'revenue_account_field';

export const RevenueAccountingField = {
  DeferredRevenueAccount: 'deferred_revenue_account_field' as const,
  RecognitionMethod: 'recognition_method_field' as const,
  RevenueAccount: 'revenue_account_field' as const,
} as const;

export const RevenueAccountingFieldUtils = {
  values: Object.values(RevenueAccountingField),
  keys: Object.keys(RevenueAccountingField) as Array<keyof typeof RevenueAccountingField>,
  entries: Object.entries(RevenueAccountingField) as Array<[keyof typeof RevenueAccountingField, RevenueAccountingField]>,
  isValid: (value: any): value is RevenueAccountingField => Object.values(RevenueAccountingField).includes(value),
  fromKey: (key: keyof typeof RevenueAccountingField): RevenueAccountingField => RevenueAccountingField[key],
};

export type RoleField = 'description_field' | 'is_system_field' | 'name_field' | 'permissions_field' | 'resource_field' | 'slug_field';

export const RoleField = {
  Description: 'description_field' as const,
  IsSystem: 'is_system_field' as const,
  Name: 'name_field' as const,
  Permissions: 'permissions_field' as const,
  Resource: 'resource_field' as const,
  Slug: 'slug_field' as const,
} as const;

export const RoleFieldUtils = {
  values: Object.values(RoleField),
  keys: Object.keys(RoleField) as Array<keyof typeof RoleField>,
  entries: Object.entries(RoleField) as Array<[keyof typeof RoleField, RoleField]>,
  isValid: (value: any): value is RoleField => Object.values(RoleField).includes(value),
  fromKey: (key: keyof typeof RoleField): RoleField => RoleField[key],
};

export type SafeHttpViolation = 'disallowed_scheme' | 'malformed_url' | 'missing_host' | 'non_public_address' | 'response_too_large' | 'unresolved_host';

export const SafeHttpViolation = {
  DisallowedScheme: 'disallowed_scheme' as const,
  MalformedUrl: 'malformed_url' as const,
  MissingHost: 'missing_host' as const,
  NonPublicAddress: 'non_public_address' as const,
  ResponseTooLarge: 'response_too_large' as const,
  UnresolvedHost: 'unresolved_host' as const,
} as const;

export const SafeHttpViolationUtils = {
  values: Object.values(SafeHttpViolation),
  keys: Object.keys(SafeHttpViolation) as Array<keyof typeof SafeHttpViolation>,
  entries: Object.entries(SafeHttpViolation) as Array<[keyof typeof SafeHttpViolation, SafeHttpViolation]>,
  isValid: (value: any): value is SafeHttpViolation => Object.values(SafeHttpViolation).includes(value),
  fromKey: (key: keyof typeof SafeHttpViolation): SafeHttpViolation => SafeHttpViolation[key],
};

export type SchedulableField = 'capacity_field' | 'color_field' | 'hours_within_relation' | 'name_field' | 'regular_hours_field' | 'seats_left_field' | 'timezone_field';

export const SchedulableField = {
  Capacity: 'capacity_field' as const,
  Color: 'color_field' as const,
  HoursWithin: 'hours_within_relation' as const,
  Name: 'name_field' as const,
  RegularHours: 'regular_hours_field' as const,
  SeatsLeft: 'seats_left_field' as const,
  Timezone: 'timezone_field' as const,
} as const;

export const SchedulableFieldUtils = {
  values: Object.values(SchedulableField),
  keys: Object.keys(SchedulableField) as Array<keyof typeof SchedulableField>,
  entries: Object.entries(SchedulableField) as Array<[keyof typeof SchedulableField, SchedulableField]>,
  isValid: (value: any): value is SchedulableField => Object.values(SchedulableField).includes(value),
  fromKey: (key: keyof typeof SchedulableField): SchedulableField => SchedulableField[key],
};

export type SecuritySettingsTab = 'api-keys' | 'authenticatable-users' | 'mcp' | 'permissions' | 'roles';

export const SecuritySettingsTab = {
  ApiKeys: 'api-keys' as const,
  AuthenticatableUsers: 'authenticatable-users' as const,
  Mcp: 'mcp' as const,
  Permissions: 'permissions' as const,
  Roles: 'roles' as const,
} as const;

export const SecuritySettingsTabUtils = {
  values: Object.values(SecuritySettingsTab),
  keys: Object.keys(SecuritySettingsTab) as Array<keyof typeof SecuritySettingsTab>,
  entries: Object.entries(SecuritySettingsTab) as Array<[keyof typeof SecuritySettingsTab, SecuritySettingsTab]>,
  isValid: (value: any): value is SecuritySettingsTab => Object.values(SecuritySettingsTab).includes(value),
  fromKey: (key: keyof typeof SecuritySettingsTab): SecuritySettingsTab => SecuritySettingsTab[key],
};

export type SettingsGroup = 'content-messaging' | 'developer-tools' | 'pages' | 'workspace-access';

export const SettingsGroup = {
  ContentMessaging: 'content-messaging' as const,
  DeveloperTools: 'developer-tools' as const,
  Pages: 'pages' as const,
  WorkspaceAccess: 'workspace-access' as const,
} as const;

export const SettingsGroupUtils = {
  values: Object.values(SettingsGroup),
  keys: Object.keys(SettingsGroup) as Array<keyof typeof SettingsGroup>,
  entries: Object.entries(SettingsGroup) as Array<[keyof typeof SettingsGroup, SettingsGroup]>,
  isValid: (value: any): value is SettingsGroup => Object.values(SettingsGroup).includes(value),
  fromKey: (key: keyof typeof SettingsGroup): SettingsGroup => SettingsGroup[key],
};

export type SubscriptionActivationPolicy = 'after_first_payment' | 'immediate';

export const SubscriptionActivationPolicy = {
  AfterFirstPayment: 'after_first_payment' as const,
  Immediate: 'immediate' as const,
} as const;

export const SubscriptionActivationPolicyUtils = {
  values: Object.values(SubscriptionActivationPolicy),
  keys: Object.keys(SubscriptionActivationPolicy) as Array<keyof typeof SubscriptionActivationPolicy>,
  entries: Object.entries(SubscriptionActivationPolicy) as Array<[keyof typeof SubscriptionActivationPolicy, SubscriptionActivationPolicy]>,
  isValid: (value: any): value is SubscriptionActivationPolicy => Object.values(SubscriptionActivationPolicy).includes(value),
  fromKey: (key: keyof typeof SubscriptionActivationPolicy): SubscriptionActivationPolicy => SubscriptionActivationPolicy[key],
};

export type SubscriptionBillingCycleMode = 'anniversary' | 'calendar_aligned';

export const SubscriptionBillingCycleMode = {
  Anniversary: 'anniversary' as const,
  CalendarAligned: 'calendar_aligned' as const,
} as const;

export const SubscriptionBillingCycleModeUtils = {
  values: Object.values(SubscriptionBillingCycleMode),
  keys: Object.keys(SubscriptionBillingCycleMode) as Array<keyof typeof SubscriptionBillingCycleMode>,
  entries: Object.entries(SubscriptionBillingCycleMode) as Array<[keyof typeof SubscriptionBillingCycleMode, SubscriptionBillingCycleMode]>,
  isValid: (value: any): value is SubscriptionBillingCycleMode => Object.values(SubscriptionBillingCycleMode).includes(value),
  fromKey: (key: keyof typeof SubscriptionBillingCycleMode): SubscriptionBillingCycleMode => SubscriptionBillingCycleMode[key],
};

export type SubscriptionChangePreviewMode = 'current_revision' | 'initial_revision' | 'prorated' | 'selection_only' | 'upcoming_revision';

export const SubscriptionChangePreviewMode = {
  CurrentRevision: 'current_revision' as const,
  InitialRevision: 'initial_revision' as const,
  Prorated: 'prorated' as const,
  SelectionOnly: 'selection_only' as const,
  UpcomingRevision: 'upcoming_revision' as const,
} as const;

export const SubscriptionChangePreviewModeUtils = {
  values: Object.values(SubscriptionChangePreviewMode),
  keys: Object.keys(SubscriptionChangePreviewMode) as Array<keyof typeof SubscriptionChangePreviewMode>,
  entries: Object.entries(SubscriptionChangePreviewMode) as Array<[keyof typeof SubscriptionChangePreviewMode, SubscriptionChangePreviewMode]>,
  isValid: (value: any): value is SubscriptionChangePreviewMode => Object.values(SubscriptionChangePreviewMode).includes(value),
  fromKey: (key: keyof typeof SubscriptionChangePreviewMode): SubscriptionChangePreviewMode => SubscriptionChangePreviewMode[key],
};

export type SubscriptionCollectionMethod = 'charge_automatically' | 'send_invoice';

export const SubscriptionCollectionMethod = {
  ChargeAutomatically: 'charge_automatically' as const,
  SendInvoice: 'send_invoice' as const,
} as const;

export const SubscriptionCollectionMethodUtils = {
  values: Object.values(SubscriptionCollectionMethod),
  keys: Object.keys(SubscriptionCollectionMethod) as Array<keyof typeof SubscriptionCollectionMethod>,
  entries: Object.entries(SubscriptionCollectionMethod) as Array<[keyof typeof SubscriptionCollectionMethod, SubscriptionCollectionMethod]>,
  isValid: (value: any): value is SubscriptionCollectionMethod => Object.values(SubscriptionCollectionMethod).includes(value),
  fromKey: (key: keyof typeof SubscriptionCollectionMethod): SubscriptionCollectionMethod => SubscriptionCollectionMethod[key],
};

export type SubscriptionDiscountDuration = 'every_invoice' | 'first_invoice' | 'specific_period';

export const SubscriptionDiscountDuration = {
  EveryInvoice: 'every_invoice' as const,
  FirstInvoice: 'first_invoice' as const,
  SpecificPeriod: 'specific_period' as const,
} as const;

export const SubscriptionDiscountDurationUtils = {
  values: Object.values(SubscriptionDiscountDuration),
  keys: Object.keys(SubscriptionDiscountDuration) as Array<keyof typeof SubscriptionDiscountDuration>,
  entries: Object.entries(SubscriptionDiscountDuration) as Array<[keyof typeof SubscriptionDiscountDuration, SubscriptionDiscountDuration]>,
  isValid: (value: any): value is SubscriptionDiscountDuration => Object.values(SubscriptionDiscountDuration).includes(value),
  fromKey: (key: keyof typeof SubscriptionDiscountDuration): SubscriptionDiscountDuration => SubscriptionDiscountDuration[key],
};

export type SubscriptionDiscountField = 'calculation_type_field' | 'description_field' | 'duration_field' | 'fixed_amount_field' | 'percent_field' | 'period_start_field' | 'status_field' | 'subscription_field';

export const SubscriptionDiscountField = {
  CalculationType: 'calculation_type_field' as const,
  Description: 'description_field' as const,
  Duration: 'duration_field' as const,
  FixedAmount: 'fixed_amount_field' as const,
  Percent: 'percent_field' as const,
  PeriodStart: 'period_start_field' as const,
  Status: 'status_field' as const,
  Subscription: 'subscription_field' as const,
} as const;

export const SubscriptionDiscountFieldUtils = {
  values: Object.values(SubscriptionDiscountField),
  keys: Object.keys(SubscriptionDiscountField) as Array<keyof typeof SubscriptionDiscountField>,
  entries: Object.entries(SubscriptionDiscountField) as Array<[keyof typeof SubscriptionDiscountField, SubscriptionDiscountField]>,
  isValid: (value: any): value is SubscriptionDiscountField => Object.values(SubscriptionDiscountField).includes(value),
  fromKey: (key: keyof typeof SubscriptionDiscountField): SubscriptionDiscountField => SubscriptionDiscountField[key],
};

export type SubscriptionDiscountStatus = 'active' | 'ended';

export const SubscriptionDiscountStatus = {
  Active: 'active' as const,
  Ended: 'ended' as const,
} as const;

export const SubscriptionDiscountStatusUtils = {
  values: Object.values(SubscriptionDiscountStatus),
  keys: Object.keys(SubscriptionDiscountStatus) as Array<keyof typeof SubscriptionDiscountStatus>,
  entries: Object.entries(SubscriptionDiscountStatus) as Array<[keyof typeof SubscriptionDiscountStatus, SubscriptionDiscountStatus]>,
  isValid: (value: any): value is SubscriptionDiscountStatus => Object.values(SubscriptionDiscountStatus).includes(value),
  fromKey: (key: keyof typeof SubscriptionDiscountStatus): SubscriptionDiscountStatus => SubscriptionDiscountStatus[key],
};

export type SubscriptionField = 'accounting_entity_field' | 'activated_at_field' | 'activation_policy_field' | 'billing_anchor_day_field' | 'billing_anchor_month_field' | 'billing_cycle_mode_field' | 'billing_timezone_field' | 'cancel_at_period_end_field' | 'canceled_at_field' | 'collection_method_field' | 'current_period_end_field' | 'current_period_start_field' | 'grace_period_days_field' | 'initial_payment_window_days_field' | 'initial_term_anchor_field' | 'interval_field' | 'lapse_billing_behavior_field' | 'latest_invoice_field' | 'next_invoice_at_field' | 'payer_field' | 'periods_field' | 'started_at_field' | 'status_field' | 'trial_ends_at_field' | 'trial_payment_method_policy_field' | 'trial_started_at_field';

export const SubscriptionField = {
  AccountingEntity: 'accounting_entity_field' as const,
  ActivatedAt: 'activated_at_field' as const,
  ActivationPolicy: 'activation_policy_field' as const,
  BillingAnchorDay: 'billing_anchor_day_field' as const,
  BillingAnchorMonth: 'billing_anchor_month_field' as const,
  BillingCycleMode: 'billing_cycle_mode_field' as const,
  BillingTimezone: 'billing_timezone_field' as const,
  CancelAtPeriodEnd: 'cancel_at_period_end_field' as const,
  CanceledAt: 'canceled_at_field' as const,
  CollectionMethod: 'collection_method_field' as const,
  CurrentPeriodEnd: 'current_period_end_field' as const,
  CurrentPeriodStart: 'current_period_start_field' as const,
  GracePeriodDays: 'grace_period_days_field' as const,
  InitialPaymentWindowDays: 'initial_payment_window_days_field' as const,
  InitialTermAnchor: 'initial_term_anchor_field' as const,
  Interval: 'interval_field' as const,
  LapseBillingBehavior: 'lapse_billing_behavior_field' as const,
  LatestInvoice: 'latest_invoice_field' as const,
  NextInvoiceAt: 'next_invoice_at_field' as const,
  Payer: 'payer_field' as const,
  Periods: 'periods_field' as const,
  StartedAt: 'started_at_field' as const,
  Status: 'status_field' as const,
  TrialEndsAt: 'trial_ends_at_field' as const,
  TrialPaymentMethodPolicy: 'trial_payment_method_policy_field' as const,
  TrialStartedAt: 'trial_started_at_field' as const,
} as const;

export const SubscriptionFieldUtils = {
  values: Object.values(SubscriptionField),
  keys: Object.keys(SubscriptionField) as Array<keyof typeof SubscriptionField>,
  entries: Object.entries(SubscriptionField) as Array<[keyof typeof SubscriptionField, SubscriptionField]>,
  isValid: (value: any): value is SubscriptionField => Object.values(SubscriptionField).includes(value),
  fromKey: (key: keyof typeof SubscriptionField): SubscriptionField => SubscriptionField[key],
};

export type SubscriptionInitialTermAnchor = 'first_payment_at' | 'subscription_created_at';

export const SubscriptionInitialTermAnchor = {
  FirstPaymentAt: 'first_payment_at' as const,
  SubscriptionCreatedAt: 'subscription_created_at' as const,
} as const;

export const SubscriptionInitialTermAnchorUtils = {
  values: Object.values(SubscriptionInitialTermAnchor),
  keys: Object.keys(SubscriptionInitialTermAnchor) as Array<keyof typeof SubscriptionInitialTermAnchor>,
  entries: Object.entries(SubscriptionInitialTermAnchor) as Array<[keyof typeof SubscriptionInitialTermAnchor, SubscriptionInitialTermAnchor]>,
  isValid: (value: any): value is SubscriptionInitialTermAnchor => Object.values(SubscriptionInitialTermAnchor).includes(value),
  fromKey: (key: keyof typeof SubscriptionInitialTermAnchor): SubscriptionInitialTermAnchor => SubscriptionInitialTermAnchor[key],
};

export type SubscriptionInterval = 'monthly' | 'quarterly' | 'semi_annual' | 'yearly';

export const SubscriptionInterval = {
  Monthly: 'monthly' as const,
  Quarterly: 'quarterly' as const,
  SemiAnnual: 'semi_annual' as const,
  Yearly: 'yearly' as const,
} as const;

export const SubscriptionIntervalUtils = {
  values: Object.values(SubscriptionInterval),
  keys: Object.keys(SubscriptionInterval) as Array<keyof typeof SubscriptionInterval>,
  entries: Object.entries(SubscriptionInterval) as Array<[keyof typeof SubscriptionInterval, SubscriptionInterval]>,
  isValid: (value: any): value is SubscriptionInterval => Object.values(SubscriptionInterval).includes(value),
  fromKey: (key: keyof typeof SubscriptionInterval): SubscriptionInterval => SubscriptionInterval[key],
};

export type SubscriptionItemField = 'description_snapshot_field' | 'ends_at_field' | 'price_field' | 'price_snapshot_field' | 'product_field' | 'quantity_field' | 'starts_at_field' | 'status_field' | 'subscription_field';

export const SubscriptionItemField = {
  DescriptionSnapshot: 'description_snapshot_field' as const,
  EndsAt: 'ends_at_field' as const,
  Price: 'price_field' as const,
  PriceSnapshot: 'price_snapshot_field' as const,
  Product: 'product_field' as const,
  Quantity: 'quantity_field' as const,
  StartsAt: 'starts_at_field' as const,
  Status: 'status_field' as const,
  Subscription: 'subscription_field' as const,
} as const;

export const SubscriptionItemFieldUtils = {
  values: Object.values(SubscriptionItemField),
  keys: Object.keys(SubscriptionItemField) as Array<keyof typeof SubscriptionItemField>,
  entries: Object.entries(SubscriptionItemField) as Array<[keyof typeof SubscriptionItemField, SubscriptionItemField]>,
  isValid: (value: any): value is SubscriptionItemField => Object.values(SubscriptionItemField).includes(value),
  fromKey: (key: keyof typeof SubscriptionItemField): SubscriptionItemField => SubscriptionItemField[key],
};

export type SubscriptionItemStatus = 'active' | 'canceled';

export const SubscriptionItemStatus = {
  Active: 'active' as const,
  Canceled: 'canceled' as const,
} as const;

export const SubscriptionItemStatusUtils = {
  values: Object.values(SubscriptionItemStatus),
  keys: Object.keys(SubscriptionItemStatus) as Array<keyof typeof SubscriptionItemStatus>,
  entries: Object.entries(SubscriptionItemStatus) as Array<[keyof typeof SubscriptionItemStatus, SubscriptionItemStatus]>,
  isValid: (value: any): value is SubscriptionItemStatus => Object.values(SubscriptionItemStatus).includes(value),
  fromKey: (key: keyof typeof SubscriptionItemStatus): SubscriptionItemStatus => SubscriptionItemStatus[key],
};

export type SubscriptionLapseBillingBehavior = 'continue_billing' | 'suspend_renewals' | 'cancel';

export const SubscriptionLapseBillingBehavior = {
  ContinueBilling: 'continue_billing' as const,
  SuspendRenewals: 'suspend_renewals' as const,
  Cancel: 'cancel' as const,
} as const;

export const SubscriptionLapseBillingBehaviorUtils = {
  values: Object.values(SubscriptionLapseBillingBehavior),
  keys: Object.keys(SubscriptionLapseBillingBehavior) as Array<keyof typeof SubscriptionLapseBillingBehavior>,
  entries: Object.entries(SubscriptionLapseBillingBehavior) as Array<[keyof typeof SubscriptionLapseBillingBehavior, SubscriptionLapseBillingBehavior]>,
  isValid: (value: any): value is SubscriptionLapseBillingBehavior => Object.values(SubscriptionLapseBillingBehavior).includes(value),
  fromKey: (key: keyof typeof SubscriptionLapseBillingBehavior): SubscriptionLapseBillingBehavior => SubscriptionLapseBillingBehavior[key],
};

export type SubscriptionPeriodField = 'billing_key_field' | 'kind_field' | 'lifecycle_field' | 'period_end_field' | 'period_start_field' | 'primary_invoice_field' | 'subscription_field' | 'superseded_by_field';

export const SubscriptionPeriodField = {
  BillingKey: 'billing_key_field' as const,
  Kind: 'kind_field' as const,
  Lifecycle: 'lifecycle_field' as const,
  PeriodEnd: 'period_end_field' as const,
  PeriodStart: 'period_start_field' as const,
  PrimaryInvoice: 'primary_invoice_field' as const,
  Subscription: 'subscription_field' as const,
  SupersededBy: 'superseded_by_field' as const,
} as const;

export const SubscriptionPeriodFieldUtils = {
  values: Object.values(SubscriptionPeriodField),
  keys: Object.keys(SubscriptionPeriodField) as Array<keyof typeof SubscriptionPeriodField>,
  entries: Object.entries(SubscriptionPeriodField) as Array<[keyof typeof SubscriptionPeriodField, SubscriptionPeriodField]>,
  isValid: (value: any): value is SubscriptionPeriodField => Object.values(SubscriptionPeriodField).includes(value),
  fromKey: (key: keyof typeof SubscriptionPeriodField): SubscriptionPeriodField => SubscriptionPeriodField[key],
};

export type SubscriptionPeriodKind = 'initial' | 'renewal';

export const SubscriptionPeriodKind = {
  Initial: 'initial' as const,
  Renewal: 'renewal' as const,
} as const;

export const SubscriptionPeriodKindUtils = {
  values: Object.values(SubscriptionPeriodKind),
  keys: Object.keys(SubscriptionPeriodKind) as Array<keyof typeof SubscriptionPeriodKind>,
  entries: Object.entries(SubscriptionPeriodKind) as Array<[keyof typeof SubscriptionPeriodKind, SubscriptionPeriodKind]>,
  isValid: (value: any): value is SubscriptionPeriodKind => Object.values(SubscriptionPeriodKind).includes(value),
  fromKey: (key: keyof typeof SubscriptionPeriodKind): SubscriptionPeriodKind => SubscriptionPeriodKind[key],
};

export type SubscriptionPeriodLifecycle = 'committed' | 'planned' | 'superseded';

export const SubscriptionPeriodLifecycle = {
  Committed: 'committed' as const,
  Planned: 'planned' as const,
  Superseded: 'superseded' as const,
} as const;

export const SubscriptionPeriodLifecycleUtils = {
  values: Object.values(SubscriptionPeriodLifecycle),
  keys: Object.keys(SubscriptionPeriodLifecycle) as Array<keyof typeof SubscriptionPeriodLifecycle>,
  entries: Object.entries(SubscriptionPeriodLifecycle) as Array<[keyof typeof SubscriptionPeriodLifecycle, SubscriptionPeriodLifecycle]>,
  isValid: (value: any): value is SubscriptionPeriodLifecycle => Object.values(SubscriptionPeriodLifecycle).includes(value),
  fromKey: (key: keyof typeof SubscriptionPeriodLifecycle): SubscriptionPeriodLifecycle => SubscriptionPeriodLifecycle[key],
};

export type SubscriptionPeriodReadiness = 'enabled' | 'preparing' | 'required' | 'unconfigured';

export const SubscriptionPeriodReadiness = {
  Enabled: 'enabled' as const,
  Preparing: 'preparing' as const,
  Required: 'required' as const,
  Unconfigured: 'unconfigured' as const,
} as const;

export const SubscriptionPeriodReadinessUtils = {
  values: Object.values(SubscriptionPeriodReadiness),
  keys: Object.keys(SubscriptionPeriodReadiness) as Array<keyof typeof SubscriptionPeriodReadiness>,
  entries: Object.entries(SubscriptionPeriodReadiness) as Array<[keyof typeof SubscriptionPeriodReadiness, SubscriptionPeriodReadiness]>,
  isValid: (value: any): value is SubscriptionPeriodReadiness => Object.values(SubscriptionPeriodReadiness).includes(value),
  fromKey: (key: keyof typeof SubscriptionPeriodReadiness): SubscriptionPeriodReadiness => SubscriptionPeriodReadiness[key],
};

export type SubscriptionRenewalOutcome = 'canceled' | 'not_due' | 'processed' | 'suspended';

export const SubscriptionRenewalOutcome = {
  Canceled: 'canceled' as const,
  NotDue: 'not_due' as const,
  Processed: 'processed' as const,
  Suspended: 'suspended' as const,
} as const;

export const SubscriptionRenewalOutcomeUtils = {
  values: Object.values(SubscriptionRenewalOutcome),
  keys: Object.keys(SubscriptionRenewalOutcome) as Array<keyof typeof SubscriptionRenewalOutcome>,
  entries: Object.entries(SubscriptionRenewalOutcome) as Array<[keyof typeof SubscriptionRenewalOutcome, SubscriptionRenewalOutcome]>,
  isValid: (value: any): value is SubscriptionRenewalOutcome => Object.values(SubscriptionRenewalOutcome).includes(value),
  fromKey: (key: keyof typeof SubscriptionRenewalOutcome): SubscriptionRenewalOutcome => SubscriptionRenewalOutcome[key],
};

export type SubscriptionStatus = 'active' | 'canceled' | 'draft' | 'incomplete' | 'incomplete_expired' | 'lapsed' | 'past_due' | 'paused' | 'trialing';

export const SubscriptionStatus = {
  Active: 'active' as const,
  Canceled: 'canceled' as const,
  Draft: 'draft' as const,
  Incomplete: 'incomplete' as const,
  IncompleteExpired: 'incomplete_expired' as const,
  Lapsed: 'lapsed' as const,
  PastDue: 'past_due' as const,
  Paused: 'paused' as const,
  Trialing: 'trialing' as const,
} as const;

export const SubscriptionStatusUtils = {
  values: Object.values(SubscriptionStatus),
  keys: Object.keys(SubscriptionStatus) as Array<keyof typeof SubscriptionStatus>,
  entries: Object.entries(SubscriptionStatus) as Array<[keyof typeof SubscriptionStatus, SubscriptionStatus]>,
  isValid: (value: any): value is SubscriptionStatus => Object.values(SubscriptionStatus).includes(value),
  fromKey: (key: keyof typeof SubscriptionStatus): SubscriptionStatus => SubscriptionStatus[key],
};

export type SubscriptionTrialPaymentMethodPolicy = 'optional' | 'required';

export const SubscriptionTrialPaymentMethodPolicy = {
  Optional: 'optional' as const,
  Required: 'required' as const,
} as const;

export const SubscriptionTrialPaymentMethodPolicyUtils = {
  values: Object.values(SubscriptionTrialPaymentMethodPolicy),
  keys: Object.keys(SubscriptionTrialPaymentMethodPolicy) as Array<keyof typeof SubscriptionTrialPaymentMethodPolicy>,
  entries: Object.entries(SubscriptionTrialPaymentMethodPolicy) as Array<[keyof typeof SubscriptionTrialPaymentMethodPolicy, SubscriptionTrialPaymentMethodPolicy]>,
  isValid: (value: any): value is SubscriptionTrialPaymentMethodPolicy => Object.values(SubscriptionTrialPaymentMethodPolicy).includes(value),
  fromKey: (key: keyof typeof SubscriptionTrialPaymentMethodPolicy): SubscriptionTrialPaymentMethodPolicy => SubscriptionTrialPaymentMethodPolicy[key],
};

export type SyncMode = 'attach' | 'detach' | 'sync';

export const SyncMode = {
  Attach: 'attach' as const,
  Detach: 'detach' as const,
  Sync: 'sync' as const,
} as const;

export const SyncModeUtils = {
  values: Object.values(SyncMode),
  keys: Object.keys(SyncMode) as Array<keyof typeof SyncMode>,
  entries: Object.entries(SyncMode) as Array<[keyof typeof SyncMode, SyncMode]>,
  isValid: (value: any): value is SyncMode => Object.values(SyncMode).includes(value),
  fromKey: (key: keyof typeof SyncMode): SyncMode => SyncMode[key],
};

export type SystemPermission = 'access_ai_agent' | 'access_mcp' | 'debug_ai_conversations' | 'export_workspace' | 'impersonate_identities' | 'import_workspace' | 'manage_ai_skills' | 'manage_branches' | 'manage_brand_kit' | 'manage_calendar_connections' | 'manage_components' | 'manage_data_imports' | 'manage_diagonal_wallet' | 'manage_domains' | 'manage_fields' | 'manage_media' | 'manage_notifications' | 'manage_packages' | 'manage_pages' | 'manage_resources' | 'manage_security' | 'manage_shared_filters' | 'manage_sub_workspaces' | 'manage_tests' | 'manage_workflows' | 'manage_workspace_fields' | 'manage_workspace_settings' | 'reopen_wallet_accounting_periods' | 'send_emails' | 'send_sms' | 'show_diagonal_support_chat' | 'access_system_admin' | 'update_workspace_fields' | 'view_ai_costs' | 'view_entity_graph' | 'view_workspace_analytics';

export const SystemPermission = {
  AccessAiAgent: 'access_ai_agent' as const,
  AccessMcp: 'access_mcp' as const,
  DebugAiConversations: 'debug_ai_conversations' as const,
  ExportWorkspace: 'export_workspace' as const,
  ImpersonateIdentities: 'impersonate_identities' as const,
  ImportWorkspace: 'import_workspace' as const,
  ManageAiSkills: 'manage_ai_skills' as const,
  ManageBranches: 'manage_branches' as const,
  ManageBrandKit: 'manage_brand_kit' as const,
  ManageCalendarConnections: 'manage_calendar_connections' as const,
  ManageComponents: 'manage_components' as const,
  ManageDataImports: 'manage_data_imports' as const,
  ManageDiagonalWallet: 'manage_diagonal_wallet' as const,
  ManageDomains: 'manage_domains' as const,
  ManageFields: 'manage_fields' as const,
  ManageMedia: 'manage_media' as const,
  ManageNotifications: 'manage_notifications' as const,
  ManagePackages: 'manage_packages' as const,
  ManagePages: 'manage_pages' as const,
  ManageResources: 'manage_resources' as const,
  ManageSecurity: 'manage_security' as const,
  ManageSharedFilters: 'manage_shared_filters' as const,
  ManageSubWorkspaces: 'manage_sub_workspaces' as const,
  ManageTests: 'manage_tests' as const,
  ManageWorkflows: 'manage_workflows' as const,
  ManageWorkspaceFields: 'manage_workspace_fields' as const,
  ManageWorkspaceSettings: 'manage_workspace_settings' as const,
  ReopenWalletAccountingPeriods: 'reopen_wallet_accounting_periods' as const,
  SendEmails: 'send_emails' as const,
  SendSms: 'send_sms' as const,
  ShowDiagonalSupportChat: 'show_diagonal_support_chat' as const,
  SystemAdministrator: 'access_system_admin' as const,
  UpdateWorkspaceFields: 'update_workspace_fields' as const,
  ViewAiCosts: 'view_ai_costs' as const,
  ViewEntityGraph: 'view_entity_graph' as const,
  ViewWorkspaceAnalytics: 'view_workspace_analytics' as const,
} as const;

export const SystemPermissionUtils = {
  values: Object.values(SystemPermission),
  keys: Object.keys(SystemPermission) as Array<keyof typeof SystemPermission>,
  entries: Object.entries(SystemPermission) as Array<[keyof typeof SystemPermission, SystemPermission]>,
  isValid: (value: any): value is SystemPermission => Object.values(SystemPermission).includes(value),
  fromKey: (key: keyof typeof SystemPermission): SystemPermission => SystemPermission[key],
};

export type SystemRole = 'system_administrator';

export const SystemRole = {
  SystemAdministrator: 'system_administrator' as const,
} as const;

export const SystemRoleUtils = {
  values: Object.values(SystemRole),
  keys: Object.keys(SystemRole) as Array<keyof typeof SystemRole>,
  entries: Object.entries(SystemRole) as Array<[keyof typeof SystemRole, SystemRole]>,
  isValid: (value: any): value is SystemRole => Object.values(SystemRole).includes(value),
  fromKey: (key: keyof typeof SystemRole): SystemRole => SystemRole[key],
};

export type SystemSettingsPage = 'ai-assistant' | 'ai-conversations' | 'branches' | 'calendar-sync' | 'components' | 'data-imports' | 'diagonal-wallet' | 'entity-graph' | 'layouts' | 'media-library' | 'navigation' | 'notifications' | 'packages' | 'page-playground' | 'pages' | 'projects' | 'redirects' | 'resources' | 'security' | 'staged-content' | 'tests' | 'workflows' | 'workspace-analytics' | 'workspace-brand-kit' | 'workspace-domains' | 'workspace-email' | 'workspace-fields' | 'workspace-files' | 'workspace-onboarding' | 'workspace-records' | 'workspaces';

export const SystemSettingsPage = {
  AiAssistant: 'ai-assistant' as const,
  AiConversations: 'ai-conversations' as const,
  Branches: 'branches' as const,
  CalendarSync: 'calendar-sync' as const,
  Components: 'components' as const,
  DataImports: 'data-imports' as const,
  DiagonalWallet: 'diagonal-wallet' as const,
  EntityGraph: 'entity-graph' as const,
  Layouts: 'layouts' as const,
  MediaLibrary: 'media-library' as const,
  Navigation: 'navigation' as const,
  Notifications: 'notifications' as const,
  Packages: 'packages' as const,
  PagePlayground: 'page-playground' as const,
  Pages: 'pages' as const,
  Projects: 'projects' as const,
  Redirects: 'redirects' as const,
  Resources: 'resources' as const,
  Security: 'security' as const,
  StagedContent: 'staged-content' as const,
  Tests: 'tests' as const,
  Workflows: 'workflows' as const,
  WorkspaceAnalytics: 'workspace-analytics' as const,
  WorkspaceBrandKit: 'workspace-brand-kit' as const,
  WorkspaceDomains: 'workspace-domains' as const,
  WorkspaceEmail: 'workspace-email' as const,
  WorkspaceFields: 'workspace-fields' as const,
  WorkspaceFiles: 'workspace-files' as const,
  WorkspaceOnboarding: 'workspace-onboarding' as const,
  WorkspaceRecords: 'workspace-records' as const,
  Workspaces: 'workspaces' as const,
} as const;

export const SystemSettingsPageUtils = {
  values: Object.values(SystemSettingsPage),
  keys: Object.keys(SystemSettingsPage) as Array<keyof typeof SystemSettingsPage>,
  entries: Object.entries(SystemSettingsPage) as Array<[keyof typeof SystemSettingsPage, SystemSettingsPage]>,
  isValid: (value: any): value is SystemSettingsPage => Object.values(SystemSettingsPage).includes(value),
  fromKey: (key: keyof typeof SystemSettingsPage): SystemSettingsPage => SystemSettingsPage[key],
};

export type TokenType = 'openrouter';

export const TokenType = {
  OpenRouter: 'openrouter' as const,
} as const;

export const TokenTypeUtils = {
  values: Object.values(TokenType),
  keys: Object.keys(TokenType) as Array<keyof typeof TokenType>,
  entries: Object.entries(TokenType) as Array<[keyof typeof TokenType, TokenType]>,
  isValid: (value: any): value is TokenType => Object.values(TokenType).includes(value),
  fromKey: (key: keyof typeof TokenType): TokenType => TokenType[key],
};

export type UserRole = 'admin' | 'member';

export const UserRole = {
  Admin: 'admin' as const,
  Member: 'member' as const,
} as const;

export const UserRoleUtils = {
  values: Object.values(UserRole),
  keys: Object.keys(UserRole) as Array<keyof typeof UserRole>,
  entries: Object.entries(UserRole) as Array<[keyof typeof UserRole, UserRole]>,
  isValid: (value: any): value is UserRole => Object.values(UserRole).includes(value),
  fromKey: (key: keyof typeof UserRole): UserRole => UserRole[key],
};

export type WebFont = 'barlow' | 'bitter' | 'crimson-text' | 'dm-sans' | 'dm-serif-display' | 'figtree' | 'fira-code' | 'fraunces' | 'geist' | 'geist-mono' | 'ibm-plex-mono' | 'inconsolata' | 'inter' | 'jetbrains-mono' | 'karla' | 'lato' | 'libre-baskerville' | 'lora' | 'manrope' | 'merriweather' | 'montserrat' | 'noto-sans' | 'noto-serif' | 'nunito' | 'open-sans' | 'outfit' | 'overpass' | 'playfair-display' | 'plus-jakarta-sans' | 'poppins' | 'public-sans' | 'raleway' | 'roboto' | 'roboto-mono' | 'rubik' | 'sora' | 'source-code-pro' | 'source-sans-3' | 'source-serif-4' | 'space-grotesk' | 'space-mono' | 'urbanist' | 'work-sans';

export const WebFont = {
  Barlow: 'barlow' as const,
  Bitter: 'bitter' as const,
  CrimsonText: 'crimson-text' as const,
  DmSans: 'dm-sans' as const,
  DmSerif: 'dm-serif-display' as const,
  Figtree: 'figtree' as const,
  FiraCode: 'fira-code' as const,
  Fraunces: 'fraunces' as const,
  Geist: 'geist' as const,
  GeistMono: 'geist-mono' as const,
  IBMPlexMono: 'ibm-plex-mono' as const,
  Inconsolata: 'inconsolata' as const,
  Inter: 'inter' as const,
  JetBrainsMono: 'jetbrains-mono' as const,
  Karla: 'karla' as const,
  Lato: 'lato' as const,
  LibreBaskerville: 'libre-baskerville' as const,
  Lora: 'lora' as const,
  Manrope: 'manrope' as const,
  Merriweather: 'merriweather' as const,
  Montserrat: 'montserrat' as const,
  NotoSans: 'noto-sans' as const,
  NotoSerif: 'noto-serif' as const,
  Nunito: 'nunito' as const,
  OpenSans: 'open-sans' as const,
  Outfit: 'outfit' as const,
  Overpass: 'overpass' as const,
  PlayfairDisplay: 'playfair-display' as const,
  PlusJakartaSans: 'plus-jakarta-sans' as const,
  Poppins: 'poppins' as const,
  PublicSans: 'public-sans' as const,
  Raleway: 'raleway' as const,
  Roboto: 'roboto' as const,
  RobotoMono: 'roboto-mono' as const,
  Rubik: 'rubik' as const,
  Sora: 'sora' as const,
  SourceCodePro: 'source-code-pro' as const,
  SourceSans3: 'source-sans-3' as const,
  SourceSerif4: 'source-serif-4' as const,
  SpaceGrotesk: 'space-grotesk' as const,
  SpaceMono: 'space-mono' as const,
  Urbanist: 'urbanist' as const,
  WorkSans: 'work-sans' as const,
} as const;

export const WebFontUtils = {
  values: Object.values(WebFont),
  keys: Object.keys(WebFont) as Array<keyof typeof WebFont>,
  entries: Object.entries(WebFont) as Array<[keyof typeof WebFont, WebFont]>,
  isValid: (value: any): value is WebFont => Object.values(WebFont).includes(value),
  fromKey: (key: keyof typeof WebFont): WebFont => WebFont[key],
};

export type WebFontCategory = 'monospace' | 'sans-serif' | 'serif';

export const WebFontCategory = {
  Monospace: 'monospace' as const,
  SansSerif: 'sans-serif' as const,
  Serif: 'serif' as const,
} as const;

export const WebFontCategoryUtils = {
  values: Object.values(WebFontCategory),
  keys: Object.keys(WebFontCategory) as Array<keyof typeof WebFontCategory>,
  entries: Object.entries(WebFontCategory) as Array<[keyof typeof WebFontCategory, WebFontCategory]>,
  isValid: (value: any): value is WebFontCategory => Object.values(WebFontCategory).includes(value),
  fromKey: (key: keyof typeof WebFontCategory): WebFontCategory => WebFontCategory[key],
};

export type DataApiEndpoint = 'analytics_distribution' | 'analytics_kpi' | 'analytics_leaderboard' | 'analytics_time_series' | 'count' | 'create' | 'create_many' | 'create_many_from_file' | 'delete' | 'delete_many' | 'export' | 'index' | 'restore' | 'search' | 'show' | 'update' | 'update_many' | 'upsert' | 'upsert_many';

export const DataApiEndpoint = {
  AnalyticsDistribution: 'analytics_distribution' as const,
  AnalyticsKpi: 'analytics_kpi' as const,
  AnalyticsLeaderboard: 'analytics_leaderboard' as const,
  AnalyticsTimeSeries: 'analytics_time_series' as const,
  Count: 'count' as const,
  Create: 'create' as const,
  CreateMany: 'create_many' as const,
  CreateManyFromFile: 'create_many_from_file' as const,
  Delete: 'delete' as const,
  DeleteMany: 'delete_many' as const,
  Export: 'export' as const,
  Index: 'index' as const,
  Restore: 'restore' as const,
  Search: 'search' as const,
  Show: 'show' as const,
  Update: 'update' as const,
  UpdateMany: 'update_many' as const,
  Upsert: 'upsert' as const,
  UpsertMany: 'upsert_many' as const,
} as const;

export const DataApiEndpointUtils = {
  values: Object.values(DataApiEndpoint),
  keys: Object.keys(DataApiEndpoint) as Array<keyof typeof DataApiEndpoint>,
  entries: Object.entries(DataApiEndpoint) as Array<[keyof typeof DataApiEndpoint, DataApiEndpoint]>,
  isValid: (value: any): value is DataApiEndpoint => Object.values(DataApiEndpoint).includes(value),
  fromKey: (key: keyof typeof DataApiEndpoint): DataApiEndpoint => DataApiEndpoint[key],
};

export type DocumentRelation = 'belongs_to' | 'belongs_to_many' | 'has_many' | 'has_one';

export const DocumentRelation = {
  BelongsTo: 'belongs_to' as const,
  BelongsToMany: 'belongs_to_many' as const,
  HasMany: 'has_many' as const,
  HasOne: 'has_one' as const,
} as const;

export const DocumentRelationUtils = {
  values: Object.values(DocumentRelation),
  keys: Object.keys(DocumentRelation) as Array<keyof typeof DocumentRelation>,
  entries: Object.entries(DocumentRelation) as Array<[keyof typeof DocumentRelation, DocumentRelation]>,
  isValid: (value: any): value is DocumentRelation => Object.values(DocumentRelation).includes(value),
  fromKey: (key: keyof typeof DocumentRelation): DocumentRelation => DocumentRelation[key],
};

export type FieldTypeSetting = 'unique';

export const FieldTypeSetting = {
  Unique: 'unique' as const,
} as const;

export const FieldTypeSettingUtils = {
  values: Object.values(FieldTypeSetting),
  keys: Object.keys(FieldTypeSetting) as Array<keyof typeof FieldTypeSetting>,
  entries: Object.entries(FieldTypeSetting) as Array<[keyof typeof FieldTypeSetting, FieldTypeSetting]>,
  isValid: (value: any): value is FieldTypeSetting => Object.values(FieldTypeSetting).includes(value),
  fromKey: (key: keyof typeof FieldTypeSetting): FieldTypeSetting => FieldTypeSetting[key],
};

export type LegacyDataFileStatus = 'failed' | 'processing' | 'ready';

export const LegacyDataFileStatus = {
  Failed: 'failed' as const,
  Processing: 'processing' as const,
  Ready: 'ready' as const,
} as const;

export const LegacyDataFileStatusUtils = {
  values: Object.values(LegacyDataFileStatus),
  keys: Object.keys(LegacyDataFileStatus) as Array<keyof typeof LegacyDataFileStatus>,
  entries: Object.entries(LegacyDataFileStatus) as Array<[keyof typeof LegacyDataFileStatus, LegacyDataFileStatus]>,
  isValid: (value: any): value is LegacyDataFileStatus => Object.values(LegacyDataFileStatus).includes(value),
  fromKey: (key: keyof typeof LegacyDataFileStatus): LegacyDataFileStatus => LegacyDataFileStatus[key],
};

export type LifecycleHookType = 'creating' | 'deleting' | 'restoring' | 'saving' | 'updating';

export const LifecycleHookType = {
  Creating: 'creating' as const,
  Deleting: 'deleting' as const,
  Restoring: 'restoring' as const,
  Saving: 'saving' as const,
  Updating: 'updating' as const,
} as const;

export const LifecycleHookTypeUtils = {
  values: Object.values(LifecycleHookType),
  keys: Object.keys(LifecycleHookType) as Array<keyof typeof LifecycleHookType>,
  entries: Object.entries(LifecycleHookType) as Array<[keyof typeof LifecycleHookType, LifecycleHookType]>,
  isValid: (value: any): value is LifecycleHookType => Object.values(LifecycleHookType).includes(value),
  fromKey: (key: keyof typeof LifecycleHookType): LifecycleHookType => LifecycleHookType[key],
};

export type MongoSettings = 'mongodb:settings:skip_indexes' | 'mongodb:settings:sleeping';

export const MongoSettings = {
  SkipIndexes: 'mongodb:settings:skip_indexes' as const,
  Sleeping: 'mongodb:settings:sleeping' as const,
} as const;

export const MongoSettingsUtils = {
  values: Object.values(MongoSettings),
  keys: Object.keys(MongoSettings) as Array<keyof typeof MongoSettings>,
  entries: Object.entries(MongoSettings) as Array<[keyof typeof MongoSettings, MongoSettings]>,
  isValid: (value: any): value is MongoSettings => Object.values(MongoSettings).includes(value),
  fromKey: (key: keyof typeof MongoSettings): MongoSettings => MongoSettings[key],
};

export type PolicyAccess = 'protected' | 'public';

export const PolicyAccess = {
  Protected: 'protected' as const,
  Public: 'public' as const,
} as const;

export const PolicyAccessUtils = {
  values: Object.values(PolicyAccess),
  keys: Object.keys(PolicyAccess) as Array<keyof typeof PolicyAccess>,
  entries: Object.entries(PolicyAccess) as Array<[keyof typeof PolicyAccess, PolicyAccess]>,
  isValid: (value: any): value is PolicyAccess => Object.values(PolicyAccess).includes(value),
  fromKey: (key: keyof typeof PolicyAccess): PolicyAccess => PolicyAccess[key],
};

export type PolicyScope = '256' | '0' | '128' | '32' | '1' | '64' | '2' | '4' | '8' | '16' | '512';

export const PolicyScope = {
  Aggregate: '256' as const,
  All: '0' as const,
  Count: '128' as const,
  Destroy: '32' as const,
  Index: '1' as const,
  Restore: '64' as const,
  Show: '2' as const,
  Store: '4' as const,
  StoreMany: '8' as const,
  Update: '16' as const,
  Validate: '512' as const,
} as const;

export const PolicyScopeUtils = {
  values: Object.values(PolicyScope),
  keys: Object.keys(PolicyScope) as Array<keyof typeof PolicyScope>,
  entries: Object.entries(PolicyScope) as Array<[keyof typeof PolicyScope, PolicyScope]>,
  isValid: (value: any): value is PolicyScope => Object.values(PolicyScope).includes(value),
  fromKey: (key: keyof typeof PolicyScope): PolicyScope => PolicyScope[key],
};

export type RecordCollapse = 'series';

export const RecordCollapse = {
  Series: 'series' as const,
} as const;

export const RecordCollapseUtils = {
  values: Object.values(RecordCollapse),
  keys: Object.keys(RecordCollapse) as Array<keyof typeof RecordCollapse>,
  entries: Object.entries(RecordCollapse) as Array<[keyof typeof RecordCollapse, RecordCollapse]>,
  isValid: (value: any): value is RecordCollapse => Object.values(RecordCollapse).includes(value),
  fromKey: (key: keyof typeof RecordCollapse): RecordCollapse => RecordCollapse[key],
};

export type RecordDataExportError = 'exporter_unavailable' | 'failed' | 'line_limit' | 'record_limit' | 'size_limit';

export const RecordDataExportError = {
  ExporterUnavailable: 'exporter_unavailable' as const,
  Failed: 'failed' as const,
  LineLimit: 'line_limit' as const,
  RecordLimit: 'record_limit' as const,
  SizeLimit: 'size_limit' as const,
} as const;

export const RecordDataExportErrorUtils = {
  values: Object.values(RecordDataExportError),
  keys: Object.keys(RecordDataExportError) as Array<keyof typeof RecordDataExportError>,
  entries: Object.entries(RecordDataExportError) as Array<[keyof typeof RecordDataExportError, RecordDataExportError]>,
  isValid: (value: any): value is RecordDataExportError => Object.values(RecordDataExportError).includes(value),
  fromKey: (key: keyof typeof RecordDataExportError): RecordDataExportError => RecordDataExportError[key],
};

export type RecordDataExportStatus = 'completed' | 'failed' | 'pending' | 'processing';

export const RecordDataExportStatus = {
  Completed: 'completed' as const,
  Failed: 'failed' as const,
  Pending: 'pending' as const,
  Processing: 'processing' as const,
} as const;

export const RecordDataExportStatusUtils = {
  values: Object.values(RecordDataExportStatus),
  keys: Object.keys(RecordDataExportStatus) as Array<keyof typeof RecordDataExportStatus>,
  entries: Object.entries(RecordDataExportStatus) as Array<[keyof typeof RecordDataExportStatus, RecordDataExportStatus]>,
  isValid: (value: any): value is RecordDataExportStatus => Object.values(RecordDataExportStatus).includes(value),
  fromKey: (key: keyof typeof RecordDataExportStatus): RecordDataExportStatus => RecordDataExportStatus[key],
};

export type RecordDataImportBatchAttemptStatus = 'cancelled' | 'failed' | 'running' | 'succeeded';

export const RecordDataImportBatchAttemptStatus = {
  Cancelled: 'cancelled' as const,
  Failed: 'failed' as const,
  Running: 'running' as const,
  Succeeded: 'succeeded' as const,
} as const;

export const RecordDataImportBatchAttemptStatusUtils = {
  values: Object.values(RecordDataImportBatchAttemptStatus),
  keys: Object.keys(RecordDataImportBatchAttemptStatus) as Array<keyof typeof RecordDataImportBatchAttemptStatus>,
  entries: Object.entries(RecordDataImportBatchAttemptStatus) as Array<[keyof typeof RecordDataImportBatchAttemptStatus, RecordDataImportBatchAttemptStatus]>,
  isValid: (value: any): value is RecordDataImportBatchAttemptStatus => Object.values(RecordDataImportBatchAttemptStatus).includes(value),
  fromKey: (key: keyof typeof RecordDataImportBatchAttemptStatus): RecordDataImportBatchAttemptStatus => RecordDataImportBatchAttemptStatus[key],
};

export type RecordDataImportBatchKind = 'email_messages' | 'media_library_items' | 'records' | 'relations';

export const RecordDataImportBatchKind = {
  EmailMessages: 'email_messages' as const,
  MediaLibraryItems: 'media_library_items' as const,
  Records: 'records' as const,
  Relations: 'relations' as const,
} as const;

export const RecordDataImportBatchKindUtils = {
  values: Object.values(RecordDataImportBatchKind),
  keys: Object.keys(RecordDataImportBatchKind) as Array<keyof typeof RecordDataImportBatchKind>,
  entries: Object.entries(RecordDataImportBatchKind) as Array<[keyof typeof RecordDataImportBatchKind, RecordDataImportBatchKind]>,
  isValid: (value: any): value is RecordDataImportBatchKind => Object.values(RecordDataImportBatchKind).includes(value),
  fromKey: (key: keyof typeof RecordDataImportBatchKind): RecordDataImportBatchKind => RecordDataImportBatchKind[key],
};

export type RecordDataImportBatchStatus = 'cancelled' | 'failed' | 'pending' | 'queued' | 'succeeded';

export const RecordDataImportBatchStatus = {
  Cancelled: 'cancelled' as const,
  Failed: 'failed' as const,
  Pending: 'pending' as const,
  Queued: 'queued' as const,
  Succeeded: 'succeeded' as const,
} as const;

export const RecordDataImportBatchStatusUtils = {
  values: Object.values(RecordDataImportBatchStatus),
  keys: Object.keys(RecordDataImportBatchStatus) as Array<keyof typeof RecordDataImportBatchStatus>,
  entries: Object.entries(RecordDataImportBatchStatus) as Array<[keyof typeof RecordDataImportBatchStatus, RecordDataImportBatchStatus]>,
  isValid: (value: any): value is RecordDataImportBatchStatus => Object.values(RecordDataImportBatchStatus).includes(value),
  fromKey: (key: keyof typeof RecordDataImportBatchStatus): RecordDataImportBatchStatus => RecordDataImportBatchStatus[key],
};

export type RecordDataImportErrorCode = 'archive_too_large' | 'asset_not_found' | 'asset_too_large' | 'duplicate_asset' | 'duplicate_source_id' | 'empty_file' | 'field_not_writable' | 'field_validation_failed' | 'identity_not_updatable' | 'importer_unavailable' | 'invalid_archive' | 'invalid_email_message' | 'invalid_json' | 'invalid_media_library_item' | 'invalid_operation' | 'invalid_record' | 'invalid_source_reference' | 'line_too_long' | 'record_write_failed' | 'remote_file_unavailable' | 'resource_not_importable' | 'session_too_large' | 'snapshot_unreadable' | 'source_reference_cycle' | 'source_reference_not_imported' | 'too_many_files' | 'unknown_field' | 'unmapped_resource_reference' | 'unresolved_record_id' | 'unresolved_source_reference' | 'unsafe_archive';

export const RecordDataImportErrorCode = {
  ArchiveTooLarge: 'archive_too_large' as const,
  AssetNotFound: 'asset_not_found' as const,
  AssetTooLarge: 'asset_too_large' as const,
  DuplicateAsset: 'duplicate_asset' as const,
  DuplicateSourceId: 'duplicate_source_id' as const,
  EmptyFile: 'empty_file' as const,
  FieldNotWritable: 'field_not_writable' as const,
  FieldValidationFailed: 'field_validation_failed' as const,
  IdentityNotUpdatable: 'identity_not_updatable' as const,
  ImporterUnavailable: 'importer_unavailable' as const,
  InvalidArchive: 'invalid_archive' as const,
  InvalidEmailMessage: 'invalid_email_message' as const,
  InvalidJson: 'invalid_json' as const,
  InvalidMediaLibraryItem: 'invalid_media_library_item' as const,
  InvalidOperation: 'invalid_operation' as const,
  InvalidRecord: 'invalid_record' as const,
  InvalidSourceReference: 'invalid_source_reference' as const,
  LineTooLong: 'line_too_long' as const,
  RecordWriteFailed: 'record_write_failed' as const,
  RemoteFileUnavailable: 'remote_file_unavailable' as const,
  ResourceNotImportable: 'resource_not_importable' as const,
  SessionTooLarge: 'session_too_large' as const,
  SnapshotUnreadable: 'snapshot_unreadable' as const,
  SourceReferenceCycle: 'source_reference_cycle' as const,
  SourceReferenceNotImported: 'source_reference_not_imported' as const,
  TooManyFiles: 'too_many_files' as const,
  UnknownField: 'unknown_field' as const,
  UnmappedResourceReference: 'unmapped_resource_reference' as const,
  UnresolvedRecordId: 'unresolved_record_id' as const,
  UnresolvedSourceReference: 'unresolved_source_reference' as const,
  UnsafeArchive: 'unsafe_archive' as const,
} as const;

export const RecordDataImportErrorCodeUtils = {
  values: Object.values(RecordDataImportErrorCode),
  keys: Object.keys(RecordDataImportErrorCode) as Array<keyof typeof RecordDataImportErrorCode>,
  entries: Object.entries(RecordDataImportErrorCode) as Array<[keyof typeof RecordDataImportErrorCode, RecordDataImportErrorCode]>,
  isValid: (value: any): value is RecordDataImportErrorCode => Object.values(RecordDataImportErrorCode).includes(value),
  fromKey: (key: keyof typeof RecordDataImportErrorCode): RecordDataImportErrorCode => RecordDataImportErrorCode[key],
};

export type RecordDataImportEvent = 'batches_assigned' | 'batch_failed' | 'cancelled' | 'completed' | 'completed_with_failures' | 'created' | 'invalid' | 'retry_requested' | 'started' | 'validated' | 'validation_requested';

export const RecordDataImportEvent = {
  BatchesAssigned: 'batches_assigned' as const,
  BatchFailed: 'batch_failed' as const,
  Cancelled: 'cancelled' as const,
  Completed: 'completed' as const,
  CompletedWithFailures: 'completed_with_failures' as const,
  Created: 'created' as const,
  Invalid: 'invalid' as const,
  RetryRequested: 'retry_requested' as const,
  Started: 'started' as const,
  Validated: 'validated' as const,
  ValidationRequested: 'validation_requested' as const,
} as const;

export const RecordDataImportEventUtils = {
  values: Object.values(RecordDataImportEvent),
  keys: Object.keys(RecordDataImportEvent) as Array<keyof typeof RecordDataImportEvent>,
  entries: Object.entries(RecordDataImportEvent) as Array<[keyof typeof RecordDataImportEvent, RecordDataImportEvent]>,
  isValid: (value: any): value is RecordDataImportEvent => Object.values(RecordDataImportEvent).includes(value),
  fromKey: (key: keyof typeof RecordDataImportEvent): RecordDataImportEvent => RecordDataImportEvent[key],
};

export type RecordDataImportFileEvent = 'confirmed' | 'expired' | 'failed' | 'purged' | 'removed' | 'reserved' | 'upload_cleaned' | 'upload_requested' | 'verification_queued' | 'verification_started';

export const RecordDataImportFileEvent = {
  Confirmed: 'confirmed' as const,
  Expired: 'expired' as const,
  Failed: 'failed' as const,
  Purged: 'purged' as const,
  Removed: 'removed' as const,
  Reserved: 'reserved' as const,
  UploadCleaned: 'upload_cleaned' as const,
  UploadRequested: 'upload_requested' as const,
  VerificationQueued: 'verification_queued' as const,
  VerificationStarted: 'verification_started' as const,
} as const;

export const RecordDataImportFileEventUtils = {
  values: Object.values(RecordDataImportFileEvent),
  keys: Object.keys(RecordDataImportFileEvent) as Array<keyof typeof RecordDataImportFileEvent>,
  entries: Object.entries(RecordDataImportFileEvent) as Array<[keyof typeof RecordDataImportFileEvent, RecordDataImportFileEvent]>,
  isValid: (value: any): value is RecordDataImportFileEvent => Object.values(RecordDataImportFileEvent).includes(value),
  fromKey: (key: keyof typeof RecordDataImportFileEvent): RecordDataImportFileEvent => RecordDataImportFileEvent[key],
};

export type RecordDataImportFileKind = 'archive' | 'asset' | 'data';

export const RecordDataImportFileKind = {
  Archive: 'archive' as const,
  Asset: 'asset' as const,
  Data: 'data' as const,
} as const;

export const RecordDataImportFileKindUtils = {
  values: Object.values(RecordDataImportFileKind),
  keys: Object.keys(RecordDataImportFileKind) as Array<keyof typeof RecordDataImportFileKind>,
  entries: Object.entries(RecordDataImportFileKind) as Array<[keyof typeof RecordDataImportFileKind, RecordDataImportFileKind]>,
  isValid: (value: any): value is RecordDataImportFileKind => Object.values(RecordDataImportFileKind).includes(value),
  fromKey: (key: keyof typeof RecordDataImportFileKind): RecordDataImportFileKind => RecordDataImportFileKind[key],
};

export type RecordDataImportFileStatus = 'confirmed' | 'expired' | 'failed' | 'purged' | 'reserved' | 'verifying';

export const RecordDataImportFileStatus = {
  Confirmed: 'confirmed' as const,
  Expired: 'expired' as const,
  Failed: 'failed' as const,
  Purged: 'purged' as const,
  Reserved: 'reserved' as const,
  Verifying: 'verifying' as const,
} as const;

export const RecordDataImportFileStatusUtils = {
  values: Object.values(RecordDataImportFileStatus),
  keys: Object.keys(RecordDataImportFileStatus) as Array<keyof typeof RecordDataImportFileStatus>,
  entries: Object.entries(RecordDataImportFileStatus) as Array<[keyof typeof RecordDataImportFileStatus, RecordDataImportFileStatus]>,
  isValid: (value: any): value is RecordDataImportFileStatus => Object.values(RecordDataImportFileStatus).includes(value),
  fromKey: (key: keyof typeof RecordDataImportFileStatus): RecordDataImportFileStatus => RecordDataImportFileStatus[key],
};

export type RecordDataImportMatchMode = 'keep' | 'update';

export const RecordDataImportMatchMode = {
  Keep: 'keep' as const,
  Update: 'update' as const,
} as const;

export const RecordDataImportMatchModeUtils = {
  values: Object.values(RecordDataImportMatchMode),
  keys: Object.keys(RecordDataImportMatchMode) as Array<keyof typeof RecordDataImportMatchMode>,
  entries: Object.entries(RecordDataImportMatchMode) as Array<[keyof typeof RecordDataImportMatchMode, RecordDataImportMatchMode]>,
  isValid: (value: any): value is RecordDataImportMatchMode => Object.values(RecordDataImportMatchMode).includes(value),
  fromKey: (key: keyof typeof RecordDataImportMatchMode): RecordDataImportMatchMode => RecordDataImportMatchMode[key],
};

export type RecordDataImportRowOperation = 'create' | 'keep' | 'update';

export const RecordDataImportRowOperation = {
  Create: 'create' as const,
  Keep: 'keep' as const,
  Update: 'update' as const,
} as const;

export const RecordDataImportRowOperationUtils = {
  values: Object.values(RecordDataImportRowOperation),
  keys: Object.keys(RecordDataImportRowOperation) as Array<keyof typeof RecordDataImportRowOperation>,
  entries: Object.entries(RecordDataImportRowOperation) as Array<[keyof typeof RecordDataImportRowOperation, RecordDataImportRowOperation]>,
  isValid: (value: any): value is RecordDataImportRowOperation => Object.values(RecordDataImportRowOperation).includes(value),
  fromKey: (key: keyof typeof RecordDataImportRowOperation): RecordDataImportRowOperation => RecordDataImportRowOperation[key],
};

export type RecordDataImportRowOutcome = 'cancelled' | 'created' | 'failed' | 'kept' | 'rolled_back' | 'updated';

export const RecordDataImportRowOutcome = {
  Cancelled: 'cancelled' as const,
  Created: 'created' as const,
  Failed: 'failed' as const,
  Kept: 'kept' as const,
  RolledBack: 'rolled_back' as const,
  Updated: 'updated' as const,
} as const;

export const RecordDataImportRowOutcomeUtils = {
  values: Object.values(RecordDataImportRowOutcome),
  keys: Object.keys(RecordDataImportRowOutcome) as Array<keyof typeof RecordDataImportRowOutcome>,
  entries: Object.entries(RecordDataImportRowOutcome) as Array<[keyof typeof RecordDataImportRowOutcome, RecordDataImportRowOutcome]>,
  isValid: (value: any): value is RecordDataImportRowOutcome => Object.values(RecordDataImportRowOutcome).includes(value),
  fromKey: (key: keyof typeof RecordDataImportRowOutcome): RecordDataImportRowOutcome => RecordDataImportRowOutcome[key],
};

export type RecordDataImportRowOutcomeFilter = 'cancelled' | 'created' | 'failed' | 'kept' | 'not_written' | 'pending' | 'rolled_back' | 'updated' | 'written';

export const RecordDataImportRowOutcomeFilter = {
  Cancelled: 'cancelled' as const,
  Created: 'created' as const,
  Failed: 'failed' as const,
  Kept: 'kept' as const,
  NotWritten: 'not_written' as const,
  Pending: 'pending' as const,
  RolledBack: 'rolled_back' as const,
  Updated: 'updated' as const,
  Written: 'written' as const,
} as const;

export const RecordDataImportRowOutcomeFilterUtils = {
  values: Object.values(RecordDataImportRowOutcomeFilter),
  keys: Object.keys(RecordDataImportRowOutcomeFilter) as Array<keyof typeof RecordDataImportRowOutcomeFilter>,
  entries: Object.entries(RecordDataImportRowOutcomeFilter) as Array<[keyof typeof RecordDataImportRowOutcomeFilter, RecordDataImportRowOutcomeFilter]>,
  isValid: (value: any): value is RecordDataImportRowOutcomeFilter => Object.values(RecordDataImportRowOutcomeFilter).includes(value),
  fromKey: (key: keyof typeof RecordDataImportRowOutcomeFilter): RecordDataImportRowOutcomeFilter => RecordDataImportRowOutcomeFilter[key],
};

export type RecordDataImportStatus = 'cancelled' | 'completed' | 'completed_with_failures' | 'invalid' | 'open' | 'processing' | 'validated' | 'validating';

export const RecordDataImportStatus = {
  Cancelled: 'cancelled' as const,
  Completed: 'completed' as const,
  CompletedWithFailures: 'completed_with_failures' as const,
  Invalid: 'invalid' as const,
  Open: 'open' as const,
  Processing: 'processing' as const,
  Validated: 'validated' as const,
  Validating: 'validating' as const,
} as const;

export const RecordDataImportStatusUtils = {
  values: Object.values(RecordDataImportStatus),
  keys: Object.keys(RecordDataImportStatus) as Array<keyof typeof RecordDataImportStatus>,
  entries: Object.entries(RecordDataImportStatus) as Array<[keyof typeof RecordDataImportStatus, RecordDataImportStatus]>,
  isValid: (value: any): value is RecordDataImportStatus => Object.values(RecordDataImportStatus).includes(value),
  fromKey: (key: keyof typeof RecordDataImportStatus): RecordDataImportStatus => RecordDataImportStatus[key],
};

export type RecordDataImportTarget = 'email_message' | 'media_library_item' | 'record';

export const RecordDataImportTarget = {
  EmailMessage: 'email_message' as const,
  MediaLibraryItem: 'media_library_item' as const,
  Record: 'record' as const,
} as const;

export const RecordDataImportTargetUtils = {
  values: Object.values(RecordDataImportTarget),
  keys: Object.keys(RecordDataImportTarget) as Array<keyof typeof RecordDataImportTarget>,
  entries: Object.entries(RecordDataImportTarget) as Array<[keyof typeof RecordDataImportTarget, RecordDataImportTarget]>,
  isValid: (value: any): value is RecordDataImportTarget => Object.values(RecordDataImportTarget).includes(value),
  fromKey: (key: keyof typeof RecordDataImportTarget): RecordDataImportTarget => RecordDataImportTarget[key],
};

export type RecordDataImportValidationPhase = 'finalizing' | 'preparing' | 'records';

export const RecordDataImportValidationPhase = {
  Finalizing: 'finalizing' as const,
  Preparing: 'preparing' as const,
  Records: 'records' as const,
} as const;

export const RecordDataImportValidationPhaseUtils = {
  values: Object.values(RecordDataImportValidationPhase),
  keys: Object.keys(RecordDataImportValidationPhase) as Array<keyof typeof RecordDataImportValidationPhase>,
  entries: Object.entries(RecordDataImportValidationPhase) as Array<[keyof typeof RecordDataImportValidationPhase, RecordDataImportValidationPhase]>,
  isValid: (value: any): value is RecordDataImportValidationPhase => Object.values(RecordDataImportValidationPhase).includes(value),
  fromKey: (key: keyof typeof RecordDataImportValidationPhase): RecordDataImportValidationPhase => RecordDataImportValidationPhase[key],
};

export type RecordDeletionEffectKind = 'archive' | 'block' | 'clear';

export const RecordDeletionEffectKind = {
  Archive: 'archive' as const,
  Block: 'block' as const,
  Clear: 'clear' as const,
} as const;

export const RecordDeletionEffectKindUtils = {
  values: Object.values(RecordDeletionEffectKind),
  keys: Object.keys(RecordDeletionEffectKind) as Array<keyof typeof RecordDeletionEffectKind>,
  entries: Object.entries(RecordDeletionEffectKind) as Array<[keyof typeof RecordDeletionEffectKind, RecordDeletionEffectKind]>,
  isValid: (value: any): value is RecordDeletionEffectKind => Object.values(RecordDeletionEffectKind).includes(value),
  fromKey: (key: keyof typeof RecordDeletionEffectKind): RecordDeletionEffectKind => RecordDeletionEffectKind[key],
};

export type RecordExportFormat = 'csv' | 'json' | 'xlsx';

export const RecordExportFormat = {
  Csv: 'csv' as const,
  Json: 'json' as const,
  Xlsx: 'xlsx' as const,
} as const;

export const RecordExportFormatUtils = {
  values: Object.values(RecordExportFormat),
  keys: Object.keys(RecordExportFormat) as Array<keyof typeof RecordExportFormat>,
  entries: Object.entries(RecordExportFormat) as Array<[keyof typeof RecordExportFormat, RecordExportFormat]>,
  isValid: (value: any): value is RecordExportFormat => Object.values(RecordExportFormat).includes(value),
  fromKey: (key: keyof typeof RecordExportFormat): RecordExportFormat => RecordExportFormat[key],
};

export type RecordRestoreEffectKind = 'cascade' | 'parent';

export const RecordRestoreEffectKind = {
  Cascade: 'cascade' as const,
  Parent: 'parent' as const,
} as const;

export const RecordRestoreEffectKindUtils = {
  values: Object.values(RecordRestoreEffectKind),
  keys: Object.keys(RecordRestoreEffectKind) as Array<keyof typeof RecordRestoreEffectKind>,
  entries: Object.entries(RecordRestoreEffectKind) as Array<[keyof typeof RecordRestoreEffectKind, RecordRestoreEffectKind]>,
  isValid: (value: any): value is RecordRestoreEffectKind => Object.values(RecordRestoreEffectKind).includes(value),
  fromKey: (key: keyof typeof RecordRestoreEffectKind): RecordRestoreEffectKind => RecordRestoreEffectKind[key],
};

export type RecordScope = 'active' | 'activeOrArchived' | 'archived';

export const RecordScope = {
  Active: 'active' as const,
  ActiveOrArchived: 'activeOrArchived' as const,
  Archived: 'archived' as const,
} as const;

export const RecordScopeUtils = {
  values: Object.values(RecordScope),
  keys: Object.keys(RecordScope) as Array<keyof typeof RecordScope>,
  entries: Object.entries(RecordScope) as Array<[keyof typeof RecordScope, RecordScope]>,
  isValid: (value: any): value is RecordScope => Object.values(RecordScope).includes(value),
  fromKey: (key: keyof typeof RecordScope): RecordScope => RecordScope[key],
};

export type RecordWriteOrigin = 'integration' | 'person' | 'series' | 'system' | 'workflow';

export const RecordWriteOrigin = {
  Integration: 'integration' as const,
  Person: 'person' as const,
  Series: 'series' as const,
  System: 'system' as const,
  Workflow: 'workflow' as const,
} as const;

export const RecordWriteOriginUtils = {
  values: Object.values(RecordWriteOrigin),
  keys: Object.keys(RecordWriteOrigin) as Array<keyof typeof RecordWriteOrigin>,
  entries: Object.entries(RecordWriteOrigin) as Array<[keyof typeof RecordWriteOrigin, RecordWriteOrigin]>,
  isValid: (value: any): value is RecordWriteOrigin => Object.values(RecordWriteOrigin).includes(value),
  fromKey: (key: keyof typeof RecordWriteOrigin): RecordWriteOrigin => RecordWriteOrigin[key],
};

export type RelationOutputRule = 'keep' | 'strip';

export const RelationOutputRule = {
  Keep: 'keep' as const,
  Strip: 'strip' as const,
} as const;

export const RelationOutputRuleUtils = {
  values: Object.values(RelationOutputRule),
  keys: Object.keys(RelationOutputRule) as Array<keyof typeof RelationOutputRule>,
  entries: Object.entries(RelationOutputRule) as Array<[keyof typeof RelationOutputRule, RelationOutputRule]>,
  isValid: (value: any): value is RelationOutputRule => Object.values(RelationOutputRule).includes(value),
  fromKey: (key: keyof typeof RelationOutputRule): RelationOutputRule => RelationOutputRule[key],
};

export type ResourceConfigurationIssueCode = 'capability_field_missing' | 'capability_field_not_unique' | 'display_field_missing' | 'duplicate_field_key' | 'invalid_delete_policy' | 'invalid_field_type' | 'invalid_max_connections' | 'invalid_relation_type' | 'missing_inverse_relation' | 'missing_relation_target';

export const ResourceConfigurationIssueCode = {
  CapabilityFieldMissing: 'capability_field_missing' as const,
  CapabilityFieldNotUnique: 'capability_field_not_unique' as const,
  DisplayFieldMissing: 'display_field_missing' as const,
  DuplicateFieldKey: 'duplicate_field_key' as const,
  InvalidDeletePolicy: 'invalid_delete_policy' as const,
  InvalidFieldType: 'invalid_field_type' as const,
  InvalidMaxConnections: 'invalid_max_connections' as const,
  InvalidRelationType: 'invalid_relation_type' as const,
  MissingInverseRelation: 'missing_inverse_relation' as const,
  MissingRelationTarget: 'missing_relation_target' as const,
} as const;

export const ResourceConfigurationIssueCodeUtils = {
  values: Object.values(ResourceConfigurationIssueCode),
  keys: Object.keys(ResourceConfigurationIssueCode) as Array<keyof typeof ResourceConfigurationIssueCode>,
  entries: Object.entries(ResourceConfigurationIssueCode) as Array<[keyof typeof ResourceConfigurationIssueCode, ResourceConfigurationIssueCode]>,
  isValid: (value: any): value is ResourceConfigurationIssueCode => Object.values(ResourceConfigurationIssueCode).includes(value),
  fromKey: (key: keyof typeof ResourceConfigurationIssueCode): ResourceConfigurationIssueCode => ResourceConfigurationIssueCode[key],
};

export type ResourceIndexView = 'canvas' | 'list';

export const ResourceIndexView = {
  Canvas: 'canvas' as const,
  List: 'list' as const,
} as const;

export const ResourceIndexViewUtils = {
  values: Object.values(ResourceIndexView),
  keys: Object.keys(ResourceIndexView) as Array<keyof typeof ResourceIndexView>,
  entries: Object.entries(ResourceIndexView) as Array<[keyof typeof ResourceIndexView, ResourceIndexView]>,
  isValid: (value: any): value is ResourceIndexView => Object.values(ResourceIndexView).includes(value),
  fromKey: (key: keyof typeof ResourceIndexView): ResourceIndexView => ResourceIndexView[key],
};

export type RevisionOperation = 'created' | 'deleted' | 'updated';

export const RevisionOperation = {
  Created: 'created' as const,
  Deleted: 'deleted' as const,
  Updated: 'updated' as const,
} as const;

export const RevisionOperationUtils = {
  values: Object.values(RevisionOperation),
  keys: Object.keys(RevisionOperation) as Array<keyof typeof RevisionOperation>,
  entries: Object.entries(RevisionOperation) as Array<[keyof typeof RevisionOperation, RevisionOperation]>,
  isValid: (value: any): value is RevisionOperation => Object.values(RevisionOperation).includes(value),
  fromKey: (key: keyof typeof RevisionOperation): RevisionOperation => RevisionOperation[key],
};

export type SortDirection = 'asc' | 'desc';

export const SortDirection = {
  Asc: 'asc' as const,
  Desc: 'desc' as const,
} as const;

export const SortDirectionUtils = {
  values: Object.values(SortDirection),
  keys: Object.keys(SortDirection) as Array<keyof typeof SortDirection>,
  entries: Object.entries(SortDirection) as Array<[keyof typeof SortDirection, SortDirection]>,
  isValid: (value: any): value is SortDirection => Object.values(SortDirection).includes(value),
  fromKey: (key: keyof typeof SortDirection): SortDirection => SortDirection[key],
};

export type DeletePolicy = 'cascade' | 'ignore' | 'restrict' | 'set_null';

export const DeletePolicy = {
  Cascade: 'cascade' as const,
  Ignore: 'ignore' as const,
  Restrict: 'restrict' as const,
  SetNull: 'set_null' as const,
} as const;

export const DeletePolicyUtils = {
  values: Object.values(DeletePolicy),
  keys: Object.keys(DeletePolicy) as Array<keyof typeof DeletePolicy>,
  entries: Object.entries(DeletePolicy) as Array<[keyof typeof DeletePolicy, DeletePolicy]>,
  isValid: (value: any): value is DeletePolicy => Object.values(DeletePolicy).includes(value),
  fromKey: (key: keyof typeof DeletePolicy): DeletePolicy => DeletePolicy[key],
};

export type EdgeKind = 'links_to';

export const EdgeKind = {
  LinksTo: 'links_to' as const,
} as const;

export const EdgeKindUtils = {
  values: Object.values(EdgeKind),
  keys: Object.keys(EdgeKind) as Array<keyof typeof EdgeKind>,
  entries: Object.entries(EdgeKind) as Array<[keyof typeof EdgeKind, EdgeKind]>,
  isValid: (value: any): value is EdgeKind => Object.values(EdgeKind).includes(value),
  fromKey: (key: keyof typeof EdgeKind): EdgeKind => EdgeKind[key],
};

export type EntityGraphNeighborhoodDirection = 'both' | 'incoming' | 'outgoing';

export const EntityGraphNeighborhoodDirection = {
  Both: 'both' as const,
  Incoming: 'incoming' as const,
  Outgoing: 'outgoing' as const,
} as const;

export const EntityGraphNeighborhoodDirectionUtils = {
  values: Object.values(EntityGraphNeighborhoodDirection),
  keys: Object.keys(EntityGraphNeighborhoodDirection) as Array<keyof typeof EntityGraphNeighborhoodDirection>,
  entries: Object.entries(EntityGraphNeighborhoodDirection) as Array<[keyof typeof EntityGraphNeighborhoodDirection, EntityGraphNeighborhoodDirection]>,
  isValid: (value: any): value is EntityGraphNeighborhoodDirection => Object.values(EntityGraphNeighborhoodDirection).includes(value),
  fromKey: (key: keyof typeof EntityGraphNeighborhoodDirection): EntityGraphNeighborhoodDirection => EntityGraphNeighborhoodDirection[key],
};

export type EntityStore = 'mongo' | 'postgres';

export const EntityStore = {
  Mongo: 'mongo' as const,
  Postgres: 'postgres' as const,
} as const;

export const EntityStoreUtils = {
  values: Object.values(EntityStore),
  keys: Object.keys(EntityStore) as Array<keyof typeof EntityStore>,
  entries: Object.entries(EntityStore) as Array<[keyof typeof EntityStore, EntityStore]>,
  isValid: (value: any): value is EntityStore => Object.values(EntityStore).includes(value),
  fromKey: (key: keyof typeof EntityStore): EntityStore => EntityStore[key],
};

export type EntityType = 'capability_definition' | 'component' | 'domain' | 'email_layout' | 'field' | 'file' | 'folder' | 'media_library_item' | 'navigation_menu' | 'navigation_menu_item' | 'notification_schedule' | 'notification_template' | 'notification_type' | 'page' | 'page_version' | 'permission' | 'policy' | 'record' | 'resource' | 'role' | 'scheduled_notification' | 'skill' | 'test_suite' | 'test_suite_case' | 'workflow' | 'workflow_scenario' | 'workflow_step' | 'workflow_transition' | 'workflow_variable' | 'workflow_version' | 'workspace' | 'workspace_field' | 'workspace_redirect';

export const EntityType = {
  CapabilityDefinition: 'capability_definition' as const,
  Component: 'component' as const,
  Domain: 'domain' as const,
  EmailLayout: 'email_layout' as const,
  Field: 'field' as const,
  File: 'file' as const,
  Folder: 'folder' as const,
  MediaLibraryItem: 'media_library_item' as const,
  NavigationMenu: 'navigation_menu' as const,
  NavigationMenuItem: 'navigation_menu_item' as const,
  NotificationSchedule: 'notification_schedule' as const,
  NotificationTemplate: 'notification_template' as const,
  NotificationType: 'notification_type' as const,
  Page: 'page' as const,
  PageVersion: 'page_version' as const,
  Permission: 'permission' as const,
  Policy: 'policy' as const,
  Record: 'record' as const,
  Resource: 'resource' as const,
  Role: 'role' as const,
  ScheduledNotification: 'scheduled_notification' as const,
  Skill: 'skill' as const,
  TestSuite: 'test_suite' as const,
  TestSuiteCase: 'test_suite_case' as const,
  Workflow: 'workflow' as const,
  WorkflowScenario: 'workflow_scenario' as const,
  WorkflowStep: 'workflow_step' as const,
  WorkflowTransition: 'workflow_transition' as const,
  WorkflowVariable: 'workflow_variable' as const,
  WorkflowVersion: 'workflow_version' as const,
  Workspace: 'workspace' as const,
  WorkspaceField: 'workspace_field' as const,
  WorkspaceRedirect: 'workspace_redirect' as const,
} as const;

export const EntityTypeUtils = {
  values: Object.values(EntityType),
  keys: Object.keys(EntityType) as Array<keyof typeof EntityType>,
  entries: Object.entries(EntityType) as Array<[keyof typeof EntityType, EntityType]>,
  isValid: (value: any): value is EntityType => Object.values(EntityType).includes(value),
  fromKey: (key: keyof typeof EntityType): EntityType => EntityType[key],
};

export type PackagePolicy = 'owned' | 'required';

export const PackagePolicy = {
  Owned: 'owned' as const,
  Required: 'required' as const,
} as const;

export const PackagePolicyUtils = {
  values: Object.values(PackagePolicy),
  keys: Object.keys(PackagePolicy) as Array<keyof typeof PackagePolicy>,
  entries: Object.entries(PackagePolicy) as Array<[keyof typeof PackagePolicy, PackagePolicy]>,
  isValid: (value: any): value is PackagePolicy => Object.values(PackagePolicy).includes(value),
  fromKey: (key: keyof typeof PackagePolicy): PackagePolicy => PackagePolicy[key],
};

export type FileAttachmentType = 'document' | 'image';

export const FileAttachmentType = {
  Document: 'document' as const,
  Image: 'image' as const,
} as const;

export const FileAttachmentTypeUtils = {
  values: Object.values(FileAttachmentType),
  keys: Object.keys(FileAttachmentType) as Array<keyof typeof FileAttachmentType>,
  entries: Object.entries(FileAttachmentType) as Array<[keyof typeof FileAttachmentType, FileAttachmentType]>,
  isValid: (value: any): value is FileAttachmentType => Object.values(FileAttachmentType).includes(value),
  fromKey: (key: keyof typeof FileAttachmentType): FileAttachmentType => FileAttachmentType[key],
};

export type FileDisk = 's3' | 's3-public';

export const FileDisk = {
  Private: 's3' as const,
  Public: 's3-public' as const,
} as const;

export const FileDiskUtils = {
  values: Object.values(FileDisk),
  keys: Object.keys(FileDisk) as Array<keyof typeof FileDisk>,
  entries: Object.entries(FileDisk) as Array<[keyof typeof FileDisk, FileDisk]>,
  isValid: (value: any): value is FileDisk => Object.values(FileDisk).includes(value),
  fromKey: (key: keyof typeof FileDisk): FileDisk => FileDisk[key],
};

export type FileExtractionKind = 'content_summary' | 'text' | 'transcript' | 'visual_reference_brief';

export const FileExtractionKind = {
  ContentSummary: 'content_summary' as const,
  Text: 'text' as const,
  Transcript: 'transcript' as const,
  VisualReferenceBrief: 'visual_reference_brief' as const,
} as const;

export const FileExtractionKindUtils = {
  values: Object.values(FileExtractionKind),
  keys: Object.keys(FileExtractionKind) as Array<keyof typeof FileExtractionKind>,
  entries: Object.entries(FileExtractionKind) as Array<[keyof typeof FileExtractionKind, FileExtractionKind]>,
  isValid: (value: any): value is FileExtractionKind => Object.values(FileExtractionKind).includes(value),
  fromKey: (key: keyof typeof FileExtractionKind): FileExtractionKind => FileExtractionKind[key],
};

export type FileExtractionStatus = 'completed' | 'failed' | 'pending';

export const FileExtractionStatus = {
  Completed: 'completed' as const,
  Failed: 'failed' as const,
  Pending: 'pending' as const,
} as const;

export const FileExtractionStatusUtils = {
  values: Object.values(FileExtractionStatus),
  keys: Object.keys(FileExtractionStatus) as Array<keyof typeof FileExtractionStatus>,
  entries: Object.entries(FileExtractionStatus) as Array<[keyof typeof FileExtractionStatus, FileExtractionStatus]>,
  isValid: (value: any): value is FileExtractionStatus => Object.values(FileExtractionStatus).includes(value),
  fromKey: (key: keyof typeof FileExtractionStatus): FileExtractionStatus => FileExtractionStatus[key],
};

export type FileMimeType = 'image/*' | 'audio/mpeg' | 'application/pdf' | 'audio/wav';

export const FileMimeType = {
  Image: 'image/*' as const,
  Mp3: 'audio/mpeg' as const,
  Pdf: 'application/pdf' as const,
  Wav: 'audio/wav' as const,
} as const;

export const FileMimeTypeUtils = {
  values: Object.values(FileMimeType),
  keys: Object.keys(FileMimeType) as Array<keyof typeof FileMimeType>,
  entries: Object.entries(FileMimeType) as Array<[keyof typeof FileMimeType, FileMimeType]>,
  isValid: (value: any): value is FileMimeType => Object.values(FileMimeType).includes(value),
  fromKey: (key: keyof typeof FileMimeType): FileMimeType => FileMimeType[key],
};

export type FileVisibility = 'private' | 'public';

export const FileVisibility = {
  Private: 'private' as const,
  Public: 'public' as const,
} as const;

export const FileVisibilityUtils = {
  values: Object.values(FileVisibility),
  keys: Object.keys(FileVisibility) as Array<keyof typeof FileVisibility>,
  entries: Object.entries(FileVisibility) as Array<[keyof typeof FileVisibility, FileVisibility]>,
  isValid: (value: any): value is FileVisibility => Object.values(FileVisibility).includes(value),
  fromKey: (key: keyof typeof FileVisibility): FileVisibility => FileVisibility[key],
};

export type ImageAnimationBackfillStatus = 'already_classified' | 'skipped' | 'unknown' | 'updated' | 'would_update';

export const ImageAnimationBackfillStatus = {
  AlreadyClassified: 'already_classified' as const,
  Skipped: 'skipped' as const,
  Unknown: 'unknown' as const,
  Updated: 'updated' as const,
  WouldUpdate: 'would_update' as const,
} as const;

export const ImageAnimationBackfillStatusUtils = {
  values: Object.values(ImageAnimationBackfillStatus),
  keys: Object.keys(ImageAnimationBackfillStatus) as Array<keyof typeof ImageAnimationBackfillStatus>,
  entries: Object.entries(ImageAnimationBackfillStatus) as Array<[keyof typeof ImageAnimationBackfillStatus, ImageAnimationBackfillStatus]>,
  isValid: (value: any): value is ImageAnimationBackfillStatus => Object.values(ImageAnimationBackfillStatus).includes(value),
  fromKey: (key: keyof typeof ImageAnimationBackfillStatus): ImageAnimationBackfillStatus => ImageAnimationBackfillStatus[key],
};

export type MediaLibraryFileOwnership = 'external' | 'library' | 'uncertain';

export const MediaLibraryFileOwnership = {
  External: 'external' as const,
  Library: 'library' as const,
  Uncertain: 'uncertain' as const,
} as const;

export const MediaLibraryFileOwnershipUtils = {
  values: Object.values(MediaLibraryFileOwnership),
  keys: Object.keys(MediaLibraryFileOwnership) as Array<keyof typeof MediaLibraryFileOwnership>,
  entries: Object.entries(MediaLibraryFileOwnership) as Array<[keyof typeof MediaLibraryFileOwnership, MediaLibraryFileOwnership]>,
  isValid: (value: any): value is MediaLibraryFileOwnership => Object.values(MediaLibraryFileOwnership).includes(value),
  fromKey: (key: keyof typeof MediaLibraryFileOwnership): MediaLibraryFileOwnership => MediaLibraryFileOwnership[key],
};

export type MediaLibraryImageDisposition = 'already_processed' | 'converted' | 'failed' | 'passthrough' | 'skipped';

export const MediaLibraryImageDisposition = {
  AlreadyProcessed: 'already_processed' as const,
  Converted: 'converted' as const,
  Failed: 'failed' as const,
  Passthrough: 'passthrough' as const,
  Skipped: 'skipped' as const,
} as const;

export const MediaLibraryImageDispositionUtils = {
  values: Object.values(MediaLibraryImageDisposition),
  keys: Object.keys(MediaLibraryImageDisposition) as Array<keyof typeof MediaLibraryImageDisposition>,
  entries: Object.entries(MediaLibraryImageDisposition) as Array<[keyof typeof MediaLibraryImageDisposition, MediaLibraryImageDisposition]>,
  isValid: (value: any): value is MediaLibraryImageDisposition => Object.values(MediaLibraryImageDisposition).includes(value),
  fromKey: (key: keyof typeof MediaLibraryImageDisposition): MediaLibraryImageDisposition => MediaLibraryImageDisposition[key],
};

export type PendingFileImportStatus = 'completed' | 'failed' | 'pending' | 'processing' | 'skipped';

export const PendingFileImportStatus = {
  Completed: 'completed' as const,
  Failed: 'failed' as const,
  Pending: 'pending' as const,
  Processing: 'processing' as const,
  Skipped: 'skipped' as const,
} as const;

export const PendingFileImportStatusUtils = {
  values: Object.values(PendingFileImportStatus),
  keys: Object.keys(PendingFileImportStatus) as Array<keyof typeof PendingFileImportStatus>,
  entries: Object.entries(PendingFileImportStatus) as Array<[keyof typeof PendingFileImportStatus, PendingFileImportStatus]>,
  isValid: (value: any): value is PendingFileImportStatus => Object.values(PendingFileImportStatus).includes(value),
  fromKey: (key: keyof typeof PendingFileImportStatus): PendingFileImportStatus => PendingFileImportStatus[key],
};

export type PublicObjectHeaderBackfillStatus = 'already_correct' | 'missing' | 'skipped' | 'updated' | 'would_update';

export const PublicObjectHeaderBackfillStatus = {
  AlreadyCorrect: 'already_correct' as const,
  Missing: 'missing' as const,
  Skipped: 'skipped' as const,
  Updated: 'updated' as const,
  WouldUpdate: 'would_update' as const,
} as const;

export const PublicObjectHeaderBackfillStatusUtils = {
  values: Object.values(PublicObjectHeaderBackfillStatus),
  keys: Object.keys(PublicObjectHeaderBackfillStatus) as Array<keyof typeof PublicObjectHeaderBackfillStatus>,
  entries: Object.entries(PublicObjectHeaderBackfillStatus) as Array<[keyof typeof PublicObjectHeaderBackfillStatus, PublicObjectHeaderBackfillStatus]>,
  isValid: (value: any): value is PublicObjectHeaderBackfillStatus => Object.values(PublicObjectHeaderBackfillStatus).includes(value),
  fromKey: (key: keyof typeof PublicObjectHeaderBackfillStatus): PublicObjectHeaderBackfillStatus => PublicObjectHeaderBackfillStatus[key],
};

export type QrCodeErrorCorrection = 'H' | 'L' | 'M' | 'Q';

export const QrCodeErrorCorrection = {
  High: 'H' as const,
  Low: 'L' as const,
  Medium: 'M' as const,
  Quartile: 'Q' as const,
} as const;

export const QrCodeErrorCorrectionUtils = {
  values: Object.values(QrCodeErrorCorrection),
  keys: Object.keys(QrCodeErrorCorrection) as Array<keyof typeof QrCodeErrorCorrection>,
  entries: Object.entries(QrCodeErrorCorrection) as Array<[keyof typeof QrCodeErrorCorrection, QrCodeErrorCorrection]>,
  isValid: (value: any): value is QrCodeErrorCorrection => Object.values(QrCodeErrorCorrection).includes(value),
  fromKey: (key: keyof typeof QrCodeErrorCorrection): QrCodeErrorCorrection => QrCodeErrorCorrection[key],
};

export type CloudDomainVerificationMethod = 'pre_verification' | 'real_time';

export const CloudDomainVerificationMethod = {
  PreVerification: 'pre_verification' as const,
  RealTime: 'real_time' as const,
} as const;

export const CloudDomainVerificationMethodUtils = {
  values: Object.values(CloudDomainVerificationMethod),
  keys: Object.keys(CloudDomainVerificationMethod) as Array<keyof typeof CloudDomainVerificationMethod>,
  entries: Object.entries(CloudDomainVerificationMethod) as Array<[keyof typeof CloudDomainVerificationMethod, CloudDomainVerificationMethod]>,
  isValid: (value: any): value is CloudDomainVerificationMethod => Object.values(CloudDomainVerificationMethod).includes(value),
  fromKey: (key: keyof typeof CloudDomainVerificationMethod): CloudDomainVerificationMethod => CloudDomainVerificationMethod[key],
};

export type PdfFormat = 'a3' | 'a4' | 'a5' | 'legal' | 'letter' | 'tabloid';

export const PdfFormat = {
  A3: 'a3' as const,
  A4: 'a4' as const,
  A5: 'a5' as const,
  Legal: 'legal' as const,
  Letter: 'letter' as const,
  Tabloid: 'tabloid' as const,
} as const;

export const PdfFormatUtils = {
  values: Object.values(PdfFormat),
  keys: Object.keys(PdfFormat) as Array<keyof typeof PdfFormat>,
  entries: Object.entries(PdfFormat) as Array<[keyof typeof PdfFormat, PdfFormat]>,
  isValid: (value: any): value is PdfFormat => Object.values(PdfFormat).includes(value),
  fromKey: (key: keyof typeof PdfFormat): PdfFormat => PdfFormat[key],
};

export type ScreenshotFormat = 'jpeg' | 'png' | 'webp';

export const ScreenshotFormat = {
  Jpeg: 'jpeg' as const,
  Png: 'png' as const,
  Webp: 'webp' as const,
} as const;

export const ScreenshotFormatUtils = {
  values: Object.values(ScreenshotFormat),
  keys: Object.keys(ScreenshotFormat) as Array<keyof typeof ScreenshotFormat>,
  entries: Object.entries(ScreenshotFormat) as Array<[keyof typeof ScreenshotFormat, ScreenshotFormat]>,
  isValid: (value: any): value is ScreenshotFormat => Object.values(ScreenshotFormat).includes(value),
  fromKey: (key: keyof typeof ScreenshotFormat): ScreenshotFormat => ScreenshotFormat[key],
};

export type CloudflareStrategy = 'dns' | 'dns_proxy' | 'none';

export const CloudflareStrategy = {
  Dns: 'dns' as const,
  DnsProxy: 'dns_proxy' as const,
  None: 'none' as const,
} as const;

export const CloudflareStrategyUtils = {
  values: Object.values(CloudflareStrategy),
  keys: Object.keys(CloudflareStrategy) as Array<keyof typeof CloudflareStrategy>,
  entries: Object.entries(CloudflareStrategy) as Array<[keyof typeof CloudflareStrategy, CloudflareStrategy]>,
  isValid: (value: any): value is CloudflareStrategy => Object.values(CloudflareStrategy).includes(value),
  fromKey: (key: keyof typeof CloudflareStrategy): CloudflareStrategy => CloudflareStrategy[key],
};

export type DataLakeEventType = 'product.ai_assistant.expanded' | 'ops.booking.admitted' | 'ops.booking.refused' | 'product.calendar_link.added' | 'product.calendar_link.removed' | 'product.calendar_login.reconnect_required' | 'ops.calendar_sync.health_alarm' | 'product.checkout.completed' | 'product.email.bounced' | 'product.email.clicked' | 'product.email.delivered' | 'product.email.dropped' | 'product.email.opened' | 'product.email.sent' | 'product.email.spam_reported' | 'product.email.unsubscribed' | 'product.page.viewed' | 'product.payment_account.connected' | 'product.payment_account.disconnected' | 'product.payment_account.verified' | 'product.payment.disputed' | 'product.payment.failed' | 'product.payment.refunded' | 'product.payment.succeeded' | 'ops.scheduling.health_alarm' | 'ops.series.reconciled' | 'product.subscription.canceled' | 'product.subscription.created' | 'product.user.impersonated' | 'product.user.locked_out' | 'product.user.password_reset' | 'product.user.signed_in' | 'product.user.signed_out' | 'product.user.sign_in_failed' | 'product.workflow_run.completed' | 'product.workflow_run.failed' | 'ops.workspace.created';

export const DataLakeEventType = {
  AiAssistantExpanded: 'product.ai_assistant.expanded' as const,
  BookingAdmitted: 'ops.booking.admitted' as const,
  BookingRefused: 'ops.booking.refused' as const,
  CalendarLinkAdded: 'product.calendar_link.added' as const,
  CalendarLinkRemoved: 'product.calendar_link.removed' as const,
  CalendarLoginReconnectRequired: 'product.calendar_login.reconnect_required' as const,
  CalendarSyncHealthAlarm: 'ops.calendar_sync.health_alarm' as const,
  CheckoutCompleted: 'product.checkout.completed' as const,
  EmailBounced: 'product.email.bounced' as const,
  EmailClicked: 'product.email.clicked' as const,
  EmailDelivered: 'product.email.delivered' as const,
  EmailDropped: 'product.email.dropped' as const,
  EmailOpened: 'product.email.opened' as const,
  EmailSent: 'product.email.sent' as const,
  EmailSpamReported: 'product.email.spam_reported' as const,
  EmailUnsubscribed: 'product.email.unsubscribed' as const,
  PageViewed: 'product.page.viewed' as const,
  PaymentAccountConnected: 'product.payment_account.connected' as const,
  PaymentAccountDisconnected: 'product.payment_account.disconnected' as const,
  PaymentAccountVerified: 'product.payment_account.verified' as const,
  PaymentDisputed: 'product.payment.disputed' as const,
  PaymentFailed: 'product.payment.failed' as const,
  PaymentRefunded: 'product.payment.refunded' as const,
  PaymentSucceeded: 'product.payment.succeeded' as const,
  SchedulingHealthAlarm: 'ops.scheduling.health_alarm' as const,
  SeriesReconciled: 'ops.series.reconciled' as const,
  SubscriptionCanceled: 'product.subscription.canceled' as const,
  SubscriptionCreated: 'product.subscription.created' as const,
  UserImpersonated: 'product.user.impersonated' as const,
  UserLockedOut: 'product.user.locked_out' as const,
  UserPasswordReset: 'product.user.password_reset' as const,
  UserSignedIn: 'product.user.signed_in' as const,
  UserSignedOut: 'product.user.signed_out' as const,
  UserSignInFailed: 'product.user.sign_in_failed' as const,
  WorkflowRunCompleted: 'product.workflow_run.completed' as const,
  WorkflowRunFailed: 'product.workflow_run.failed' as const,
  WorkspaceCreated: 'ops.workspace.created' as const,
} as const;

export const DataLakeEventTypeUtils = {
  values: Object.values(DataLakeEventType),
  keys: Object.keys(DataLakeEventType) as Array<keyof typeof DataLakeEventType>,
  entries: Object.entries(DataLakeEventType) as Array<[keyof typeof DataLakeEventType, DataLakeEventType]>,
  isValid: (value: any): value is DataLakeEventType => Object.values(DataLakeEventType).includes(value),
  fromKey: (key: keyof typeof DataLakeEventType): DataLakeEventType => DataLakeEventType[key],
};

export type CrawlFormat = 'branding' | 'html' | 'images' | 'links' | 'markdown' | 'product' | 'summary';

export const CrawlFormat = {
  Branding: 'branding' as const,
  Html: 'html' as const,
  Images: 'images' as const,
  Links: 'links' as const,
  Markdown: 'markdown' as const,
  Product: 'product' as const,
  Summary: 'summary' as const,
} as const;

export const CrawlFormatUtils = {
  values: Object.values(CrawlFormat),
  keys: Object.keys(CrawlFormat) as Array<keyof typeof CrawlFormat>,
  entries: Object.entries(CrawlFormat) as Array<[keyof typeof CrawlFormat, CrawlFormat]>,
  isValid: (value: any): value is CrawlFormat => Object.values(CrawlFormat).includes(value),
  fromKey: (key: keyof typeof CrawlFormat): CrawlFormat => CrawlFormat[key],
};

export type ScrapeFormat = 'branding' | 'html' | 'images' | 'markdown';

export const ScrapeFormat = {
  Branding: 'branding' as const,
  Html: 'html' as const,
  Images: 'images' as const,
  Markdown: 'markdown' as const,
} as const;

export const ScrapeFormatUtils = {
  values: Object.values(ScrapeFormat),
  keys: Object.keys(ScrapeFormat) as Array<keyof typeof ScrapeFormat>,
  entries: Object.entries(ScrapeFormat) as Array<[keyof typeof ScrapeFormat, ScrapeFormat]>,
  isValid: (value: any): value is ScrapeFormat => Object.values(ScrapeFormat).includes(value),
  fromKey: (key: keyof typeof ScrapeFormat): ScrapeFormat => ScrapeFormat[key],
};

export type ScrapeMode = 'content' | 'json';

export const ScrapeMode = {
  Content: 'content' as const,
  Json: 'json' as const,
} as const;

export const ScrapeModeUtils = {
  values: Object.values(ScrapeMode),
  keys: Object.keys(ScrapeMode) as Array<keyof typeof ScrapeMode>,
  entries: Object.entries(ScrapeMode) as Array<[keyof typeof ScrapeMode, ScrapeMode]>,
  isValid: (value: any): value is ScrapeMode => Object.values(ScrapeMode).includes(value),
  fromKey: (key: keyof typeof ScrapeMode): ScrapeMode => ScrapeMode[key],
};

export type CalendarCheckPhase = 'links' | 'logins';

export const CalendarCheckPhase = {
  Links: 'links' as const,
  Logins: 'logins' as const,
} as const;

export const CalendarCheckPhaseUtils = {
  values: Object.values(CalendarCheckPhase),
  keys: Object.keys(CalendarCheckPhase) as Array<keyof typeof CalendarCheckPhase>,
  entries: Object.entries(CalendarCheckPhase) as Array<[keyof typeof CalendarCheckPhase, CalendarCheckPhase]>,
  isValid: (value: any): value is CalendarCheckPhase => Object.values(CalendarCheckPhase).includes(value),
  fromKey: (key: keyof typeof CalendarCheckPhase): CalendarCheckPhase => CalendarCheckPhase[key],
};

export type CalendarEventsChoice = 'keep' | 'remove';

export const CalendarEventsChoice = {
  Keep: 'keep' as const,
  Remove: 'remove' as const,
} as const;

export const CalendarEventsChoiceUtils = {
  values: Object.values(CalendarEventsChoice),
  keys: Object.keys(CalendarEventsChoice) as Array<keyof typeof CalendarEventsChoice>,
  entries: Object.entries(CalendarEventsChoice) as Array<[keyof typeof CalendarEventsChoice, CalendarEventsChoice]>,
  isValid: (value: any): value is CalendarEventsChoice => Object.values(CalendarEventsChoice).includes(value),
  fromKey: (key: keyof typeof CalendarEventsChoice): CalendarEventsChoice => CalendarEventsChoice[key],
};

export type CalendarLinkProblem = 'calendar_not_found' | 'login_disconnected' | 'login_owner_archived' | 'login_reconnect_required' | 'staff_archived';

export const CalendarLinkProblem = {
  CalendarNotFound: 'calendar_not_found' as const,
  LoginDisconnected: 'login_disconnected' as const,
  LoginOwnerArchived: 'login_owner_archived' as const,
  LoginReconnectRequired: 'login_reconnect_required' as const,
  StaffArchived: 'staff_archived' as const,
} as const;

export const CalendarLinkProblemUtils = {
  values: Object.values(CalendarLinkProblem),
  keys: Object.keys(CalendarLinkProblem) as Array<keyof typeof CalendarLinkProblem>,
  entries: Object.entries(CalendarLinkProblem) as Array<[keyof typeof CalendarLinkProblem, CalendarLinkProblem]>,
  isValid: (value: any): value is CalendarLinkProblem => Object.values(CalendarLinkProblem).includes(value),
  fromKey: (key: keyof typeof CalendarLinkProblem): CalendarLinkProblem => CalendarLinkProblem[key],
};

export type CalendarLinkState = 'active' | 'broken' | 'waiting_for_write_access';

export const CalendarLinkState = {
  Active: 'active' as const,
  Broken: 'broken' as const,
  WaitingForWriteAccess: 'waiting_for_write_access' as const,
} as const;

export const CalendarLinkStateUtils = {
  values: Object.values(CalendarLinkState),
  keys: Object.keys(CalendarLinkState) as Array<keyof typeof CalendarLinkState>,
  entries: Object.entries(CalendarLinkState) as Array<[keyof typeof CalendarLinkState, CalendarLinkState]>,
  isValid: (value: any): value is CalendarLinkState => Object.values(CalendarLinkState).includes(value),
  fromKey: (key: keyof typeof CalendarLinkState): CalendarLinkState => CalendarLinkState[key],
};

export type CalendarMeetingStatus = 'created' | 'failed' | 'pending' | 'unavailable';

export const CalendarMeetingStatus = {
  Created: 'created' as const,
  Failed: 'failed' as const,
  Pending: 'pending' as const,
  Unavailable: 'unavailable' as const,
} as const;

export const CalendarMeetingStatusUtils = {
  values: Object.values(CalendarMeetingStatus),
  keys: Object.keys(CalendarMeetingStatus) as Array<keyof typeof CalendarMeetingStatus>,
  entries: Object.entries(CalendarMeetingStatus) as Array<[keyof typeof CalendarMeetingStatus, CalendarMeetingStatus]>,
  isValid: (value: any): value is CalendarMeetingStatus => Object.values(CalendarMeetingStatus).includes(value),
  fromKey: (key: keyof typeof CalendarMeetingStatus): CalendarMeetingStatus => CalendarMeetingStatus[key],
};

export type CalendarSyncEventKind = 'exception' | 'master' | 'single';

export const CalendarSyncEventKind = {
  Exception: 'exception' as const,
  Master: 'master' as const,
  Single: 'single' as const,
} as const;

export const CalendarSyncEventKindUtils = {
  values: Object.values(CalendarSyncEventKind),
  keys: Object.keys(CalendarSyncEventKind) as Array<keyof typeof CalendarSyncEventKind>,
  entries: Object.entries(CalendarSyncEventKind) as Array<[keyof typeof CalendarSyncEventKind, CalendarSyncEventKind]>,
  isValid: (value: any): value is CalendarSyncEventKind => Object.values(CalendarSyncEventKind).includes(value),
  fromKey: (key: keyof typeof CalendarSyncEventKind): CalendarSyncEventKind => CalendarSyncEventKind[key],
};

export type CalendarSyncEventStatus = 'deleted' | 'failed' | 'pending' | 'removing' | 'synced';

export const CalendarSyncEventStatus = {
  Deleted: 'deleted' as const,
  Failed: 'failed' as const,
  Pending: 'pending' as const,
  Removing: 'removing' as const,
  Synced: 'synced' as const,
} as const;

export const CalendarSyncEventStatusUtils = {
  values: Object.values(CalendarSyncEventStatus),
  keys: Object.keys(CalendarSyncEventStatus) as Array<keyof typeof CalendarSyncEventStatus>,
  entries: Object.entries(CalendarSyncEventStatus) as Array<[keyof typeof CalendarSyncEventStatus, CalendarSyncEventStatus]>,
  isValid: (value: any): value is CalendarSyncEventStatus => Object.values(CalendarSyncEventStatus).includes(value),
  fromKey: (key: keyof typeof CalendarSyncEventStatus): CalendarSyncEventStatus => CalendarSyncEventStatus[key],
};

export type CalendarSyncReason = 'access_lost' | 'calendar_not_found' | 'calendar_not_ready' | 'failed' | 'login_missing' | 'reconnect_required' | 'rejected';

export const CalendarSyncReason = {
  AccessLost: 'access_lost' as const,
  CalendarNotFound: 'calendar_not_found' as const,
  CalendarNotReady: 'calendar_not_ready' as const,
  Failed: 'failed' as const,
  LoginMissing: 'login_missing' as const,
  ReconnectRequired: 'reconnect_required' as const,
  Rejected: 'rejected' as const,
} as const;

export const CalendarSyncReasonUtils = {
  values: Object.values(CalendarSyncReason),
  keys: Object.keys(CalendarSyncReason) as Array<keyof typeof CalendarSyncReason>,
  entries: Object.entries(CalendarSyncReason) as Array<[keyof typeof CalendarSyncReason, CalendarSyncReason]>,
  isValid: (value: any): value is CalendarSyncReason => Object.values(CalendarSyncReason).includes(value),
  fromKey: (key: keyof typeof CalendarSyncReason): CalendarSyncReason => CalendarSyncReason[key],
};

export type CalendarSyncState = 'deleted' | 'failed' | 'not_written' | 'pending' | 'removing' | 'synced';

export const CalendarSyncState = {
  Deleted: 'deleted' as const,
  Failed: 'failed' as const,
  NotWritten: 'not_written' as const,
  Pending: 'pending' as const,
  Removing: 'removing' as const,
  Synced: 'synced' as const,
} as const;

export const CalendarSyncStateUtils = {
  values: Object.values(CalendarSyncState),
  keys: Object.keys(CalendarSyncState) as Array<keyof typeof CalendarSyncState>,
  entries: Object.entries(CalendarSyncState) as Array<[keyof typeof CalendarSyncState, CalendarSyncState]>,
  isValid: (value: any): value is CalendarSyncState => Object.values(CalendarSyncState).includes(value),
  fromKey: (key: keyof typeof CalendarSyncState): CalendarSyncState => CalendarSyncState[key],
};

export type GoogleCalendarAccessRole = 'freeBusyReader' | 'owner' | 'reader' | 'writer';

export const GoogleCalendarAccessRole = {
  FreeBusyReader: 'freeBusyReader' as const,
  Owner: 'owner' as const,
  Reader: 'reader' as const,
  Writer: 'writer' as const,
} as const;

export const GoogleCalendarAccessRoleUtils = {
  values: Object.values(GoogleCalendarAccessRole),
  keys: Object.keys(GoogleCalendarAccessRole) as Array<keyof typeof GoogleCalendarAccessRole>,
  entries: Object.entries(GoogleCalendarAccessRole) as Array<[keyof typeof GoogleCalendarAccessRole, GoogleCalendarAccessRole]>,
  isValid: (value: any): value is GoogleCalendarAccessRole => Object.values(GoogleCalendarAccessRole).includes(value),
  fromKey: (key: keyof typeof GoogleCalendarAccessRole): GoogleCalendarAccessRole => GoogleCalendarAccessRole[key],
};

export type GoogleCalendarFailure = 'access_lost' | 'conflict' | 'full_sync_required' | 'invalid_grant' | 'not_configured' | 'not_found' | 'rate_limited' | 'transient' | 'unauthorized';

export const GoogleCalendarFailure = {
  AccessLost: 'access_lost' as const,
  Conflict: 'conflict' as const,
  FullSyncRequired: 'full_sync_required' as const,
  InvalidGrant: 'invalid_grant' as const,
  NotConfigured: 'not_configured' as const,
  NotFound: 'not_found' as const,
  RateLimited: 'rate_limited' as const,
  Transient: 'transient' as const,
  Unauthorized: 'unauthorized' as const,
} as const;

export const GoogleCalendarFailureUtils = {
  values: Object.values(GoogleCalendarFailure),
  keys: Object.keys(GoogleCalendarFailure) as Array<keyof typeof GoogleCalendarFailure>,
  entries: Object.entries(GoogleCalendarFailure) as Array<[keyof typeof GoogleCalendarFailure, GoogleCalendarFailure]>,
  isValid: (value: any): value is GoogleCalendarFailure => Object.values(GoogleCalendarFailure).includes(value),
  fromKey: (key: keyof typeof GoogleCalendarFailure): GoogleCalendarFailure => GoogleCalendarFailure[key],
};

export type GoogleCalendarLoginStatus = 'connected' | 'disconnected' | 'disconnecting' | 'reconnect_required';

export const GoogleCalendarLoginStatus = {
  Connected: 'connected' as const,
  Disconnected: 'disconnected' as const,
  Disconnecting: 'disconnecting' as const,
  ReconnectRequired: 'reconnect_required' as const,
} as const;

export const GoogleCalendarLoginStatusUtils = {
  values: Object.values(GoogleCalendarLoginStatus),
  keys: Object.keys(GoogleCalendarLoginStatus) as Array<keyof typeof GoogleCalendarLoginStatus>,
  entries: Object.entries(GoogleCalendarLoginStatus) as Array<[keyof typeof GoogleCalendarLoginStatus, GoogleCalendarLoginStatus]>,
  isValid: (value: any): value is GoogleCalendarLoginStatus => Object.values(GoogleCalendarLoginStatus).includes(value),
  fromKey: (key: keyof typeof GoogleCalendarLoginStatus): GoogleCalendarLoginStatus => GoogleCalendarLoginStatus[key],
};

export type GoogleCalendarSendUpdates = 'all' | 'externalOnly' | 'none';

export const GoogleCalendarSendUpdates = {
  All: 'all' as const,
  ExternalOnly: 'externalOnly' as const,
  None: 'none' as const,
} as const;

export const GoogleCalendarSendUpdatesUtils = {
  values: Object.values(GoogleCalendarSendUpdates),
  keys: Object.keys(GoogleCalendarSendUpdates) as Array<keyof typeof GoogleCalendarSendUpdates>,
  entries: Object.entries(GoogleCalendarSendUpdates) as Array<[keyof typeof GoogleCalendarSendUpdates, GoogleCalendarSendUpdates]>,
  isValid: (value: any): value is GoogleCalendarSendUpdates => Object.values(GoogleCalendarSendUpdates).includes(value),
  fromKey: (key: keyof typeof GoogleCalendarSendUpdates): GoogleCalendarSendUpdates => GoogleCalendarSendUpdates[key],
};

export type IntegrationProvider = 'google_calendar' | 'mcp' | 'quickbooks_online' | 'stripe';

export const IntegrationProvider = {
  GoogleCalendar: 'google_calendar' as const,
  Mcp: 'mcp' as const,
  QuickBooksOnline: 'quickbooks_online' as const,
  Stripe: 'stripe' as const,
} as const;

export const IntegrationProviderUtils = {
  values: Object.values(IntegrationProvider),
  keys: Object.keys(IntegrationProvider) as Array<keyof typeof IntegrationProvider>,
  entries: Object.entries(IntegrationProvider) as Array<[keyof typeof IntegrationProvider, IntegrationProvider]>,
  isValid: (value: any): value is IntegrationProvider => Object.values(IntegrationProvider).includes(value),
  fromKey: (key: keyof typeof IntegrationProvider): IntegrationProvider => IntegrationProvider[key],
};

export type IntegrationStatus = 'error' | 'unverified' | 'verified';

export const IntegrationStatus = {
  Error: 'error' as const,
  Unverified: 'unverified' as const,
  Verified: 'verified' as const,
} as const;

export const IntegrationStatusUtils = {
  values: Object.values(IntegrationStatus),
  keys: Object.keys(IntegrationStatus) as Array<keyof typeof IntegrationStatus>,
  entries: Object.entries(IntegrationStatus) as Array<[keyof typeof IntegrationStatus, IntegrationStatus]>,
  isValid: (value: any): value is IntegrationStatus => Object.values(IntegrationStatus).includes(value),
  fromKey: (key: keyof typeof IntegrationStatus): IntegrationStatus => IntegrationStatus[key],
};

export type McpAuthType = 'bearer' | 'none' | 'oauth';

export const McpAuthType = {
  Bearer: 'bearer' as const,
  None: 'none' as const,
  OAuth: 'oauth' as const,
} as const;

export const McpAuthTypeUtils = {
  values: Object.values(McpAuthType),
  keys: Object.keys(McpAuthType) as Array<keyof typeof McpAuthType>,
  entries: Object.entries(McpAuthType) as Array<[keyof typeof McpAuthType, McpAuthType]>,
  isValid: (value: any): value is McpAuthType => Object.values(McpAuthType).includes(value),
  fromKey: (key: keyof typeof McpAuthType): McpAuthType => McpAuthType[key],
};

export type McpBuiltInServer = 'gmail' | 'google_calendar' | 'google_drive' | 'linear';

export const McpBuiltInServer = {
  Gmail: 'gmail' as const,
  GoogleCalendar: 'google_calendar' as const,
  GoogleDrive: 'google_drive' as const,
  Linear: 'linear' as const,
} as const;

export const McpBuiltInServerUtils = {
  values: Object.values(McpBuiltInServer),
  keys: Object.keys(McpBuiltInServer) as Array<keyof typeof McpBuiltInServer>,
  entries: Object.entries(McpBuiltInServer) as Array<[keyof typeof McpBuiltInServer, McpBuiltInServer]>,
  isValid: (value: any): value is McpBuiltInServer => Object.values(McpBuiltInServer).includes(value),
  fromKey: (key: keyof typeof McpBuiltInServer): McpBuiltInServer => McpBuiltInServer[key],
};

export type McpClientProvider = 'google';

export const McpClientProvider = {
  Google: 'google' as const,
} as const;

export const McpClientProviderUtils = {
  values: Object.values(McpClientProvider),
  keys: Object.keys(McpClientProvider) as Array<keyof typeof McpClientProvider>,
  entries: Object.entries(McpClientProvider) as Array<[keyof typeof McpClientProvider, McpClientProvider]>,
  isValid: (value: any): value is McpClientProvider => Object.values(McpClientProvider).includes(value),
  fromKey: (key: keyof typeof McpClientProvider): McpClientProvider => McpClientProvider[key],
};

export type McpConnectionStatus = 'connected' | 'disconnected' | 'pending' | 'reconnect_required';

export const McpConnectionStatus = {
  Connected: 'connected' as const,
  Disconnected: 'disconnected' as const,
  Pending: 'pending' as const,
  ReconnectRequired: 'reconnect_required' as const,
} as const;

export const McpConnectionStatusUtils = {
  values: Object.values(McpConnectionStatus),
  keys: Object.keys(McpConnectionStatus) as Array<keyof typeof McpConnectionStatus>,
  entries: Object.entries(McpConnectionStatus) as Array<[keyof typeof McpConnectionStatus, McpConnectionStatus]>,
  isValid: (value: any): value is McpConnectionStatus => Object.values(McpConnectionStatus).includes(value),
  fromKey: (key: keyof typeof McpConnectionStatus): McpConnectionStatus => McpConnectionStatus[key],
};

export type OpenRouterLimitReset = 'daily' | 'monthly' | 'weekly';

export const OpenRouterLimitReset = {
  Daily: 'daily' as const,
  Monthly: 'monthly' as const,
  Weekly: 'weekly' as const,
} as const;

export const OpenRouterLimitResetUtils = {
  values: Object.values(OpenRouterLimitReset),
  keys: Object.keys(OpenRouterLimitReset) as Array<keyof typeof OpenRouterLimitReset>,
  entries: Object.entries(OpenRouterLimitReset) as Array<[keyof typeof OpenRouterLimitReset, OpenRouterLimitReset]>,
  isValid: (value: any): value is OpenRouterLimitReset => Object.values(OpenRouterLimitReset).includes(value),
  fromKey: (key: keyof typeof OpenRouterLimitReset): OpenRouterLimitReset => OpenRouterLimitReset[key],
};

export type QuickBooksAccountMatchStatus = 'local_inactive' | 'matched' | 'target_inactive' | 'target_missing' | 'type_mismatch' | 'unmatched' | 'unverified';

export const QuickBooksAccountMatchStatus = {
  LocalInactive: 'local_inactive' as const,
  Matched: 'matched' as const,
  TargetInactive: 'target_inactive' as const,
  TargetMissing: 'target_missing' as const,
  TypeMismatch: 'type_mismatch' as const,
  Unmatched: 'unmatched' as const,
  Unverified: 'unverified' as const,
} as const;

export const QuickBooksAccountMatchStatusUtils = {
  values: Object.values(QuickBooksAccountMatchStatus),
  keys: Object.keys(QuickBooksAccountMatchStatus) as Array<keyof typeof QuickBooksAccountMatchStatus>,
  entries: Object.entries(QuickBooksAccountMatchStatus) as Array<[keyof typeof QuickBooksAccountMatchStatus, QuickBooksAccountMatchStatus]>,
  isValid: (value: any): value is QuickBooksAccountMatchStatus => Object.values(QuickBooksAccountMatchStatus).includes(value),
  fromKey: (key: keyof typeof QuickBooksAccountMatchStatus): QuickBooksAccountMatchStatus => QuickBooksAccountMatchStatus[key],
};

export type QuickBooksAccountReadiness = 'needs_attention' | 'no_matches' | 'not_connected' | 'ready' | 'reconnect_required' | 'unverified';

export const QuickBooksAccountReadiness = {
  NeedsAttention: 'needs_attention' as const,
  NoMatches: 'no_matches' as const,
  NotConnected: 'not_connected' as const,
  Ready: 'ready' as const,
  ReconnectRequired: 'reconnect_required' as const,
  Unverified: 'unverified' as const,
} as const;

export const QuickBooksAccountReadinessUtils = {
  values: Object.values(QuickBooksAccountReadiness),
  keys: Object.keys(QuickBooksAccountReadiness) as Array<keyof typeof QuickBooksAccountReadiness>,
  entries: Object.entries(QuickBooksAccountReadiness) as Array<[keyof typeof QuickBooksAccountReadiness, QuickBooksAccountReadiness]>,
  isValid: (value: any): value is QuickBooksAccountReadiness => Object.values(QuickBooksAccountReadiness).includes(value),
  fromKey: (key: keyof typeof QuickBooksAccountReadiness): QuickBooksAccountReadiness => QuickBooksAccountReadiness[key],
};

export type QuickBooksConnectionStatus = 'connected' | 'disconnected' | 'reconnect_required';

export const QuickBooksConnectionStatus = {
  Connected: 'connected' as const,
  Disconnected: 'disconnected' as const,
  ReconnectRequired: 'reconnect_required' as const,
} as const;

export const QuickBooksConnectionStatusUtils = {
  values: Object.values(QuickBooksConnectionStatus),
  keys: Object.keys(QuickBooksConnectionStatus) as Array<keyof typeof QuickBooksConnectionStatus>,
  entries: Object.entries(QuickBooksConnectionStatus) as Array<[keyof typeof QuickBooksConnectionStatus, QuickBooksConnectionStatus]>,
  isValid: (value: any): value is QuickBooksConnectionStatus => Object.values(QuickBooksConnectionStatus).includes(value),
  fromKey: (key: keyof typeof QuickBooksConnectionStatus): QuickBooksConnectionStatus => QuickBooksConnectionStatus[key],
};

export type QuickBooksEnvironment = 'production' | 'sandbox';

export const QuickBooksEnvironment = {
  Production: 'production' as const,
  Sandbox: 'sandbox' as const,
} as const;

export const QuickBooksEnvironmentUtils = {
  values: Object.values(QuickBooksEnvironment),
  keys: Object.keys(QuickBooksEnvironment) as Array<keyof typeof QuickBooksEnvironment>,
  entries: Object.entries(QuickBooksEnvironment) as Array<[keyof typeof QuickBooksEnvironment, QuickBooksEnvironment]>,
  isValid: (value: any): value is QuickBooksEnvironment => Object.values(QuickBooksEnvironment).includes(value),
  fromKey: (key: keyof typeof QuickBooksEnvironment): QuickBooksEnvironment => QuickBooksEnvironment[key],
};

export type StripeAccountCountry = 'CA' | 'US';

export const StripeAccountCountry = {
  CA: 'CA' as const,
  US: 'US' as const,
} as const;

export const StripeAccountCountryUtils = {
  values: Object.values(StripeAccountCountry),
  keys: Object.keys(StripeAccountCountry) as Array<keyof typeof StripeAccountCountry>,
  entries: Object.entries(StripeAccountCountry) as Array<[keyof typeof StripeAccountCountry, StripeAccountCountry]>,
  isValid: (value: any): value is StripeAccountCountry => Object.values(StripeAccountCountry).includes(value),
  fromKey: (key: keyof typeof StripeAccountCountry): StripeAccountCountry => StripeAccountCountry[key],
};

export type StripeCheckoutMode = 'payment' | 'setup' | 'subscription';

export const StripeCheckoutMode = {
  Payment: 'payment' as const,
  Setup: 'setup' as const,
  Subscription: 'subscription' as const,
} as const;

export const StripeCheckoutModeUtils = {
  values: Object.values(StripeCheckoutMode),
  keys: Object.keys(StripeCheckoutMode) as Array<keyof typeof StripeCheckoutMode>,
  entries: Object.entries(StripeCheckoutMode) as Array<[keyof typeof StripeCheckoutMode, StripeCheckoutMode]>,
  isValid: (value: any): value is StripeCheckoutMode => Object.values(StripeCheckoutMode).includes(value),
  fromKey: (key: keyof typeof StripeCheckoutMode): StripeCheckoutMode => StripeCheckoutMode[key],
};

export type StripeConnectionStatus = 'active' | 'onboarding_incomplete';

export const StripeConnectionStatus = {
  Active: 'active' as const,
  OnboardingIncomplete: 'onboarding_incomplete' as const,
} as const;

export const StripeConnectionStatusUtils = {
  values: Object.values(StripeConnectionStatus),
  keys: Object.keys(StripeConnectionStatus) as Array<keyof typeof StripeConnectionStatus>,
  entries: Object.entries(StripeConnectionStatus) as Array<[keyof typeof StripeConnectionStatus, StripeConnectionStatus]>,
  isValid: (value: any): value is StripeConnectionStatus => Object.values(StripeConnectionStatus).includes(value),
  fromKey: (key: keyof typeof StripeConnectionStatus): StripeConnectionStatus => StripeConnectionStatus[key],
};

export type StripeCurrency = 'aed' | 'ars' | 'aud' | 'brl' | 'cad' | 'chf' | 'clp' | 'cny' | 'cop' | 'czk' | 'dkk' | 'eur' | 'gbp' | 'hkd' | 'idr' | 'ils' | 'inr' | 'jpy' | 'krw' | 'mxn' | 'myr' | 'nok' | 'nzd' | 'pen' | 'php' | 'pln' | 'sar' | 'sek' | 'sgd' | 'thb' | 'twd' | 'usd' | 'zar';

export const StripeCurrency = {
  AED: 'aed' as const,
  ARS: 'ars' as const,
  AUD: 'aud' as const,
  BRL: 'brl' as const,
  CAD: 'cad' as const,
  CHF: 'chf' as const,
  CLP: 'clp' as const,
  CNY: 'cny' as const,
  COP: 'cop' as const,
  CZK: 'czk' as const,
  DKK: 'dkk' as const,
  EUR: 'eur' as const,
  GBP: 'gbp' as const,
  HKD: 'hkd' as const,
  IDR: 'idr' as const,
  ILS: 'ils' as const,
  INR: 'inr' as const,
  JPY: 'jpy' as const,
  KRW: 'krw' as const,
  MXN: 'mxn' as const,
  MYR: 'myr' as const,
  NOK: 'nok' as const,
  NZD: 'nzd' as const,
  PEN: 'pen' as const,
  PHP: 'php' as const,
  PLN: 'pln' as const,
  SAR: 'sar' as const,
  SEK: 'sek' as const,
  SGD: 'sgd' as const,
  THB: 'thb' as const,
  TWD: 'twd' as const,
  USD: 'usd' as const,
  ZAR: 'zar' as const,
} as const;

export const StripeCurrencyUtils = {
  values: Object.values(StripeCurrency),
  keys: Object.keys(StripeCurrency) as Array<keyof typeof StripeCurrency>,
  entries: Object.entries(StripeCurrency) as Array<[keyof typeof StripeCurrency, StripeCurrency]>,
  isValid: (value: any): value is StripeCurrency => Object.values(StripeCurrency).includes(value),
  fromKey: (key: keyof typeof StripeCurrency): StripeCurrency => StripeCurrency[key],
};

export type StripeEmbeddedComponent = 'account-management' | 'balances' | 'disputes-list' | 'notification-banner' | 'payments' | 'payout-details' | 'payout-reconciliation-report';

export const StripeEmbeddedComponent = {
  AccountManagement: 'account-management' as const,
  Balances: 'balances' as const,
  DisputesList: 'disputes-list' as const,
  NotificationBanner: 'notification-banner' as const,
  Payments: 'payments' as const,
  PayoutDetails: 'payout-details' as const,
  PayoutReconciliationReport: 'payout-reconciliation-report' as const,
} as const;

export const StripeEmbeddedComponentUtils = {
  values: Object.values(StripeEmbeddedComponent),
  keys: Object.keys(StripeEmbeddedComponent) as Array<keyof typeof StripeEmbeddedComponent>,
  entries: Object.entries(StripeEmbeddedComponent) as Array<[keyof typeof StripeEmbeddedComponent, StripeEmbeddedComponent]>,
  isValid: (value: any): value is StripeEmbeddedComponent => Object.values(StripeEmbeddedComponent).includes(value),
  fromKey: (key: keyof typeof StripeEmbeddedComponent): StripeEmbeddedComponent => StripeEmbeddedComponent[key],
};

export type StripePaymentFeeSyncResult = 'branch_workspace' | 'currency_mismatch' | 'fee_pending' | 'missing_fee_mappings' | 'no_stripe_account' | 'not_in_stripe_account' | 'not_settled' | 'not_stripe_payment' | 'payment_pending' | 'synced' | 'unchanged';

export const StripePaymentFeeSyncResult = {
  BranchWorkspace: 'branch_workspace' as const,
  CurrencyMismatch: 'currency_mismatch' as const,
  FeePending: 'fee_pending' as const,
  MissingFeeMappings: 'missing_fee_mappings' as const,
  NoStripeAccount: 'no_stripe_account' as const,
  NotInStripeAccount: 'not_in_stripe_account' as const,
  NotSettled: 'not_settled' as const,
  NotStripePayment: 'not_stripe_payment' as const,
  PaymentPending: 'payment_pending' as const,
  Synced: 'synced' as const,
  Unchanged: 'unchanged' as const,
} as const;

export const StripePaymentFeeSyncResultUtils = {
  values: Object.values(StripePaymentFeeSyncResult),
  keys: Object.keys(StripePaymentFeeSyncResult) as Array<keyof typeof StripePaymentFeeSyncResult>,
  entries: Object.entries(StripePaymentFeeSyncResult) as Array<[keyof typeof StripePaymentFeeSyncResult, StripePaymentFeeSyncResult]>,
  isValid: (value: any): value is StripePaymentFeeSyncResult => Object.values(StripePaymentFeeSyncResult).includes(value),
  fromKey: (key: keyof typeof StripePaymentFeeSyncResult): StripePaymentFeeSyncResult => StripePaymentFeeSyncResult[key],
};

export type NavigationMenuItemType = 'dropdown' | 'external_link' | 'page' | 'system_config' | 'url';

export const NavigationMenuItemType = {
  Dropdown: 'dropdown' as const,
  ExternalLink: 'external_link' as const,
  Page: 'page' as const,
  SystemConfig: 'system_config' as const,
  Url: 'url' as const,
} as const;

export const NavigationMenuItemTypeUtils = {
  values: Object.values(NavigationMenuItemType),
  keys: Object.keys(NavigationMenuItemType) as Array<keyof typeof NavigationMenuItemType>,
  entries: Object.entries(NavigationMenuItemType) as Array<[keyof typeof NavigationMenuItemType, NavigationMenuItemType]>,
  isValid: (value: any): value is NavigationMenuItemType => Object.values(NavigationMenuItemType).includes(value),
  fromKey: (key: keyof typeof NavigationMenuItemType): NavigationMenuItemType => NavigationMenuItemType[key],
};

export type BulkNotificationItemStatus = 'dispatching' | 'duplicate' | 'failed' | 'pending' | 'preparing' | 'queued' | 'uncertain';

export const BulkNotificationItemStatus = {
  Dispatching: 'dispatching' as const,
  Duplicate: 'duplicate' as const,
  Failed: 'failed' as const,
  Pending: 'pending' as const,
  Preparing: 'preparing' as const,
  Queued: 'queued' as const,
  Uncertain: 'uncertain' as const,
} as const;

export const BulkNotificationItemStatusUtils = {
  values: Object.values(BulkNotificationItemStatus),
  keys: Object.keys(BulkNotificationItemStatus) as Array<keyof typeof BulkNotificationItemStatus>,
  entries: Object.entries(BulkNotificationItemStatus) as Array<[keyof typeof BulkNotificationItemStatus, BulkNotificationItemStatus]>,
  isValid: (value: any): value is BulkNotificationItemStatus => Object.values(BulkNotificationItemStatus).includes(value),
  fromKey: (key: keyof typeof BulkNotificationItemStatus): BulkNotificationItemStatus => BulkNotificationItemStatus[key],
};

export type BulkNotificationRunStatus = 'completed' | 'failed' | 'interrupted' | 'processing' | 'queued';

export const BulkNotificationRunStatus = {
  Completed: 'completed' as const,
  Failed: 'failed' as const,
  Interrupted: 'interrupted' as const,
  Processing: 'processing' as const,
  Queued: 'queued' as const,
} as const;

export const BulkNotificationRunStatusUtils = {
  values: Object.values(BulkNotificationRunStatus),
  keys: Object.keys(BulkNotificationRunStatus) as Array<keyof typeof BulkNotificationRunStatus>,
  entries: Object.entries(BulkNotificationRunStatus) as Array<[keyof typeof BulkNotificationRunStatus, BulkNotificationRunStatus]>,
  isValid: (value: any): value is BulkNotificationRunStatus => Object.values(BulkNotificationRunStatus).includes(value),
  fromKey: (key: keyof typeof BulkNotificationRunStatus): BulkNotificationRunStatus => BulkNotificationRunStatus[key],
};

export type EmailBounceType = 'hard' | 'soft';

export const EmailBounceType = {
  Hard: 'hard' as const,
  Soft: 'soft' as const,
} as const;

export const EmailBounceTypeUtils = {
  values: Object.values(EmailBounceType),
  keys: Object.keys(EmailBounceType) as Array<keyof typeof EmailBounceType>,
  entries: Object.entries(EmailBounceType) as Array<[keyof typeof EmailBounceType, EmailBounceType]>,
  isValid: (value: any): value is EmailBounceType => Object.values(EmailBounceType).includes(value),
  fromKey: (key: keyof typeof EmailBounceType): EmailBounceType => EmailBounceType[key],
};

export type EmailEventType = 'bounce' | 'click' | 'deferred' | 'delivered' | 'dropped' | 'group_resubscribe' | 'group_unsubscribe' | 'open' | 'processed' | 'spamreport' | 'unsubscribe';

export const EmailEventType = {
  Bounce: 'bounce' as const,
  Click: 'click' as const,
  Deferred: 'deferred' as const,
  Delivered: 'delivered' as const,
  Dropped: 'dropped' as const,
  GroupResubscribe: 'group_resubscribe' as const,
  GroupUnsubscribe: 'group_unsubscribe' as const,
  Open: 'open' as const,
  Processed: 'processed' as const,
  SpamReport: 'spamreport' as const,
  Unsubscribe: 'unsubscribe' as const,
} as const;

export const EmailEventTypeUtils = {
  values: Object.values(EmailEventType),
  keys: Object.keys(EmailEventType) as Array<keyof typeof EmailEventType>,
  entries: Object.entries(EmailEventType) as Array<[keyof typeof EmailEventType, EmailEventType]>,
  isValid: (value: any): value is EmailEventType => Object.values(EmailEventType).includes(value),
  fromKey: (key: keyof typeof EmailEventType): EmailEventType => EmailEventType[key],
};

export type EmailMessageFileDisposition = 'attachment' | 'inline';

export const EmailMessageFileDisposition = {
  Attachment: 'attachment' as const,
  Inline: 'inline' as const,
} as const;

export const EmailMessageFileDispositionUtils = {
  values: Object.values(EmailMessageFileDisposition),
  keys: Object.keys(EmailMessageFileDisposition) as Array<keyof typeof EmailMessageFileDisposition>,
  entries: Object.entries(EmailMessageFileDisposition) as Array<[keyof typeof EmailMessageFileDisposition, EmailMessageFileDisposition]>,
  isValid: (value: any): value is EmailMessageFileDisposition => Object.values(EmailMessageFileDisposition).includes(value),
  fromKey: (key: keyof typeof EmailMessageFileDisposition): EmailMessageFileDisposition => EmailMessageFileDisposition[key],
};

export type EmailMessageStatus = 'bounced' | 'deferred' | 'delivered' | 'dropped' | 'failed' | 'sending' | 'sent' | 'spam_reported' | 'suppressed';

export const EmailMessageStatus = {
  Bounced: 'bounced' as const,
  Deferred: 'deferred' as const,
  Delivered: 'delivered' as const,
  Dropped: 'dropped' as const,
  Failed: 'failed' as const,
  Sending: 'sending' as const,
  Sent: 'sent' as const,
  SpamReported: 'spam_reported' as const,
  Suppressed: 'suppressed' as const,
} as const;

export const EmailMessageStatusUtils = {
  values: Object.values(EmailMessageStatus),
  keys: Object.keys(EmailMessageStatus) as Array<keyof typeof EmailMessageStatus>,
  entries: Object.entries(EmailMessageStatus) as Array<[keyof typeof EmailMessageStatus, EmailMessageStatus]>,
  isValid: (value: any): value is EmailMessageStatus => Object.values(EmailMessageStatus).includes(value),
  fromKey: (key: keyof typeof EmailMessageStatus): EmailMessageStatus => EmailMessageStatus[key],
};

export type EmailSendingDomainDnsRecordStatus = 'active' | 'pending_dns';

export const EmailSendingDomainDnsRecordStatus = {
  Active: 'active' as const,
  PendingDns: 'pending_dns' as const,
} as const;

export const EmailSendingDomainDnsRecordStatusUtils = {
  values: Object.values(EmailSendingDomainDnsRecordStatus),
  keys: Object.keys(EmailSendingDomainDnsRecordStatus) as Array<keyof typeof EmailSendingDomainDnsRecordStatus>,
  entries: Object.entries(EmailSendingDomainDnsRecordStatus) as Array<[keyof typeof EmailSendingDomainDnsRecordStatus, EmailSendingDomainDnsRecordStatus]>,
  isValid: (value: any): value is EmailSendingDomainDnsRecordStatus => Object.values(EmailSendingDomainDnsRecordStatus).includes(value),
  fromKey: (key: keyof typeof EmailSendingDomainDnsRecordStatus): EmailSendingDomainDnsRecordStatus => EmailSendingDomainDnsRecordStatus[key],
};

export type EmailSendingDomainStatus = 'active' | 'inactive' | 'pending_dns';

export const EmailSendingDomainStatus = {
  Active: 'active' as const,
  Inactive: 'inactive' as const,
  PendingDns: 'pending_dns' as const,
} as const;

export const EmailSendingDomainStatusUtils = {
  values: Object.values(EmailSendingDomainStatus),
  keys: Object.keys(EmailSendingDomainStatus) as Array<keyof typeof EmailSendingDomainStatus>,
  entries: Object.entries(EmailSendingDomainStatus) as Array<[keyof typeof EmailSendingDomainStatus, EmailSendingDomainStatus]>,
  isValid: (value: any): value is EmailSendingDomainStatus => Object.values(EmailSendingDomainStatus).includes(value),
  fromKey: (key: keyof typeof EmailSendingDomainStatus): EmailSendingDomainStatus => EmailSendingDomainStatus[key],
};

export type MailProvider = 'sendgrid';

export const MailProvider = {
  Sendgrid: 'sendgrid' as const,
} as const;

export const MailProviderUtils = {
  values: Object.values(MailProvider),
  keys: Object.keys(MailProvider) as Array<keyof typeof MailProvider>,
  entries: Object.entries(MailProvider) as Array<[keyof typeof MailProvider, MailProvider]>,
  isValid: (value: any): value is MailProvider => Object.values(MailProvider).includes(value),
  fromKey: (key: keyof typeof MailProvider): MailProvider => MailProvider[key],
};

export type NotificationChannelUnavailableReason = 'no_address' | 'no_permission' | 'no_phone' | 'opted_out' | 'template_off';

export const NotificationChannelUnavailableReason = {
  NoAddress: 'no_address' as const,
  NoPermission: 'no_permission' as const,
  NoPhone: 'no_phone' as const,
  OptedOut: 'opted_out' as const,
  TemplateOff: 'template_off' as const,
} as const;

export const NotificationChannelUnavailableReasonUtils = {
  values: Object.values(NotificationChannelUnavailableReason),
  keys: Object.keys(NotificationChannelUnavailableReason) as Array<keyof typeof NotificationChannelUnavailableReason>,
  entries: Object.entries(NotificationChannelUnavailableReason) as Array<[keyof typeof NotificationChannelUnavailableReason, NotificationChannelUnavailableReason]>,
  isValid: (value: any): value is NotificationChannelUnavailableReason => Object.values(NotificationChannelUnavailableReason).includes(value),
  fromKey: (key: keyof typeof NotificationChannelUnavailableReason): NotificationChannelUnavailableReason => NotificationChannelUnavailableReason[key],
};

export type NotificationConsentMethod = 'api' | 'inbound_sms' | 'workflow';

export const NotificationConsentMethod = {
  Api: 'api' as const,
  InboundSms: 'inbound_sms' as const,
  Workflow: 'workflow' as const,
} as const;

export const NotificationConsentMethodUtils = {
  values: Object.values(NotificationConsentMethod),
  keys: Object.keys(NotificationConsentMethod) as Array<keyof typeof NotificationConsentMethod>,
  entries: Object.entries(NotificationConsentMethod) as Array<[keyof typeof NotificationConsentMethod, NotificationConsentMethod]>,
  isValid: (value: any): value is NotificationConsentMethod => Object.values(NotificationConsentMethod).includes(value),
  fromKey: (key: keyof typeof NotificationConsentMethod): NotificationConsentMethod => NotificationConsentMethod[key],
};

export type NotificationDeliveryChannel = 'email' | 'email_and_sms' | 'sms';

export const NotificationDeliveryChannel = {
  Email: 'email' as const,
  EmailAndSms: 'email_and_sms' as const,
  Sms: 'sms' as const,
} as const;

export const NotificationDeliveryChannelUtils = {
  values: Object.values(NotificationDeliveryChannel),
  keys: Object.keys(NotificationDeliveryChannel) as Array<keyof typeof NotificationDeliveryChannel>,
  entries: Object.entries(NotificationDeliveryChannel) as Array<[keyof typeof NotificationDeliveryChannel, NotificationDeliveryChannel]>,
  isValid: (value: any): value is NotificationDeliveryChannel => Object.values(NotificationDeliveryChannel).includes(value),
  fromKey: (key: keyof typeof NotificationDeliveryChannel): NotificationDeliveryChannel => NotificationDeliveryChannel[key],
};

export type NotificationListItemKind = 'scheduled' | 'sent';

export const NotificationListItemKind = {
  Scheduled: 'scheduled' as const,
  Sent: 'sent' as const,
} as const;

export const NotificationListItemKindUtils = {
  values: Object.values(NotificationListItemKind),
  keys: Object.keys(NotificationListItemKind) as Array<keyof typeof NotificationListItemKind>,
  entries: Object.entries(NotificationListItemKind) as Array<[keyof typeof NotificationListItemKind, NotificationListItemKind]>,
  isValid: (value: any): value is NotificationListItemKind => Object.values(NotificationListItemKind).includes(value),
  fromKey: (key: keyof typeof NotificationListItemKind): NotificationListItemKind => NotificationListItemKind[key],
};

export type NotificationListStatus = 'cancelled' | 'expired' | 'failed' | 'sent' | 'upcoming';

export const NotificationListStatus = {
  Cancelled: 'cancelled' as const,
  Expired: 'expired' as const,
  Failed: 'failed' as const,
  Sent: 'sent' as const,
  Upcoming: 'upcoming' as const,
} as const;

export const NotificationListStatusUtils = {
  values: Object.values(NotificationListStatus),
  keys: Object.keys(NotificationListStatus) as Array<keyof typeof NotificationListStatus>,
  entries: Object.entries(NotificationListStatus) as Array<[keyof typeof NotificationListStatus, NotificationListStatus]>,
  isValid: (value: any): value is NotificationListStatus => Object.values(NotificationListStatus).includes(value),
  fromKey: (key: keyof typeof NotificationListStatus): NotificationListStatus => NotificationListStatus[key],
};

export type NotificationSourceKind = 'api' | 'one_off' | 'schedule' | 'workflow';

export const NotificationSourceKind = {
  Api: 'api' as const,
  OneOff: 'one_off' as const,
  Schedule: 'schedule' as const,
  Workflow: 'workflow' as const,
} as const;

export const NotificationSourceKindUtils = {
  values: Object.values(NotificationSourceKind),
  keys: Object.keys(NotificationSourceKind) as Array<keyof typeof NotificationSourceKind>,
  entries: Object.entries(NotificationSourceKind) as Array<[keyof typeof NotificationSourceKind, NotificationSourceKind]>,
  isValid: (value: any): value is NotificationSourceKind => Object.values(NotificationSourceKind).includes(value),
  fromKey: (key: keyof typeof NotificationSourceKind): NotificationSourceKind => NotificationSourceKind[key],
};

export type ScheduledNotificationStatus = 'cancelled' | 'draft' | 'expired' | 'failed' | 'queued' | 'scheduled';

export const ScheduledNotificationStatus = {
  Cancelled: 'cancelled' as const,
  Draft: 'draft' as const,
  Expired: 'expired' as const,
  Failed: 'failed' as const,
  Queued: 'queued' as const,
  Scheduled: 'scheduled' as const,
} as const;

export const ScheduledNotificationStatusUtils = {
  values: Object.values(ScheduledNotificationStatus),
  keys: Object.keys(ScheduledNotificationStatus) as Array<keyof typeof ScheduledNotificationStatus>,
  entries: Object.entries(ScheduledNotificationStatus) as Array<[keyof typeof ScheduledNotificationStatus, ScheduledNotificationStatus]>,
  isValid: (value: any): value is ScheduledNotificationStatus => Object.values(ScheduledNotificationStatus).includes(value),
  fromKey: (key: keyof typeof ScheduledNotificationStatus): ScheduledNotificationStatus => ScheduledNotificationStatus[key],
};

export type SmsMessageStatus = 'delivered' | 'failed' | 'queued' | 'sending' | 'sent' | 'suppressed';

export const SmsMessageStatus = {
  Delivered: 'delivered' as const,
  Failed: 'failed' as const,
  Queued: 'queued' as const,
  Sending: 'sending' as const,
  Sent: 'sent' as const,
  Suppressed: 'suppressed' as const,
} as const;

export const SmsMessageStatusUtils = {
  values: Object.values(SmsMessageStatus),
  keys: Object.keys(SmsMessageStatus) as Array<keyof typeof SmsMessageStatus>,
  entries: Object.entries(SmsMessageStatus) as Array<[keyof typeof SmsMessageStatus, SmsMessageStatus]>,
  isValid: (value: any): value is SmsMessageStatus => Object.values(SmsMessageStatus).includes(value),
  fromKey: (key: keyof typeof SmsMessageStatus): SmsMessageStatus => SmsMessageStatus[key],
};

export type SmsSenderSource = 'environment' | 'workspace';

export const SmsSenderSource = {
  Environment: 'environment' as const,
  Workspace: 'workspace' as const,
} as const;

export const SmsSenderSourceUtils = {
  values: Object.values(SmsSenderSource),
  keys: Object.keys(SmsSenderSource) as Array<keyof typeof SmsSenderSource>,
  entries: Object.entries(SmsSenderSource) as Array<[keyof typeof SmsSenderSource, SmsSenderSource]>,
  isValid: (value: any): value is SmsSenderSource => Object.values(SmsSenderSource).includes(value),
  fromKey: (key: keyof typeof SmsSenderSource): SmsSenderSource => SmsSenderSource[key],
};

export type AttemptOutcome = 'cancelled' | 'conflicted' | 'needs_recovery' | 'refused' | 'rolled_back' | 'sent_back' | 'setup_failed' | 'succeeded';

export const AttemptOutcome = {
  Cancelled: 'cancelled' as const,
  Conflicted: 'conflicted' as const,
  NeedsRecovery: 'needs_recovery' as const,
  Refused: 'refused' as const,
  RolledBack: 'rolled_back' as const,
  SentBack: 'sent_back' as const,
  SetupFailed: 'setup_failed' as const,
  Succeeded: 'succeeded' as const,
} as const;

export const AttemptOutcomeUtils = {
  values: Object.values(AttemptOutcome),
  keys: Object.keys(AttemptOutcome) as Array<keyof typeof AttemptOutcome>,
  entries: Object.entries(AttemptOutcome) as Array<[keyof typeof AttemptOutcome, AttemptOutcome]>,
  isValid: (value: any): value is AttemptOutcome => Object.values(AttemptOutcome).includes(value),
  fromKey: (key: keyof typeof AttemptOutcome): AttemptOutcome => AttemptOutcome[key],
};

export type BranchSyncDirection = 'merge' | 'update';

export const BranchSyncDirection = {
  Merge: 'merge' as const,
  Update: 'update' as const,
} as const;

export const BranchSyncDirectionUtils = {
  values: Object.values(BranchSyncDirection),
  keys: Object.keys(BranchSyncDirection) as Array<keyof typeof BranchSyncDirection>,
  entries: Object.entries(BranchSyncDirection) as Array<[keyof typeof BranchSyncDirection, BranchSyncDirection]>,
  isValid: (value: any): value is BranchSyncDirection => Object.values(BranchSyncDirection).includes(value),
  fromKey: (key: keyof typeof BranchSyncDirection): BranchSyncDirection => BranchSyncDirection[key],
};

export type CollectorKind = 'graph' | 'record' | 'workspace_field';

export const CollectorKind = {
  Graph: 'graph' as const,
  Record: 'record' as const,
  WorkspaceField: 'workspace_field' as const,
} as const;

export const CollectorKindUtils = {
  values: Object.values(CollectorKind),
  keys: Object.keys(CollectorKind) as Array<keyof typeof CollectorKind>,
  entries: Object.entries(CollectorKind) as Array<[keyof typeof CollectorKind, CollectorKind]>,
  isValid: (value: any): value is CollectorKind => Object.values(CollectorKind).includes(value),
  fromKey: (key: keyof typeof CollectorKind): CollectorKind => CollectorKind[key],
};

export type PackageAutomaticBindingResolver = 'system_permission';

export const PackageAutomaticBindingResolver = {
  SystemPermission: 'system_permission' as const,
} as const;

export const PackageAutomaticBindingResolverUtils = {
  values: Object.values(PackageAutomaticBindingResolver),
  keys: Object.keys(PackageAutomaticBindingResolver) as Array<keyof typeof PackageAutomaticBindingResolver>,
  entries: Object.entries(PackageAutomaticBindingResolver) as Array<[keyof typeof PackageAutomaticBindingResolver, PackageAutomaticBindingResolver]>,
  isValid: (value: any): value is PackageAutomaticBindingResolver => Object.values(PackageAutomaticBindingResolver).includes(value),
  fromKey: (key: keyof typeof PackageAutomaticBindingResolver): PackageAutomaticBindingResolver => PackageAutomaticBindingResolver[key],
};

export type PackageContentsSection = 'extensions' | 'media' | 'resources' | 'workspace_fields';

export const PackageContentsSection = {
  Extensions: 'extensions' as const,
  Media: 'media' as const,
  Resources: 'resources' as const,
  WorkspaceFields: 'workspace_fields' as const,
} as const;

export const PackageContentsSectionUtils = {
  values: Object.values(PackageContentsSection),
  keys: Object.keys(PackageContentsSection) as Array<keyof typeof PackageContentsSection>,
  entries: Object.entries(PackageContentsSection) as Array<[keyof typeof PackageContentsSection, PackageContentsSection]>,
  isValid: (value: any): value is PackageContentsSection => Object.values(PackageContentsSection).includes(value),
  fromKey: (key: keyof typeof PackageContentsSection): PackageContentsSection => PackageContentsSection[key],
};

export type PackageEnvironment = 'development' | 'production' | 'staging';

export const PackageEnvironment = {
  Development: 'development' as const,
  Production: 'production' as const,
  Staging: 'staging' as const,
} as const;

export const PackageEnvironmentUtils = {
  values: Object.values(PackageEnvironment),
  keys: Object.keys(PackageEnvironment) as Array<keyof typeof PackageEnvironment>,
  entries: Object.entries(PackageEnvironment) as Array<[keyof typeof PackageEnvironment, PackageEnvironment]>,
  isValid: (value: any): value is PackageEnvironment => Object.values(PackageEnvironment).includes(value),
  fromKey: (key: keyof typeof PackageEnvironment): PackageEnvironment => PackageEnvironment[key],
};

export type PackageInstallAttemptKind = 'cancel' | 'cleanup' | 'detach' | 'install' | 'recovery' | 'setup' | 'setup_retry' | 'setup_skip' | 'update';

export const PackageInstallAttemptKind = {
  Cancel: 'cancel' as const,
  Cleanup: 'cleanup' as const,
  Detach: 'detach' as const,
  Install: 'install' as const,
  Recovery: 'recovery' as const,
  Setup: 'setup' as const,
  SetupRetry: 'setup_retry' as const,
  SetupSkip: 'setup_skip' as const,
  Update: 'update' as const,
} as const;

export const PackageInstallAttemptKindUtils = {
  values: Object.values(PackageInstallAttemptKind),
  keys: Object.keys(PackageInstallAttemptKind) as Array<keyof typeof PackageInstallAttemptKind>,
  entries: Object.entries(PackageInstallAttemptKind) as Array<[keyof typeof PackageInstallAttemptKind, PackageInstallAttemptKind]>,
  isValid: (value: any): value is PackageInstallAttemptKind => Object.values(PackageInstallAttemptKind).includes(value),
  fromKey: (key: keyof typeof PackageInstallAttemptKind): PackageInstallAttemptKind => PackageInstallAttemptKind[key],
};

export type PackageInstallAttemptStatus = 'abandoned' | 'failed' | 'rolled_back' | 'running' | 'succeeded';

export const PackageInstallAttemptStatus = {
  Abandoned: 'abandoned' as const,
  Failed: 'failed' as const,
  RolledBack: 'rolled_back' as const,
  Running: 'running' as const,
  Succeeded: 'succeeded' as const,
} as const;

export const PackageInstallAttemptStatusUtils = {
  values: Object.values(PackageInstallAttemptStatus),
  keys: Object.keys(PackageInstallAttemptStatus) as Array<keyof typeof PackageInstallAttemptStatus>,
  entries: Object.entries(PackageInstallAttemptStatus) as Array<[keyof typeof PackageInstallAttemptStatus, PackageInstallAttemptStatus]>,
  isValid: (value: any): value is PackageInstallAttemptStatus => Object.values(PackageInstallAttemptStatus).includes(value),
  fromKey: (key: keyof typeof PackageInstallAttemptStatus): PackageInstallAttemptStatus => PackageInstallAttemptStatus[key],
};

export type PackageInstallBackupDisposition = 'captured' | 'not_applicable' | 'reused' | 'skipped';

export const PackageInstallBackupDisposition = {
  Captured: 'captured' as const,
  NotApplicable: 'not_applicable' as const,
  Reused: 'reused' as const,
  Skipped: 'skipped' as const,
} as const;

export const PackageInstallBackupDispositionUtils = {
  values: Object.values(PackageInstallBackupDisposition),
  keys: Object.keys(PackageInstallBackupDisposition) as Array<keyof typeof PackageInstallBackupDisposition>,
  entries: Object.entries(PackageInstallBackupDisposition) as Array<[keyof typeof PackageInstallBackupDisposition, PackageInstallBackupDisposition]>,
  isValid: (value: any): value is PackageInstallBackupDisposition => Object.values(PackageInstallBackupDisposition).includes(value),
  fromKey: (key: keyof typeof PackageInstallBackupDisposition): PackageInstallBackupDisposition => PackageInstallBackupDisposition[key],
};

export type PackageInstallDecision = 'adopt' | 'contribute' | 'map';

export const PackageInstallDecision = {
  Adopt: 'adopt' as const,
  Contribute: 'contribute' as const,
  Map: 'map' as const,
} as const;

export const PackageInstallDecisionUtils = {
  values: Object.values(PackageInstallDecision),
  keys: Object.keys(PackageInstallDecision) as Array<keyof typeof PackageInstallDecision>,
  entries: Object.entries(PackageInstallDecision) as Array<[keyof typeof PackageInstallDecision, PackageInstallDecision]>,
  isValid: (value: any): value is PackageInstallDecision => Object.values(PackageInstallDecision).includes(value),
  fromKey: (key: keyof typeof PackageInstallDecision): PackageInstallDecision => PackageInstallDecision[key],
};

export type PackageInstallFailurePhase = 'activation' | 'backup' | 'commit' | 'drift' | 'finish' | 'plan' | 'recovery_cleanup' | 'recovery_entity_graph' | 'recovery_rollback' | 'recovery_store' | 'setup' | 'stage_assets';

export const PackageInstallFailurePhase = {
  Activation: 'activation' as const,
  Backup: 'backup' as const,
  Commit: 'commit' as const,
  Drift: 'drift' as const,
  Finish: 'finish' as const,
  Plan: 'plan' as const,
  RecoveryCleanup: 'recovery_cleanup' as const,
  RecoveryEntityGraph: 'recovery_entity_graph' as const,
  RecoveryRollback: 'recovery_rollback' as const,
  RecoveryStore: 'recovery_store' as const,
  Setup: 'setup' as const,
  StageAssets: 'stage_assets' as const,
} as const;

export const PackageInstallFailurePhaseUtils = {
  values: Object.values(PackageInstallFailurePhase),
  keys: Object.keys(PackageInstallFailurePhase) as Array<keyof typeof PackageInstallFailurePhase>,
  entries: Object.entries(PackageInstallFailurePhase) as Array<[keyof typeof PackageInstallFailurePhase, PackageInstallFailurePhase]>,
  isValid: (value: any): value is PackageInstallFailurePhase => Object.values(PackageInstallFailurePhase).includes(value),
  fromKey: (key: keyof typeof PackageInstallFailurePhase): PackageInstallFailurePhase => PackageInstallFailurePhase[key],
};

export type PackageInstallMatchKind = 'field' | 'permission' | 'resource' | 'role' | 'route' | 'workflow_input' | 'workspace_field';

export const PackageInstallMatchKind = {
  Field: 'field' as const,
  Permission: 'permission' as const,
  Resource: 'resource' as const,
  Role: 'role' as const,
  Route: 'route' as const,
  WorkflowInput: 'workflow_input' as const,
  WorkspaceField: 'workspace_field' as const,
} as const;

export const PackageInstallMatchKindUtils = {
  values: Object.values(PackageInstallMatchKind),
  keys: Object.keys(PackageInstallMatchKind) as Array<keyof typeof PackageInstallMatchKind>,
  entries: Object.entries(PackageInstallMatchKind) as Array<[keyof typeof PackageInstallMatchKind, PackageInstallMatchKind]>,
  isValid: (value: any): value is PackageInstallMatchKind => Object.values(PackageInstallMatchKind).includes(value),
  fromKey: (key: keyof typeof PackageInstallMatchKind): PackageInstallMatchKind => PackageInstallMatchKind[key],
};

export type PackageInstallPlanKind = 'fresh' | 'merge' | 'update';

export const PackageInstallPlanKind = {
  Fresh: 'fresh' as const,
  Merge: 'merge' as const,
  Update: 'update' as const,
} as const;

export const PackageInstallPlanKindUtils = {
  values: Object.values(PackageInstallPlanKind),
  keys: Object.keys(PackageInstallPlanKind) as Array<keyof typeof PackageInstallPlanKind>,
  entries: Object.entries(PackageInstallPlanKind) as Array<[keyof typeof PackageInstallPlanKind, PackageInstallPlanKind]>,
  isValid: (value: any): value is PackageInstallPlanKind => Object.values(PackageInstallPlanKind).includes(value),
  fromKey: (key: keyof typeof PackageInstallPlanKind): PackageInstallPlanKind => PackageInstallPlanKind[key],
};

export type PackageInstallPlanStatus = 'applying' | 'approved' | 'completed' | 'draft' | 'needs_recovery' | 'planning' | 'rolled_back' | 'setup_failed';

export const PackageInstallPlanStatus = {
  Applying: 'applying' as const,
  Approved: 'approved' as const,
  Completed: 'completed' as const,
  Draft: 'draft' as const,
  NeedsRecovery: 'needs_recovery' as const,
  Planning: 'planning' as const,
  RolledBack: 'rolled_back' as const,
  SetupFailed: 'setup_failed' as const,
} as const;

export const PackageInstallPlanStatusUtils = {
  values: Object.values(PackageInstallPlanStatus),
  keys: Object.keys(PackageInstallPlanStatus) as Array<keyof typeof PackageInstallPlanStatus>,
  entries: Object.entries(PackageInstallPlanStatus) as Array<[keyof typeof PackageInstallPlanStatus, PackageInstallPlanStatus]>,
  isValid: (value: any): value is PackageInstallPlanStatus => Object.values(PackageInstallPlanStatus).includes(value),
  fromKey: (key: keyof typeof PackageInstallPlanStatus): PackageInstallPlanStatus => PackageInstallPlanStatus[key],
};

export type PackageInstallStatus = 'installed' | 'needs_recovery' | 'pending' | 'setup_failed';

export const PackageInstallStatus = {
  Installed: 'installed' as const,
  NeedsRecovery: 'needs_recovery' as const,
  Pending: 'pending' as const,
  SetupFailed: 'setup_failed' as const,
} as const;

export const PackageInstallStatusUtils = {
  values: Object.values(PackageInstallStatus),
  keys: Object.keys(PackageInstallStatus) as Array<keyof typeof PackageInstallStatus>,
  entries: Object.entries(PackageInstallStatus) as Array<[keyof typeof PackageInstallStatus, PackageInstallStatus]>,
  isValid: (value: any): value is PackageInstallStatus => Object.values(PackageInstallStatus).includes(value),
  fromKey: (key: keyof typeof PackageInstallStatus): PackageInstallStatus => PackageInstallStatus[key],
};

export type PackageInstallationTargetContract = 'authenticatable_record' | 'authenticatable_resource' | 'entity' | 'page_layout' | 'record';

export const PackageInstallationTargetContract = {
  AuthenticatableRecord: 'authenticatable_record' as const,
  AuthenticatableResource: 'authenticatable_resource' as const,
  Entity: 'entity' as const,
  PageLayout: 'page_layout' as const,
  Record: 'record' as const,
} as const;

export const PackageInstallationTargetContractUtils = {
  values: Object.values(PackageInstallationTargetContract),
  keys: Object.keys(PackageInstallationTargetContract) as Array<keyof typeof PackageInstallationTargetContract>,
  entries: Object.entries(PackageInstallationTargetContract) as Array<[keyof typeof PackageInstallationTargetContract, PackageInstallationTargetContract]>,
  isValid: (value: any): value is PackageInstallationTargetContract => Object.values(PackageInstallationTargetContract).includes(value),
  fromKey: (key: keyof typeof PackageInstallationTargetContract): PackageInstallationTargetContract => PackageInstallationTargetContract[key],
};

export type PackageJobKind = 'apply' | 'branch_create' | 'branch_head' | 'branch_update' | 'build' | 'cancel' | 'cancel_stopped' | 'plan' | 'recover' | 'setup_reconcile';

export const PackageJobKind = {
  Apply: 'apply' as const,
  BranchCreate: 'branch_create' as const,
  BranchHead: 'branch_head' as const,
  BranchUpdate: 'branch_update' as const,
  Build: 'build' as const,
  Cancel: 'cancel' as const,
  CancelStopped: 'cancel_stopped' as const,
  Plan: 'plan' as const,
  Recover: 'recover' as const,
  SetupReconcile: 'setup_reconcile' as const,
} as const;

export const PackageJobKindUtils = {
  values: Object.values(PackageJobKind),
  keys: Object.keys(PackageJobKind) as Array<keyof typeof PackageJobKind>,
  entries: Object.entries(PackageJobKind) as Array<[keyof typeof PackageJobKind, PackageJobKind]>,
  isValid: (value: any): value is PackageJobKind => Object.values(PackageJobKind).includes(value),
  fromKey: (key: keyof typeof PackageJobKind): PackageJobKind => PackageJobKind[key],
};

export type PackageJobStatus = 'failed' | 'queued' | 'running' | 'succeeded';

export const PackageJobStatus = {
  Failed: 'failed' as const,
  Queued: 'queued' as const,
  Running: 'running' as const,
  Succeeded: 'succeeded' as const,
} as const;

export const PackageJobStatusUtils = {
  values: Object.values(PackageJobStatus),
  keys: Object.keys(PackageJobStatus) as Array<keyof typeof PackageJobStatus>,
  entries: Object.entries(PackageJobStatus) as Array<[keyof typeof PackageJobStatus, PackageJobStatus]>,
  isValid: (value: any): value is PackageJobStatus => Object.values(PackageJobStatus).includes(value),
  fromKey: (key: keyof typeof PackageJobStatus): PackageJobStatus => PackageJobStatus[key],
};

export type PackageJobSubject = 'branch' | 'installation' | 'plan' | 'release';

export const PackageJobSubject = {
  Branch: 'branch' as const,
  Installation: 'installation' as const,
  Plan: 'plan' as const,
  Release: 'release' as const,
} as const;

export const PackageJobSubjectUtils = {
  values: Object.values(PackageJobSubject),
  keys: Object.keys(PackageJobSubject) as Array<keyof typeof PackageJobSubject>,
  entries: Object.entries(PackageJobSubject) as Array<[keyof typeof PackageJobSubject, PackageJobSubject]>,
  isValid: (value: any): value is PackageJobSubject => Object.values(PackageJobSubject).includes(value),
  fromKey: (key: keyof typeof PackageJobSubject): PackageJobSubject => PackageJobSubject[key],
};

export type PackageListFilter = 'all' | 'installed';

export const PackageListFilter = {
  All: 'all' as const,
  Installed: 'installed' as const,
} as const;

export const PackageListFilterUtils = {
  values: Object.values(PackageListFilter),
  keys: Object.keys(PackageListFilter) as Array<keyof typeof PackageListFilter>,
  entries: Object.entries(PackageListFilter) as Array<[keyof typeof PackageListFilter, PackageListFilter]>,
  isValid: (value: any): value is PackageListFilter => Object.values(PackageListFilter).includes(value),
  fromKey: (key: keyof typeof PackageListFilter): PackageListFilter => PackageListFilter[key],
};

export type PackageOwnerStatus = 'elsewhere' | 'none';

export const PackageOwnerStatus = {
  Elsewhere: 'elsewhere' as const,
  None: 'none' as const,
} as const;

export const PackageOwnerStatusUtils = {
  values: Object.values(PackageOwnerStatus),
  keys: Object.keys(PackageOwnerStatus) as Array<keyof typeof PackageOwnerStatus>,
  entries: Object.entries(PackageOwnerStatus) as Array<[keyof typeof PackageOwnerStatus, PackageOwnerStatus]>,
  isValid: (value: any): value is PackageOwnerStatus => Object.values(PackageOwnerStatus).includes(value),
  fromKey: (key: keyof typeof PackageOwnerStatus): PackageOwnerStatus => PackageOwnerStatus[key],
};

export type PackageOwnership = 'package';

export const PackageOwnership = {
  Package: 'package' as const,
} as const;

export const PackageOwnershipUtils = {
  values: Object.values(PackageOwnership),
  keys: Object.keys(PackageOwnership) as Array<keyof typeof PackageOwnership>,
  entries: Object.entries(PackageOwnership) as Array<[keyof typeof PackageOwnership, PackageOwnership]>,
  isValid: (value: any): value is PackageOwnership => Object.values(PackageOwnership).includes(value),
  fromKey: (key: keyof typeof PackageOwnership): PackageOwnership => PackageOwnership[key],
};

export type PackageOwnershipRule = 'package_owned' | 'shared' | 'workspace_owned';

export const PackageOwnershipRule = {
  PackageOwned: 'package_owned' as const,
  Shared: 'shared' as const,
  WorkspaceOwned: 'workspace_owned' as const,
} as const;

export const PackageOwnershipRuleUtils = {
  values: Object.values(PackageOwnershipRule),
  keys: Object.keys(PackageOwnershipRule) as Array<keyof typeof PackageOwnershipRule>,
  entries: Object.entries(PackageOwnershipRule) as Array<[keyof typeof PackageOwnershipRule, PackageOwnershipRule]>,
  isValid: (value: any): value is PackageOwnershipRule => Object.values(PackageOwnershipRule).includes(value),
  fromKey: (key: keyof typeof PackageOwnershipRule): PackageOwnershipRule => PackageOwnershipRule[key],
};

export type PackagePolicyAudience = 'author' | 'installer';

export const PackagePolicyAudience = {
  Author: 'author' as const,
  Installer: 'installer' as const,
} as const;

export const PackagePolicyAudienceUtils = {
  values: Object.values(PackagePolicyAudience),
  keys: Object.keys(PackagePolicyAudience) as Array<keyof typeof PackagePolicyAudience>,
  entries: Object.entries(PackagePolicyAudience) as Array<[keyof typeof PackagePolicyAudience, PackagePolicyAudience]>,
  isValid: (value: any): value is PackagePolicyAudience => Object.values(PackagePolicyAudience).includes(value),
  fromKey: (key: keyof typeof PackagePolicyAudience): PackagePolicyAudience => PackagePolicyAudience[key],
};

export type PackagePolicyPreset = 'extensible' | 'limited' | 'locked' | 'unlocked';

export const PackagePolicyPreset = {
  Extensible: 'extensible' as const,
  Limited: 'limited' as const,
  Locked: 'locked' as const,
  Unlocked: 'unlocked' as const,
} as const;

export const PackagePolicyPresetUtils = {
  values: Object.values(PackagePolicyPreset),
  keys: Object.keys(PackagePolicyPreset) as Array<keyof typeof PackagePolicyPreset>,
  entries: Object.entries(PackagePolicyPreset) as Array<[keyof typeof PackagePolicyPreset, PackagePolicyPreset]>,
  isValid: (value: any): value is PackagePolicyPreset => Object.values(PackagePolicyPreset).includes(value),
  fromKey: (key: keyof typeof PackagePolicyPreset): PackagePolicyPreset => PackagePolicyPreset[key],
};

export type PackagePolicyScope = 'container' | 'resource_capabilities' | 'resource_definition' | 'resource_records' | 'singular_entity' | 'workspace_fields';

export const PackagePolicyScope = {
  Container: 'container' as const,
  ResourceCapabilities: 'resource_capabilities' as const,
  ResourceDefinition: 'resource_definition' as const,
  ResourceRecords: 'resource_records' as const,
  SingularEntity: 'singular_entity' as const,
  WorkspaceFields: 'workspace_fields' as const,
} as const;

export const PackagePolicyScopeUtils = {
  values: Object.values(PackagePolicyScope),
  keys: Object.keys(PackagePolicyScope) as Array<keyof typeof PackagePolicyScope>,
  entries: Object.entries(PackagePolicyScope) as Array<[keyof typeof PackagePolicyScope, PackagePolicyScope]>,
  isValid: (value: any): value is PackagePolicyScope => Object.values(PackagePolicyScope).includes(value),
  fromKey: (key: keyof typeof PackagePolicyScope): PackagePolicyScope => PackagePolicyScope[key],
};

export type PackagePreImageOperation = 'create' | 'overwrite' | 'restamp' | 'restore_archived' | 'soft_delete';

export const PackagePreImageOperation = {
  Create: 'create' as const,
  Overwrite: 'overwrite' as const,
  Restamp: 'restamp' as const,
  RestoreArchived: 'restore_archived' as const,
  SoftDelete: 'soft_delete' as const,
} as const;

export const PackagePreImageOperationUtils = {
  values: Object.values(PackagePreImageOperation),
  keys: Object.keys(PackagePreImageOperation) as Array<keyof typeof PackagePreImageOperation>,
  entries: Object.entries(PackagePreImageOperation) as Array<[keyof typeof PackagePreImageOperation, PackagePreImageOperation]>,
  isValid: (value: any): value is PackagePreImageOperation => Object.values(PackagePreImageOperation).includes(value),
  fromKey: (key: keyof typeof PackagePreImageOperation): PackagePreImageOperation => PackagePreImageOperation[key],
};

export type PackagePublicationAction = 'level_changed' | 'owner_claimed' | 'published' | 'publish_failed' | 'relisted' | 'unlisted' | 'withdrawn';

export const PackagePublicationAction = {
  LevelChanged: 'level_changed' as const,
  OwnerClaimed: 'owner_claimed' as const,
  Published: 'published' as const,
  PublishFailed: 'publish_failed' as const,
  Relisted: 'relisted' as const,
  Unlisted: 'unlisted' as const,
  Withdrawn: 'withdrawn' as const,
} as const;

export const PackagePublicationActionUtils = {
  values: Object.values(PackagePublicationAction),
  keys: Object.keys(PackagePublicationAction) as Array<keyof typeof PackagePublicationAction>,
  entries: Object.entries(PackagePublicationAction) as Array<[keyof typeof PackagePublicationAction, PackagePublicationAction]>,
  isValid: (value: any): value is PackagePublicationAction => Object.values(PackagePublicationAction).includes(value),
  fromKey: (key: keyof typeof PackagePublicationAction): PackagePublicationAction => PackagePublicationAction[key],
};

export type PackageRegistryOperation = 'claim' | 'destroy_listing_asset' | 'publish' | 'relist' | 'store_listing_asset' | 'unlist' | 'update_listing' | 'update_package' | 'withdraw';

export const PackageRegistryOperation = {
  Claim: 'claim' as const,
  DestroyListingAsset: 'destroy_listing_asset' as const,
  Publish: 'publish' as const,
  Relist: 'relist' as const,
  StoreListingAsset: 'store_listing_asset' as const,
  Unlist: 'unlist' as const,
  UpdateListing: 'update_listing' as const,
  UpdatePackage: 'update_package' as const,
  Withdraw: 'withdraw' as const,
} as const;

export const PackageRegistryOperationUtils = {
  values: Object.values(PackageRegistryOperation),
  keys: Object.keys(PackageRegistryOperation) as Array<keyof typeof PackageRegistryOperation>,
  entries: Object.entries(PackageRegistryOperation) as Array<[keyof typeof PackageRegistryOperation, PackageRegistryOperation]>,
  isValid: (value: any): value is PackageRegistryOperation => Object.values(PackageRegistryOperation).includes(value),
  fromKey: (key: keyof typeof PackageRegistryOperation): PackageRegistryOperation => PackageRegistryOperation[key],
};

export type PackageReleaseAvailability = 'installable' | 'missing_requirements' | 'not_published' | 'requires_newer_version' | 'withdrawn';

export const PackageReleaseAvailability = {
  Installable: 'installable' as const,
  MissingRequirements: 'missing_requirements' as const,
  NotPublished: 'not_published' as const,
  RequiresNewerVersion: 'requires_newer_version' as const,
  Withdrawn: 'withdrawn' as const,
} as const;

export const PackageReleaseAvailabilityUtils = {
  values: Object.values(PackageReleaseAvailability),
  keys: Object.keys(PackageReleaseAvailability) as Array<keyof typeof PackageReleaseAvailability>,
  entries: Object.entries(PackageReleaseAvailability) as Array<[keyof typeof PackageReleaseAvailability, PackageReleaseAvailability]>,
  isValid: (value: any): value is PackageReleaseAvailability => Object.values(PackageReleaseAvailability).includes(value),
  fromKey: (key: keyof typeof PackageReleaseAvailability): PackageReleaseAvailability => PackageReleaseAvailability[key],
};

export type PackageReleaseSessionAction = 'cancel' | 'review' | 'take-over';

export const PackageReleaseSessionAction = {
  Cancel: 'cancel' as const,
  Review: 'review' as const,
  TakeOver: 'take-over' as const,
} as const;

export const PackageReleaseSessionActionUtils = {
  values: Object.values(PackageReleaseSessionAction),
  keys: Object.keys(PackageReleaseSessionAction) as Array<keyof typeof PackageReleaseSessionAction>,
  entries: Object.entries(PackageReleaseSessionAction) as Array<[keyof typeof PackageReleaseSessionAction, PackageReleaseSessionAction]>,
  isValid: (value: any): value is PackageReleaseSessionAction => Object.values(PackageReleaseSessionAction).includes(value),
  fromKey: (key: keyof typeof PackageReleaseSessionAction): PackageReleaseSessionAction => PackageReleaseSessionAction[key],
};

export type PackageReleaseStatus = 'draft' | 'published';

export const PackageReleaseStatus = {
  Draft: 'draft' as const,
  Published: 'published' as const,
} as const;

export const PackageReleaseStatusUtils = {
  values: Object.values(PackageReleaseStatus),
  keys: Object.keys(PackageReleaseStatus) as Array<keyof typeof PackageReleaseStatus>,
  entries: Object.entries(PackageReleaseStatus) as Array<[keyof typeof PackageReleaseStatus, PackageReleaseStatus]>,
  isValid: (value: any): value is PackageReleaseStatus => Object.values(PackageReleaseStatus).includes(value),
  fromKey: (key: keyof typeof PackageReleaseStatus): PackageReleaseStatus => PackageReleaseStatus[key],
};

export type PackageResolutionKind = 'adopted' | 'contributed' | 'created' | 'excluded' | 'mapped';

export const PackageResolutionKind = {
  Adopted: 'adopted' as const,
  Contributed: 'contributed' as const,
  Created: 'created' as const,
  Excluded: 'excluded' as const,
  Mapped: 'mapped' as const,
} as const;

export const PackageResolutionKindUtils = {
  values: Object.values(PackageResolutionKind),
  keys: Object.keys(PackageResolutionKind) as Array<keyof typeof PackageResolutionKind>,
  entries: Object.entries(PackageResolutionKind) as Array<[keyof typeof PackageResolutionKind, PackageResolutionKind]>,
  isValid: (value: any): value is PackageResolutionKind => Object.values(PackageResolutionKind).includes(value),
  fromKey: (key: keyof typeof PackageResolutionKind): PackageResolutionKind => PackageResolutionKind[key],
};

export type PackageSettings = 'packages:settings:install_backup_in_process' | 'packages:settings:skip_install_backup';

export const PackageSettings = {
  InstallBackupInProcess: 'packages:settings:install_backup_in_process' as const,
  SkipInstallBackup: 'packages:settings:skip_install_backup' as const,
} as const;

export const PackageSettingsUtils = {
  values: Object.values(PackageSettings),
  keys: Object.keys(PackageSettings) as Array<keyof typeof PackageSettings>,
  entries: Object.entries(PackageSettings) as Array<[keyof typeof PackageSettings, PackageSettings]>,
  isValid: (value: any): value is PackageSettings => Object.values(PackageSettings).includes(value),
  fromKey: (key: keyof typeof PackageSettings): PackageSettings => PackageSettings[key],
};

export type PackageSetupRunStatus = 'failed' | 'pending' | 'running' | 'skipped' | 'succeeded';

export const PackageSetupRunStatus = {
  Failed: 'failed' as const,
  Pending: 'pending' as const,
  Running: 'running' as const,
  Skipped: 'skipped' as const,
  Succeeded: 'succeeded' as const,
} as const;

export const PackageSetupRunStatusUtils = {
  values: Object.values(PackageSetupRunStatus),
  keys: Object.keys(PackageSetupRunStatus) as Array<keyof typeof PackageSetupRunStatus>,
  entries: Object.entries(PackageSetupRunStatus) as Array<[keyof typeof PackageSetupRunStatus, PackageSetupRunStatus]>,
  isValid: (value: any): value is PackageSetupRunStatus => Object.values(PackageSetupRunStatus).includes(value),
  fromKey: (key: keyof typeof PackageSetupRunStatus): PackageSetupRunStatus => PackageSetupRunStatus[key],
};

export type PackageSetupWorkflowKind = 'install' | 'upgrade';

export const PackageSetupWorkflowKind = {
  Install: 'install' as const,
  Upgrade: 'upgrade' as const,
} as const;

export const PackageSetupWorkflowKindUtils = {
  values: Object.values(PackageSetupWorkflowKind),
  keys: Object.keys(PackageSetupWorkflowKind) as Array<keyof typeof PackageSetupWorkflowKind>,
  entries: Object.entries(PackageSetupWorkflowKind) as Array<[keyof typeof PackageSetupWorkflowKind, PackageSetupWorkflowKind]>,
  isValid: (value: any): value is PackageSetupWorkflowKind => Object.values(PackageSetupWorkflowKind).includes(value),
  fromKey: (key: keyof typeof PackageSetupWorkflowKind): PackageSetupWorkflowKind => PackageSetupWorkflowKind[key],
};

export type PackageStatusFilter = 'draft' | 'published';

export const PackageStatusFilter = {
  Draft: 'draft' as const,
  Published: 'published' as const,
} as const;

export const PackageStatusFilterUtils = {
  values: Object.values(PackageStatusFilter),
  keys: Object.keys(PackageStatusFilter) as Array<keyof typeof PackageStatusFilter>,
  entries: Object.entries(PackageStatusFilter) as Array<[keyof typeof PackageStatusFilter, PackageStatusFilter]>,
  isValid: (value: any): value is PackageStatusFilter => Object.values(PackageStatusFilter).includes(value),
  fromKey: (key: keyof typeof PackageStatusFilter): PackageStatusFilter => PackageStatusFilter[key],
};

export type PackageStoreKind = 'authorization' | 'mongo' | 'postgres';

export const PackageStoreKind = {
  Authorization: 'authorization' as const,
  Mongo: 'mongo' as const,
  Postgres: 'postgres' as const,
} as const;

export const PackageStoreKindUtils = {
  values: Object.values(PackageStoreKind),
  keys: Object.keys(PackageStoreKind) as Array<keyof typeof PackageStoreKind>,
  entries: Object.entries(PackageStoreKind) as Array<[keyof typeof PackageStoreKind, PackageStoreKind]>,
  isValid: (value: any): value is PackageStoreKind => Object.values(PackageStoreKind).includes(value),
  fromKey: (key: keyof typeof PackageStoreKind): PackageStoreKind => PackageStoreKind[key],
};

export type PackageUpdateChange = 'added' | 'changed' | 'policy' | 'removed';

export const PackageUpdateChange = {
  Added: 'added' as const,
  Changed: 'changed' as const,
  Policy: 'policy' as const,
  Removed: 'removed' as const,
} as const;

export const PackageUpdateChangeUtils = {
  values: Object.values(PackageUpdateChange),
  keys: Object.keys(PackageUpdateChange) as Array<keyof typeof PackageUpdateChange>,
  entries: Object.entries(PackageUpdateChange) as Array<[keyof typeof PackageUpdateChange, PackageUpdateChange]>,
  isValid: (value: any): value is PackageUpdateChange => Object.values(PackageUpdateChange).includes(value),
  fromKey: (key: keyof typeof PackageUpdateChange): PackageUpdateChange => PackageUpdateChange[key],
};

export type PackageUpdateChoice = 'exclude' | 'include' | 'keep_as_mine' | 'keep_mine' | 'leave_deleted' | 'merge' | 'remove' | 'restore' | 'take_theirs';

export const PackageUpdateChoice = {
  Exclude: 'exclude' as const,
  Include: 'include' as const,
  KeepAsMine: 'keep_as_mine' as const,
  KeepMine: 'keep_mine' as const,
  LeaveDeleted: 'leave_deleted' as const,
  Merge: 'merge' as const,
  Remove: 'remove' as const,
  Restore: 'restore' as const,
  TakeTheirs: 'take_theirs' as const,
} as const;

export const PackageUpdateChoiceUtils = {
  values: Object.values(PackageUpdateChoice),
  keys: Object.keys(PackageUpdateChoice) as Array<keyof typeof PackageUpdateChoice>,
  entries: Object.entries(PackageUpdateChoice) as Array<[keyof typeof PackageUpdateChoice, PackageUpdateChoice]>,
  isValid: (value: any): value is PackageUpdateChoice => Object.values(PackageUpdateChoice).includes(value),
  fromKey: (key: keyof typeof PackageUpdateChoice): PackageUpdateChoice => PackageUpdateChoice[key],
};

export type PackageUpdateDecisionKind = 'addition' | 'delete_modify' | 'orphan' | 'property_conflict' | 'revision';

export const PackageUpdateDecisionKind = {
  Addition: 'addition' as const,
  DeleteModify: 'delete_modify' as const,
  Orphan: 'orphan' as const,
  PropertyConflict: 'property_conflict' as const,
  Revision: 'revision' as const,
} as const;

export const PackageUpdateDecisionKindUtils = {
  values: Object.values(PackageUpdateDecisionKind),
  keys: Object.keys(PackageUpdateDecisionKind) as Array<keyof typeof PackageUpdateDecisionKind>,
  entries: Object.entries(PackageUpdateDecisionKind) as Array<[keyof typeof PackageUpdateDecisionKind, PackageUpdateDecisionKind]>,
  isValid: (value: any): value is PackageUpdateDecisionKind => Object.values(PackageUpdateDecisionKind).includes(value),
  fromKey: (key: keyof typeof PackageUpdateDecisionKind): PackageUpdateDecisionKind => PackageUpdateDecisionKind[key],
};

export type RegistryDeletionPhase = 'deleted' | 'deleting' | 'preparing';

export const RegistryDeletionPhase = {
  Deleted: 'deleted' as const,
  Deleting: 'deleting' as const,
  Preparing: 'preparing' as const,
} as const;

export const RegistryDeletionPhaseUtils = {
  values: Object.values(RegistryDeletionPhase),
  keys: Object.keys(RegistryDeletionPhase) as Array<keyof typeof RegistryDeletionPhase>,
  entries: Object.entries(RegistryDeletionPhase) as Array<[keyof typeof RegistryDeletionPhase, RegistryDeletionPhase]>,
  isValid: (value: any): value is RegistryDeletionPhase => Object.values(RegistryDeletionPhase).includes(value),
  fromKey: (key: keyof typeof RegistryDeletionPhase): RegistryDeletionPhase => RegistryDeletionPhase[key],
};

export type RollbackMode = 'cancel' | 'failure' | 'recover';

export const RollbackMode = {
  Cancel: 'cancel' as const,
  Failure: 'failure' as const,
  Recover: 'recover' as const,
} as const;

export const RollbackModeUtils = {
  values: Object.values(RollbackMode),
  keys: Object.keys(RollbackMode) as Array<keyof typeof RollbackMode>,
  entries: Object.entries(RollbackMode) as Array<[keyof typeof RollbackMode, RollbackMode]>,
  isValid: (value: any): value is RollbackMode => Object.values(RollbackMode).includes(value),
  fromKey: (key: keyof typeof RollbackMode): RollbackMode => RollbackMode[key],
};

export type SnapshotView = 'normalized' | 'raw';

export const SnapshotView = {
  Normalized: 'normalized' as const,
  Raw: 'raw' as const,
} as const;

export const SnapshotViewUtils = {
  values: Object.values(SnapshotView),
  keys: Object.keys(SnapshotView) as Array<keyof typeof SnapshotView>,
  entries: Object.entries(SnapshotView) as Array<[keyof typeof SnapshotView, SnapshotView]>,
  isValid: (value: any): value is SnapshotView => Object.values(SnapshotView).includes(value),
  fromKey: (key: keyof typeof SnapshotView): SnapshotView => SnapshotView[key],
};

export type InitialBuildStatus = 'building' | 'failed' | 'ready';

export const InitialBuildStatus = {
  Building: 'building' as const,
  Failed: 'failed' as const,
  Ready: 'ready' as const,
} as const;

export const InitialBuildStatusUtils = {
  values: Object.values(InitialBuildStatus),
  keys: Object.keys(InitialBuildStatus) as Array<keyof typeof InitialBuildStatus>,
  entries: Object.entries(InitialBuildStatus) as Array<[keyof typeof InitialBuildStatus, InitialBuildStatus]>,
  isValid: (value: any): value is InitialBuildStatus => Object.values(InitialBuildStatus).includes(value),
  fromKey: (key: keyof typeof InitialBuildStatus): InitialBuildStatus => InitialBuildStatus[key],
};

export type PageRenderProfile = 'print' | 'standard';

export const PageRenderProfile = {
  Print: 'print' as const,
  Standard: 'standard' as const,
} as const;

export const PageRenderProfileUtils = {
  values: Object.values(PageRenderProfile),
  keys: Object.keys(PageRenderProfile) as Array<keyof typeof PageRenderProfile>,
  entries: Object.entries(PageRenderProfile) as Array<[keyof typeof PageRenderProfile, PageRenderProfile]>,
  isValid: (value: any): value is PageRenderProfile => Object.values(PageRenderProfile).includes(value),
  fromKey: (key: keyof typeof PageRenderProfile): PageRenderProfile => PageRenderProfile[key],
};

export type PageStatus = 'active' | 'paused';

export const PageStatus = {
  Active: 'active' as const,
  Paused: 'paused' as const,
} as const;

export const PageStatusUtils = {
  values: Object.values(PageStatus),
  keys: Object.keys(PageStatus) as Array<keyof typeof PageStatus>,
  entries: Object.entries(PageStatus) as Array<[keyof typeof PageStatus, PageStatus]>,
  isValid: (value: any): value is PageStatus => Object.values(PageStatus).includes(value),
  fromKey: (key: keyof typeof PageStatus): PageStatus => PageStatus[key],
};

export type RouteScopeType = 'domain' | 'primary';

export const RouteScopeType = {
  Domain: 'domain' as const,
  Primary: 'primary' as const,
} as const;

export const RouteScopeTypeUtils = {
  values: Object.values(RouteScopeType),
  keys: Object.keys(RouteScopeType) as Array<keyof typeof RouteScopeType>,
  entries: Object.entries(RouteScopeType) as Array<[keyof typeof RouteScopeType, RouteScopeType]>,
  isValid: (value: any): value is RouteScopeType => Object.values(RouteScopeType).includes(value),
  fromKey: (key: keyof typeof RouteScopeType): RouteScopeType => RouteScopeType[key],
};

export type ArtifactType = 'email_layout' | 'field' | 'layout' | 'navigation_menu' | 'page' | 'policy' | 'resource' | 'role' | 'shared_component' | 'workflow';

export const ArtifactType = {
  EmailLayout: 'email_layout' as const,
  Field: 'field' as const,
  Layout: 'layout' as const,
  NavigationMenu: 'navigation_menu' as const,
  Page: 'page' as const,
  Policy: 'policy' as const,
  Resource: 'resource' as const,
  Role: 'role' as const,
  SharedComponent: 'shared_component' as const,
  Workflow: 'workflow' as const,
} as const;

export const ArtifactTypeUtils = {
  values: Object.values(ArtifactType),
  keys: Object.keys(ArtifactType) as Array<keyof typeof ArtifactType>,
  entries: Object.entries(ArtifactType) as Array<[keyof typeof ArtifactType, ArtifactType]>,
  isValid: (value: any): value is ArtifactType => Object.values(ArtifactType).includes(value),
  fromKey: (key: keyof typeof ArtifactType): ArtifactType => ArtifactType[key],
};

export type ProjectStatus = 'archived' | 'building' | 'completed' | 'draft' | 'planned' | 'planning';

export const ProjectStatus = {
  Archived: 'archived' as const,
  Building: 'building' as const,
  Completed: 'completed' as const,
  Draft: 'draft' as const,
  Planned: 'planned' as const,
  Planning: 'planning' as const,
} as const;

export const ProjectStatusUtils = {
  values: Object.values(ProjectStatus),
  keys: Object.keys(ProjectStatus) as Array<keyof typeof ProjectStatus>,
  entries: Object.entries(ProjectStatus) as Array<[keyof typeof ProjectStatus, ProjectStatus]>,
  isValid: (value: any): value is ProjectStatus => Object.values(ProjectStatus).includes(value),
  fromKey: (key: keyof typeof ProjectStatus): ProjectStatus => ProjectStatus[key],
};

export type SchemaOrigin = 'existing' | 'planned';

export const SchemaOrigin = {
  Existing: 'existing' as const,
  Planned: 'planned' as const,
} as const;

export const SchemaOriginUtils = {
  values: Object.values(SchemaOrigin),
  keys: Object.keys(SchemaOrigin) as Array<keyof typeof SchemaOrigin>,
  entries: Object.entries(SchemaOrigin) as Array<[keyof typeof SchemaOrigin, SchemaOrigin]>,
  isValid: (value: any): value is SchemaOrigin => Object.values(SchemaOrigin).includes(value),
  fromKey: (key: keyof typeof SchemaOrigin): SchemaOrigin => SchemaOrigin[key],
};

export type TaskOperation = 'create' | 'remove' | 'update';

export const TaskOperation = {
  Create: 'create' as const,
  Remove: 'remove' as const,
  Update: 'update' as const,
} as const;

export const TaskOperationUtils = {
  values: Object.values(TaskOperation),
  keys: Object.keys(TaskOperation) as Array<keyof typeof TaskOperation>,
  entries: Object.entries(TaskOperation) as Array<[keyof typeof TaskOperation, TaskOperation]>,
  isValid: (value: any): value is TaskOperation => Object.values(TaskOperation).includes(value),
  fromKey: (key: keyof typeof TaskOperation): TaskOperation => TaskOperation[key],
};

export type TaskReviewStatus = 'needs_rereview' | 'pending' | 'reviewed';

export const TaskReviewStatus = {
  NeedsRereview: 'needs_rereview' as const,
  Pending: 'pending' as const,
  Reviewed: 'reviewed' as const,
} as const;

export const TaskReviewStatusUtils = {
  values: Object.values(TaskReviewStatus),
  keys: Object.keys(TaskReviewStatus) as Array<keyof typeof TaskReviewStatus>,
  entries: Object.entries(TaskReviewStatus) as Array<[keyof typeof TaskReviewStatus, TaskReviewStatus]>,
  isValid: (value: any): value is TaskReviewStatus => Object.values(TaskReviewStatus).includes(value),
  fromKey: (key: keyof typeof TaskReviewStatus): TaskReviewStatus => TaskReviewStatus[key],
};

export type TaskStatus = 'done' | 'failed' | 'in_progress' | 'needs_input' | 'pending' | 'skipped';

export const TaskStatus = {
  Done: 'done' as const,
  Failed: 'failed' as const,
  InProgress: 'in_progress' as const,
  NeedsInput: 'needs_input' as const,
  Pending: 'pending' as const,
  Skipped: 'skipped' as const,
} as const;

export const TaskStatusUtils = {
  values: Object.values(TaskStatus),
  keys: Object.keys(TaskStatus) as Array<keyof typeof TaskStatus>,
  entries: Object.entries(TaskStatus) as Array<[keyof typeof TaskStatus, TaskStatus]>,
  isValid: (value: any): value is TaskStatus => Object.values(TaskStatus).includes(value),
  fromKey: (key: keyof typeof TaskStatus): TaskStatus => TaskStatus[key],
};

export type DeploymentKind = 'deployment' | 'snapshot';

export const DeploymentKind = {
  Deployment: 'deployment' as const,
  Snapshot: 'snapshot' as const,
} as const;

export const DeploymentKindUtils = {
  values: Object.values(DeploymentKind),
  keys: Object.keys(DeploymentKind) as Array<keyof typeof DeploymentKind>,
  entries: Object.entries(DeploymentKind) as Array<[keyof typeof DeploymentKind, DeploymentKind]>,
  isValid: (value: any): value is DeploymentKind => Object.values(DeploymentKind).includes(value),
  fromKey: (key: keyof typeof DeploymentKind): DeploymentKind => DeploymentKind[key],
};

export type DeploymentStatus = 'awaiting_confirmation' | 'building' | 'built' | 'deployed' | 'failed';

export const DeploymentStatus = {
  AwaitingConfirmation: 'awaiting_confirmation' as const,
  Building: 'building' as const,
  Built: 'built' as const,
  Deployed: 'deployed' as const,
  Failed: 'failed' as const,
} as const;

export const DeploymentStatusUtils = {
  values: Object.values(DeploymentStatus),
  keys: Object.keys(DeploymentStatus) as Array<keyof typeof DeploymentStatus>,
  entries: Object.entries(DeploymentStatus) as Array<[keyof typeof DeploymentStatus, DeploymentStatus]>,
  isValid: (value: any): value is DeploymentStatus => Object.values(DeploymentStatus).includes(value),
  fromKey: (key: keyof typeof DeploymentStatus): DeploymentStatus => DeploymentStatus[key],
};

export type PageBuildJobStatus = 'failed' | 'rejected' | 'running' | 'succeeded';

export const PageBuildJobStatus = {
  Failed: 'failed' as const,
  Rejected: 'rejected' as const,
  Running: 'running' as const,
  Succeeded: 'succeeded' as const,
} as const;

export const PageBuildJobStatusUtils = {
  values: Object.values(PageBuildJobStatus),
  keys: Object.keys(PageBuildJobStatus) as Array<keyof typeof PageBuildJobStatus>,
  entries: Object.entries(PageBuildJobStatus) as Array<[keyof typeof PageBuildJobStatus, PageBuildJobStatus]>,
  isValid: (value: any): value is PageBuildJobStatus => Object.values(PageBuildJobStatus).includes(value),
  fromKey: (key: keyof typeof PageBuildJobStatus): PageBuildJobStatus => PageBuildJobStatus[key],
};

export type PageBuildState = 'cancelled' | 'completed' | 'failed' | 'queued' | 'running';

export const PageBuildState = {
  Cancelled: 'cancelled' as const,
  Completed: 'completed' as const,
  Failed: 'failed' as const,
  Queued: 'queued' as const,
  Running: 'running' as const,
} as const;

export const PageBuildStateUtils = {
  values: Object.values(PageBuildState),
  keys: Object.keys(PageBuildState) as Array<keyof typeof PageBuildState>,
  entries: Object.entries(PageBuildState) as Array<[keyof typeof PageBuildState, PageBuildState]>,
  isValid: (value: any): value is PageBuildState => Object.values(PageBuildState).includes(value),
  fromKey: (key: keyof typeof PageBuildState): PageBuildState => PageBuildState[key],
};

export type AvailabilityEffect = 'closed' | 'open' | 'replace';

export const AvailabilityEffect = {
  Closed: 'closed' as const,
  Open: 'open' as const,
  Replace: 'replace' as const,
} as const;

export const AvailabilityEffectUtils = {
  values: Object.values(AvailabilityEffect),
  keys: Object.keys(AvailabilityEffect) as Array<keyof typeof AvailabilityEffect>,
  entries: Object.entries(AvailabilityEffect) as Array<[keyof typeof AvailabilityEffect, AvailabilityEffect]>,
  isValid: (value: any): value is AvailabilityEffect => Object.values(AvailabilityEffect).includes(value),
  fromKey: (key: keyof typeof AvailabilityEffect): AvailabilityEffect => AvailabilityEffect[key],
};

export type BookingEffect = 'held' | 'released' | 'takes' | 'waiting';

export const BookingEffect = {
  Held: 'held' as const,
  Released: 'released' as const,
  Takes: 'takes' as const,
  Waiting: 'waiting' as const,
} as const;

export const BookingEffectUtils = {
  values: Object.values(BookingEffect),
  keys: Object.keys(BookingEffect) as Array<keyof typeof BookingEffect>,
  entries: Object.entries(BookingEffect) as Array<[keyof typeof BookingEffect, BookingEffect]>,
  isValid: (value: any): value is BookingEffect => Object.values(BookingEffect).includes(value),
  fromKey: (key: keyof typeof BookingEffect): BookingEffect => BookingEffect[key],
};

export type CalendarEventColor = 'banana' | 'basil' | 'blueberry' | 'flamingo' | 'grape' | 'graphite' | 'lavender' | 'peacock' | 'sage' | 'tangerine' | 'tomato';

export const CalendarEventColor = {
  Banana: 'banana' as const,
  Basil: 'basil' as const,
  Blueberry: 'blueberry' as const,
  Flamingo: 'flamingo' as const,
  Grape: 'grape' as const,
  Graphite: 'graphite' as const,
  Lavender: 'lavender' as const,
  Peacock: 'peacock' as const,
  Sage: 'sage' as const,
  Tangerine: 'tangerine' as const,
  Tomato: 'tomato' as const,
} as const;

export const CalendarEventColorUtils = {
  values: Object.values(CalendarEventColor),
  keys: Object.keys(CalendarEventColor) as Array<keyof typeof CalendarEventColor>,
  entries: Object.entries(CalendarEventColor) as Array<[keyof typeof CalendarEventColor, CalendarEventColor]>,
  isValid: (value: any): value is CalendarEventColor => Object.values(CalendarEventColor).includes(value),
  fromKey: (key: keyof typeof CalendarEventColor): CalendarEventColor => CalendarEventColor[key],
};

export type CalendarLinkType = 'apple' | 'google' | 'outlook';

export const CalendarLinkType = {
  Apple: 'apple' as const,
  Google: 'google' as const,
  Outlook: 'outlook' as const,
} as const;

export const CalendarLinkTypeUtils = {
  values: Object.values(CalendarLinkType),
  keys: Object.keys(CalendarLinkType) as Array<keyof typeof CalendarLinkType>,
  entries: Object.entries(CalendarLinkType) as Array<[keyof typeof CalendarLinkType, CalendarLinkType]>,
  isValid: (value: any): value is CalendarLinkType => Object.values(CalendarLinkType).includes(value),
  fromKey: (key: keyof typeof CalendarLinkType): CalendarLinkType => CalendarLinkType[key],
};

export type CalendarStatusMeaning = 'cancelled' | 'tentative';

export const CalendarStatusMeaning = {
  Cancelled: 'cancelled' as const,
  Tentative: 'tentative' as const,
} as const;

export const CalendarStatusMeaningUtils = {
  values: Object.values(CalendarStatusMeaning),
  keys: Object.keys(CalendarStatusMeaning) as Array<keyof typeof CalendarStatusMeaning>,
  entries: Object.entries(CalendarStatusMeaning) as Array<[keyof typeof CalendarStatusMeaning, CalendarStatusMeaning]>,
  isValid: (value: any): value is CalendarStatusMeaning => Object.values(CalendarStatusMeaning).includes(value),
  fromKey: (key: keyof typeof CalendarStatusMeaning): CalendarStatusMeaning => CalendarStatusMeaning[key],
};

export type IcsEventStatus = 'CANCELLED' | 'CONFIRMED' | 'TENTATIVE';

export const IcsEventStatus = {
  Cancelled: 'CANCELLED' as const,
  Confirmed: 'CONFIRMED' as const,
  Tentative: 'TENTATIVE' as const,
} as const;

export const IcsEventStatusUtils = {
  values: Object.values(IcsEventStatus),
  keys: Object.keys(IcsEventStatus) as Array<keyof typeof IcsEventStatus>,
  entries: Object.entries(IcsEventStatus) as Array<[keyof typeof IcsEventStatus, IcsEventStatus]>,
  isValid: (value: any): value is IcsEventStatus => Object.values(IcsEventStatus).includes(value),
  fromKey: (key: keyof typeof IcsEventStatus): IcsEventStatus => IcsEventStatus[key],
};

export type IcsMethod = 'CANCEL' | 'PUBLISH' | 'REQUEST';

export const IcsMethod = {
  Cancel: 'CANCEL' as const,
  Publish: 'PUBLISH' as const,
  Request: 'REQUEST' as const,
} as const;

export const IcsMethodUtils = {
  values: Object.values(IcsMethod),
  keys: Object.keys(IcsMethod) as Array<keyof typeof IcsMethod>,
  entries: Object.entries(IcsMethod) as Array<[keyof typeof IcsMethod, IcsMethod]>,
  isValid: (value: any): value is IcsMethod => Object.values(IcsMethod).includes(value),
  fromKey: (key: keyof typeof IcsMethod): IcsMethod => IcsMethod[key],
};

export type RecurrenceByDay = 'SU' | 'MO' | 'TU' | 'WE' | 'TH' | 'FR' | 'SA';

export const RecurrenceByDay = {
  Sunday: 'SU' as const,
  Monday: 'MO' as const,
  Tuesday: 'TU' as const,
  Wednesday: 'WE' as const,
  Thursday: 'TH' as const,
  Friday: 'FR' as const,
  Saturday: 'SA' as const,
} as const;

export const RecurrenceByDayUtils = {
  values: Object.values(RecurrenceByDay),
  keys: Object.keys(RecurrenceByDay) as Array<keyof typeof RecurrenceByDay>,
  entries: Object.entries(RecurrenceByDay) as Array<[keyof typeof RecurrenceByDay, RecurrenceByDay]>,
  isValid: (value: any): value is RecurrenceByDay => Object.values(RecurrenceByDay).includes(value),
  fromKey: (key: keyof typeof RecurrenceByDay): RecurrenceByDay => RecurrenceByDay[key],
};

export type RecurrenceFrequency = 'DAILY' | 'MONTHLY' | 'WEEKLY' | 'YEARLY';

export const RecurrenceFrequency = {
  Daily: 'DAILY' as const,
  Monthly: 'MONTHLY' as const,
  Weekly: 'WEEKLY' as const,
  Yearly: 'YEARLY' as const,
} as const;

export const RecurrenceFrequencyUtils = {
  values: Object.values(RecurrenceFrequency),
  keys: Object.keys(RecurrenceFrequency) as Array<keyof typeof RecurrenceFrequency>,
  entries: Object.entries(RecurrenceFrequency) as Array<[keyof typeof RecurrenceFrequency, RecurrenceFrequency]>,
  isValid: (value: any): value is RecurrenceFrequency => Object.values(RecurrenceFrequency).includes(value),
  fromKey: (key: keyof typeof RecurrenceFrequency): RecurrenceFrequency => RecurrenceFrequency[key],
};

export type RecurringEditScope = 'all' | 'this' | 'this_and_future';

export const RecurringEditScope = {
  All: 'all' as const,
  This: 'this' as const,
  ThisAndFuture: 'this_and_future' as const,
} as const;

export const RecurringEditScopeUtils = {
  values: Object.values(RecurringEditScope),
  keys: Object.keys(RecurringEditScope) as Array<keyof typeof RecurringEditScope>,
  entries: Object.entries(RecurringEditScope) as Array<[keyof typeof RecurringEditScope, RecurringEditScope]>,
  isValid: (value: any): value is RecurringEditScope => Object.values(RecurringEditScope).includes(value),
  fromKey: (key: keyof typeof RecurringEditScope): RecurringEditScope => RecurringEditScope[key],
};

export type SeriesEndReason = 'deleted' | 'owner_archived' | 'stopped';

export const SeriesEndReason = {
  Deleted: 'deleted' as const,
  OwnerArchived: 'owner_archived' as const,
  Stopped: 'stopped' as const,
} as const;

export const SeriesEndReasonUtils = {
  values: Object.values(SeriesEndReason),
  keys: Object.keys(SeriesEndReason) as Array<keyof typeof SeriesEndReason>,
  entries: Object.entries(SeriesEndReason) as Array<[keyof typeof SeriesEndReason, SeriesEndReason]>,
  isValid: (value: any): value is SeriesEndReason => Object.values(SeriesEndReason).includes(value),
  fromKey: (key: keyof typeof SeriesEndReason): SeriesEndReason => SeriesEndReason[key],
};

export type SeriesItemCode = 'series_failed' | 'series_kept_capacity' | 'series_kept_hook' | 'series_kept_locked' | 'series_kept_override' | 'series_kept_policy' | 'series_kept_referenced';

export const SeriesItemCode = {
  Failed: 'series_failed' as const,
  KeptCapacity: 'series_kept_capacity' as const,
  KeptHook: 'series_kept_hook' as const,
  KeptLocked: 'series_kept_locked' as const,
  KeptOverride: 'series_kept_override' as const,
  KeptPolicy: 'series_kept_policy' as const,
  KeptReferenced: 'series_kept_referenced' as const,
} as const;

export const SeriesItemCodeUtils = {
  values: Object.values(SeriesItemCode),
  keys: Object.keys(SeriesItemCode) as Array<keyof typeof SeriesItemCode>,
  entries: Object.entries(SeriesItemCode) as Array<[keyof typeof SeriesItemCode, SeriesItemCode]>,
  isValid: (value: any): value is SeriesItemCode => Object.values(SeriesItemCode).includes(value),
  fromKey: (key: keyof typeof SeriesItemCode): SeriesItemCode => SeriesItemCode[key],
};

export type SeriesNotCopiedReason = 'computed' | 'excluded' | 'other' | 'system_managed' | 'unique';

export const SeriesNotCopiedReason = {
  Computed: 'computed' as const,
  Excluded: 'excluded' as const,
  Other: 'other' as const,
  SystemManaged: 'system_managed' as const,
  Unique: 'unique' as const,
} as const;

export const SeriesNotCopiedReasonUtils = {
  values: Object.values(SeriesNotCopiedReason),
  keys: Object.keys(SeriesNotCopiedReason) as Array<keyof typeof SeriesNotCopiedReason>,
  entries: Object.entries(SeriesNotCopiedReason) as Array<[keyof typeof SeriesNotCopiedReason, SeriesNotCopiedReason]>,
  isValid: (value: any): value is SeriesNotCopiedReason => Object.values(SeriesNotCopiedReason).includes(value),
  fromKey: (key: keyof typeof SeriesNotCopiedReason): SeriesNotCopiedReason => SeriesNotCopiedReason[key],
};

export type SeriesOccurrenceState = 'kept' | 'regular' | 'restored';

export const SeriesOccurrenceState = {
  Kept: 'kept' as const,
  Regular: 'regular' as const,
  Restored: 'restored' as const,
} as const;

export const SeriesOccurrenceStateUtils = {
  values: Object.values(SeriesOccurrenceState),
  keys: Object.keys(SeriesOccurrenceState) as Array<keyof typeof SeriesOccurrenceState>,
  entries: Object.entries(SeriesOccurrenceState) as Array<[keyof typeof SeriesOccurrenceState, SeriesOccurrenceState]>,
  isValid: (value: any): value is SeriesOccurrenceState => Object.values(SeriesOccurrenceState).includes(value),
  fromKey: (key: keyof typeof SeriesOccurrenceState): SeriesOccurrenceState => SeriesOccurrenceState[key],
};

export type SeriesRowOperation = 'apply' | 'create' | 'keep' | 'move' | 'past' | 'rekey_archived' | 'remove' | 'restore';

export const SeriesRowOperation = {
  Apply: 'apply' as const,
  Create: 'create' as const,
  Keep: 'keep' as const,
  Move: 'move' as const,
  Past: 'past' as const,
  RekeyArchived: 'rekey_archived' as const,
  Remove: 'remove' as const,
  Restore: 'restore' as const,
} as const;

export const SeriesRowOperationUtils = {
  values: Object.values(SeriesRowOperation),
  keys: Object.keys(SeriesRowOperation) as Array<keyof typeof SeriesRowOperation>,
  entries: Object.entries(SeriesRowOperation) as Array<[keyof typeof SeriesRowOperation, SeriesRowOperation]>,
  isValid: (value: any): value is SeriesRowOperation => Object.values(SeriesRowOperation).includes(value),
  fromKey: (key: keyof typeof SeriesRowOperation): SeriesRowOperation => SeriesRowOperation[key],
};

export type RunnerSubmission = 'accepted' | 'busy' | 'rejected' | 'unacknowledged';

export const RunnerSubmission = {
  Accepted: 'accepted' as const,
  Busy: 'busy' as const,
  Rejected: 'rejected' as const,
  Unacknowledged: 'unacknowledged' as const,
} as const;

export const RunnerSubmissionUtils = {
  values: Object.values(RunnerSubmission),
  keys: Object.keys(RunnerSubmission) as Array<keyof typeof RunnerSubmission>,
  entries: Object.entries(RunnerSubmission) as Array<[keyof typeof RunnerSubmission, RunnerSubmission]>,
  isValid: (value: any): value is RunnerSubmission => Object.values(RunnerSubmission).includes(value),
  fromKey: (key: keyof typeof RunnerSubmission): RunnerSubmission => RunnerSubmission[key],
};

export type TestCaseScriptPhase = 'assert' | 'setup';

export const TestCaseScriptPhase = {
  Assert: 'assert' as const,
  Setup: 'setup' as const,
} as const;

export const TestCaseScriptPhaseUtils = {
  values: Object.values(TestCaseScriptPhase),
  keys: Object.keys(TestCaseScriptPhase) as Array<keyof typeof TestCaseScriptPhase>,
  entries: Object.entries(TestCaseScriptPhase) as Array<[keyof typeof TestCaseScriptPhase, TestCaseScriptPhase]>,
  isValid: (value: any): value is TestCaseScriptPhase => Object.values(TestCaseScriptPhase).includes(value),
  fromKey: (key: keyof typeof TestCaseScriptPhase): TestCaseScriptPhase => TestCaseScriptPhase[key],
};

export type TestResultStatus = 'failed' | 'interrupted' | 'passed' | 'skipped' | 'timed_out';

export const TestResultStatus = {
  Failed: 'failed' as const,
  Interrupted: 'interrupted' as const,
  Passed: 'passed' as const,
  Skipped: 'skipped' as const,
  TimedOut: 'timed_out' as const,
} as const;

export const TestResultStatusUtils = {
  values: Object.values(TestResultStatus),
  keys: Object.keys(TestResultStatus) as Array<keyof typeof TestResultStatus>,
  entries: Object.entries(TestResultStatus) as Array<[keyof typeof TestResultStatus, TestResultStatus]>,
  isValid: (value: any): value is TestResultStatus => Object.values(TestResultStatus).includes(value),
  fromKey: (key: keyof typeof TestResultStatus): TestResultStatus => TestResultStatus[key],
};

export type TestRunArtifactKind = 'screenshot' | 'trace' | 'video';

export const TestRunArtifactKind = {
  Screenshot: 'screenshot' as const,
  Trace: 'trace' as const,
  Video: 'video' as const,
} as const;

export const TestRunArtifactKindUtils = {
  values: Object.values(TestRunArtifactKind),
  keys: Object.keys(TestRunArtifactKind) as Array<keyof typeof TestRunArtifactKind>,
  entries: Object.entries(TestRunArtifactKind) as Array<[keyof typeof TestRunArtifactKind, TestRunArtifactKind]>,
  isValid: (value: any): value is TestRunArtifactKind => Object.values(TestRunArtifactKind).includes(value),
  fromKey: (key: keyof typeof TestRunArtifactKind): TestRunArtifactKind => TestRunArtifactKind[key],
};

export type TestRunOutcome = 'completed' | 'errored';

export const TestRunOutcome = {
  Completed: 'completed' as const,
  Errored: 'errored' as const,
} as const;

export const TestRunOutcomeUtils = {
  values: Object.values(TestRunOutcome),
  keys: Object.keys(TestRunOutcome) as Array<keyof typeof TestRunOutcome>,
  entries: Object.entries(TestRunOutcome) as Array<[keyof typeof TestRunOutcome, TestRunOutcome]>,
  isValid: (value: any): value is TestRunOutcome => Object.values(TestRunOutcome).includes(value),
  fromKey: (key: keyof typeof TestRunOutcome): TestRunOutcome => TestRunOutcome[key],
};

export type TestRunStatus = 'cancelled' | 'errored' | 'failed' | 'passed' | 'preparing' | 'queued' | 'running';

export const TestRunStatus = {
  Cancelled: 'cancelled' as const,
  Errored: 'errored' as const,
  Failed: 'failed' as const,
  Passed: 'passed' as const,
  Preparing: 'preparing' as const,
  Queued: 'queued' as const,
  Running: 'running' as const,
} as const;

export const TestRunStatusUtils = {
  values: Object.values(TestRunStatus),
  keys: Object.keys(TestRunStatus) as Array<keyof typeof TestRunStatus>,
  entries: Object.entries(TestRunStatus) as Array<[keyof typeof TestRunStatus, TestRunStatus]>,
  isValid: (value: any): value is TestRunStatus => Object.values(TestRunStatus).includes(value),
  fromKey: (key: keyof typeof TestRunStatus): TestRunStatus => TestRunStatus[key],
};

export type TestRunTrigger = 'api' | 'manual';

export const TestRunTrigger = {
  Api: 'api' as const,
  Manual: 'manual' as const,
} as const;

export const TestRunTriggerUtils = {
  values: Object.values(TestRunTrigger),
  keys: Object.keys(TestRunTrigger) as Array<keyof typeof TestRunTrigger>,
  entries: Object.entries(TestRunTrigger) as Array<[keyof typeof TestRunTrigger, TestRunTrigger]>,
  isValid: (value: any): value is TestRunTrigger => Object.values(TestRunTrigger).includes(value),
  fromKey: (key: keyof typeof TestRunTrigger): TestRunTrigger => TestRunTrigger[key],
};

export type TestRunnerDriver = 'fly_machines' | 'service';

export const TestRunnerDriver = {
  FlyMachines: 'fly_machines' as const,
  Service: 'service' as const,
} as const;

export const TestRunnerDriverUtils = {
  values: Object.values(TestRunnerDriver),
  keys: Object.keys(TestRunnerDriver) as Array<keyof typeof TestRunnerDriver>,
  entries: Object.entries(TestRunnerDriver) as Array<[keyof typeof TestRunnerDriver, TestRunnerDriver]>,
  isValid: (value: any): value is TestRunnerDriver => Object.values(TestRunnerDriver).includes(value),
  fromKey: (key: keyof typeof TestRunnerDriver): TestRunnerDriver => TestRunnerDriver[key],
};

export type ContainerType = 'loop' | 'transaction';

export const ContainerType = {
  Loop: 'loop' as const,
  Transaction: 'transaction' as const,
} as const;

export const ContainerTypeUtils = {
  values: Object.values(ContainerType),
  keys: Object.keys(ContainerType) as Array<keyof typeof ContainerType>,
  entries: Object.entries(ContainerType) as Array<[keyof typeof ContainerType, ContainerType]>,
  isValid: (value: any): value is ContainerType => Object.values(ContainerType).includes(value),
  fromKey: (key: keyof typeof ContainerType): ContainerType => ContainerType[key],
};

export type DatePeriod = 'month' | 'quarter' | 'week' | 'year';

export const DatePeriod = {
  Month: 'month' as const,
  Quarter: 'quarter' as const,
  Week: 'week' as const,
  Year: 'year' as const,
} as const;

export const DatePeriodUtils = {
  values: Object.values(DatePeriod),
  keys: Object.keys(DatePeriod) as Array<keyof typeof DatePeriod>,
  entries: Object.entries(DatePeriod) as Array<[keyof typeof DatePeriod, DatePeriod]>,
  isValid: (value: any): value is DatePeriod => Object.values(DatePeriod).includes(value),
  fromKey: (key: keyof typeof DatePeriod): DatePeriod => DatePeriod[key],
};

export type DateUnit = 'days' | 'months' | 'weeks' | 'years';

export const DateUnit = {
  Days: 'days' as const,
  Months: 'months' as const,
  Weeks: 'weeks' as const,
  Years: 'years' as const,
} as const;

export const DateUnitUtils = {
  values: Object.values(DateUnit),
  keys: Object.keys(DateUnit) as Array<keyof typeof DateUnit>,
  entries: Object.entries(DateUnit) as Array<[keyof typeof DateUnit, DateUnit]>,
  isValid: (value: any): value is DateUnit => Object.values(DateUnit).includes(value),
  fromKey: (key: keyof typeof DateUnit): DateUnit => DateUnit[key],
};

export type DocumentEventType = 'created' | 'deleted' | 'restored' | 'saved' | 'updated';

export const DocumentEventType = {
  Created: 'created' as const,
  Deleted: 'deleted' as const,
  Restored: 'restored' as const,
  Saved: 'saved' as const,
  Updated: 'updated' as const,
} as const;

export const DocumentEventTypeUtils = {
  values: Object.values(DocumentEventType),
  keys: Object.keys(DocumentEventType) as Array<keyof typeof DocumentEventType>,
  entries: Object.entries(DocumentEventType) as Array<[keyof typeof DocumentEventType, DocumentEventType]>,
  isValid: (value: any): value is DocumentEventType => Object.values(DocumentEventType).includes(value),
  fromKey: (key: keyof typeof DocumentEventType): DocumentEventType => DocumentEventType[key],
};

export type Environment = 'isomorphic' | 'server';

export const Environment = {
  Isomorphic: 'isomorphic' as const,
  Server: 'server' as const,
} as const;

export const EnvironmentUtils = {
  values: Object.values(Environment),
  keys: Object.keys(Environment) as Array<keyof typeof Environment>,
  entries: Object.entries(Environment) as Array<[keyof typeof Environment, Environment]>,
  isValid: (value: any): value is Environment => Object.values(Environment).includes(value),
  fromKey: (key: keyof typeof Environment): Environment => Environment[key],
};

export type ExecutionMode = 'async' | 'sync';

export const ExecutionMode = {
  Async: 'async' as const,
  Sync: 'sync' as const,
} as const;

export const ExecutionModeUtils = {
  values: Object.values(ExecutionMode),
  keys: Object.keys(ExecutionMode) as Array<keyof typeof ExecutionMode>,
  entries: Object.entries(ExecutionMode) as Array<[keyof typeof ExecutionMode, ExecutionMode]>,
  isValid: (value: any): value is ExecutionMode => Object.values(ExecutionMode).includes(value),
  fromKey: (key: keyof typeof ExecutionMode): ExecutionMode => ExecutionMode[key],
};

export type ExecutionSetting = 'workflow.blocking' | 'workflow.force_sync_testing' | 'workflow.processing' | 'workflow.testing' | 'workflow.use_published_version';

export const ExecutionSetting = {
  Blocking: 'workflow.blocking' as const,
  ForceSyncTesting: 'workflow.force_sync_testing' as const,
  Processing: 'workflow.processing' as const,
  Testing: 'workflow.testing' as const,
  UsePublishedVersion: 'workflow.use_published_version' as const,
} as const;

export const ExecutionSettingUtils = {
  values: Object.values(ExecutionSetting),
  keys: Object.keys(ExecutionSetting) as Array<keyof typeof ExecutionSetting>,
  entries: Object.entries(ExecutionSetting) as Array<[keyof typeof ExecutionSetting, ExecutionSetting]>,
  isValid: (value: any): value is ExecutionSetting => Object.values(ExecutionSetting).includes(value),
  fromKey: (key: keyof typeof ExecutionSetting): ExecutionSetting => ExecutionSetting[key],
};

export type GuardRule = 'nullable' | 'required' | 'present' | 'array' | 'list' | 'string' | 'numeric' | 'integer' | 'boolean' | 'email' | 'liquid' | 'markdown' | 'date' | 'date_format:Y-m-d' | 'phone' | 'timezone' | 'uuid:7' | 'url' | 'ip' | 'ipv4' | 'ipv6' | 'mac_address' | 'json' | 'uuid' | 'ulid' | 'hex_color' | 'alpha' | 'alpha_num' | 'alpha_dash' | 'ascii' | 'lowercase' | 'uppercase' | 'starts_with' | 'ends_with' | 'doesnt_start_with' | 'doesnt_end_with' | 'regex' | 'min' | 'max' | 'size' | 'between' | 'digits' | 'digits_between' | 'distinct' | 'in' | 'not_in' | 'after' | 'after_or_equal' | 'before' | 'before_or_equal' | 'required_if';

export const GuardRule = {
  Nullable: 'nullable' as const,
  Required: 'required' as const,
  Present: 'present' as const,
  Dictionary: 'array' as const,
  ListType: 'list' as const,
  Text: 'string' as const,
  Numeric: 'numeric' as const,
  Integer: 'integer' as const,
  Boolean: 'boolean' as const,
  Email: 'email' as const,
  Liquid: 'liquid' as const,
  Markdown: 'markdown' as const,
  Date: 'date' as const,
  DateYmd: 'date_format:Y-m-d' as const,
  Phone: 'phone' as const,
  Timezone: 'timezone' as const,
  UuidV7: 'uuid:7' as const,
  Url: 'url' as const,
  Ip: 'ip' as const,
  Ipv4: 'ipv4' as const,
  Ipv6: 'ipv6' as const,
  MacAddress: 'mac_address' as const,
  Json: 'json' as const,
  Uuid: 'uuid' as const,
  Ulid: 'ulid' as const,
  HexColor: 'hex_color' as const,
  Alpha: 'alpha' as const,
  AlphaNum: 'alpha_num' as const,
  AlphaDash: 'alpha_dash' as const,
  Ascii: 'ascii' as const,
  Lowercase: 'lowercase' as const,
  Uppercase: 'uppercase' as const,
  StartsWith: 'starts_with' as const,
  EndsWith: 'ends_with' as const,
  DoesntStartWith: 'doesnt_start_with' as const,
  DoesntEndWith: 'doesnt_end_with' as const,
  Regex: 'regex' as const,
  Min: 'min' as const,
  Max: 'max' as const,
  Size: 'size' as const,
  Between: 'between' as const,
  Digits: 'digits' as const,
  DigitsBetween: 'digits_between' as const,
  Distinct: 'distinct' as const,
  In: 'in' as const,
  NotIn: 'not_in' as const,
  After: 'after' as const,
  AfterOrEqual: 'after_or_equal' as const,
  Before: 'before' as const,
  BeforeOrEqual: 'before_or_equal' as const,
  RequiredIf: 'required_if' as const,
} as const;

export const GuardRuleUtils = {
  values: Object.values(GuardRule),
  keys: Object.keys(GuardRule) as Array<keyof typeof GuardRule>,
  entries: Object.entries(GuardRule) as Array<[keyof typeof GuardRule, GuardRule]>,
  isValid: (value: any): value is GuardRule => Object.values(GuardRule).includes(value),
  fromKey: (key: keyof typeof GuardRule): GuardRule => GuardRule[key],
};

export type GuardRuleCategory = 'custom' | 'presence' | 'type';

export const GuardRuleCategory = {
  Custom: 'custom' as const,
  Presence: 'presence' as const,
  Type: 'type' as const,
} as const;

export const GuardRuleCategoryUtils = {
  values: Object.values(GuardRuleCategory),
  keys: Object.keys(GuardRuleCategory) as Array<keyof typeof GuardRuleCategory>,
  entries: Object.entries(GuardRuleCategory) as Array<[keyof typeof GuardRuleCategory, GuardRuleCategory]>,
  isValid: (value: any): value is GuardRuleCategory => Object.values(GuardRuleCategory).includes(value),
  fromKey: (key: keyof typeof GuardRuleCategory): GuardRuleCategory => GuardRuleCategory[key],
};

export type OffsetState = 'manually_skipped' | 'pending' | 'sent' | 'skipped';

export const OffsetState = {
  ManuallySkipped: 'manually_skipped' as const,
  Pending: 'pending' as const,
  Sent: 'sent' as const,
  Skipped: 'skipped' as const,
} as const;

export const OffsetStateUtils = {
  values: Object.values(OffsetState),
  keys: Object.keys(OffsetState) as Array<keyof typeof OffsetState>,
  entries: Object.entries(OffsetState) as Array<[keyof typeof OffsetState, OffsetState]>,
  isValid: (value: any): value is OffsetState => Object.values(OffsetState).includes(value),
  fromKey: (key: keyof typeof OffsetState): OffsetState => OffsetState[key],
};

export type PhoneFormat = 'e164' | 'international' | 'national' | 'rfc3966';

export const PhoneFormat = {
  E164: 'e164' as const,
  International: 'international' as const,
  National: 'national' as const,
  Rfc3966: 'rfc3966' as const,
} as const;

export const PhoneFormatUtils = {
  values: Object.values(PhoneFormat),
  keys: Object.keys(PhoneFormat) as Array<keyof typeof PhoneFormat>,
  entries: Object.entries(PhoneFormat) as Array<[keyof typeof PhoneFormat, PhoneFormat]>,
  isValid: (value: any): value is PhoneFormat => Object.values(PhoneFormat).includes(value),
  fromKey: (key: keyof typeof PhoneFormat): PhoneFormat => PhoneFormat[key],
};

export type RecordScheduleParticipantsViewMode = 'draft' | 'live';

export const RecordScheduleParticipantsViewMode = {
  Draft: 'draft' as const,
  Live: 'live' as const,
} as const;

export const RecordScheduleParticipantsViewModeUtils = {
  values: Object.values(RecordScheduleParticipantsViewMode),
  keys: Object.keys(RecordScheduleParticipantsViewMode) as Array<keyof typeof RecordScheduleParticipantsViewMode>,
  entries: Object.entries(RecordScheduleParticipantsViewMode) as Array<[keyof typeof RecordScheduleParticipantsViewMode, RecordScheduleParticipantsViewMode]>,
  isValid: (value: any): value is RecordScheduleParticipantsViewMode => Object.values(RecordScheduleParticipantsViewMode).includes(value),
  fromKey: (key: keyof typeof RecordScheduleParticipantsViewMode): RecordScheduleParticipantsViewMode => RecordScheduleParticipantsViewMode[key],
};

export type RecordScheduleTiming = 'day' | 'exact';

export const RecordScheduleTiming = {
  Day: 'day' as const,
  Exact: 'exact' as const,
} as const;

export const RecordScheduleTimingUtils = {
  values: Object.values(RecordScheduleTiming),
  keys: Object.keys(RecordScheduleTiming) as Array<keyof typeof RecordScheduleTiming>,
  entries: Object.entries(RecordScheduleTiming) as Array<[keyof typeof RecordScheduleTiming, RecordScheduleTiming]>,
  isValid: (value: any): value is RecordScheduleTiming => Object.values(RecordScheduleTiming).includes(value),
  fromKey: (key: keyof typeof RecordScheduleTiming): RecordScheduleTiming => RecordScheduleTiming[key],
};

export type RecordSearchPaging = 'cursor' | 'page';

export const RecordSearchPaging = {
  Cursor: 'cursor' as const,
  Page: 'page' as const,
} as const;

export const RecordSearchPagingUtils = {
  values: Object.values(RecordSearchPaging),
  keys: Object.keys(RecordSearchPaging) as Array<keyof typeof RecordSearchPaging>,
  entries: Object.entries(RecordSearchPaging) as Array<[keyof typeof RecordSearchPaging, RecordSearchPaging]>,
  isValid: (value: any): value is RecordSearchPaging => Object.values(RecordSearchPaging).includes(value),
  fromKey: (key: keyof typeof RecordSearchPaging): RecordSearchPaging => RecordSearchPaging[key],
};

export type RecordSelector = 'filters' | 'record';

export const RecordSelector = {
  Filters: 'filters' as const,
  Record: 'record' as const,
} as const;

export const RecordSelectorUtils = {
  values: Object.values(RecordSelector),
  keys: Object.keys(RecordSelector) as Array<keyof typeof RecordSelector>,
  entries: Object.entries(RecordSelector) as Array<[keyof typeof RecordSelector, RecordSelector]>,
  isValid: (value: any): value is RecordSelector => Object.values(RecordSelector).includes(value),
  fromKey: (key: keyof typeof RecordSelector): RecordSelector => RecordSelector[key],
};

export type RedirectType = 'back' | 'external' | 'internal';

export const RedirectType = {
  Back: 'back' as const,
  External: 'external' as const,
  Internal: 'internal' as const,
} as const;

export const RedirectTypeUtils = {
  values: Object.values(RedirectType),
  keys: Object.keys(RedirectType) as Array<keyof typeof RedirectType>,
  entries: Object.entries(RedirectType) as Array<[keyof typeof RedirectType, RedirectType]>,
  isValid: (value: any): value is RedirectType => Object.values(RedirectType).includes(value),
  fromKey: (key: keyof typeof RedirectType): RedirectType => RedirectType[key],
};

export type RunAsMode = 'fixed' | 'session' | 'system';

export const RunAsMode = {
  Fixed: 'fixed' as const,
  Session: 'session' as const,
  System: 'system' as const,
} as const;

export const RunAsModeUtils = {
  values: Object.values(RunAsMode),
  keys: Object.keys(RunAsMode) as Array<keyof typeof RunAsMode>,
  entries: Object.entries(RunAsMode) as Array<[keyof typeof RunAsMode, RunAsMode]>,
  isValid: (value: any): value is RunAsMode => Object.values(RunAsMode).includes(value),
  fromKey: (key: keyof typeof RunAsMode): RunAsMode => RunAsMode[key],
};

export type ScriptTaskDisposition = 'capability' | 'context' | 'host_helper' | 'internal' | 'language' | 'sdk' | 'testing';

export const ScriptTaskDisposition = {
  Capability: 'capability' as const,
  Context: 'context' as const,
  HostHelper: 'host_helper' as const,
  Internal: 'internal' as const,
  Language: 'language' as const,
  Sdk: 'sdk' as const,
  Testing: 'testing' as const,
} as const;

export const ScriptTaskDispositionUtils = {
  values: Object.values(ScriptTaskDisposition),
  keys: Object.keys(ScriptTaskDisposition) as Array<keyof typeof ScriptTaskDisposition>,
  entries: Object.entries(ScriptTaskDisposition) as Array<[keyof typeof ScriptTaskDisposition, ScriptTaskDisposition]>,
  isValid: (value: any): value is ScriptTaskDisposition => Object.values(ScriptTaskDisposition).includes(value),
  fromKey: (key: keyof typeof ScriptTaskDisposition): ScriptTaskDisposition => ScriptTaskDisposition[key],
};

export type StagedContentGroup = 'components' | 'email_layouts' | 'pages' | 'workflows';

export const StagedContentGroup = {
  Components: 'components' as const,
  EmailLayouts: 'email_layouts' as const,
  Pages: 'pages' as const,
  Workflows: 'workflows' as const,
} as const;

export const StagedContentGroupUtils = {
  values: Object.values(StagedContentGroup),
  keys: Object.keys(StagedContentGroup) as Array<keyof typeof StagedContentGroup>,
  entries: Object.entries(StagedContentGroup) as Array<[keyof typeof StagedContentGroup, StagedContentGroup]>,
  isValid: (value: any): value is StagedContentGroup => Object.values(StagedContentGroup).includes(value),
  fromKey: (key: keyof typeof StagedContentGroup): StagedContentGroup => StagedContentGroup[key],
};

export type TaskType = 'ai.decide' | 'ai.run_prompt' | 'assert.dictionary_does_not_have_key' | 'assert.dictionary_does_not_have_value' | 'assert.dictionary_has_key' | 'assert.dictionary_has_value' | 'assert.equals' | 'assert.greater_than' | 'assert.greater_than_or_equals_to' | 'assert.empty' | 'assert.false' | 'assert.not_empty' | 'assert.true' | 'assert.less_than' | 'assert.less_than_or_equals_to' | 'assert.list_contains' | 'assert.list_does_not_contain' | 'assert.not_equals' | 'assert.not_same' | 'assert.same' | 'assert.text_contains' | 'assert.text_does_not_contain' | 'auth.impersonate' | 'auth.login' | 'calendar.generate_link' | 'calendar.search_events' | 'callback.get' | 'callback.remove' | 'callback.set' | 'cast.to_date' | 'cast.to_datetime' | 'cast.to_json' | 'cast.to_money' | 'cast.to_number' | 'cast.to_select' | 'cast.to_string' | 'chart.distribution' | 'chart.kpi' | 'chart.leaderboard' | 'chart.time_series' | 'color.random' | 'condition.if' | 'condition.match' | 'condition.switch' | 'context.get' | 'data.aggregate_metrics' | 'data.context' | 'data.count' | 'data.create' | 'data.create-many' | 'data.delete' | 'data.delete-many' | 'data.factory' | 'data.find' | 'data.find-or-create' | 'data.relation.attach' | 'data.relation.attach-many' | 'data.relation.detach' | 'data.relation.detach-many' | 'data.relation.sync' | 'data.restore' | 'data.search' | 'data.search-loop' | 'data.semantic_search' | 'data.sum' | 'data.update' | 'data.update-or-create' | 'data.validate' | 'date.add' | 'date.current' | 'date.diff' | 'date.end_of' | 'date.format' | 'date.start_of' | 'date.subtract' | 'dictionary.get' | 'dictionary.keys' | 'dictionary.merge' | 'dictionary.purge' | 'dictionary.set' | 'fake.boolean' | 'fake.company' | 'fake.content' | 'fake.date' | 'fake.datetime' | 'fake.email' | 'fake.first_name' | 'fake.last_name' | 'fake.money' | 'fake.name' | 'fake.number' | 'fake.paragraph' | 'fake.phone' | 'fake.random_element' | 'fake.sentence' | 'fake.text' | 'fake.uuid' | 'fallback.empty' | 'fallback.null' | 'file.change_visibility' | 'file.create_from_url' | 'media_library.create_folder' | 'file.create_media_library_item' | 'file.create_qr_code' | 'media_library.delete_item' | 'media_library.move_items' | 'guard.authorize' | 'guard.check' | 'guard.filter_check' | 'guard.validate' | 'guard.verify' | 'http.redirect' | 'http.request' | 'http.response' | 'http.validation_error' | 'lifecycle.output' | 'list.append' | 'list.count' | 'list.filter' | 'list.first' | 'list.flatten' | 'list.get' | 'list.join' | 'list.last' | 'list.map' | 'list.pluck' | 'list.removeAt' | 'list.sum' | 'loop' | 'loop.break' | 'loop.index' | 'loop.value' | 'mail.search' | 'mail.send' | 'mail.send-notification' | 'markdown.from_content' | 'markdown.to_content' | 'math.add' | 'math.divide' | 'math.floor' | 'math.modulo' | 'math.multiply' | 'math.round' | 'math.subtract' | 'media_library.update_item' | 'money.add' | 'money.divide' | 'money.format' | 'money.multiply' | 'money.percentage' | 'money.subtract' | 'money.sum' | 'notification.send' | 'notification.send-bulk-notifications' | 'notification.send-notification' | 'notification.set-consent' | 'number.format' | 'package.install-input' | 'page.binding' | 'page.code' | 'page.url' | 'payables.void' | 'payables.write-off' | 'payments.charge' | 'payments.checkout' | 'payments.confirm' | 'payment.create_manual' | 'payments.refund' | 'phone.format' | 'proxy' | 'request.body' | 'request.body.all' | 'request.headers' | 'request.headers.all' | 'request.input' | 'request.params' | 'request.params.all' | 'request.query' | 'request.query.all' | 'resolve' | 'scenario.setup' | 'scheduling.book_slot' | 'scheduling.find_slots' | 'schema.to_json_schema' | 'security.random_password' | 'sms.send-notification' | 'state.all' | 'state.get' | 'state.set' | 'subscriptions.activate' | 'subscriptions.cancel' | 'subscriptions.change_items' | 'subscriptions.create' | 'subscriptions.generate_invoice' | 'subscriptions.pause' | 'subscriptions.preview' | 'subscriptions.preview_change' | 'subscriptions.resume' | 'subscriptions.set_upcoming_items' | 'task.artifact_id' | 'text.generate' | 'text.hash' | 'text.headline' | 'text.length' | 'text.lowercase' | 'text.random_uuid' | 'text.slugify' | 'text.template' | 'text.to_content' | 'text.trim' | 'text.uppercase' | 'time.add' | 'time.current' | 'time.diff' | 'time.end_of' | 'time.format' | 'time.start_of' | 'time.subtract' | 'timezone.format' | 'timezone.interpret' | 'tiptap.parse' | 'transaction' | 'user.authorize' | 'user.calling' | 'user.current' | 'variable.guard' | 'variable.make' | 'web.agent' | 'web.batch_scrape' | 'web.crawl' | 'web.extract' | 'web.google_search' | 'web.map' | 'web.pdf' | 'web.scrape' | 'web.screenshot' | 'web.search_ranked' | 'workflow.compile' | 'workflow.context' | 'workflow.execute' | 'workflow.fail' | 'workflow.input' | 'workflow.output' | 'workflow.run' | 'workflow.step' | 'workflow.step.output' | 'workflow.throw_validation_exception' | 'workflow.trigger.get' | 'workflow.url' | 'workflow.watch' | 'workspace.login_url' | 'workspace.set_value' | 'workspace.set_values' | 'workspace.value' | 'workspace.values';

export const TaskType = {
  AiDecide: 'ai.decide' as const,
  AiRunPrompt: 'ai.run_prompt' as const,
  AssertDictionaryDoesNotHaveKey: 'assert.dictionary_does_not_have_key' as const,
  AssertDictionaryDoesNotHaveValue: 'assert.dictionary_does_not_have_value' as const,
  AssertDictionaryHasKey: 'assert.dictionary_has_key' as const,
  AssertDictionaryHasValue: 'assert.dictionary_has_value' as const,
  AssertEquals: 'assert.equals' as const,
  AssertGreaterThan: 'assert.greater_than' as const,
  AssertGreaterThanOrEqualsTo: 'assert.greater_than_or_equals_to' as const,
  AssertIsEmpty: 'assert.empty' as const,
  AssertIsFalse: 'assert.false' as const,
  AssertIsNotEmpty: 'assert.not_empty' as const,
  AssertIsTrue: 'assert.true' as const,
  AssertLessThan: 'assert.less_than' as const,
  AssertLessThanOrEqualsTo: 'assert.less_than_or_equals_to' as const,
  AssertListContains: 'assert.list_contains' as const,
  AssertListDoesNotContain: 'assert.list_does_not_contain' as const,
  AssertNotEquals: 'assert.not_equals' as const,
  AssertNotSame: 'assert.not_same' as const,
  AssertSame: 'assert.same' as const,
  AssertTextContains: 'assert.text_contains' as const,
  AssertTextDoesNotContain: 'assert.text_does_not_contain' as const,
  AuthImpersonate: 'auth.impersonate' as const,
  AuthLogin: 'auth.login' as const,
  CalendarGenerateLink: 'calendar.generate_link' as const,
  CalendarSearchEvents: 'calendar.search_events' as const,
  CallbackGet: 'callback.get' as const,
  CallbackRemove: 'callback.remove' as const,
  CallbackSet: 'callback.set' as const,
  CastToDate: 'cast.to_date' as const,
  CastToDatetime: 'cast.to_datetime' as const,
  CastToJson: 'cast.to_json' as const,
  CastToMoney: 'cast.to_money' as const,
  CastToNumber: 'cast.to_number' as const,
  CastToSelect: 'cast.to_select' as const,
  CastToString: 'cast.to_string' as const,
  ChartDistribution: 'chart.distribution' as const,
  ChartKpi: 'chart.kpi' as const,
  ChartLeaderboard: 'chart.leaderboard' as const,
  ChartTimeSeries: 'chart.time_series' as const,
  ColorRandomColor: 'color.random' as const,
  ConditionIf: 'condition.if' as const,
  ConditionMatch: 'condition.match' as const,
  ConditionSwitch: 'condition.switch' as const,
  ContextGet: 'context.get' as const,
  DataAggregateMetrics: 'data.aggregate_metrics' as const,
  DataContext: 'data.context' as const,
  DataCount: 'data.count' as const,
  DataCreate: 'data.create' as const,
  DataCreateMany: 'data.create-many' as const,
  DataDelete: 'data.delete' as const,
  DataDeleteMany: 'data.delete-many' as const,
  DataFactory: 'data.factory' as const,
  DataFind: 'data.find' as const,
  DataFindOrCreate: 'data.find-or-create' as const,
  DataRelationAttach: 'data.relation.attach' as const,
  DataRelationAttachMany: 'data.relation.attach-many' as const,
  DataRelationDetach: 'data.relation.detach' as const,
  DataRelationDetachMany: 'data.relation.detach-many' as const,
  DataRelationSync: 'data.relation.sync' as const,
  DataRestore: 'data.restore' as const,
  DataSearch: 'data.search' as const,
  DataSearchLoop: 'data.search-loop' as const,
  DataSemanticSearch: 'data.semantic_search' as const,
  DataSum: 'data.sum' as const,
  DataUpdate: 'data.update' as const,
  DataUpdateOrCreate: 'data.update-or-create' as const,
  DataValidate: 'data.validate' as const,
  DateAdd: 'date.add' as const,
  DateCurrent: 'date.current' as const,
  DateDiff: 'date.diff' as const,
  DateEndOf: 'date.end_of' as const,
  DateFormat: 'date.format' as const,
  DateStartOf: 'date.start_of' as const,
  DateSubtract: 'date.subtract' as const,
  DictionaryGet: 'dictionary.get' as const,
  DictionaryKeys: 'dictionary.keys' as const,
  DictionaryMerge: 'dictionary.merge' as const,
  DictionaryPurge: 'dictionary.purge' as const,
  DictionarySet: 'dictionary.set' as const,
  FakeBoolean: 'fake.boolean' as const,
  FakeCompany: 'fake.company' as const,
  FakeContent: 'fake.content' as const,
  FakeDate: 'fake.date' as const,
  FakeDatetime: 'fake.datetime' as const,
  FakeEmail: 'fake.email' as const,
  FakeFirstName: 'fake.first_name' as const,
  FakeLastName: 'fake.last_name' as const,
  FakeMoney: 'fake.money' as const,
  FakeName: 'fake.name' as const,
  FakeNumber: 'fake.number' as const,
  FakeParagraph: 'fake.paragraph' as const,
  FakePhone: 'fake.phone' as const,
  FakeRandomElement: 'fake.random_element' as const,
  FakeSentence: 'fake.sentence' as const,
  FakeText: 'fake.text' as const,
  FakeUuid: 'fake.uuid' as const,
  FallbackEmpty: 'fallback.empty' as const,
  FallbackNull: 'fallback.null' as const,
  FileChangeVisibility: 'file.change_visibility' as const,
  FileCreateFromUrl: 'file.create_from_url' as const,
  FileCreateMediaLibraryFolder: 'media_library.create_folder' as const,
  FileCreateMediaLibraryItem: 'file.create_media_library_item' as const,
  FileCreateQrCode: 'file.create_qr_code' as const,
  FileDeleteMediaLibraryItem: 'media_library.delete_item' as const,
  FileMoveMediaLibraryItems: 'media_library.move_items' as const,
  GuardAuthorize: 'guard.authorize' as const,
  GuardCheck: 'guard.check' as const,
  GuardFilterCheck: 'guard.filter_check' as const,
  GuardValidate: 'guard.validate' as const,
  GuardVerify: 'guard.verify' as const,
  HttpRedirect: 'http.redirect' as const,
  HttpRequest: 'http.request' as const,
  HttpResponse: 'http.response' as const,
  HttpValidationError: 'http.validation_error' as const,
  LifecycleOutput: 'lifecycle.output' as const,
  ListAppend: 'list.append' as const,
  ListCount: 'list.count' as const,
  ListFilter: 'list.filter' as const,
  ListFirst: 'list.first' as const,
  ListFlatten: 'list.flatten' as const,
  ListGet: 'list.get' as const,
  ListJoin: 'list.join' as const,
  ListLast: 'list.last' as const,
  ListMap: 'list.map' as const,
  ListPluck: 'list.pluck' as const,
  ListRemoveAt: 'list.removeAt' as const,
  ListSum: 'list.sum' as const,
  Loop: 'loop' as const,
  LoopBreak: 'loop.break' as const,
  LoopIndex: 'loop.index' as const,
  LoopValue: 'loop.value' as const,
  MailSearch: 'mail.search' as const,
  MailSend: 'mail.send' as const,
  MailSendNotification: 'mail.send-notification' as const,
  MarkdownFromContent: 'markdown.from_content' as const,
  MarkdownToContent: 'markdown.to_content' as const,
  MathAdd: 'math.add' as const,
  MathDivide: 'math.divide' as const,
  MathFloor: 'math.floor' as const,
  MathModulo: 'math.modulo' as const,
  MathMultiply: 'math.multiply' as const,
  MathRound: 'math.round' as const,
  MathSubtract: 'math.subtract' as const,
  MediaLibraryUpdateItem: 'media_library.update_item' as const,
  MoneyAdd: 'money.add' as const,
  MoneyDivide: 'money.divide' as const,
  MoneyFormat: 'money.format' as const,
  MoneyMultiply: 'money.multiply' as const,
  MoneyPercentage: 'money.percentage' as const,
  MoneySubtract: 'money.subtract' as const,
  MoneySum: 'money.sum' as const,
  NotificationSend: 'notification.send' as const,
  NotificationSendBulkNotifications: 'notification.send-bulk-notifications' as const,
  NotificationSendNotification: 'notification.send-notification' as const,
  NotificationSetConsent: 'notification.set-consent' as const,
  NumberFormat: 'number.format' as const,
  PackageInstallInput: 'package.install-input' as const,
  PageBinding: 'page.binding' as const,
  PageCode: 'page.code' as const,
  PageUrl: 'page.url' as const,
  PayableVoid: 'payables.void' as const,
  PayableWriteOff: 'payables.write-off' as const,
  PaymentCharge: 'payments.charge' as const,
  PaymentCheckout: 'payments.checkout' as const,
  PaymentConfirm: 'payments.confirm' as const,
  PaymentCreateManual: 'payment.create_manual' as const,
  PaymentRefund: 'payments.refund' as const,
  PhoneFormat: 'phone.format' as const,
  Proxy: 'proxy' as const,
  RequestBody: 'request.body' as const,
  RequestBodyAll: 'request.body.all' as const,
  RequestHeaders: 'request.headers' as const,
  RequestHeadersAll: 'request.headers.all' as const,
  RequestInput: 'request.input' as const,
  RequestParams: 'request.params' as const,
  RequestParamsAll: 'request.params.all' as const,
  RequestQuery: 'request.query' as const,
  RequestQueryAll: 'request.query.all' as const,
  Resolve: 'resolve' as const,
  ScenarioSetup: 'scenario.setup' as const,
  SchedulingBookSlot: 'scheduling.book_slot' as const,
  SchedulingFindSlots: 'scheduling.find_slots' as const,
  SchemaToJsonSchema: 'schema.to_json_schema' as const,
  SecurityRandomPassword: 'security.random_password' as const,
  SmsSendNotification: 'sms.send-notification' as const,
  StateAll: 'state.all' as const,
  StateGet: 'state.get' as const,
  StateSet: 'state.set' as const,
  SubscriptionActivate: 'subscriptions.activate' as const,
  SubscriptionCancel: 'subscriptions.cancel' as const,
  SubscriptionChangeItems: 'subscriptions.change_items' as const,
  SubscriptionCreate: 'subscriptions.create' as const,
  SubscriptionGenerateInvoice: 'subscriptions.generate_invoice' as const,
  SubscriptionPause: 'subscriptions.pause' as const,
  SubscriptionPreview: 'subscriptions.preview' as const,
  SubscriptionPreviewChange: 'subscriptions.preview_change' as const,
  SubscriptionResume: 'subscriptions.resume' as const,
  SubscriptionSetUpcomingItems: 'subscriptions.set_upcoming_items' as const,
  TaskArtifactId: 'task.artifact_id' as const,
  TextGenerate: 'text.generate' as const,
  TextHash: 'text.hash' as const,
  TextHeadline: 'text.headline' as const,
  TextLength: 'text.length' as const,
  TextLowercase: 'text.lowercase' as const,
  TextRandomUuid: 'text.random_uuid' as const,
  TextSlugify: 'text.slugify' as const,
  TextTemplate: 'text.template' as const,
  TextToContent: 'text.to_content' as const,
  TextTrim: 'text.trim' as const,
  TextUppercase: 'text.uppercase' as const,
  TimeAdd: 'time.add' as const,
  TimeCurrent: 'time.current' as const,
  TimeDiff: 'time.diff' as const,
  TimeEndOf: 'time.end_of' as const,
  TimeFormat: 'time.format' as const,
  TimeStartOf: 'time.start_of' as const,
  TimeSubtract: 'time.subtract' as const,
  TimezoneFormat: 'timezone.format' as const,
  TimezoneInterpret: 'timezone.interpret' as const,
  TipTapParse: 'tiptap.parse' as const,
  Transaction: 'transaction' as const,
  UserAuthorize: 'user.authorize' as const,
  UserCalling: 'user.calling' as const,
  UserCurrent: 'user.current' as const,
  VariableGuard: 'variable.guard' as const,
  VariableMake: 'variable.make' as const,
  WebAgent: 'web.agent' as const,
  WebBatchScrape: 'web.batch_scrape' as const,
  WebCrawl: 'web.crawl' as const,
  WebExtract: 'web.extract' as const,
  WebGoogleSearch: 'web.google_search' as const,
  WebMap: 'web.map' as const,
  WebPdf: 'web.pdf' as const,
  WebScrape: 'web.scrape' as const,
  WebScreenshot: 'web.screenshot' as const,
  WebSearchRanked: 'web.search_ranked' as const,
  WorkflowCompile: 'workflow.compile' as const,
  WorkflowContext: 'workflow.context' as const,
  WorkflowExecute: 'workflow.execute' as const,
  WorkflowFail: 'workflow.fail' as const,
  WorkflowInput: 'workflow.input' as const,
  WorkflowOutput: 'workflow.output' as const,
  WorkflowRun: 'workflow.run' as const,
  WorkflowStep: 'workflow.step' as const,
  WorkflowStepOutput: 'workflow.step.output' as const,
  WorkflowThrowValidationException: 'workflow.throw_validation_exception' as const,
  WorkflowTriggerGet: 'workflow.trigger.get' as const,
  WorkflowUrl: 'workflow.url' as const,
  WorkflowWatch: 'workflow.watch' as const,
  WorkspaceLoginUrl: 'workspace.login_url' as const,
  WorkspaceSetValue: 'workspace.set_value' as const,
  WorkspaceSetValues: 'workspace.set_values' as const,
  WorkspaceValue: 'workspace.value' as const,
  WorkspaceValues: 'workspace.values' as const,
} as const;

export const TaskTypeUtils = {
  values: Object.values(TaskType),
  keys: Object.keys(TaskType) as Array<keyof typeof TaskType>,
  entries: Object.entries(TaskType) as Array<[keyof typeof TaskType, TaskType]>,
  isValid: (value: any): value is TaskType => Object.values(TaskType).includes(value),
  fromKey: (key: keyof typeof TaskType): TaskType => TaskType[key],
};

export type TimePeriod = 'day' | 'hour' | 'month' | 'quarter' | 'week' | 'year';

export const TimePeriod = {
  Day: 'day' as const,
  Hour: 'hour' as const,
  Month: 'month' as const,
  Quarter: 'quarter' as const,
  Week: 'week' as const,
  Year: 'year' as const,
} as const;

export const TimePeriodUtils = {
  values: Object.values(TimePeriod),
  keys: Object.keys(TimePeriod) as Array<keyof typeof TimePeriod>,
  entries: Object.entries(TimePeriod) as Array<[keyof typeof TimePeriod, TimePeriod]>,
  isValid: (value: any): value is TimePeriod => Object.values(TimePeriod).includes(value),
  fromKey: (key: keyof typeof TimePeriod): TimePeriod => TimePeriod[key],
};

export type TimeUnit = 'days' | 'hours' | 'minutes' | 'months' | 'seconds' | 'weeks' | 'years';

export const TimeUnit = {
  Days: 'days' as const,
  Hours: 'hours' as const,
  Minutes: 'minutes' as const,
  Months: 'months' as const,
  Seconds: 'seconds' as const,
  Weeks: 'weeks' as const,
  Years: 'years' as const,
} as const;

export const TimeUnitUtils = {
  values: Object.values(TimeUnit),
  keys: Object.keys(TimeUnit) as Array<keyof typeof TimeUnit>,
  entries: Object.entries(TimeUnit) as Array<[keyof typeof TimeUnit, TimeUnit]>,
  isValid: (value: any): value is TimeUnit => Object.values(TimeUnit).includes(value),
  fromKey: (key: keyof typeof TimeUnit): TimeUnit => TimeUnit[key],
};

export type TimezoneFormat = 'abbreviation' | 'city' | 'full' | 'offset';

export const TimezoneFormat = {
  Abbreviation: 'abbreviation' as const,
  City: 'city' as const,
  Full: 'full' as const,
  Offset: 'offset' as const,
} as const;

export const TimezoneFormatUtils = {
  values: Object.values(TimezoneFormat),
  keys: Object.keys(TimezoneFormat) as Array<keyof typeof TimezoneFormat>,
  entries: Object.entries(TimezoneFormat) as Array<[keyof typeof TimezoneFormat, TimezoneFormat]>,
  isValid: (value: any): value is TimezoneFormat => Object.values(TimezoneFormat).includes(value),
  fromKey: (key: keyof typeof TimezoneFormat): TimezoneFormat => TimezoneFormat[key],
};

export type UrlScheme = 'http' | 'https';

export const UrlScheme = {
  Http: 'http' as const,
  Https: 'https' as const,
} as const;

export const UrlSchemeUtils = {
  values: Object.values(UrlScheme),
  keys: Object.keys(UrlScheme) as Array<keyof typeof UrlScheme>,
  entries: Object.entries(UrlScheme) as Array<[keyof typeof UrlScheme, UrlScheme]>,
  isValid: (value: any): value is UrlScheme => Object.values(UrlScheme).includes(value),
  fromKey: (key: keyof typeof UrlScheme): UrlScheme => UrlScheme[key],
};

export type VariableHookType = 'after_archive' | 'after_create' | 'after_restore' | 'after_save' | 'after_update' | 'before_archive' | 'before_create' | 'before_restore' | 'before_save' | 'before_update';

export const VariableHookType = {
  AfterArchive: 'after_archive' as const,
  AfterCreate: 'after_create' as const,
  AfterRestore: 'after_restore' as const,
  AfterSave: 'after_save' as const,
  AfterUpdate: 'after_update' as const,
  BeforeArchive: 'before_archive' as const,
  BeforeCreate: 'before_create' as const,
  BeforeRestore: 'before_restore' as const,
  BeforeSave: 'before_save' as const,
  BeforeUpdate: 'before_update' as const,
} as const;

export const VariableHookTypeUtils = {
  values: Object.values(VariableHookType),
  keys: Object.keys(VariableHookType) as Array<keyof typeof VariableHookType>,
  entries: Object.entries(VariableHookType) as Array<[keyof typeof VariableHookType, VariableHookType]>,
  isValid: (value: any): value is VariableHookType => Object.values(VariableHookType).includes(value),
  fromKey: (key: keyof typeof VariableHookType): VariableHookType => VariableHookType[key],
};

export type VariableType = 'boolean' | 'color' | 'component_reference' | 'content' | 'date' | 'datetime' | 'dictionary' | 'domain_reference' | 'dynamic' | 'email' | 'email_layout_reference' | 'event_schedule' | 'field_reference' | 'file_reference' | 'filter' | 'form' | 'guard' | 'identity' | 'liquid' | 'list' | 'location' | 'markdown' | 'money' | 'notification_template_reference' | 'notification_type_reference' | 'null' | 'number' | 'package_input_reference' | 'page_reference' | 'password' | 'phone' | 'point' | 'record' | 'record_reference' | 'recurrence' | 'regular_hours' | 'relation' | 'resolver' | 'resource_field_key_reference' | 'resource_field_value' | 'resource_reference' | 'role_reference' | 'schema' | 'select' | 'text' | 'time' | 'timezone' | 'unknown' | 'url' | 'uuid' | 'wallet_accounting_account' | 'wallet_accounting_entity' | 'workflow_reference' | 'workflow_state_variable_reference' | 'workflow_step_reference';

export const VariableType = {
  Boolean: 'boolean' as const,
  Color: 'color' as const,
  ComponentReference: 'component_reference' as const,
  Content: 'content' as const,
  Date: 'date' as const,
  Datetime: 'datetime' as const,
  Dictionary: 'dictionary' as const,
  DomainReferenceVariable: 'domain_reference' as const,
  Dynamic: 'dynamic' as const,
  Email: 'email' as const,
  EmailLayoutReference: 'email_layout_reference' as const,
  EventSchedule: 'event_schedule' as const,
  FieldReference: 'field_reference' as const,
  FileReferenceVariable: 'file_reference' as const,
  Filter: 'filter' as const,
  Form: 'form' as const,
  Guard: 'guard' as const,
  Identity: 'identity' as const,
  Liquid: 'liquid' as const,
  List: 'list' as const,
  Location: 'location' as const,
  Markdown: 'markdown' as const,
  Money: 'money' as const,
  NotificationTemplateReference: 'notification_template_reference' as const,
  NotificationTypeReference: 'notification_type_reference' as const,
  Null: 'null' as const,
  Number: 'number' as const,
  PackageInputReference: 'package_input_reference' as const,
  PageReference: 'page_reference' as const,
  Password: 'password' as const,
  Phone: 'phone' as const,
  Point: 'point' as const,
  Record: 'record' as const,
  RecordReference: 'record_reference' as const,
  Recurrence: 'recurrence' as const,
  RegularHours: 'regular_hours' as const,
  Relation: 'relation' as const,
  Resolver: 'resolver' as const,
  ResourceFieldKeyReference: 'resource_field_key_reference' as const,
  ResourceFieldValue: 'resource_field_value' as const,
  ResourceReference: 'resource_reference' as const,
  RoleReference: 'role_reference' as const,
  Schema: 'schema' as const,
  Select: 'select' as const,
  Text: 'text' as const,
  Time: 'time' as const,
  Timezone: 'timezone' as const,
  Unknown: 'unknown' as const,
  Url: 'url' as const,
  Uuid: 'uuid' as const,
  WalletAccountingAccount: 'wallet_accounting_account' as const,
  WalletAccountingEntity: 'wallet_accounting_entity' as const,
  WorkflowReferenceVariable: 'workflow_reference' as const,
  WorkflowStateVariableReference: 'workflow_state_variable_reference' as const,
  WorkflowStepReferenceVariable: 'workflow_step_reference' as const,
} as const;

export const VariableTypeUtils = {
  values: Object.values(VariableType),
  keys: Object.keys(VariableType) as Array<keyof typeof VariableType>,
  entries: Object.entries(VariableType) as Array<[keyof typeof VariableType, VariableType]>,
  isValid: (value: any): value is VariableType => Object.values(VariableType).includes(value),
  fromKey: (key: keyof typeof VariableType): VariableType => VariableType[key],
};

export type WorkflowAccess = 'private' | 'public';

export const WorkflowAccess = {
  Private: 'private' as const,
  Public: 'public' as const,
} as const;

export const WorkflowAccessUtils = {
  values: Object.values(WorkflowAccess),
  keys: Object.keys(WorkflowAccess) as Array<keyof typeof WorkflowAccess>,
  entries: Object.entries(WorkflowAccess) as Array<[keyof typeof WorkflowAccess, WorkflowAccess]>,
  isValid: (value: any): value is WorkflowAccess => Object.values(WorkflowAccess).includes(value),
  fromKey: (key: keyof typeof WorkflowAccess): WorkflowAccess => WorkflowAccess[key],
};

export type WorkflowExecutionEventType = 'execution.error' | 'execution.exception' | 'execution.pending' | 'execution.started' | 'execution.success' | 'step.error' | 'step.pending' | 'step.started' | 'step.success';

export const WorkflowExecutionEventType = {
  ExecutionError: 'execution.error' as const,
  ExecutionException: 'execution.exception' as const,
  ExecutionPending: 'execution.pending' as const,
  ExecutionStarted: 'execution.started' as const,
  ExecutionSuccess: 'execution.success' as const,
  StepError: 'step.error' as const,
  StepPending: 'step.pending' as const,
  StepStarted: 'step.started' as const,
  StepSuccess: 'step.success' as const,
} as const;

export const WorkflowExecutionEventTypeUtils = {
  values: Object.values(WorkflowExecutionEventType),
  keys: Object.keys(WorkflowExecutionEventType) as Array<keyof typeof WorkflowExecutionEventType>,
  entries: Object.entries(WorkflowExecutionEventType) as Array<[keyof typeof WorkflowExecutionEventType, WorkflowExecutionEventType]>,
  isValid: (value: any): value is WorkflowExecutionEventType => Object.values(WorkflowExecutionEventType).includes(value),
  fromKey: (key: keyof typeof WorkflowExecutionEventType): WorkflowExecutionEventType => WorkflowExecutionEventType[key],
};

export type WorkflowExecutionStatus = 'error' | 'exception' | 'pending' | 'started' | 'success';

export const WorkflowExecutionStatus = {
  Error: 'error' as const,
  Exception: 'exception' as const,
  Pending: 'pending' as const,
  Started: 'started' as const,
  Success: 'success' as const,
} as const;

export const WorkflowExecutionStatusUtils = {
  values: Object.values(WorkflowExecutionStatus),
  keys: Object.keys(WorkflowExecutionStatus) as Array<keyof typeof WorkflowExecutionStatus>,
  entries: Object.entries(WorkflowExecutionStatus) as Array<[keyof typeof WorkflowExecutionStatus, WorkflowExecutionStatus]>,
  isValid: (value: any): value is WorkflowExecutionStatus => Object.values(WorkflowExecutionStatus).includes(value),
  fromKey: (key: keyof typeof WorkflowExecutionStatus): WorkflowExecutionStatus => WorkflowExecutionStatus[key],
};

export type WorkflowScenarioAssertionMatchMode = 'exact' | 'partial';

export const WorkflowScenarioAssertionMatchMode = {
  Exact: 'exact' as const,
  Partial: 'partial' as const,
} as const;

export const WorkflowScenarioAssertionMatchModeUtils = {
  values: Object.values(WorkflowScenarioAssertionMatchMode),
  keys: Object.keys(WorkflowScenarioAssertionMatchMode) as Array<keyof typeof WorkflowScenarioAssertionMatchMode>,
  entries: Object.entries(WorkflowScenarioAssertionMatchMode) as Array<[keyof typeof WorkflowScenarioAssertionMatchMode, WorkflowScenarioAssertionMatchMode]>,
  isValid: (value: any): value is WorkflowScenarioAssertionMatchMode => Object.values(WorkflowScenarioAssertionMatchMode).includes(value),
  fromKey: (key: keyof typeof WorkflowScenarioAssertionMatchMode): WorkflowScenarioAssertionMatchMode => WorkflowScenarioAssertionMatchMode[key],
};

export type WorkflowScenarioAssertionType = 'call_count_equals' | 'call_input_path_equals' | 'call_made' | 'call_not_made' | 'call_output_equals' | 'call_output_path_equals' | 'call_status_equals' | 'execution_status' | 'output_equals' | 'output_path_equals' | 'output_path_exists' | 'step_executed' | 'step_execution_count_equals' | 'step_not_executed' | 'step_output_equals' | 'step_output_path_equals' | 'step_status_equals';

export const WorkflowScenarioAssertionType = {
  CallCountEquals: 'call_count_equals' as const,
  CallInputPathEquals: 'call_input_path_equals' as const,
  CallMade: 'call_made' as const,
  CallNotMade: 'call_not_made' as const,
  CallOutputEquals: 'call_output_equals' as const,
  CallOutputPathEquals: 'call_output_path_equals' as const,
  CallStatusEquals: 'call_status_equals' as const,
  ExecutionStatus: 'execution_status' as const,
  OutputEquals: 'output_equals' as const,
  OutputPathEquals: 'output_path_equals' as const,
  OutputPathExists: 'output_path_exists' as const,
  StepExecuted: 'step_executed' as const,
  StepExecutionCountEquals: 'step_execution_count_equals' as const,
  StepNotExecuted: 'step_not_executed' as const,
  StepOutputEquals: 'step_output_equals' as const,
  StepOutputPathEquals: 'step_output_path_equals' as const,
  StepStatusEquals: 'step_status_equals' as const,
} as const;

export const WorkflowScenarioAssertionTypeUtils = {
  values: Object.values(WorkflowScenarioAssertionType),
  keys: Object.keys(WorkflowScenarioAssertionType) as Array<keyof typeof WorkflowScenarioAssertionType>,
  entries: Object.entries(WorkflowScenarioAssertionType) as Array<[keyof typeof WorkflowScenarioAssertionType, WorkflowScenarioAssertionType]>,
  isValid: (value: any): value is WorkflowScenarioAssertionType => Object.values(WorkflowScenarioAssertionType).includes(value),
  fromKey: (key: keyof typeof WorkflowScenarioAssertionType): WorkflowScenarioAssertionType => WorkflowScenarioAssertionType[key],
};

export type WorkflowScenarioStatus = 'failed' | 'passed';

export const WorkflowScenarioStatus = {
  Failed: 'failed' as const,
  Passed: 'passed' as const,
} as const;

export const WorkflowScenarioStatusUtils = {
  values: Object.values(WorkflowScenarioStatus),
  keys: Object.keys(WorkflowScenarioStatus) as Array<keyof typeof WorkflowScenarioStatus>,
  entries: Object.entries(WorkflowScenarioStatus) as Array<[keyof typeof WorkflowScenarioStatus, WorkflowScenarioStatus]>,
  isValid: (value: any): value is WorkflowScenarioStatus => Object.values(WorkflowScenarioStatus).includes(value),
  fromKey: (key: keyof typeof WorkflowScenarioStatus): WorkflowScenarioStatus => WorkflowScenarioStatus[key],
};

export type WorkflowScenarioStepMockType = 'exception' | 'output';

export const WorkflowScenarioStepMockType = {
  Exception: 'exception' as const,
  Output: 'output' as const,
} as const;

export const WorkflowScenarioStepMockTypeUtils = {
  values: Object.values(WorkflowScenarioStepMockType),
  keys: Object.keys(WorkflowScenarioStepMockType) as Array<keyof typeof WorkflowScenarioStepMockType>,
  entries: Object.entries(WorkflowScenarioStepMockType) as Array<[keyof typeof WorkflowScenarioStepMockType, WorkflowScenarioStepMockType]>,
  isValid: (value: any): value is WorkflowScenarioStepMockType => Object.values(WorkflowScenarioStepMockType).includes(value),
  fromKey: (key: keyof typeof WorkflowScenarioStepMockType): WorkflowScenarioStepMockType => WorkflowScenarioStepMockType[key],
};

export type WorkflowStatus = 'active' | 'paused';

export const WorkflowStatus = {
  Active: 'active' as const,
  Paused: 'paused' as const,
} as const;

export const WorkflowStatusUtils = {
  values: Object.values(WorkflowStatus),
  keys: Object.keys(WorkflowStatus) as Array<keyof typeof WorkflowStatus>,
  entries: Object.entries(WorkflowStatus) as Array<[keyof typeof WorkflowStatus, WorkflowStatus]>,
  isValid: (value: any): value is WorkflowStatus => Object.values(WorkflowStatus).includes(value),
  fromKey: (key: keyof typeof WorkflowStatus): WorkflowStatus => WorkflowStatus[key],
};

export type WorkflowSuiteRunKind = 'publish' | 'scenarios';

export const WorkflowSuiteRunKind = {
  Publish: 'publish' as const,
  Scenarios: 'scenarios' as const,
} as const;

export const WorkflowSuiteRunKindUtils = {
  values: Object.values(WorkflowSuiteRunKind),
  keys: Object.keys(WorkflowSuiteRunKind) as Array<keyof typeof WorkflowSuiteRunKind>,
  entries: Object.entries(WorkflowSuiteRunKind) as Array<[keyof typeof WorkflowSuiteRunKind, WorkflowSuiteRunKind]>,
  isValid: (value: any): value is WorkflowSuiteRunKind => Object.values(WorkflowSuiteRunKind).includes(value),
  fromKey: (key: keyof typeof WorkflowSuiteRunKind): WorkflowSuiteRunKind => WorkflowSuiteRunKind[key],
};

export type WorkflowSuiteRunStatus = 'errored' | 'failed' | 'queued' | 'running' | 'succeeded';

export const WorkflowSuiteRunStatus = {
  Errored: 'errored' as const,
  Failed: 'failed' as const,
  Queued: 'queued' as const,
  Running: 'running' as const,
  Succeeded: 'succeeded' as const,
} as const;

export const WorkflowSuiteRunStatusUtils = {
  values: Object.values(WorkflowSuiteRunStatus),
  keys: Object.keys(WorkflowSuiteRunStatus) as Array<keyof typeof WorkflowSuiteRunStatus>,
  entries: Object.entries(WorkflowSuiteRunStatus) as Array<[keyof typeof WorkflowSuiteRunStatus, WorkflowSuiteRunStatus]>,
  isValid: (value: any): value is WorkflowSuiteRunStatus => Object.values(WorkflowSuiteRunStatus).includes(value),
  fromKey: (key: keyof typeof WorkflowSuiteRunStatus): WorkflowSuiteRunStatus => WorkflowSuiteRunStatus[key],
};

export type WorkflowTransitionValidationIssueCode = 'conflicting_step_input' | 'cross_scope_transition' | 'duplicate_execution_started' | 'duplicate_source_event_case' | 'incomplete_step_input' | 'invalid_transition_case' | 'loop_break_outside_loop_body' | 'mixed_entry_transitions' | 'multiple_transition_types_same_edge' | 'orphaned_step' | 'request_data_in_step_input' | 'side_effecting_resolver_in_step_input' | 'source_step_missing' | 'target_step_missing' | 'terminal_step_has_outgoing_transitions' | 'transition_cycle';

export const WorkflowTransitionValidationIssueCode = {
  ConflictingStepInput: 'conflicting_step_input' as const,
  CrossScopeTransition: 'cross_scope_transition' as const,
  DuplicateExecutionStarted: 'duplicate_execution_started' as const,
  DuplicateSourceEventCase: 'duplicate_source_event_case' as const,
  IncompleteStepInput: 'incomplete_step_input' as const,
  InvalidTransitionCase: 'invalid_transition_case' as const,
  LoopBreakOutsideLoopBody: 'loop_break_outside_loop_body' as const,
  MixedEntryTransitions: 'mixed_entry_transitions' as const,
  MultipleTransitionTypesSameEdge: 'multiple_transition_types_same_edge' as const,
  OrphanedStep: 'orphaned_step' as const,
  RequestDataInStepInput: 'request_data_in_step_input' as const,
  SideEffectingResolverInStepInput: 'side_effecting_resolver_in_step_input' as const,
  SourceStepMissing: 'source_step_missing' as const,
  TargetStepMissing: 'target_step_missing' as const,
  TerminalStepHasOutgoingTransitions: 'terminal_step_has_outgoing_transitions' as const,
  TransitionCycle: 'transition_cycle' as const,
} as const;

export const WorkflowTransitionValidationIssueCodeUtils = {
  values: Object.values(WorkflowTransitionValidationIssueCode),
  keys: Object.keys(WorkflowTransitionValidationIssueCode) as Array<keyof typeof WorkflowTransitionValidationIssueCode>,
  entries: Object.entries(WorkflowTransitionValidationIssueCode) as Array<[keyof typeof WorkflowTransitionValidationIssueCode, WorkflowTransitionValidationIssueCode]>,
  isValid: (value: any): value is WorkflowTransitionValidationIssueCode => Object.values(WorkflowTransitionValidationIssueCode).includes(value),
  fromKey: (key: keyof typeof WorkflowTransitionValidationIssueCode): WorkflowTransitionValidationIssueCode => WorkflowTransitionValidationIssueCode[key],
};

export type WorkflowTransitionValidationRuleSet = 'ai_mutation' | 'delete' | 'publish' | 'update';

export const WorkflowTransitionValidationRuleSet = {
  AiMutation: 'ai_mutation' as const,
  Delete: 'delete' as const,
  Publish: 'publish' as const,
  Update: 'update' as const,
} as const;

export const WorkflowTransitionValidationRuleSetUtils = {
  values: Object.values(WorkflowTransitionValidationRuleSet),
  keys: Object.keys(WorkflowTransitionValidationRuleSet) as Array<keyof typeof WorkflowTransitionValidationRuleSet>,
  entries: Object.entries(WorkflowTransitionValidationRuleSet) as Array<[keyof typeof WorkflowTransitionValidationRuleSet, WorkflowTransitionValidationRuleSet]>,
  isValid: (value: any): value is WorkflowTransitionValidationRuleSet => Object.values(WorkflowTransitionValidationRuleSet).includes(value),
  fromKey: (key: keyof typeof WorkflowTransitionValidationRuleSet): WorkflowTransitionValidationRuleSet => WorkflowTransitionValidationRuleSet[key],
};

export type WorkflowType = 'manual' | 'event.record' | 'lifecycle.record' | 'schedule.record' | 'request' | 'scheduled' | 'event.workflow';

export const WorkflowType = {
  Manual: 'manual' as const,
  RecordEvent: 'event.record' as const,
  RecordLifecycle: 'lifecycle.record' as const,
  RecordSchedule: 'schedule.record' as const,
  Request: 'request' as const,
  Scheduled: 'scheduled' as const,
  WorkflowEvent: 'event.workflow' as const,
} as const;

export const WorkflowTypeUtils = {
  values: Object.values(WorkflowType),
  keys: Object.keys(WorkflowType) as Array<keyof typeof WorkflowType>,
  entries: Object.entries(WorkflowType) as Array<[keyof typeof WorkflowType, WorkflowType]>,
  isValid: (value: any): value is WorkflowType => Object.values(WorkflowType).includes(value),
  fromKey: (key: keyof typeof WorkflowType): WorkflowType => WorkflowType[key],
};

export type WorkflowVariableScope = 'input' | 'output' | 'setting' | 'state';

export const WorkflowVariableScope = {
  Input: 'input' as const,
  Output: 'output' as const,
  Setting: 'setting' as const,
  State: 'state' as const,
} as const;

export const WorkflowVariableScopeUtils = {
  values: Object.values(WorkflowVariableScope),
  keys: Object.keys(WorkflowVariableScope) as Array<keyof typeof WorkflowVariableScope>,
  entries: Object.entries(WorkflowVariableScope) as Array<[keyof typeof WorkflowVariableScope, WorkflowVariableScope]>,
  isValid: (value: any): value is WorkflowVariableScope => Object.values(WorkflowVariableScope).includes(value),
  fromKey: (key: keyof typeof WorkflowVariableScope): WorkflowVariableScope => WorkflowVariableScope[key],
};

export type BrandColorMode = 'dark' | 'light';

export const BrandColorMode = {
  Dark: 'dark' as const,
  Light: 'light' as const,
} as const;

export const BrandColorModeUtils = {
  values: Object.values(BrandColorMode),
  keys: Object.keys(BrandColorMode) as Array<keyof typeof BrandColorMode>,
  entries: Object.entries(BrandColorMode) as Array<[keyof typeof BrandColorMode, BrandColorMode]>,
  isValid: (value: any): value is BrandColorMode => Object.values(BrandColorMode).includes(value),
  fromKey: (key: keyof typeof BrandColorMode): BrandColorMode => BrandColorMode[key],
};

export type BrandLogoVariant = 'horizontal' | 'icon' | 'wordmark';

export const BrandLogoVariant = {
  Horizontal: 'horizontal' as const,
  Icon: 'icon' as const,
  Wordmark: 'wordmark' as const,
} as const;

export const BrandLogoVariantUtils = {
  values: Object.values(BrandLogoVariant),
  keys: Object.keys(BrandLogoVariant) as Array<keyof typeof BrandLogoVariant>,
  entries: Object.entries(BrandLogoVariant) as Array<[keyof typeof BrandLogoVariant, BrandLogoVariant]>,
  isValid: (value: any): value is BrandLogoVariant => Object.values(BrandLogoVariant).includes(value),
  fromKey: (key: keyof typeof BrandLogoVariant): BrandLogoVariant => BrandLogoVariant[key],
};

export type DefaultWorkspaceSystemField = 'ai_custom_system_prompt' | 'brand_kit' | 'default_currency' | 'default_timezone' | 'custom_401_error_page' | 'custom_403_error_page' | 'custom_404_error_page' | 'custom_422_error_page' | 'custom_500_error_page' | 'fathom_site_id' | 'head_html' | 'name' | 'sidebar_icon' | 'sidebar_icon_color' | 'slug' | 'website';

export const DefaultWorkspaceSystemField = {
  AiCustomSystemPrompt: 'ai_custom_system_prompt' as const,
  BrandKit: 'brand_kit' as const,
  DefaultCurrency: 'default_currency' as const,
  DefaultTimezone: 'default_timezone' as const,
  Error401: 'custom_401_error_page' as const,
  Error403: 'custom_403_error_page' as const,
  Error404: 'custom_404_error_page' as const,
  Error422: 'custom_422_error_page' as const,
  Error500: 'custom_500_error_page' as const,
  FathomSiteId: 'fathom_site_id' as const,
  HeadHtml: 'head_html' as const,
  Name: 'name' as const,
  SidebarIcon: 'sidebar_icon' as const,
  SidebarIconColor: 'sidebar_icon_color' as const,
  Slug: 'slug' as const,
  Website: 'website' as const,
} as const;

export const DefaultWorkspaceSystemFieldUtils = {
  values: Object.values(DefaultWorkspaceSystemField),
  keys: Object.keys(DefaultWorkspaceSystemField) as Array<keyof typeof DefaultWorkspaceSystemField>,
  entries: Object.entries(DefaultWorkspaceSystemField) as Array<[keyof typeof DefaultWorkspaceSystemField, DefaultWorkspaceSystemField]>,
  isValid: (value: any): value is DefaultWorkspaceSystemField => Object.values(DefaultWorkspaceSystemField).includes(value),
  fromKey: (key: keyof typeof DefaultWorkspaceSystemField): DefaultWorkspaceSystemField => DefaultWorkspaceSystemField[key],
};

export type DnsProvider = 'bluehost' | 'cloudflare' | 'easydns' | 'godaddy' | 'hostgator' | 'namecheap' | 'network_solutions' | 'route53' | 'siteground' | 'squarespace' | 'unknown' | 'wix';

export const DnsProvider = {
  Bluehost: 'bluehost' as const,
  Cloudflare: 'cloudflare' as const,
  EasyDns: 'easydns' as const,
  GoDaddy: 'godaddy' as const,
  HostGator: 'hostgator' as const,
  Namecheap: 'namecheap' as const,
  NetworkSolutions: 'network_solutions' as const,
  Route53: 'route53' as const,
  SiteGround: 'siteground' as const,
  Squarespace: 'squarespace' as const,
  Unknown: 'unknown' as const,
  Wix: 'wix' as const,
} as const;

export const DnsProviderUtils = {
  values: Object.values(DnsProvider),
  keys: Object.keys(DnsProvider) as Array<keyof typeof DnsProvider>,
  entries: Object.entries(DnsProvider) as Array<[keyof typeof DnsProvider, DnsProvider]>,
  isValid: (value: any): value is DnsProvider => Object.values(DnsProvider).includes(value),
  fromKey: (key: keyof typeof DnsProvider): DnsProvider => DnsProvider[key],
};

export type DnsProxyStatus = 'dns_only' | 'proxied' | 'unknown';

export const DnsProxyStatus = {
  DnsOnly: 'dns_only' as const,
  Proxied: 'proxied' as const,
  Unknown: 'unknown' as const,
} as const;

export const DnsProxyStatusUtils = {
  values: Object.values(DnsProxyStatus),
  keys: Object.keys(DnsProxyStatus) as Array<keyof typeof DnsProxyStatus>,
  entries: Object.entries(DnsProxyStatus) as Array<[keyof typeof DnsProxyStatus, DnsProxyStatus]>,
  isValid: (value: any): value is DnsProxyStatus => Object.values(DnsProxyStatus).includes(value),
  fromKey: (key: keyof typeof DnsProxyStatus): DnsProxyStatus => DnsProxyStatus[key],
};

export type DnsRecordVerdict = 'conflicting' | 'missing' | 'ok' | 'wrong_value';

export const DnsRecordVerdict = {
  Conflicting: 'conflicting' as const,
  Missing: 'missing' as const,
  Ok: 'ok' as const,
  WrongValue: 'wrong_value' as const,
} as const;

export const DnsRecordVerdictUtils = {
  values: Object.values(DnsRecordVerdict),
  keys: Object.keys(DnsRecordVerdict) as Array<keyof typeof DnsRecordVerdict>,
  entries: Object.entries(DnsRecordVerdict) as Array<[keyof typeof DnsRecordVerdict, DnsRecordVerdict]>,
  isValid: (value: any): value is DnsRecordVerdict => Object.values(DnsRecordVerdict).includes(value),
  fromKey: (key: keyof typeof DnsRecordVerdict): DnsRecordVerdict => DnsRecordVerdict[key],
};

export type DomainAttentionReason = 'cloud_configuration' | 'cloud_failed' | 'cloud_rejected' | 'cloud_replacement_failed' | 'cloud_unavailable' | 'dns_problem' | 'route_conflict';

export const DomainAttentionReason = {
  CloudConfiguration: 'cloud_configuration' as const,
  CloudFailed: 'cloud_failed' as const,
  CloudRejected: 'cloud_rejected' as const,
  CloudReplacementFailed: 'cloud_replacement_failed' as const,
  CloudUnavailable: 'cloud_unavailable' as const,
  DnsProblem: 'dns_problem' as const,
  RouteConflict: 'route_conflict' as const,
} as const;

export const DomainAttentionReasonUtils = {
  values: Object.values(DomainAttentionReason),
  keys: Object.keys(DomainAttentionReason) as Array<keyof typeof DomainAttentionReason>,
  entries: Object.entries(DomainAttentionReason) as Array<[keyof typeof DomainAttentionReason, DomainAttentionReason]>,
  isValid: (value: any): value is DomainAttentionReason => Object.values(DomainAttentionReason).includes(value),
  fromKey: (key: keyof typeof DomainAttentionReason): DomainAttentionReason => DomainAttentionReason[key],
};

export type DomainCheckKind = 'challenge_override' | 'cloud_adopt' | 'cloud_create' | 'cloud_link' | 'cloud_poll' | 'cloud_rearm' | 'cloud_recreate' | 'dns' | 'error' | 'staff_force_activate' | 'staff_inspect' | 'monitor' | 'staff_pause' | 'staff_reprovision' | 'staff_resume' | 'status_change' | 'staff_verification_method';

export const DomainCheckKind = {
  ChallengeOverride: 'challenge_override' as const,
  CloudAdopt: 'cloud_adopt' as const,
  CloudCreate: 'cloud_create' as const,
  CloudLink: 'cloud_link' as const,
  CloudPoll: 'cloud_poll' as const,
  CloudRearm: 'cloud_rearm' as const,
  CloudRecreate: 'cloud_recreate' as const,
  Dns: 'dns' as const,
  Error: 'error' as const,
  ForceActivate: 'staff_force_activate' as const,
  Inspect: 'staff_inspect' as const,
  Monitor: 'monitor' as const,
  Pause: 'staff_pause' as const,
  Reprovision: 'staff_reprovision' as const,
  Resume: 'staff_resume' as const,
  StatusChange: 'status_change' as const,
  VerificationMethod: 'staff_verification_method' as const,
} as const;

export const DomainCheckKindUtils = {
  values: Object.values(DomainCheckKind),
  keys: Object.keys(DomainCheckKind) as Array<keyof typeof DomainCheckKind>,
  entries: Object.entries(DomainCheckKind) as Array<[keyof typeof DomainCheckKind, DomainCheckKind]>,
  isValid: (value: any): value is DomainCheckKind => Object.values(DomainCheckKind).includes(value),
  fromKey: (key: keyof typeof DomainCheckKind): DomainCheckKind => DomainCheckKind[key],
};

export type DomainConnectionMode = 'fallback_move' | 'new_domain' | 'website_move';

export const DomainConnectionMode = {
  FallbackMove: 'fallback_move' as const,
  NewDomain: 'new_domain' as const,
  WebsiteMove: 'website_move' as const,
} as const;

export const DomainConnectionModeUtils = {
  values: Object.values(DomainConnectionMode),
  keys: Object.keys(DomainConnectionMode) as Array<keyof typeof DomainConnectionMode>,
  entries: Object.entries(DomainConnectionMode) as Array<[keyof typeof DomainConnectionMode, DomainConnectionMode]>,
  isValid: (value: any): value is DomainConnectionMode => Object.values(DomainConnectionMode).includes(value),
  fromKey: (key: keyof typeof DomainConnectionMode): DomainConnectionMode => DomainConnectionMode[key],
};

export type DomainDriftReason = 'certificate_authorization' | 'cloud_missing' | 'cloud_unhealthy' | 'permanent_dcv' | 'traffic_dns';

export const DomainDriftReason = {
  CertificateAuthorization: 'certificate_authorization' as const,
  CloudMissing: 'cloud_missing' as const,
  CloudUnhealthy: 'cloud_unhealthy' as const,
  PermanentDcv: 'permanent_dcv' as const,
  TrafficDns: 'traffic_dns' as const,
} as const;

export const DomainDriftReasonUtils = {
  values: Object.values(DomainDriftReason),
  keys: Object.keys(DomainDriftReason) as Array<keyof typeof DomainDriftReason>,
  entries: Object.entries(DomainDriftReason) as Array<[keyof typeof DomainDriftReason, DomainDriftReason]>,
  isValid: (value: any): value is DomainDriftReason => Object.values(DomainDriftReason).includes(value),
  fromKey: (key: keyof typeof DomainDriftReason): DomainDriftReason => DomainDriftReason[key],
};

export type DomainStatus = 'active' | 'awaiting_dns' | 'needs_attention' | 'paused' | 'stalled' | 'verifying';

export const DomainStatus = {
  Active: 'active' as const,
  AwaitingDns: 'awaiting_dns' as const,
  NeedsAttention: 'needs_attention' as const,
  Paused: 'paused' as const,
  Stalled: 'stalled' as const,
  Verifying: 'verifying' as const,
} as const;

export const DomainStatusUtils = {
  values: Object.values(DomainStatus),
  keys: Object.keys(DomainStatus) as Array<keyof typeof DomainStatus>,
  entries: Object.entries(DomainStatus) as Array<[keyof typeof DomainStatus, DomainStatus]>,
  isValid: (value: any): value is DomainStatus => Object.values(DomainStatus).includes(value),
  fromKey: (key: keyof typeof DomainStatus): DomainStatus => DomainStatus[key],
};

export type HostnameTrafficStatus = 'diagonal' | 'external' | 'unknown' | 'unused';

export const HostnameTrafficStatus = {
  Diagonal: 'diagonal' as const,
  External: 'external' as const,
  Unknown: 'unknown' as const,
  Unused: 'unused' as const,
} as const;

export const HostnameTrafficStatusUtils = {
  values: Object.values(HostnameTrafficStatus),
  keys: Object.keys(HostnameTrafficStatus) as Array<keyof typeof HostnameTrafficStatus>,
  entries: Object.entries(HostnameTrafficStatus) as Array<[keyof typeof HostnameTrafficStatus, HostnameTrafficStatus]>,
  isValid: (value: any): value is HostnameTrafficStatus => Object.values(HostnameTrafficStatus).includes(value),
  fromKey: (key: keyof typeof HostnameTrafficStatus): HostnameTrafficStatus => HostnameTrafficStatus[key],
};

export type RecordImportStatus = 'completed' | 'completed_with_failures' | 'failed' | 'importing_files' | 'importing_records' | 'pending';

export const RecordImportStatus = {
  Completed: 'completed' as const,
  CompletedWithFailures: 'completed_with_failures' as const,
  Failed: 'failed' as const,
  ImportingFiles: 'importing_files' as const,
  ImportingRecords: 'importing_records' as const,
  Pending: 'pending' as const,
} as const;

export const RecordImportStatusUtils = {
  values: Object.values(RecordImportStatus),
  keys: Object.keys(RecordImportStatus) as Array<keyof typeof RecordImportStatus>,
  entries: Object.entries(RecordImportStatus) as Array<[keyof typeof RecordImportStatus, RecordImportStatus]>,
  isValid: (value: any): value is RecordImportStatus => Object.values(RecordImportStatus).includes(value),
  fromKey: (key: keyof typeof RecordImportStatus): RecordImportStatus => RecordImportStatus[key],
};

export type RevenueRecognitionMethod = 'on_date' | 'on_issue' | 'over_service_period';

export const RevenueRecognitionMethod = {
  OnDate: 'on_date' as const,
  OnIssue: 'on_issue' as const,
  OverServicePeriod: 'over_service_period' as const,
} as const;

export const RevenueRecognitionMethodUtils = {
  values: Object.values(RevenueRecognitionMethod),
  keys: Object.keys(RevenueRecognitionMethod) as Array<keyof typeof RevenueRecognitionMethod>,
  entries: Object.entries(RevenueRecognitionMethod) as Array<[keyof typeof RevenueRecognitionMethod, RevenueRecognitionMethod]>,
  isValid: (value: any): value is RevenueRecognitionMethod => Object.values(RevenueRecognitionMethod).includes(value),
  fromKey: (key: keyof typeof RevenueRecognitionMethod): RevenueRecognitionMethod => RevenueRecognitionMethod[key],
};

export type StaffDomainOutcome = 'failed' | 'no_change' | 'rejected' | 'started' | 'succeeded';

export const StaffDomainOutcome = {
  Failed: 'failed' as const,
  NoChange: 'no_change' as const,
  Rejected: 'rejected' as const,
  Started: 'started' as const,
  Succeeded: 'succeeded' as const,
} as const;

export const StaffDomainOutcomeUtils = {
  values: Object.values(StaffDomainOutcome),
  keys: Object.keys(StaffDomainOutcome) as Array<keyof typeof StaffDomainOutcome>,
  entries: Object.entries(StaffDomainOutcome) as Array<[keyof typeof StaffDomainOutcome, StaffDomainOutcome]>,
  isValid: (value: any): value is StaffDomainOutcome => Object.values(StaffDomainOutcome).includes(value),
  fromKey: (key: keyof typeof StaffDomainOutcome): StaffDomainOutcome => StaffDomainOutcome[key],
};

export type TemporaryAdministratorOutcome = 'kept' | 'none' | 'replaced' | 'waiting';

export const TemporaryAdministratorOutcome = {
  Kept: 'kept' as const,
  None: 'none' as const,
  Replaced: 'replaced' as const,
  Waiting: 'waiting' as const,
} as const;

export const TemporaryAdministratorOutcomeUtils = {
  values: Object.values(TemporaryAdministratorOutcome),
  keys: Object.keys(TemporaryAdministratorOutcome) as Array<keyof typeof TemporaryAdministratorOutcome>,
  entries: Object.entries(TemporaryAdministratorOutcome) as Array<[keyof typeof TemporaryAdministratorOutcome, TemporaryAdministratorOutcome]>,
  isValid: (value: any): value is TemporaryAdministratorOutcome => Object.values(TemporaryAdministratorOutcome).includes(value),
  fromKey: (key: keyof typeof TemporaryAdministratorOutcome): TemporaryAdministratorOutcome => TemporaryAdministratorOutcome[key],
};

export type WalletAccountingAccountType = 'asset' | 'equity' | 'expense' | 'income' | 'liability';

export const WalletAccountingAccountType = {
  Asset: 'asset' as const,
  Equity: 'equity' as const,
  Expense: 'expense' as const,
  Income: 'income' as const,
  Liability: 'liability' as const,
} as const;

export const WalletAccountingAccountTypeUtils = {
  values: Object.values(WalletAccountingAccountType),
  keys: Object.keys(WalletAccountingAccountType) as Array<keyof typeof WalletAccountingAccountType>,
  entries: Object.entries(WalletAccountingAccountType) as Array<[keyof typeof WalletAccountingAccountType, WalletAccountingAccountType]>,
  isValid: (value: any): value is WalletAccountingAccountType => Object.values(WalletAccountingAccountType).includes(value),
  fromKey: (key: keyof typeof WalletAccountingAccountType): WalletAccountingAccountType => WalletAccountingAccountType[key],
};

export type WebsiteMovePhase = 'preparing' | 'ready' | 'switching' | 'verifying';

export const WebsiteMovePhase = {
  Preparing: 'preparing' as const,
  Ready: 'ready' as const,
  Switching: 'switching' as const,
  Verifying: 'verifying' as const,
} as const;

export const WebsiteMovePhaseUtils = {
  values: Object.values(WebsiteMovePhase),
  keys: Object.keys(WebsiteMovePhase) as Array<keyof typeof WebsiteMovePhase>,
  entries: Object.entries(WebsiteMovePhase) as Array<[keyof typeof WebsiteMovePhase, WebsiteMovePhase]>,
  isValid: (value: any): value is WebsiteMovePhase => Object.values(WebsiteMovePhase).includes(value),
  fromKey: (key: keyof typeof WebsiteMovePhase): WebsiteMovePhase => WebsiteMovePhase[key],
};

export type WorkspaceBranchEvent = 'created' | 'creation_failed' | 'discarded' | 'head_built' | 'head_failed' | 'merged' | 'retried' | 'updated_from_main';

export const WorkspaceBranchEvent = {
  Created: 'created' as const,
  CreationFailed: 'creation_failed' as const,
  Discarded: 'discarded' as const,
  HeadBuilt: 'head_built' as const,
  HeadFailed: 'head_failed' as const,
  Merged: 'merged' as const,
  Retried: 'retried' as const,
  UpdatedFromMain: 'updated_from_main' as const,
} as const;

export const WorkspaceBranchEventUtils = {
  values: Object.values(WorkspaceBranchEvent),
  keys: Object.keys(WorkspaceBranchEvent) as Array<keyof typeof WorkspaceBranchEvent>,
  entries: Object.entries(WorkspaceBranchEvent) as Array<[keyof typeof WorkspaceBranchEvent, WorkspaceBranchEvent]>,
  isValid: (value: any): value is WorkspaceBranchEvent => Object.values(WorkspaceBranchEvent).includes(value),
  fromKey: (key: keyof typeof WorkspaceBranchEvent): WorkspaceBranchEvent => WorkspaceBranchEvent[key],
};

export type WorkspaceBranchKind = 'test_run' | 'working';

export const WorkspaceBranchKind = {
  TestRun: 'test_run' as const,
  Working: 'working' as const,
} as const;

export const WorkspaceBranchKindUtils = {
  values: Object.values(WorkspaceBranchKind),
  keys: Object.keys(WorkspaceBranchKind) as Array<keyof typeof WorkspaceBranchKind>,
  entries: Object.entries(WorkspaceBranchKind) as Array<[keyof typeof WorkspaceBranchKind, WorkspaceBranchKind]>,
  isValid: (value: any): value is WorkspaceBranchKind => Object.values(WorkspaceBranchKind).includes(value),
  fromKey: (key: keyof typeof WorkspaceBranchKind): WorkspaceBranchKind => WorkspaceBranchKind[key],
};

export type WorkspaceBranchMergeState = 'blocked' | 'failed' | 'mergeable' | 'merging' | 'needs_recovery' | 'not_planned' | 'not_ready' | 'planning';

export const WorkspaceBranchMergeState = {
  Blocked: 'blocked' as const,
  Failed: 'failed' as const,
  Mergeable: 'mergeable' as const,
  Merging: 'merging' as const,
  NeedsRecovery: 'needs_recovery' as const,
  NotPlanned: 'not_planned' as const,
  NotReady: 'not_ready' as const,
  Planning: 'planning' as const,
} as const;

export const WorkspaceBranchMergeStateUtils = {
  values: Object.values(WorkspaceBranchMergeState),
  keys: Object.keys(WorkspaceBranchMergeState) as Array<keyof typeof WorkspaceBranchMergeState>,
  entries: Object.entries(WorkspaceBranchMergeState) as Array<[keyof typeof WorkspaceBranchMergeState, WorkspaceBranchMergeState]>,
  isValid: (value: any): value is WorkspaceBranchMergeState => Object.values(WorkspaceBranchMergeState).includes(value),
  fromKey: (key: keyof typeof WorkspaceBranchMergeState): WorkspaceBranchMergeState => WorkspaceBranchMergeState[key],
};

export type WorkspaceBranchStatus = 'create_failed' | 'creating' | 'discarded' | 'merged' | 'open' | 'ready';

export const WorkspaceBranchStatus = {
  CreateFailed: 'create_failed' as const,
  Creating: 'creating' as const,
  Discarded: 'discarded' as const,
  Merged: 'merged' as const,
  Open: 'open' as const,
  Ready: 'ready' as const,
} as const;

export const WorkspaceBranchStatusUtils = {
  values: Object.values(WorkspaceBranchStatus),
  keys: Object.keys(WorkspaceBranchStatus) as Array<keyof typeof WorkspaceBranchStatus>,
  entries: Object.entries(WorkspaceBranchStatus) as Array<[keyof typeof WorkspaceBranchStatus, WorkspaceBranchStatus]>,
  isValid: (value: any): value is WorkspaceBranchStatus => Object.values(WorkspaceBranchStatus).includes(value),
  fromKey: (key: keyof typeof WorkspaceBranchStatus): WorkspaceBranchStatus => WorkspaceBranchStatus[key],
};

export type WorkspaceBranchUpdateRecoveryAction = 'attempt' | 'installation';

export const WorkspaceBranchUpdateRecoveryAction = {
  Attempt: 'attempt' as const,
  Installation: 'installation' as const,
} as const;

export const WorkspaceBranchUpdateRecoveryActionUtils = {
  values: Object.values(WorkspaceBranchUpdateRecoveryAction),
  keys: Object.keys(WorkspaceBranchUpdateRecoveryAction) as Array<keyof typeof WorkspaceBranchUpdateRecoveryAction>,
  entries: Object.entries(WorkspaceBranchUpdateRecoveryAction) as Array<[keyof typeof WorkspaceBranchUpdateRecoveryAction, WorkspaceBranchUpdateRecoveryAction]>,
  isValid: (value: any): value is WorkspaceBranchUpdateRecoveryAction => Object.values(WorkspaceBranchUpdateRecoveryAction).includes(value),
  fromKey: (key: keyof typeof WorkspaceBranchUpdateRecoveryAction): WorkspaceBranchUpdateRecoveryAction => WorkspaceBranchUpdateRecoveryAction[key],
};

export type WorkspaceBranchUpdateState = 'applying' | 'approved' | 'completed' | 'failed' | 'no_changes' | 'none' | 'planning' | 'recovery_required' | 'review_required';

export const WorkspaceBranchUpdateState = {
  Applying: 'applying' as const,
  Approved: 'approved' as const,
  Completed: 'completed' as const,
  Failed: 'failed' as const,
  NoChanges: 'no_changes' as const,
  None: 'none' as const,
  Planning: 'planning' as const,
  RecoveryRequired: 'recovery_required' as const,
  ReviewRequired: 'review_required' as const,
} as const;

export const WorkspaceBranchUpdateStateUtils = {
  values: Object.values(WorkspaceBranchUpdateState),
  keys: Object.keys(WorkspaceBranchUpdateState) as Array<keyof typeof WorkspaceBranchUpdateState>,
  entries: Object.entries(WorkspaceBranchUpdateState) as Array<[keyof typeof WorkspaceBranchUpdateState, WorkspaceBranchUpdateState]>,
  isValid: (value: any): value is WorkspaceBranchUpdateState => Object.values(WorkspaceBranchUpdateState).includes(value),
  fromKey: (key: keyof typeof WorkspaceBranchUpdateState): WorkspaceBranchUpdateState => WorkspaceBranchUpdateState[key],
};

export type WorkspaceExportMode = 'combined' | 'config' | 'records' | 'zip';

export const WorkspaceExportMode = {
  Combined: 'combined' as const,
  Config: 'config' as const,
  Records: 'records' as const,
  Zip: 'zip' as const,
} as const;

export const WorkspaceExportModeUtils = {
  values: Object.values(WorkspaceExportMode),
  keys: Object.keys(WorkspaceExportMode) as Array<keyof typeof WorkspaceExportMode>,
  entries: Object.entries(WorkspaceExportMode) as Array<[keyof typeof WorkspaceExportMode, WorkspaceExportMode]>,
  isValid: (value: any): value is WorkspaceExportMode => Object.values(WorkspaceExportMode).includes(value),
  fromKey: (key: keyof typeof WorkspaceExportMode): WorkspaceExportMode => WorkspaceExportMode[key],
};

export type WorkspaceFeatureFlag = 'calendar_sync' | 'outbound_emails' | 'script_workflows' | 'stripe_test_mode';

export const WorkspaceFeatureFlag = {
  CalendarSync: 'calendar_sync' as const,
  OutboundEmails: 'outbound_emails' as const,
  ScriptWorkflows: 'script_workflows' as const,
  StripeTestMode: 'stripe_test_mode' as const,
} as const;

export const WorkspaceFeatureFlagUtils = {
  values: Object.values(WorkspaceFeatureFlag),
  keys: Object.keys(WorkspaceFeatureFlag) as Array<keyof typeof WorkspaceFeatureFlag>,
  entries: Object.entries(WorkspaceFeatureFlag) as Array<[keyof typeof WorkspaceFeatureFlag, WorkspaceFeatureFlag]>,
  isValid: (value: any): value is WorkspaceFeatureFlag => Object.values(WorkspaceFeatureFlag).includes(value),
  fromKey: (key: keyof typeof WorkspaceFeatureFlag): WorkspaceFeatureFlag => WorkspaceFeatureFlag[key],
};

export type WorkspaceImportStatus = 'completed' | 'failed' | 'importing' | 'pending';

export const WorkspaceImportStatus = {
  Completed: 'completed' as const,
  Failed: 'failed' as const,
  Importing: 'importing' as const,
  Pending: 'pending' as const,
} as const;

export const WorkspaceImportStatusUtils = {
  values: Object.values(WorkspaceImportStatus),
  keys: Object.keys(WorkspaceImportStatus) as Array<keyof typeof WorkspaceImportStatus>,
  entries: Object.entries(WorkspaceImportStatus) as Array<[keyof typeof WorkspaceImportStatus, WorkspaceImportStatus]>,
  isValid: (value: any): value is WorkspaceImportStatus => Object.values(WorkspaceImportStatus).includes(value),
  fromKey: (key: keyof typeof WorkspaceImportStatus): WorkspaceImportStatus => WorkspaceImportStatus[key],
};

export type WorkspaceOnboardingStepStatus = 'complete' | 'in_progress' | 'not_started';

export const WorkspaceOnboardingStepStatus = {
  Complete: 'complete' as const,
  InProgress: 'in_progress' as const,
  NotStarted: 'not_started' as const,
} as const;

export const WorkspaceOnboardingStepStatusUtils = {
  values: Object.values(WorkspaceOnboardingStepStatus),
  keys: Object.keys(WorkspaceOnboardingStepStatus) as Array<keyof typeof WorkspaceOnboardingStepStatus>,
  entries: Object.entries(WorkspaceOnboardingStepStatus) as Array<[keyof typeof WorkspaceOnboardingStepStatus, WorkspaceOnboardingStepStatus]>,
  isValid: (value: any): value is WorkspaceOnboardingStepStatus => Object.values(WorkspaceOnboardingStepStatus).includes(value),
  fromKey: (key: keyof typeof WorkspaceOnboardingStepStatus): WorkspaceOnboardingStepStatus => WorkspaceOnboardingStepStatus[key],
};

export type WorkspaceRuntime = 'files' | 'rows';

export const WorkspaceRuntime = {
  Files: 'files' as const,
  Rows: 'rows' as const,
} as const;

export const WorkspaceRuntimeUtils = {
  values: Object.values(WorkspaceRuntime),
  keys: Object.keys(WorkspaceRuntime) as Array<keyof typeof WorkspaceRuntime>,
  entries: Object.entries(WorkspaceRuntime) as Array<[keyof typeof WorkspaceRuntime, WorkspaceRuntime]>,
  isValid: (value: any): value is WorkspaceRuntime => Object.values(WorkspaceRuntime).includes(value),
  fromKey: (key: keyof typeof WorkspaceRuntime): WorkspaceRuntime => WorkspaceRuntime[key],
};

export type WorkspaceSettings = 'workspaces:settings:skip_provisioning';

export const WorkspaceSettings = {
  SkipProvisioning: 'workspaces:settings:skip_provisioning' as const,
} as const;

export const WorkspaceSettingsUtils = {
  values: Object.values(WorkspaceSettings),
  keys: Object.keys(WorkspaceSettings) as Array<keyof typeof WorkspaceSettings>,
  entries: Object.entries(WorkspaceSettings) as Array<[keyof typeof WorkspaceSettings, WorkspaceSettings]>,
  isValid: (value: any): value is WorkspaceSettings => Object.values(WorkspaceSettings).includes(value),
  fromKey: (key: keyof typeof WorkspaceSettings): WorkspaceSettings => WorkspaceSettings[key],
};

